import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  UnsignedInt: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  UUID: { input: string; output: string; }
  NonEmptyTrimmedString: { input: string; output: string; }
  NonEmptyString: { input: string; output: string; }
  URL: { input: string; output: string; }
  UUIDv4: { input: string; output: string; }
  NonEmptySanitizedString: { input: string; output: string; }
  Slug: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  JSONArray: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  DraftJS: { input: any; output: any; }
  JSONValue: { input: any; output: any; }
  UnsignedFloat: { input: number; output: number; }
};

export type Query = {
  __typename?: 'query';
  /** Retrieves one "Article", throws an error if it does not exist */
  article: Article;
  /** Retrieves one "ArticleAuthor", throws an error if it does not exist */
  articleAuthor: ArticleAuthor;
  /** Gets the number of "ArticleAuthors" */
  articleAuthorCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleAuthor" exists or not? */
  articleAuthorExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleAuthor" if it exists, returns null otherwise */
  articleAuthorIfExists?: Maybe<ArticleAuthor>;
  /** Retrieves a list of "ArticleAuthors" */
  articleAuthors: Array<ArticleAuthor>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleAuthors" in the same order, throws an error if one does not exist
   */
  articleAuthorsInOrder: Array<ArticleAuthor>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleAuthors", or null, in the same order */
  articleAuthorsInOrderIfExists: Array<Maybe<ArticleAuthor>>;
  /** Retrieves a list of "ArticleCategories" */
  articleCategories: Array<ArticleCategory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleCategories" in the same order, throws an error if one does not exist
   */
  articleCategoriesInOrder: Array<ArticleCategory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleCategories", or null, in the same order */
  articleCategoriesInOrderIfExists: Array<Maybe<ArticleCategory>>;
  /** Retrieves one "ArticleCategory", throws an error if it does not exist */
  articleCategory: ArticleCategory;
  /** Gets the number of "ArticleCategories" */
  articleCategoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleCategory" exists or not? */
  articleCategoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleCategory" if it exists, returns null otherwise */
  articleCategoryIfExists?: Maybe<ArticleCategory>;
  /** Retrieves one "ArticleChannel", throws an error if it does not exist */
  articleChannel: ArticleChannel;
  /** Gets the number of "ArticleChannels" */
  articleChannelCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleChannel" exists or not? */
  articleChannelExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleChannel" if it exists, returns null otherwise */
  articleChannelIfExists?: Maybe<ArticleChannel>;
  /** Retrieves a list of "ArticleChannels" */
  articleChannels: Array<ArticleChannel>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleChannels" in the same order, throws an error if one does not exist
   */
  articleChannelsInOrder: Array<ArticleChannel>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleChannels", or null, in the same order */
  articleChannelsInOrderIfExists: Array<Maybe<ArticleChannel>>;
  /** Gets the number of "Articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  /** Retrieves one "ArticleEvent", throws an error if it does not exist */
  articleEvent: ArticleEvent;
  /** Gets the number of "ArticleEvents" */
  articleEventCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleEvent" exists or not? */
  articleEventExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleEvent" if it exists, returns null otherwise */
  articleEventIfExists?: Maybe<ArticleEvent>;
  /** Retrieves a list of "ArticleEvents" */
  articleEvents: Array<ArticleEvent>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleEvents" in the same order, throws an error if one does not exist
   */
  articleEventsInOrder: Array<ArticleEvent>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleEvents", or null, in the same order */
  articleEventsInOrderIfExists: Array<Maybe<ArticleEvent>>;
  /** Either the "Article" exists or not? */
  articleExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleGoodDealAiProcess", throws an error if it does not exist */
  articleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Gets the number of "ArticleGoodDealAiProcesses" */
  articleGoodDealAiProcessCount: Scalars['UnsignedInt']['output'];
  /** Retrieves a list of "ArticleGoodDealAiProcesses" */
  articleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleGoodDealAiProcesses" in the same order, throws an error if one does not exist
   */
  articleGoodDealAiProcessesInOrder: Array<ArticleGoodDealAiProcess>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleGoodDealAiProcesses", or null, in the same order
   */
  articleGoodDealAiProcessesInOrderIfExists: Array<Maybe<ArticleGoodDealAiProcess>>;
  /** Either the "ArticleGoodDealAiProcess" exists or not? */
  articleGoodDealAiProcessExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleGoodDealAiProcess" if it exists, returns null otherwise */
  articleGoodDealAiProcessIfExists?: Maybe<ArticleGoodDealAiProcess>;
  /** Retrieves one "ArticleGoodDealAiPrompt", throws an error if it does not exist */
  articleGoodDealAiPrompt: ArticleGoodDealAiPrompt;
  /** Gets the number of "ArticleGoodDealAiPrompts" */
  articleGoodDealAiPromptCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleGoodDealAiPrompt" exists or not? */
  articleGoodDealAiPromptExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleGoodDealAiPrompt" if it exists, returns null otherwise */
  articleGoodDealAiPromptIfExists?: Maybe<ArticleGoodDealAiPrompt>;
  /** Retrieves a list of "ArticleGoodDealAiPrompts" */
  articleGoodDealAiPrompts: Array<ArticleGoodDealAiPrompt>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleGoodDealAiPrompts" in the same order, throws an error if one does not exist
   */
  articleGoodDealAiPromptsInOrder: Array<ArticleGoodDealAiPrompt>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleGoodDealAiPrompts", or null, in the same order */
  articleGoodDealAiPromptsInOrderIfExists: Array<Maybe<ArticleGoodDealAiPrompt>>;
  /** Retrieves one "ArticleGuide", throws an error if it does not exist */
  articleGuide: ArticleGuide;
  /** Gets the number of "ArticleGuides" */
  articleGuideCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleGuide" exists or not? */
  articleGuideExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleGuide" if it exists, returns null otherwise */
  articleGuideIfExists?: Maybe<ArticleGuide>;
  /** Retrieves a list of "ArticleGuides" */
  articleGuides: Array<ArticleGuide>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleGuides" in the same order, throws an error if one does not exist
   */
  articleGuidesInOrder: Array<ArticleGuide>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleGuides", or null, in the same order */
  articleGuidesInOrderIfExists: Array<Maybe<ArticleGuide>>;
  /** Retrieves a list of "ArticleHistories" */
  articleHistories: Array<ArticleHistory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleHistories" in the same order, throws an error if one does not exist
   */
  articleHistoriesInOrder: Array<ArticleHistory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleHistories", or null, in the same order */
  articleHistoriesInOrderIfExists: Array<Maybe<ArticleHistory>>;
  /** Retrieves one "ArticleHistory", throws an error if it does not exist */
  articleHistory: ArticleHistory;
  /** Gets the number of "ArticleHistories" */
  articleHistoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleHistory" exists or not? */
  articleHistoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleHistory" if it exists, returns null otherwise */
  articleHistoryIfExists?: Maybe<ArticleHistory>;
  /** Retrieves one "Article" if it exists, returns null otherwise */
  articleIfExists?: Maybe<Article>;
  /** Retrieves one "ArticleMachineTag", throws an error if it does not exist */
  articleMachineTag: ArticleMachineTag;
  /** Gets the number of "ArticleMachineTags" */
  articleMachineTagCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleMachineTag" exists or not? */
  articleMachineTagExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleMachineTag" if it exists, returns null otherwise */
  articleMachineTagIfExists?: Maybe<ArticleMachineTag>;
  /** Retrieves a list of "ArticleMachineTags" */
  articleMachineTags: Array<ArticleMachineTag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleMachineTags" in the same order, throws an error if one does not exist
   */
  articleMachineTagsInOrder: Array<ArticleMachineTag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleMachineTags", or null, in the same order */
  articleMachineTagsInOrderIfExists: Array<Maybe<ArticleMachineTag>>;
  /** Retrieves one "ArticleQualifier", throws an error if it does not exist */
  articleQualifier: ArticleQualifier;
  /** Gets the number of "ArticleQualifiers" */
  articleQualifierCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleQualifier" exists or not? */
  articleQualifierExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleQualifier" if it exists, returns null otherwise */
  articleQualifierIfExists?: Maybe<ArticleQualifier>;
  /** Retrieves a list of "ArticleQualifiers" */
  articleQualifiers: Array<ArticleQualifier>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleQualifiers" in the same order, throws an error if one does not exist
   */
  articleQualifiersInOrder: Array<ArticleQualifier>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleQualifiers", or null, in the same order */
  articleQualifiersInOrderIfExists: Array<Maybe<ArticleQualifier>>;
  /** Retrieves a list of "Articles" */
  articles: Array<Article>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Articles"
   * in the same order, throws an error if one does not exist
   */
  articlesInOrder: Array<Article>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Articles", or null, in the same order */
  articlesInOrderIfExists: Array<Maybe<Article>>;
  /** Retrieves a list of "ArticleSummaries" */
  articleSummaries: Array<ArticleSummary>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleSummaries" in the same order, throws an error if one does not exist
   */
  articleSummariesInOrder: Array<ArticleSummary>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleSummaries", or null, in the same order */
  articleSummariesInOrderIfExists: Array<Maybe<ArticleSummary>>;
  /** Retrieves one "ArticleSummary", throws an error if it does not exist */
  articleSummary: ArticleSummary;
  /** Gets the number of "ArticleSummaries" */
  articleSummaryCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleSummary" exists or not? */
  articleSummaryExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleSummary" if it exists, returns null otherwise */
  articleSummaryIfExists?: Maybe<ArticleSummary>;
  /** Retrieves one "ArticleTag", throws an error if it does not exist */
  articleTag: ArticleTag;
  /** Gets the number of "ArticleTags" */
  articleTagCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleTag" exists or not? */
  articleTagExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleTag" if it exists, returns null otherwise */
  articleTagIfExists?: Maybe<ArticleTag>;
  /** Retrieves a list of "ArticleTags" */
  articleTags: Array<ArticleTag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleTags" in the same order, throws an error if one does not exist
   */
  articleTagsInOrder: Array<ArticleTag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleTags", or null, in the same order */
  articleTagsInOrderIfExists: Array<Maybe<ArticleTag>>;
  /** Retrieves a list of "ArticleTaxonomies" */
  articleTaxonomies: Array<ArticleTaxonomy>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleTaxonomies" in the same order, throws an error if one does not exist
   */
  articleTaxonomiesInOrder: Array<ArticleTaxonomy>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleTaxonomies", or null, in the same order */
  articleTaxonomiesInOrderIfExists: Array<Maybe<ArticleTaxonomy>>;
  /** Retrieves one "ArticleTaxonomy", throws an error if it does not exist */
  articleTaxonomy: ArticleTaxonomy;
  /** Gets the number of "ArticleTaxonomies" */
  articleTaxonomyCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleTaxonomy" exists or not? */
  articleTaxonomyExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleTaxonomy" if it exists, returns null otherwise */
  articleTaxonomyIfExists?: Maybe<ArticleTaxonomy>;
  /** Retrieves one "ArticleUrl", throws an error if it does not exist */
  articleUrl: ArticleUrl;
  /** Gets the number of "ArticleUrls" */
  articleUrlCount: Scalars['UnsignedInt']['output'];
  /** Either the "ArticleUrl" exists or not? */
  articleUrlExists: Scalars['Boolean']['output'];
  /** Retrieves one "ArticleUrl" if it exists, returns null otherwise */
  articleUrlIfExists?: Maybe<ArticleUrl>;
  /** Retrieves a list of "ArticleUrls" */
  articleUrls: Array<ArticleUrl>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ArticleUrls" in the same order, throws an error if one does not exist
   */
  articleUrlsInOrder: Array<ArticleUrl>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ArticleUrls", or null, in the same order */
  articleUrlsInOrderIfExists: Array<Maybe<ArticleUrl>>;
  /** Retrieves one "Attribute", throws an error if it does not exist */
  attribute: Attribute;
  /** Gets the number of "Attributes" */
  attributeCount: Scalars['UnsignedInt']['output'];
  /** Either the "Attribute" exists or not? */
  attributeExists: Scalars['Boolean']['output'];
  /** Retrieves one "Attribute" if it exists, returns null otherwise */
  attributeIfExists?: Maybe<Attribute>;
  /** Retrieves a list of "Attributes" */
  attributes: Array<Attribute>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Attributes" in the same order, throws an error if one does not exist
   */
  attributesInOrder: Array<Attribute>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Attributes", or null, in the same order */
  attributesInOrderIfExists: Array<Maybe<Attribute>>;
  /** Retrieves one "Author", throws an error if it does not exist */
  author: Author;
  /** Retrieves one "AuthorAttribute", throws an error if it does not exist */
  authorAttribute: AuthorAttribute;
  /** Gets the number of "AuthorAttributes" */
  authorAttributeCount: Scalars['UnsignedInt']['output'];
  /** Either the "AuthorAttribute" exists or not? */
  authorAttributeExists: Scalars['Boolean']['output'];
  /** Retrieves one "AuthorAttribute" if it exists, returns null otherwise */
  authorAttributeIfExists?: Maybe<AuthorAttribute>;
  /** Retrieves a list of "AuthorAttributes" */
  authorAttributes: Array<AuthorAttribute>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "AuthorAttributes" in the same order, throws an error if one does not exist
   */
  authorAttributesInOrder: Array<AuthorAttribute>;
  /** Given a list of unique-filter's value, retrieves the corresponding "AuthorAttributes", or null, in the same order */
  authorAttributesInOrderIfExists: Array<Maybe<AuthorAttribute>>;
  /** Gets the number of "Authors" */
  authorCount: Scalars['UnsignedInt']['output'];
  /** Either the "Author" exists or not? */
  authorExists: Scalars['Boolean']['output'];
  /** Retrieves a list of "AuthorHistories" */
  authorHistories: Array<AuthorHistory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "AuthorHistories" in the same order, throws an error if one does not exist
   */
  authorHistoriesInOrder: Array<AuthorHistory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "AuthorHistories", or null, in the same order */
  authorHistoriesInOrderIfExists: Array<Maybe<AuthorHistory>>;
  /** Retrieves one "AuthorHistory", throws an error if it does not exist */
  authorHistory: AuthorHistory;
  /** Gets the number of "AuthorHistories" */
  authorHistoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "AuthorHistory" exists or not? */
  authorHistoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "AuthorHistory" if it exists, returns null otherwise */
  authorHistoryIfExists?: Maybe<AuthorHistory>;
  /** Retrieves one "Author" if it exists, returns null otherwise */
  authorIfExists?: Maybe<Author>;
  /** Retrieves a list of "Authors" */
  authors: Array<Author>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Authors"
   * in the same order, throws an error if one does not exist
   */
  authorsInOrder: Array<Author>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Authors", or null, in the same order */
  authorsInOrderIfExists: Array<Maybe<Author>>;
  /** Retrieves one "Card", throws an error if it does not exist */
  card: Card;
  /** Retrieves a list of "CardCategories" */
  cardCategories: Array<CardCategory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "CardCategories" in the same order, throws an error if one does not exist
   */
  cardCategoriesInOrder: Array<CardCategory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CardCategories", or null, in the same order */
  cardCategoriesInOrderIfExists: Array<Maybe<CardCategory>>;
  /** Retrieves one "CardCategory", throws an error if it does not exist */
  cardCategory: CardCategory;
  /** Gets the number of "CardCategories" */
  cardCategoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "CardCategory" exists or not? */
  cardCategoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "CardCategory" if it exists, returns null otherwise */
  cardCategoryIfExists?: Maybe<CardCategory>;
  /** Gets the number of "Cards" */
  cardCount: Scalars['UnsignedInt']['output'];
  /** Either the "Card" exists or not? */
  cardExists: Scalars['Boolean']['output'];
  /** Retrieves one "Card" if it exists, returns null otherwise */
  cardIfExists?: Maybe<Card>;
  /** Retrieves a list of "Cards" */
  cards: Array<Card>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Cards" in
   * the same order, throws an error if one does not exist
   */
  cardsInOrder: Array<Card>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Cards", or null, in the same order */
  cardsInOrderIfExists: Array<Maybe<Card>>;
  /** Retrieves one "CardTag", throws an error if it does not exist */
  cardTag: CardTag;
  /** Gets the number of "CardTags" */
  cardTagCount: Scalars['UnsignedInt']['output'];
  /** Either the "CardTag" exists or not? */
  cardTagExists: Scalars['Boolean']['output'];
  /** Retrieves one "CardTag" if it exists, returns null otherwise */
  cardTagIfExists?: Maybe<CardTag>;
  /** Retrieves a list of "CardTags" */
  cardTags: Array<CardTag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "CardTags"
   * in the same order, throws an error if one does not exist
   */
  cardTagsInOrder: Array<CardTag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CardTags", or null, in the same order */
  cardTagsInOrderIfExists: Array<Maybe<CardTag>>;
  /** Retrieves a list of "Categories" */
  categories: Array<Category>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Categories" in the same order, throws an error if one does not exist
   */
  categoriesInOrder: Array<Category>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Categories", or null, in the same order */
  categoriesInOrderIfExists: Array<Maybe<Category>>;
  /** Retrieves one "Category", throws an error if it does not exist */
  category: Category;
  /** Gets the number of "Categories" */
  categoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "Category" exists or not? */
  categoryExists: Scalars['Boolean']['output'];
  /** Retrieves a list of "CategoryHistories" */
  categoryHistories: Array<CategoryHistory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "CategoryHistories" in the same order, throws an error if one does not exist
   */
  categoryHistoriesInOrder: Array<CategoryHistory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CategoryHistories", or null, in the same order */
  categoryHistoriesInOrderIfExists: Array<Maybe<CategoryHistory>>;
  /** Retrieves one "CategoryHistory", throws an error if it does not exist */
  categoryHistory: CategoryHistory;
  /** Gets the number of "CategoryHistories" */
  categoryHistoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "CategoryHistory" exists or not? */
  categoryHistoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "CategoryHistory" if it exists, returns null otherwise */
  categoryHistoryIfExists?: Maybe<CategoryHistory>;
  /** Retrieves one "Category" if it exists, returns null otherwise */
  categoryIfExists?: Maybe<Category>;
  /** Retrieves one "CategoryTag", throws an error if it does not exist */
  categoryTag: CategoryTag;
  /** Gets the number of "CategoryTags" */
  categoryTagCount: Scalars['UnsignedInt']['output'];
  /** Either the "CategoryTag" exists or not? */
  categoryTagExists: Scalars['Boolean']['output'];
  /** Retrieves one "CategoryTag" if it exists, returns null otherwise */
  categoryTagIfExists?: Maybe<CategoryTag>;
  /** Retrieves a list of "CategoryTags" */
  categoryTags: Array<CategoryTag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "CategoryTags" in the same order, throws an error if one does not exist
   */
  categoryTagsInOrder: Array<CategoryTag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CategoryTags", or null, in the same order */
  categoryTagsInOrderIfExists: Array<Maybe<CategoryTag>>;
  /** Retrieves one "CategoryUrl", throws an error if it does not exist */
  categoryUrl: CategoryUrl;
  /** Gets the number of "CategoryUrls" */
  categoryUrlCount: Scalars['UnsignedInt']['output'];
  /** Either the "CategoryUrl" exists or not? */
  categoryUrlExists: Scalars['Boolean']['output'];
  /** Retrieves one "CategoryUrl" if it exists, returns null otherwise */
  categoryUrlIfExists?: Maybe<CategoryUrl>;
  /** Retrieves a list of "CategoryUrls" */
  categoryUrls: Array<CategoryUrl>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "CategoryUrls" in the same order, throws an error if one does not exist
   */
  categoryUrlsInOrder: Array<CategoryUrl>;
  /** Given a list of unique-filter's value, retrieves the corresponding "CategoryUrls", or null, in the same order */
  categoryUrlsInOrderIfExists: Array<Maybe<CategoryUrl>>;
  /** Retrieves one "DailymotionLog", throws an error if it does not exist */
  dailymotionLog: DailymotionLog;
  /** Gets the number of "DailymotionLogs" */
  dailymotionLogCount: Scalars['UnsignedInt']['output'];
  /** Either the "DailymotionLog" exists or not? */
  dailymotionLogExists: Scalars['Boolean']['output'];
  /** Retrieves one "DailymotionLog" if it exists, returns null otherwise */
  dailymotionLogIfExists?: Maybe<DailymotionLog>;
  /** Retrieves a list of "DailymotionLogs" */
  dailymotionLogs: Array<DailymotionLog>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "DailymotionLogs" in the same order, throws an error if one does not exist
   */
  dailymotionLogsInOrder: Array<DailymotionLog>;
  /** Given a list of unique-filter's value, retrieves the corresponding "DailymotionLogs", or null, in the same order */
  dailymotionLogsInOrderIfExists: Array<Maybe<DailymotionLog>>;
  /** Get URL to upload video to Dailymotion. */
  dailymotionUploadURL: DailymotionUploadUrl;
  /** Execute an image prompt */
  executeImagePrompt: ImagePrompt;
  /** Execute a text prompt */
  executeTextPrompt: TextPrompt;
  /** Add suggested links to the article body */
  getBodyWithSuggestedLinks: GetBodyWithSuggestedLinksResult;
  /** Retrieves one "ImageSource", throws an error if it does not exist */
  imageSource: ImageSource;
  /** Retrieves a list of "ImageSourceCategories" */
  imageSourceCategories: Array<ImageSourceCategory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ImageSourceCategories" in the same order, throws an error if one does not exist
   */
  imageSourceCategoriesInOrder: Array<ImageSourceCategory>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ImageSourceCategories", or null, in the same order */
  imageSourceCategoriesInOrderIfExists: Array<Maybe<ImageSourceCategory>>;
  /** Retrieves one "ImageSourceCategory", throws an error if it does not exist */
  imageSourceCategory: ImageSourceCategory;
  /** Gets the number of "ImageSourceCategories" */
  imageSourceCategoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "ImageSourceCategory" exists or not? */
  imageSourceCategoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "ImageSourceCategory" if it exists, returns null otherwise */
  imageSourceCategoryIfExists?: Maybe<ImageSourceCategory>;
  /** Gets the number of "ImageSources" */
  imageSourceCount: Scalars['UnsignedInt']['output'];
  /** Either the "ImageSource" exists or not? */
  imageSourceExists: Scalars['Boolean']['output'];
  /** Retrieves one "ImageSource" if it exists, returns null otherwise */
  imageSourceIfExists?: Maybe<ImageSource>;
  /** Retrieves a list of "ImageSources" */
  imageSources: Array<ImageSource>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "ImageSources" in the same order, throws an error if one does not exist
   */
  imageSourcesInOrder: Array<ImageSource>;
  /** Given a list of unique-filter's value, retrieves the corresponding "ImageSources", or null, in the same order */
  imageSourcesInOrderIfExists: Array<Maybe<ImageSource>>;
  /** Retrieves one "Live", throws an error if it does not exist */
  live: Live;
  /** Gets the number of "Lives" */
  liveCount: Scalars['UnsignedInt']['output'];
  /** Either the "Live" exists or not? */
  liveExists: Scalars['Boolean']['output'];
  /** Retrieves one "Live" if it exists, returns null otherwise */
  liveIfExists?: Maybe<Live>;
  /** Retrieves one "LivePost", throws an error if it does not exist */
  livePost: LivePost;
  /** Gets the number of "LivePosts" */
  livePostCount: Scalars['UnsignedInt']['output'];
  /** Either the "LivePost" exists or not? */
  livePostExists: Scalars['Boolean']['output'];
  /** Retrieves one "LivePost" if it exists, returns null otherwise */
  livePostIfExists?: Maybe<LivePost>;
  /** Retrieves a list of "LivePosts" */
  livePosts: Array<LivePost>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "LivePosts"
   * in the same order, throws an error if one does not exist
   */
  livePostsInOrder: Array<LivePost>;
  /** Given a list of unique-filter's value, retrieves the corresponding "LivePosts", or null, in the same order */
  livePostsInOrderIfExists: Array<Maybe<LivePost>>;
  /** Retrieves a list of "Lives" */
  lives: Array<Live>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Lives" in
   * the same order, throws an error if one does not exist
   */
  livesInOrder: Array<Live>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Lives", or null, in the same order */
  livesInOrderIfExists: Array<Maybe<Live>>;
  /** Retrieves one "MachineTag", throws an error if it does not exist */
  machineTag: MachineTag;
  /** Gets the number of "MachineTags" */
  machineTagCount: Scalars['UnsignedInt']['output'];
  /** Either the "MachineTag" exists or not? */
  machineTagExists: Scalars['Boolean']['output'];
  /** Retrieves one "MachineTag" if it exists, returns null otherwise */
  machineTagIfExists?: Maybe<MachineTag>;
  /** Retrieves a list of "MachineTags" */
  machineTags: Array<MachineTag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "MachineTags" in the same order, throws an error if one does not exist
   */
  machineTagsInOrder: Array<MachineTag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "MachineTags", or null, in the same order */
  machineTagsInOrderIfExists: Array<Maybe<MachineTag>>;
  /** Retrieves one "OpenAiProcess", throws an error if it does not exist */
  openAiProcess: OpenAiProcess;
  /** Gets the number of "OpenAiProcesses" */
  openAiProcessCount: Scalars['UnsignedInt']['output'];
  /** Retrieves a list of "OpenAiProcesses" */
  openAiProcesses: Array<OpenAiProcess>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "OpenAiProcesses" in the same order, throws an error if one does not exist
   */
  openAiProcessesInOrder: Array<OpenAiProcess>;
  /** Given a list of unique-filter's value, retrieves the corresponding "OpenAiProcesses", or null, in the same order */
  openAiProcessesInOrderIfExists: Array<Maybe<OpenAiProcess>>;
  /** Either the "OpenAiProcess" exists or not? */
  openAiProcessExists: Scalars['Boolean']['output'];
  /** Retrieves one "OpenAiProcess" if it exists, returns null otherwise */
  openAiProcessIfExists?: Maybe<OpenAiProcess>;
  /** Retrieves one "OrphanPage", throws an error if it does not exist */
  orphanPage: OrphanPage;
  /** Gets the number of "OrphanPages" */
  orphanPageCount: Scalars['UnsignedInt']['output'];
  /** Either the "OrphanPage" exists or not? */
  orphanPageExists: Scalars['Boolean']['output'];
  /** Retrieves one "OrphanPage" if it exists, returns null otherwise */
  orphanPageIfExists?: Maybe<OrphanPage>;
  /** Retrieves a list of "OrphanPages" */
  orphanPages: Array<OrphanPage>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "OrphanPages" in the same order, throws an error if one does not exist
   */
  orphanPagesInOrder: Array<OrphanPage>;
  /** Given a list of unique-filter's value, retrieves the corresponding "OrphanPages", or null, in the same order */
  orphanPagesInOrderIfExists: Array<Maybe<OrphanPage>>;
  /** Retrieves one "Prompt", throws an error if it does not exist */
  prompt: Prompt;
  /** Gets the number of "Prompts" */
  promptCount: Scalars['UnsignedInt']['output'];
  /** Either the "Prompt" exists or not? */
  promptExists: Scalars['Boolean']['output'];
  /** Retrieves one "Prompt" if it exists, returns null otherwise */
  promptIfExists?: Maybe<Prompt>;
  /** Retrieves a list of "Prompts" */
  prompts: Array<Prompt>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Prompts"
   * in the same order, throws an error if one does not exist
   */
  promptsInOrder: Array<Prompt>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Prompts", or null, in the same order */
  promptsInOrderIfExists: Array<Maybe<Prompt>>;
  /** Retrieves one "Push", throws an error if it does not exist */
  push: Push;
  /** Gets the number of "Pushes" */
  pushCount: Scalars['UnsignedInt']['output'];
  /** Retrieves one "PushError", throws an error if it does not exist */
  pushError: PushError;
  /** Gets the number of "PushErrors" */
  pushErrorCount: Scalars['UnsignedInt']['output'];
  /** Either the "PushError" exists or not? */
  pushErrorExists: Scalars['Boolean']['output'];
  /** Retrieves one "PushError" if it exists, returns null otherwise */
  pushErrorIfExists?: Maybe<PushError>;
  /** Retrieves a list of "PushErrors" */
  pushErrors: Array<PushError>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PushErrors" in the same order, throws an error if one does not exist
   */
  pushErrorsInOrder: Array<PushError>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PushErrors", or null, in the same order */
  pushErrorsInOrderIfExists: Array<Maybe<PushError>>;
  /** Retrieves a list of "Pushes" */
  pushes: Array<Push>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Pushes" in
   * the same order, throws an error if one does not exist
   */
  pushesInOrder: Array<Push>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Pushes", or null, in the same order */
  pushesInOrderIfExists: Array<Maybe<Push>>;
  /** Either the "Push" exists or not? */
  pushExists: Scalars['Boolean']['output'];
  /** Retrieves one "Push" if it exists, returns null otherwise */
  pushIfExists?: Maybe<Push>;
  /** Get one push-notification campaign */
  pushNotificationCampaign: PushNotificationCampaign;
  /** List push-notification campaigns */
  pushNotificationCampaigns: Array<PushNotificationCampaignsItem>;
  /** List push-notification segmentations */
  pushNotificationSegmentations: Array<PushNotificationSegmentationsItem>;
  /** Retrieves one "PushSegment", throws an error if it does not exist */
  pushSegment: PushSegment;
  /** Gets the number of "PushSegments" */
  pushSegmentCount: Scalars['UnsignedInt']['output'];
  /** Either the "PushSegment" exists or not? */
  pushSegmentExists: Scalars['Boolean']['output'];
  /** Retrieves one "PushSegment" if it exists, returns null otherwise */
  pushSegmentIfExists?: Maybe<PushSegment>;
  /** Retrieves a list of "PushSegments" */
  pushSegments: Array<PushSegment>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "PushSegments" in the same order, throws an error if one does not exist
   */
  pushSegmentsInOrder: Array<PushSegment>;
  /** Given a list of unique-filter's value, retrieves the corresponding "PushSegments", or null, in the same order */
  pushSegmentsInOrderIfExists: Array<Maybe<PushSegment>>;
  /** Retrieves one "Qualifier", throws an error if it does not exist */
  qualifier: Qualifier;
  /** Gets the number of "Qualifiers" */
  qualifierCount: Scalars['UnsignedInt']['output'];
  /** Either the "Qualifier" exists or not? */
  qualifierExists: Scalars['Boolean']['output'];
  /** Retrieves one "Qualifier" if it exists, returns null otherwise */
  qualifierIfExists?: Maybe<Qualifier>;
  /** Retrieves a list of "Qualifiers" */
  qualifiers: Array<Qualifier>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Qualifiers" in the same order, throws an error if one does not exist
   */
  qualifiersInOrder: Array<Qualifier>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Qualifiers", or null, in the same order */
  qualifiersInOrderIfExists: Array<Maybe<Qualifier>>;
  /** Affilizz design search query */
  searchAffiliationDesign: Array<SearchAffilizzDesignResult>;
  searchAffiliationProduct: SearchAffilizzProductResult;
  searchArticleCount: Scalars['UnsignedInt']['output'];
  searchArticles: Array<Article>;
  searchExternalImages: Array<PhotoSearchResult>;
  searchTagCount: Scalars['UnsignedInt']['output'];
  searchTags: Array<Tag>;
  searchTvCollections: Array<TvCollection>;
  searchTvPrograms: Array<TvProgram>;
  /** Retrieves one "Segment", throws an error if it does not exist */
  segment: Segment;
  /** Gets the number of "Segments" */
  segmentCount: Scalars['UnsignedInt']['output'];
  /** Either the "Segment" exists or not? */
  segmentExists: Scalars['Boolean']['output'];
  /** Retrieves one "Segment" if it exists, returns null otherwise */
  segmentIfExists?: Maybe<Segment>;
  /** Retrieves a list of "Segments" */
  segments: Array<Segment>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Segments"
   * in the same order, throws an error if one does not exist
   */
  segmentsInOrder: Array<Segment>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Segments", or null, in the same order */
  segmentsInOrderIfExists: Array<Maybe<Segment>>;
  /** Retrieves one "Source", throws an error if it does not exist */
  source: Source;
  /** Gets the number of "Sources" */
  sourceCount: Scalars['UnsignedInt']['output'];
  /** Either the "Source" exists or not? */
  sourceExists: Scalars['Boolean']['output'];
  /** Retrieves one "Source" if it exists, returns null otherwise */
  sourceIfExists?: Maybe<Source>;
  /** Retrieves a list of "Sources" */
  sources: Array<Source>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Sources"
   * in the same order, throws an error if one does not exist
   */
  sourcesInOrder: Array<Source>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Sources", or null, in the same order */
  sourcesInOrderIfExists: Array<Maybe<Source>>;
  /** Get "active" categories used in similar articles */
  suggestCategories: Array<Category>;
  /** Suggest internal links based on title and body of article */
  suggestInternalLinks: Array<SuggestInternalLinksResult>;
  /** Get "active" tags used in similar articles */
  suggestTags: Array<Tag>;
  /** Retrieves one "Tab", throws an error if it does not exist */
  tab: Tab;
  /** Gets the number of "Tabs" */
  tabCount: Scalars['UnsignedInt']['output'];
  /** Either the "Tab" exists or not? */
  tabExists: Scalars['Boolean']['output'];
  /** Retrieves one "Tab" if it exists, returns null otherwise */
  tabIfExists?: Maybe<Tab>;
  /** Retrieves a list of "Tabs" */
  tabs: Array<Tab>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Tabs" in
   * the same order, throws an error if one does not exist
   */
  tabsInOrder: Array<Tab>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Tabs", or null, in the same order */
  tabsInOrderIfExists: Array<Maybe<Tab>>;
  /** Retrieves one "Tag", throws an error if it does not exist */
  tag: Tag;
  /** Retrieves one "TagBrandedContent", throws an error if it does not exist */
  tagBrandedContent: TagBrandedContent;
  /** Gets the number of "TagBrandedContents" */
  tagBrandedContentCount: Scalars['UnsignedInt']['output'];
  /** Either the "TagBrandedContent" exists or not? */
  tagBrandedContentExists: Scalars['Boolean']['output'];
  /** Retrieves a list of "TagBrandedContentHistories" */
  tagBrandedContentHistories: Array<TagBrandedContentHistory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "TagBrandedContentHistories" in the same order, throws an error if one does not exist
   */
  tagBrandedContentHistoriesInOrder: Array<TagBrandedContentHistory>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "TagBrandedContentHistories", or null, in the same order
   */
  tagBrandedContentHistoriesInOrderIfExists: Array<Maybe<TagBrandedContentHistory>>;
  /** Retrieves one "TagBrandedContentHistory", throws an error if it does not exist */
  tagBrandedContentHistory: TagBrandedContentHistory;
  /** Gets the number of "TagBrandedContentHistories" */
  tagBrandedContentHistoryCount: Scalars['UnsignedInt']['output'];
  /** Either the "TagBrandedContentHistory" exists or not? */
  tagBrandedContentHistoryExists: Scalars['Boolean']['output'];
  /** Retrieves one "TagBrandedContentHistory" if it exists, returns null otherwise */
  tagBrandedContentHistoryIfExists?: Maybe<TagBrandedContentHistory>;
  /** Retrieves one "TagBrandedContent" if it exists, returns null otherwise */
  tagBrandedContentIfExists?: Maybe<TagBrandedContent>;
  /** Retrieves a list of "TagBrandedContents" */
  tagBrandedContents: Array<TagBrandedContent>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "TagBrandedContents" in the same order, throws an error if one does not exist
   */
  tagBrandedContentsInOrder: Array<TagBrandedContent>;
  /** Given a list of unique-filter's value, retrieves the corresponding "TagBrandedContents", or null, in the same order */
  tagBrandedContentsInOrderIfExists: Array<Maybe<TagBrandedContent>>;
  /** Gets the number of "Tags" */
  tagCount: Scalars['UnsignedInt']['output'];
  /** Either the "Tag" exists or not? */
  tagExists: Scalars['Boolean']['output'];
  /** Retrieves one "Tag" if it exists, returns null otherwise */
  tagIfExists?: Maybe<Tag>;
  /** Retrieves a list of "Tags" */
  tags: Array<Tag>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding "Tags" in
   * the same order, throws an error if one does not exist
   */
  tagsInOrder: Array<Tag>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Tags", or null, in the same order */
  tagsInOrderIfExists: Array<Maybe<Tag>>;
  /** Retrieves a list of "Taxonomies" */
  taxonomies: Array<Taxonomy>;
  /**
   * Given a list of unique-filter's value, retrieves the corresponding
   * "Taxonomies" in the same order, throws an error if one does not exist
   */
  taxonomiesInOrder: Array<Taxonomy>;
  /** Given a list of unique-filter's value, retrieves the corresponding "Taxonomies", or null, in the same order */
  taxonomiesInOrderIfExists: Array<Maybe<Taxonomy>>;
  /** Retrieves one "Taxonomy", throws an error if it does not exist */
  taxonomy: Taxonomy;
  /** Gets the number of "Taxonomies" */
  taxonomyCount: Scalars['UnsignedInt']['output'];
  /** Either the "Taxonomy" exists or not? */
  taxonomyExists: Scalars['Boolean']['output'];
  /** Retrieves one "Taxonomy" if it exists, returns null otherwise */
  taxonomyIfExists?: Maybe<Taxonomy>;
  /** Translate some article's properties: title, lead and body */
  translateArticle: Article;
  /** Proxy to make a query to Vertex AI */
  vertexAiQuery: Array<VertexAiQueryResult>;
};


export type QueryArticleArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: ArticleUniqueFilterInput;
};


export type QueryArticleAuthorArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type QueryArticleAuthorCountArgs = {
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type QueryArticleAuthorExistsArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type QueryArticleAuthorIfExistsArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type QueryArticleAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type QueryArticleAuthorsInOrderArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type QueryArticleAuthorsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type QueryArticleCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type QueryArticleCategoriesInOrderArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type QueryArticleCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type QueryArticleCategoryArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type QueryArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type QueryArticleCategoryExistsArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type QueryArticleCategoryIfExistsArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type QueryArticleChannelArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type QueryArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type QueryArticleChannelExistsArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type QueryArticleChannelIfExistsArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type QueryArticleChannelsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type QueryArticleChannelsInOrderArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type QueryArticleChannelsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type QueryArticleCountArgs = {
  where?: InputMaybe<ArticleFilterInput>;
};


export type QueryArticleEventArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: ArticleEventUniqueFilterInput;
};


export type QueryArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type QueryArticleEventExistsArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: ArticleEventUniqueFilterInput;
};


export type QueryArticleEventIfExistsArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: ArticleEventUniqueFilterInput;
};


export type QueryArticleEventsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type QueryArticleEventsInOrderArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type QueryArticleEventsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type QueryArticleExistsArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: ArticleUniqueFilterInput;
};


export type QueryArticleGoodDealAiProcessArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type QueryArticleGoodDealAiProcessCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


export type QueryArticleGoodDealAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


export type QueryArticleGoodDealAiProcessesInOrderArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type QueryArticleGoodDealAiProcessesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type QueryArticleGoodDealAiProcessExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type QueryArticleGoodDealAiProcessIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type QueryArticleGoodDealAiPromptArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type QueryArticleGoodDealAiPromptCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
};


export type QueryArticleGoodDealAiPromptExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type QueryArticleGoodDealAiPromptIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type QueryArticleGoodDealAiPromptsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiPromptOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
};


export type QueryArticleGoodDealAiPromptsInOrderArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type QueryArticleGoodDealAiPromptsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type QueryArticleGuideArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type QueryArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type QueryArticleGuideExistsArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type QueryArticleGuideIfExistsArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type QueryArticleGuidesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type QueryArticleGuidesInOrderArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type QueryArticleGuidesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type QueryArticleHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleHistoryFilterInput>;
};


export type QueryArticleHistoriesInOrderArgs = {
  subset?: InputMaybe<ArticleHistoryFilterInput>;
  where: Array<ArticleHistoryUniqueFilterInput>;
};


export type QueryArticleHistoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleHistoryFilterInput>;
  where: Array<ArticleHistoryUniqueFilterInput>;
};


export type QueryArticleHistoryArgs = {
  subset?: InputMaybe<ArticleHistoryFilterInput>;
  where: ArticleHistoryUniqueFilterInput;
};


export type QueryArticleHistoryCountArgs = {
  where?: InputMaybe<ArticleHistoryFilterInput>;
};


export type QueryArticleHistoryExistsArgs = {
  subset?: InputMaybe<ArticleHistoryFilterInput>;
  where: ArticleHistoryUniqueFilterInput;
};


export type QueryArticleHistoryIfExistsArgs = {
  subset?: InputMaybe<ArticleHistoryFilterInput>;
  where: ArticleHistoryUniqueFilterInput;
};


export type QueryArticleIfExistsArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: ArticleUniqueFilterInput;
};


export type QueryArticleMachineTagArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type QueryArticleMachineTagCountArgs = {
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


export type QueryArticleMachineTagExistsArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type QueryArticleMachineTagIfExistsArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type QueryArticleMachineTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


export type QueryArticleMachineTagsInOrderArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type QueryArticleMachineTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type QueryArticleQualifierArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type QueryArticleQualifierCountArgs = {
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type QueryArticleQualifierExistsArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type QueryArticleQualifierIfExistsArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type QueryArticleQualifiersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type QueryArticleQualifiersInOrderArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type QueryArticleQualifiersInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type QueryArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleFilterInput>;
};


export type QueryArticlesInOrderArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type QueryArticlesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type QueryArticleSummariesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleSummaryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


export type QueryArticleSummariesInOrderArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type QueryArticleSummariesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type QueryArticleSummaryArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type QueryArticleSummaryCountArgs = {
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


export type QueryArticleSummaryExistsArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type QueryArticleSummaryIfExistsArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type QueryArticleTagArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: ArticleTagUniqueFilterInput;
};


export type QueryArticleTagCountArgs = {
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type QueryArticleTagExistsArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: ArticleTagUniqueFilterInput;
};


export type QueryArticleTagIfExistsArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: ArticleTagUniqueFilterInput;
};


export type QueryArticleTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type QueryArticleTagsInOrderArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type QueryArticleTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type QueryArticleTaxonomiesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


export type QueryArticleTaxonomiesInOrderArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type QueryArticleTaxonomiesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type QueryArticleTaxonomyArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type QueryArticleTaxonomyCountArgs = {
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


export type QueryArticleTaxonomyExistsArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type QueryArticleTaxonomyIfExistsArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type QueryArticleUrlArgs = {
  subset?: InputMaybe<ArticleUrlFilterInput>;
  where: ArticleUrlUniqueFilterInput;
};


export type QueryArticleUrlCountArgs = {
  where?: InputMaybe<ArticleUrlFilterInput>;
};


export type QueryArticleUrlExistsArgs = {
  subset?: InputMaybe<ArticleUrlFilterInput>;
  where: ArticleUrlUniqueFilterInput;
};


export type QueryArticleUrlIfExistsArgs = {
  subset?: InputMaybe<ArticleUrlFilterInput>;
  where: ArticleUrlUniqueFilterInput;
};


export type QueryArticleUrlsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleUrlFilterInput>;
};


export type QueryArticleUrlsInOrderArgs = {
  subset?: InputMaybe<ArticleUrlFilterInput>;
  where: Array<ArticleUrlUniqueFilterInput>;
};


export type QueryArticleUrlsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleUrlFilterInput>;
  where: Array<ArticleUrlUniqueFilterInput>;
};


export type QueryAttributeArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: AttributeUniqueFilterInput;
};


export type QueryAttributeCountArgs = {
  where?: InputMaybe<AttributeFilterInput>;
};


export type QueryAttributeExistsArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: AttributeUniqueFilterInput;
};


export type QueryAttributeIfExistsArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: AttributeUniqueFilterInput;
};


export type QueryAttributesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttributeOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AttributeFilterInput>;
};


export type QueryAttributesInOrderArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type QueryAttributesInOrderIfExistsArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type QueryAuthorArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: AuthorUniqueFilterInput;
};


export type QueryAuthorAttributeArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type QueryAuthorAttributeCountArgs = {
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type QueryAuthorAttributeExistsArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type QueryAuthorAttributeIfExistsArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type QueryAuthorAttributesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type QueryAuthorAttributesInOrderArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type QueryAuthorAttributesInOrderIfExistsArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type QueryAuthorCountArgs = {
  where?: InputMaybe<AuthorFilterInput>;
};


export type QueryAuthorExistsArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: AuthorUniqueFilterInput;
};


export type QueryAuthorHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorHistoryFilterInput>;
};


export type QueryAuthorHistoriesInOrderArgs = {
  subset?: InputMaybe<AuthorHistoryFilterInput>;
  where: Array<AuthorHistoryUniqueFilterInput>;
};


export type QueryAuthorHistoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<AuthorHistoryFilterInput>;
  where: Array<AuthorHistoryUniqueFilterInput>;
};


export type QueryAuthorHistoryArgs = {
  subset?: InputMaybe<AuthorHistoryFilterInput>;
  where: AuthorHistoryUniqueFilterInput;
};


export type QueryAuthorHistoryCountArgs = {
  where?: InputMaybe<AuthorHistoryFilterInput>;
};


export type QueryAuthorHistoryExistsArgs = {
  subset?: InputMaybe<AuthorHistoryFilterInput>;
  where: AuthorHistoryUniqueFilterInput;
};


export type QueryAuthorHistoryIfExistsArgs = {
  subset?: InputMaybe<AuthorHistoryFilterInput>;
  where: AuthorHistoryUniqueFilterInput;
};


export type QueryAuthorIfExistsArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: AuthorUniqueFilterInput;
};


export type QueryAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorFilterInput>;
};


export type QueryAuthorsInOrderArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type QueryAuthorsInOrderIfExistsArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type QueryCardArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: CardUniqueFilterInput;
};


export type QueryCardCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type QueryCardCategoriesInOrderArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type QueryCardCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type QueryCardCategoryArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: CardCategoryUniqueFilterInput;
};


export type QueryCardCategoryCountArgs = {
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type QueryCardCategoryExistsArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: CardCategoryUniqueFilterInput;
};


export type QueryCardCategoryIfExistsArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: CardCategoryUniqueFilterInput;
};


export type QueryCardCountArgs = {
  where?: InputMaybe<CardFilterInput>;
};


export type QueryCardExistsArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: CardUniqueFilterInput;
};


export type QueryCardIfExistsArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: CardUniqueFilterInput;
};


export type QueryCardsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardFilterInput>;
};


export type QueryCardsInOrderArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type QueryCardsInOrderIfExistsArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type QueryCardTagArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: CardTagUniqueFilterInput;
};


export type QueryCardTagCountArgs = {
  where?: InputMaybe<CardTagFilterInput>;
};


export type QueryCardTagExistsArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: CardTagUniqueFilterInput;
};


export type QueryCardTagIfExistsArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: CardTagUniqueFilterInput;
};


export type QueryCardTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardTagFilterInput>;
};


export type QueryCardTagsInOrderArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type QueryCardTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type QueryCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryFilterInput>;
};


export type QueryCategoriesInOrderArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type QueryCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type QueryCategoryArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: CategoryUniqueFilterInput;
};


export type QueryCategoryCountArgs = {
  where?: InputMaybe<CategoryFilterInput>;
};


export type QueryCategoryExistsArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: CategoryUniqueFilterInput;
};


export type QueryCategoryHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryHistoryFilterInput>;
};


export type QueryCategoryHistoriesInOrderArgs = {
  subset?: InputMaybe<CategoryHistoryFilterInput>;
  where: Array<CategoryHistoryUniqueFilterInput>;
};


export type QueryCategoryHistoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryHistoryFilterInput>;
  where: Array<CategoryHistoryUniqueFilterInput>;
};


export type QueryCategoryHistoryArgs = {
  subset?: InputMaybe<CategoryHistoryFilterInput>;
  where: CategoryHistoryUniqueFilterInput;
};


export type QueryCategoryHistoryCountArgs = {
  where?: InputMaybe<CategoryHistoryFilterInput>;
};


export type QueryCategoryHistoryExistsArgs = {
  subset?: InputMaybe<CategoryHistoryFilterInput>;
  where: CategoryHistoryUniqueFilterInput;
};


export type QueryCategoryHistoryIfExistsArgs = {
  subset?: InputMaybe<CategoryHistoryFilterInput>;
  where: CategoryHistoryUniqueFilterInput;
};


export type QueryCategoryIfExistsArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: CategoryUniqueFilterInput;
};


export type QueryCategoryTagArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: CategoryTagUniqueFilterInput;
};


export type QueryCategoryTagCountArgs = {
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type QueryCategoryTagExistsArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: CategoryTagUniqueFilterInput;
};


export type QueryCategoryTagIfExistsArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: CategoryTagUniqueFilterInput;
};


export type QueryCategoryTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type QueryCategoryTagsInOrderArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type QueryCategoryTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type QueryCategoryUrlArgs = {
  subset?: InputMaybe<CategoryUrlFilterInput>;
  where: CategoryUrlUniqueFilterInput;
};


export type QueryCategoryUrlCountArgs = {
  where?: InputMaybe<CategoryUrlFilterInput>;
};


export type QueryCategoryUrlExistsArgs = {
  subset?: InputMaybe<CategoryUrlFilterInput>;
  where: CategoryUrlUniqueFilterInput;
};


export type QueryCategoryUrlIfExistsArgs = {
  subset?: InputMaybe<CategoryUrlFilterInput>;
  where: CategoryUrlUniqueFilterInput;
};


export type QueryCategoryUrlsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryUrlFilterInput>;
};


export type QueryCategoryUrlsInOrderArgs = {
  subset?: InputMaybe<CategoryUrlFilterInput>;
  where: Array<CategoryUrlUniqueFilterInput>;
};


export type QueryCategoryUrlsInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryUrlFilterInput>;
  where: Array<CategoryUrlUniqueFilterInput>;
};


export type QueryDailymotionLogArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: DailymotionLogUniqueFilterInput;
};


export type QueryDailymotionLogCountArgs = {
  where?: InputMaybe<DailymotionLogFilterInput>;
};


export type QueryDailymotionLogExistsArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: DailymotionLogUniqueFilterInput;
};


export type QueryDailymotionLogIfExistsArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: DailymotionLogUniqueFilterInput;
};


export type QueryDailymotionLogsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<DailymotionLogOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<DailymotionLogFilterInput>;
};


export type QueryDailymotionLogsInOrderArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: Array<DailymotionLogUniqueFilterInput>;
};


export type QueryDailymotionLogsInOrderIfExistsArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: Array<DailymotionLogUniqueFilterInput>;
};


export type QueryDailymotionUploadUrlArgs = {
  brandKey: BrandKey;
};


export type QueryExecuteImagePromptArgs = {
  prompt: Scalars['NonEmptyTrimmedString']['input'];
};


export type QueryExecuteTextPromptArgs = {
  frequency_penalty?: InputMaybe<Scalars['Float']['input']>;
  max_completion_tokens?: InputMaybe<Scalars['UnsignedInt']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  presence_penalty?: InputMaybe<Scalars['Float']['input']>;
  prompt: Scalars['NonEmptyTrimmedString']['input'];
  response_format?: InputMaybe<Scalars['JSONObject']['input']>;
  temperature?: InputMaybe<Scalars['UnsignedFloat']['input']>;
  top_p?: InputMaybe<Scalars['UnsignedFloat']['input']>;
};


export type QueryGetBodyWithSuggestedLinksArgs = {
  body: Scalars['String']['input'];
  links: Array<InputMaybe<LinkInput>>;
};


export type QueryImageSourceArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: ImageSourceUniqueFilterInput;
};


export type QueryImageSourceCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ImageSourceCategoryFilterInput>;
};


export type QueryImageSourceCategoriesInOrderArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type QueryImageSourceCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type QueryImageSourceCategoryArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type QueryImageSourceCategoryCountArgs = {
  where?: InputMaybe<ImageSourceCategoryFilterInput>;
};


export type QueryImageSourceCategoryExistsArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type QueryImageSourceCategoryIfExistsArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type QueryImageSourceCountArgs = {
  where?: InputMaybe<ImageSourceFilterInput>;
};


export type QueryImageSourceExistsArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: ImageSourceUniqueFilterInput;
};


export type QueryImageSourceIfExistsArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: ImageSourceUniqueFilterInput;
};


export type QueryImageSourcesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ImageSourceFilterInput>;
};


export type QueryImageSourcesInOrderArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type QueryImageSourcesInOrderIfExistsArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type QueryLiveArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: LiveUniqueFilterInput;
};


export type QueryLiveCountArgs = {
  where?: InputMaybe<LiveFilterInput>;
};


export type QueryLiveExistsArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: LiveUniqueFilterInput;
};


export type QueryLiveIfExistsArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: LiveUniqueFilterInput;
};


export type QueryLivePostArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: LivePostUniqueFilterInput;
};


export type QueryLivePostCountArgs = {
  where?: InputMaybe<LivePostFilterInput>;
};


export type QueryLivePostExistsArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: LivePostUniqueFilterInput;
};


export type QueryLivePostIfExistsArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: LivePostUniqueFilterInput;
};


export type QueryLivePostsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LivePostFilterInput>;
};


export type QueryLivePostsInOrderArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type QueryLivePostsInOrderIfExistsArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type QueryLivesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LiveOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LiveFilterInput>;
};


export type QueryLivesInOrderArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type QueryLivesInOrderIfExistsArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type QueryMachineTagArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: MachineTagUniqueFilterInput;
};


export type QueryMachineTagCountArgs = {
  where?: InputMaybe<MachineTagFilterInput>;
};


export type QueryMachineTagExistsArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: MachineTagUniqueFilterInput;
};


export type QueryMachineTagIfExistsArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: MachineTagUniqueFilterInput;
};


export type QueryMachineTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MachineTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<MachineTagFilterInput>;
};


export type QueryMachineTagsInOrderArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type QueryMachineTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type QueryOpenAiProcessArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type QueryOpenAiProcessCountArgs = {
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


export type QueryOpenAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


export type QueryOpenAiProcessesInOrderArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type QueryOpenAiProcessesInOrderIfExistsArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type QueryOpenAiProcessExistsArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type QueryOpenAiProcessIfExistsArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type QueryOrphanPageArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: OrphanPageUniqueFilterInput;
};


export type QueryOrphanPageCountArgs = {
  where?: InputMaybe<OrphanPageFilterInput>;
};


export type QueryOrphanPageExistsArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: OrphanPageUniqueFilterInput;
};


export type QueryOrphanPageIfExistsArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: OrphanPageUniqueFilterInput;
};


export type QueryOrphanPagesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OrphanPageOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<OrphanPageFilterInput>;
};


export type QueryOrphanPagesInOrderArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type QueryOrphanPagesInOrderIfExistsArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type QueryPromptArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: PromptUniqueFilterInput;
};


export type QueryPromptCountArgs = {
  where?: InputMaybe<PromptFilterInput>;
};


export type QueryPromptExistsArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: PromptUniqueFilterInput;
};


export type QueryPromptIfExistsArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: PromptUniqueFilterInput;
};


export type QueryPromptsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PromptOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PromptFilterInput>;
};


export type QueryPromptsInOrderArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type QueryPromptsInOrderIfExistsArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type QueryPushArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: PushUniqueFilterInput;
};


export type QueryPushCountArgs = {
  where?: InputMaybe<PushFilterInput>;
};


export type QueryPushErrorArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: PushErrorUniqueFilterInput;
};


export type QueryPushErrorCountArgs = {
  where?: InputMaybe<PushErrorFilterInput>;
};


export type QueryPushErrorExistsArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: PushErrorUniqueFilterInput;
};


export type QueryPushErrorIfExistsArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: PushErrorUniqueFilterInput;
};


export type QueryPushErrorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushErrorOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushErrorFilterInput>;
};


export type QueryPushErrorsInOrderArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: Array<PushErrorUniqueFilterInput>;
};


export type QueryPushErrorsInOrderIfExistsArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: Array<PushErrorUniqueFilterInput>;
};


export type QueryPushesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushFilterInput>;
};


export type QueryPushesInOrderArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type QueryPushesInOrderIfExistsArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type QueryPushExistsArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: PushUniqueFilterInput;
};


export type QueryPushIfExistsArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: PushUniqueFilterInput;
};


export type QueryPushNotificationCampaignArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
  pushId: Scalars['ID']['input'];
};


export type QueryPushNotificationCampaignsArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
  first?: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type QueryPushNotificationSegmentationsArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
  first?: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
};


export type QueryPushSegmentArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: PushSegmentUniqueFilterInput;
};


export type QueryPushSegmentCountArgs = {
  where?: InputMaybe<PushSegmentFilterInput>;
};


export type QueryPushSegmentExistsArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: PushSegmentUniqueFilterInput;
};


export type QueryPushSegmentIfExistsArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: PushSegmentUniqueFilterInput;
};


export type QueryPushSegmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushSegmentFilterInput>;
};


export type QueryPushSegmentsInOrderArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: Array<PushSegmentUniqueFilterInput>;
};


export type QueryPushSegmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: Array<PushSegmentUniqueFilterInput>;
};


export type QueryQualifierArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: QualifierUniqueFilterInput;
};


export type QueryQualifierCountArgs = {
  where?: InputMaybe<QualifierFilterInput>;
};


export type QueryQualifierExistsArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: QualifierUniqueFilterInput;
};


export type QueryQualifierIfExistsArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: QualifierUniqueFilterInput;
};


export type QueryQualifiersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<QualifierOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<QualifierFilterInput>;
};


export type QueryQualifiersInOrderArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type QueryQualifiersInOrderIfExistsArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type QuerySearchAffiliationDesignArgs = {
  mediaId: Scalars['String']['input'];
  originTypes?: InputMaybe<Array<AffilizzDesignOriginType>>;
  renderingTypes?: InputMaybe<Array<AffilizzDesignRenderingType>>;
  states?: InputMaybe<Array<AffilizzDesignState>>;
};


export type QuerySearchAffiliationProductArgs = {
  keyword: Scalars['String']['input'];
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['UnsignedInt']['input']>;
  size?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sort?: InputMaybe<AffilizzProductSearchSort>;
};


export type QuerySearchArticleCountArgs = {
  like?: InputMaybe<ArticleLikeInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  where?: InputMaybe<ArticleFilterSearchInput>;
};


export type QuerySearchArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  like?: InputMaybe<ArticleLikeInput>;
  orderBy?: InputMaybe<Array<ArticleOrderingSearchInput>>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleFilterSearchInput>;
};


export type QuerySearchExternalImagesArgs = {
  currentPage?: Scalars['UnsignedInt']['input'];
  perPage?: Scalars['UnsignedInt']['input'];
  providers?: Array<ImageProviderName>;
  query: Scalars['NonEmptyTrimmedString']['input'];
};


export type QuerySearchTagCountArgs = {
  like?: InputMaybe<TagLikeInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  where?: InputMaybe<TagFilterSearchInput>;
};


export type QuerySearchTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  like?: InputMaybe<TagLikeInput>;
  orderBy?: InputMaybe<Array<TagOrderingSearchInput>>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagFilterSearchInput>;
};


export type QuerySearchTvCollectionsArgs = {
  context?: TvSearchContextType;
  first?: Scalars['UnsignedInt']['input'];
  query: Scalars['NonEmptyTrimmedString']['input'];
  timeoutInSeconds?: Scalars['UnsignedInt']['input'];
};


export type QuerySearchTvProgramsArgs = {
  context?: TvSearchContextType;
  first?: Scalars['UnsignedInt']['input'];
  query: Scalars['NonEmptyTrimmedString']['input'];
  timeoutInSeconds?: Scalars['UnsignedInt']['input'];
  types?: Array<TvSearchProgramType>;
};


export type QuerySegmentArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: SegmentUniqueFilterInput;
};


export type QuerySegmentCountArgs = {
  where?: InputMaybe<SegmentFilterInput>;
};


export type QuerySegmentExistsArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: SegmentUniqueFilterInput;
};


export type QuerySegmentIfExistsArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: SegmentUniqueFilterInput;
};


export type QuerySegmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SegmentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SegmentFilterInput>;
};


export type QuerySegmentsInOrderArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type QuerySegmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type QuerySourceArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: SourceUniqueFilterInput;
};


export type QuerySourceCountArgs = {
  where?: InputMaybe<SourceFilterInput>;
};


export type QuerySourceExistsArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: SourceUniqueFilterInput;
};


export type QuerySourceIfExistsArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: SourceUniqueFilterInput;
};


export type QuerySourcesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SourceOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<SourceFilterInput>;
};


export type QuerySourcesInOrderArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type QuerySourcesInOrderIfExistsArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type QuerySuggestCategoriesArgs = {
  article: ArticleLikeInput;
  first?: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<ArticleCategoriesCategoryFilterSearchInput>;
};


export type QuerySuggestInternalLinksArgs = {
  body: Scalars['String']['input'];
  brandKey: BrandKey;
  existingLinksLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  idArticle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type QuerySuggestTagsArgs = {
  article: ArticleLikeInput;
  first?: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<ArticleTagsTagFilterSearchInput>;
};


export type QueryTabArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: TabUniqueFilterInput;
};


export type QueryTabCountArgs = {
  where?: InputMaybe<TabFilterInput>;
};


export type QueryTabExistsArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: TabUniqueFilterInput;
};


export type QueryTabIfExistsArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: TabUniqueFilterInput;
};


export type QueryTabsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TabOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TabFilterInput>;
};


export type QueryTabsInOrderArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type QueryTabsInOrderIfExistsArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type QueryTagArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: TagUniqueFilterInput;
};


export type QueryTagBrandedContentArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type QueryTagBrandedContentCountArgs = {
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type QueryTagBrandedContentExistsArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type QueryTagBrandedContentHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagBrandedContentHistoryFilterInput>;
};


export type QueryTagBrandedContentHistoriesInOrderArgs = {
  subset?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  where: Array<TagBrandedContentHistoryUniqueFilterInput>;
};


export type QueryTagBrandedContentHistoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  where: Array<TagBrandedContentHistoryUniqueFilterInput>;
};


export type QueryTagBrandedContentHistoryArgs = {
  subset?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  where: TagBrandedContentHistoryUniqueFilterInput;
};


export type QueryTagBrandedContentHistoryCountArgs = {
  where?: InputMaybe<TagBrandedContentHistoryFilterInput>;
};


export type QueryTagBrandedContentHistoryExistsArgs = {
  subset?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  where: TagBrandedContentHistoryUniqueFilterInput;
};


export type QueryTagBrandedContentHistoryIfExistsArgs = {
  subset?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  where: TagBrandedContentHistoryUniqueFilterInput;
};


export type QueryTagBrandedContentIfExistsArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type QueryTagBrandedContentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type QueryTagBrandedContentsInOrderArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type QueryTagBrandedContentsInOrderIfExistsArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type QueryTagCountArgs = {
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTagExistsArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: TagUniqueFilterInput;
};


export type QueryTagIfExistsArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: TagUniqueFilterInput;
};


export type QueryTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagFilterInput>;
};


export type QueryTagsInOrderArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type QueryTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type QueryTaxonomiesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TaxonomyOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TaxonomyFilterInput>;
};


export type QueryTaxonomiesInOrderArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type QueryTaxonomiesInOrderIfExistsArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type QueryTaxonomyArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: TaxonomyUniqueFilterInput;
};


export type QueryTaxonomyCountArgs = {
  where?: InputMaybe<TaxonomyFilterInput>;
};


export type QueryTaxonomyExistsArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: TaxonomyUniqueFilterInput;
};


export type QueryTaxonomyIfExistsArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: TaxonomyUniqueFilterInput;
};


export type QueryTranslateArticleArgs = {
  lang: Scalars['NonEmptyTrimmedString']['input'];
  where: ArticleUniqueFilterInput;
};


export type QueryVertexAiQueryArgs = {
  filter: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

/** The "Article" nodes' filter */
export type ArticleFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleFilterInput>>>;
  authorCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authors_every?: InputMaybe<ArticleAuthorFilterInput>;
  authors_none?: InputMaybe<ArticleAuthorFilterInput>;
  authors_some?: InputMaybe<ArticleAuthorFilterInput>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  categories_every?: InputMaybe<ArticleCategoryFilterInput>;
  categories_none?: InputMaybe<ArticleCategoryFilterInput>;
  categories_some?: InputMaybe<ArticleCategoryFilterInput>;
  categoryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channelCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  channels_every?: InputMaybe<ArticleChannelFilterInput>;
  channels_none?: InputMaybe<ArticleChannelFilterInput>;
  channels_some?: InputMaybe<ArticleChannelFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  discoverTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  discoverTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discoverTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discoverTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  discoverTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  discoverTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  discoverTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discoverTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discoverTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  discoverTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  discoverTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  eventCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  eventCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  eventCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  eventCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  eventCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  eventCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  events_every?: InputMaybe<ArticleEventFilterInput>;
  events_none?: InputMaybe<ArticleEventFilterInput>;
  events_some?: InputMaybe<ArticleEventFilterInput>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  goodDealAiProcessCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcessCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcessCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcessCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcessCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcessCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  goodDealAiProcesses_every?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  goodDealAiProcesses_none?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  goodDealAiProcesses_some?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  guideCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guideCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guideCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guideCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guideCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guideCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  guides_every?: InputMaybe<ArticleGuideFilterInput>;
  guides_none?: InputMaybe<ArticleGuideFilterInput>;
  guides_some?: InputMaybe<ArticleGuideFilterInput>;
  histories_every?: InputMaybe<ArticleHistoryFilterInput>;
  histories_none?: InputMaybe<ArticleHistoryFilterInput>;
  histories_some?: InputMaybe<ArticleHistoryFilterInput>;
  historyCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lead_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lead_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  lead_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  live?: InputMaybe<LiveFilterInput>;
  live_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  live_not?: InputMaybe<LiveFilterInput>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  machineTagCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTagCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTagCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTagCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTagCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTagCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  machineTags_every?: InputMaybe<ArticleMachineTagFilterInput>;
  machineTags_none?: InputMaybe<ArticleMachineTagFilterInput>;
  machineTags_some?: InputMaybe<ArticleMachineTagFilterInput>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ArticleFilterInput>;
  openAiProcessCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcessCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcessCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcessCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcessCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcessCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  openAiProcesses_every?: InputMaybe<OpenAiProcessFilterInput>;
  openAiProcesses_none?: InputMaybe<OpenAiProcessFilterInput>;
  openAiProcesses_some?: InputMaybe<OpenAiProcessFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleFilterInput>>>;
  partnerTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  partnerTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  partnerTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  partnerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  partnerTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  partnerTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  partnerTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  partnerTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  partnerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  partnerTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  partnerTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  platform_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  platform_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  platform_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  platform_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  platform_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platform_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  platformId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  platformId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  platformId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  platformId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  platformId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  platformId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  publicId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushes_every?: InputMaybe<PushFilterInput>;
  pushes_none?: InputMaybe<PushFilterInput>;
  pushes_some?: InputMaybe<PushFilterInput>;
  qualifierCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifierCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifierCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifierCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifierCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifierCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifiers_every?: InputMaybe<ArticleQualifierFilterInput>;
  qualifiers_none?: InputMaybe<ArticleQualifierFilterInput>;
  qualifiers_some?: InputMaybe<ArticleQualifierFilterInput>;
  secondaryTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  secondaryTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  secondaryTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  secondaryTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  secondaryTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  signature_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  signature_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  signature_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  signature_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  signature_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  signature_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  source?: InputMaybe<SourceFilterInput>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  source_not?: InputMaybe<SourceFilterInput>;
  status?: InputMaybe<ArticleStatus>;
  status_in?: InputMaybe<Array<ArticleStatus>>;
  status_not?: InputMaybe<ArticleStatus>;
  status_not_in?: InputMaybe<Array<ArticleStatus>>;
  summaries_every?: InputMaybe<ArticleSummaryFilterInput>;
  summaries_none?: InputMaybe<ArticleSummaryFilterInput>;
  summaries_some?: InputMaybe<ArticleSummaryFilterInput>;
  summaryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  summaryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  summaryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  summaryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  summaryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  summaryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tags_every?: InputMaybe<ArticleTagFilterInput>;
  tags_none?: InputMaybe<ArticleTagFilterInput>;
  tags_some?: InputMaybe<ArticleTagFilterInput>;
  taxonomies_every?: InputMaybe<ArticleTaxonomyFilterInput>;
  taxonomies_none?: InputMaybe<ArticleTaxonomyFilterInput>;
  taxonomies_some?: InputMaybe<ArticleTaxonomyFilterInput>;
  taxonomyCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomyCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomyCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomyCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomyCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomyCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  urlCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urls_every?: InputMaybe<ArticleUrlFilterInput>;
  urls_none?: InputMaybe<ArticleUrlFilterInput>;
  urls_some?: InputMaybe<ArticleUrlFilterInput>;
};

/** The "ArticleAuthor" nodes' filter */
export type ArticleAuthorFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleAuthorFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  author?: InputMaybe<AuthorFilterInput>;
  author_not?: InputMaybe<AuthorFilterInput>;
  NOT?: InputMaybe<ArticleAuthorFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleAuthorFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "Author" nodes' filter */
export type AuthorFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<AuthorFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleAuthorFilterInput>;
  articles_none?: InputMaybe<ArticleAuthorFilterInput>;
  articles_some?: InputMaybe<ArticleAuthorFilterInput>;
  attributeCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributeCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributeCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributeCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributeCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributeCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  attributes_every?: InputMaybe<AuthorAttributeFilterInput>;
  attributes_none?: InputMaybe<AuthorAttributeFilterInput>;
  attributes_some?: InputMaybe<AuthorAttributeFilterInput>;
  avatarUrl?: InputMaybe<Scalars['URL']['input']>;
  avatarUrl_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  avatarUrl_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  avatarUrl_in?: InputMaybe<Array<InputMaybe<Scalars['URL']['input']>>>;
  avatarUrl_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  avatarUrl_not?: InputMaybe<Scalars['URL']['input']>;
  avatarUrl_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  avatarUrl_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  avatarUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['URL']['input']>>>;
  avatarUrl_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  avatarUrl_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  email_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  email_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  email_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  email_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  email_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  email_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  facebookId?: InputMaybe<Scalars['ID']['input']>;
  facebookId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facebookId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  facebookId_not?: InputMaybe<Scalars['ID']['input']>;
  facebookId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  googleId?: InputMaybe<Scalars['ID']['input']>;
  googleId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  googleId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  googleId_not?: InputMaybe<Scalars['ID']['input']>;
  googleId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicProfile_not?: InputMaybe<Scalars['Boolean']['input']>;
  histories_every?: InputMaybe<AuthorHistoryFilterInput>;
  histories_none?: InputMaybe<AuthorHistoryFilterInput>;
  histories_some?: InputMaybe<AuthorHistoryFilterInput>;
  historyCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  instagramId?: InputMaybe<Scalars['ID']['input']>;
  instagramId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  instagramId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  instagramId_not?: InputMaybe<Scalars['ID']['input']>;
  instagramId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  isExternal_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  isMain_not?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId?: InputMaybe<Scalars['ID']['input']>;
  linkedinId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  linkedinId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId_not?: InputMaybe<Scalars['ID']['input']>;
  linkedinId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  media_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  name_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<AuthorFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AuthorFilterInput>>>;
  pinterestId?: InputMaybe<Scalars['ID']['input']>;
  pinterestId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pinterestId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  pinterestId_not?: InputMaybe<Scalars['ID']['input']>;
  pinterestId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resume?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  resume_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  resume_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  resume_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  resume_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  resume_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  resume_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  resume_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  resume_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  resume_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  resume_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  snapchatId?: InputMaybe<Scalars['ID']['input']>;
  snapchatId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  snapchatId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  snapchatId_not?: InputMaybe<Scalars['ID']['input']>;
  snapchatId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  twitterId?: InputMaybe<Scalars['ID']['input']>;
  twitterId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  twitterId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  twitterId_not?: InputMaybe<Scalars['ID']['input']>;
  twitterId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  userId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  userId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
};

/** The "AuthorAttribute" nodes' filter */
export type AuthorAttributeFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<AuthorAttributeFilterInput>>>;
  attribute?: InputMaybe<AttributeFilterInput>;
  attribute_not?: InputMaybe<AttributeFilterInput>;
  author?: InputMaybe<AuthorFilterInput>;
  author_not?: InputMaybe<AuthorFilterInput>;
  NOT?: InputMaybe<AuthorAttributeFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AuthorAttributeFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "Attribute" nodes' filter */
export type AttributeFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<AttributeFilterInput>>>;
  authorCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authorCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  authors_every?: InputMaybe<AuthorAttributeFilterInput>;
  authors_none?: InputMaybe<AuthorAttributeFilterInput>;
  authors_some?: InputMaybe<AuthorAttributeFilterInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<AttributeFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AttributeFilterInput>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum BrandKey {
  BEA = 'BEA',
  BIN = 'BIN',
  BONE = 'BONE',
  CAC = 'CAC',
  CAM = 'CAM',
  CAP = 'CAP',
  CTM = 'CTM',
  DEGTS = 'DEGTS',
  DEOMM = 'DEOMM',
  FAC = 'FAC',
  FRGSD = 'FRGSD',
  FRGSG = 'FRGSG',
  FRGSL = 'FRGSL',
  FRGSS = 'FRGSS',
  FRGSV = 'FRGSV',
  FROMM = 'FROMM',
  GEO = 'GEO',
  HBR = 'HBR',
  HBZ = 'HBZ',
  HCO = 'HCO',
  IDE = 'IDE',
  MLK = 'MLK',
  MVO = 'MVO',
  NEO = 'NEO',
  PRA = 'PRA',
  QUOI = 'QUOI',
  SESH = 'SESH',
  SHGFAC = 'SHGFAC',
  SIM = 'SIM',
  TEL = 'TEL',
  TESTBRAND = 'TESTBRAND',
  TGC = 'TGC',
  TGL = 'TGL',
  TLS = 'TLS',
  TLZ = 'TLZ',
  TMA = 'TMA',
  TVP = 'TVP',
  UKGTS = 'UKGTS',
  UKOMM = 'UKOMM',
  VOI = 'VOI'
}

/** The "AuthorHistory" nodes' filter */
export type AuthorHistoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<AuthorHistoryFilterInput>>>;
  author?: InputMaybe<AuthorFilterInput>;
  author_not?: InputMaybe<AuthorFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<AuthorHistoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<AuthorHistoryFilterInput>>>;
};

/** The "ArticleCategory" nodes' filter */
export type ArticleCategoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleCategoryFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<ArticleCategoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleCategoryFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "Category" nodes' filter */
export type CategoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CategoryFilterInput>>>;
  articleCategories_every?: InputMaybe<ArticleCategoryFilterInput>;
  articleCategories_none?: InputMaybe<ArticleCategoryFilterInput>;
  articleCategories_some?: InputMaybe<ArticleCategoryFilterInput>;
  articleCategoryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCategoryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCategoryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCategoryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCategoryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCategoryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannelCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleChannels_every?: InputMaybe<ArticleChannelFilterInput>;
  articleChannels_none?: InputMaybe<ArticleChannelFilterInput>;
  articleChannels_some?: InputMaybe<ArticleChannelFilterInput>;
  articleEventCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEventCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEventCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEventCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEventCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEventCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleEvents_every?: InputMaybe<ArticleEventFilterInput>;
  articleEvents_none?: InputMaybe<ArticleEventFilterInput>;
  articleEvents_some?: InputMaybe<ArticleEventFilterInput>;
  articleGuideCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuideCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuideCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuideCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuideCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuideCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleGuides_every?: InputMaybe<ArticleGuideFilterInput>;
  articleGuides_none?: InputMaybe<ArticleGuideFilterInput>;
  articleGuides_some?: InputMaybe<ArticleGuideFilterInput>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  cardCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cards_every?: InputMaybe<CardCategoryFilterInput>;
  cards_none?: InputMaybe<CardCategoryFilterInput>;
  cards_some?: InputMaybe<CardCategoryFilterInput>;
  childCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  childCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  children_every?: InputMaybe<CategoryFilterInput>;
  children_none?: InputMaybe<CategoryFilterInput>;
  children_some?: InputMaybe<CategoryFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  histories_every?: InputMaybe<CategoryHistoryFilterInput>;
  histories_none?: InputMaybe<CategoryHistoryFilterInput>;
  histories_some?: InputMaybe<CategoryHistoryFilterInput>;
  historyCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  isHeadlined_not?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  level_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  level_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  maxBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  maxBoardPinned_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  maxBoardPinned_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  maxBoardPinned_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  minBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  minBoardPinned_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  minBoardPinned_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  minBoardPinned_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  NOT?: InputMaybe<CategoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CategoryFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  parent?: InputMaybe<CategoryFilterInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  parent_not?: InputMaybe<CategoryFilterInput>;
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  publicId_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publicId_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  subtitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  subtitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subtitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  subtitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subtitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  subtitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  subtitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tabCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tabs_every?: InputMaybe<TabFilterInput>;
  tabs_none?: InputMaybe<TabFilterInput>;
  tabs_some?: InputMaybe<TabFilterInput>;
  tagCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tags_every?: InputMaybe<CategoryTagFilterInput>;
  tags_none?: InputMaybe<CategoryTagFilterInput>;
  tags_some?: InputMaybe<CategoryTagFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  urlCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urlCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  urls_every?: InputMaybe<CategoryUrlFilterInput>;
  urls_none?: InputMaybe<CategoryUrlFilterInput>;
  urls_some?: InputMaybe<CategoryUrlFilterInput>;
};

/** The "ArticleChannel" nodes' filter */
export type ArticleChannelFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleChannelFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<ArticleChannelFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleChannelFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "ArticleEvent" nodes' filter */
export type ArticleEventFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleEventFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<ArticleEventFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleEventFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "ArticleGuide" nodes' filter */
export type ArticleGuideFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleGuideFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<ArticleGuideFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleGuideFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "CardCategory" nodes' filter */
export type CardCategoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CardCategoryFilterInput>>>;
  card?: InputMaybe<CardFilterInput>;
  card_not?: InputMaybe<CardFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<CardCategoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CardCategoryFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "Card" nodes' filter */
export type CardFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CardFilterInput>>>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  categories_every?: InputMaybe<CardCategoryFilterInput>;
  categories_none?: InputMaybe<CardCategoryFilterInput>;
  categories_some?: InputMaybe<CardCategoryFilterInput>;
  categoryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  label?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CardFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CardFilterInput>>>;
  secondaryTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  secondaryTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  secondaryTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  secondaryTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  secondaryTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  secondaryTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<CardStatus>;
  status_in?: InputMaybe<Array<CardStatus>>;
  status_not?: InputMaybe<CardStatus>;
  status_not_in?: InputMaybe<Array<CardStatus>>;
  tagCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tagCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tags_every?: InputMaybe<CardTagFilterInput>;
  tags_none?: InputMaybe<CardTagFilterInput>;
  tags_some?: InputMaybe<CardTagFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  url?: InputMaybe<Scalars['URL']['input']>;
  url_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  url_not?: InputMaybe<Scalars['URL']['input']>;
  url_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url_not_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  url_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  url_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export enum CardStatus {
  Archived = 'Archived',
  Deleted = 'Deleted',
  Published = 'Published'
}

/** The "CardTag" nodes' filter */
export type CardTagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CardTagFilterInput>>>;
  card?: InputMaybe<CardFilterInput>;
  card_not?: InputMaybe<CardFilterInput>;
  NOT?: InputMaybe<CardTagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CardTagFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  tag?: InputMaybe<TagFilterInput>;
  tag_not?: InputMaybe<TagFilterInput>;
};

/** The "Tag" nodes' filter */
export type TagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<TagFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleTagFilterInput>;
  articles_none?: InputMaybe<ArticleTagFilterInput>;
  articles_some?: InputMaybe<ArticleTagFilterInput>;
  articleUsageCache_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandedContentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  brandedContents_every?: InputMaybe<TagBrandedContentFilterInput>;
  brandedContents_none?: InputMaybe<TagBrandedContentFilterInput>;
  brandedContents_some?: InputMaybe<TagBrandedContentFilterInput>;
  cardCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cardCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  cards_every?: InputMaybe<CardTagFilterInput>;
  cards_none?: InputMaybe<CardTagFilterInput>;
  cards_some?: InputMaybe<CardTagFilterInput>;
  categories_every?: InputMaybe<CategoryTagFilterInput>;
  categories_none?: InputMaybe<CategoryTagFilterInput>;
  categories_some?: InputMaybe<CategoryTagFilterInput>;
  categoryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  categoryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lang?: InputMaybe<TagLang>;
  lang_in?: InputMaybe<Array<TagLang>>;
  lang_not?: InputMaybe<TagLang>;
  lang_not_in?: InputMaybe<Array<TagLang>>;
  NOT?: InputMaybe<TagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TagFilterInput>>>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  relationId_in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  relationId_not?: InputMaybe<Scalars['UUID']['input']>;
  relationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<TagType>;
  type_in?: InputMaybe<Array<TagType>>;
  type_not?: InputMaybe<TagType>;
  type_not_in?: InputMaybe<Array<TagType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "ArticleTag" nodes' filter */
export type ArticleTagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleTagFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  NOT?: InputMaybe<ArticleTagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTagFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  tag?: InputMaybe<TagFilterInput>;
  tag_not?: InputMaybe<TagFilterInput>;
};

/** The "TagBrandedContent" nodes' filter */
export type TagBrandedContentFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<TagBrandedContentFilterInput>>>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  histories_every?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  histories_none?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  histories_some?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  historyCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  historyCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  media_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TagBrandedContentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TagBrandedContentFilterInput>>>;
  status?: InputMaybe<TagBrandedContentStatus>;
  status_in?: InputMaybe<Array<TagBrandedContentStatus>>;
  status_not?: InputMaybe<TagBrandedContentStatus>;
  status_not_in?: InputMaybe<Array<TagBrandedContentStatus>>;
  tag?: InputMaybe<TagFilterInput>;
  tag_not?: InputMaybe<TagFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "TagBrandedContentHistory" nodes' filter */
export type TagBrandedContentHistoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<TagBrandedContentHistoryFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<TagBrandedContentHistoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TagBrandedContentHistoryFilterInput>>>;
  tagBrandedContent?: InputMaybe<TagBrandedContentFilterInput>;
  tagBrandedContent_not?: InputMaybe<TagBrandedContentFilterInput>;
};

export enum TagBrandedContentStatus {
  Draft = 'Draft',
  Published = 'Published'
}

/** The "CategoryTag" nodes' filter */
export type CategoryTagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CategoryTagFilterInput>>>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  NOT?: InputMaybe<CategoryTagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CategoryTagFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  tag?: InputMaybe<TagFilterInput>;
  tag_not?: InputMaybe<TagFilterInput>;
};

export enum TagLang {
  DE = 'DE',
  EN = 'EN',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
  PT = 'PT'
}

export enum TagType {
  Company = 'Company',
  Destination = 'Destination',
  Isin = 'Isin',
  Medecine = 'Medecine',
  Person = 'Person',
  Tag = 'Tag',
  TvCollection = 'TvCollection',
  TvProgram = 'TvProgram',
  Video = 'Video'
}

export enum CategoryFormat {
  Category = 'Category',
  Channel = 'Channel',
  Event = 'Event',
  Guide = 'Guide'
}

/** The "CategoryHistory" nodes' filter */
export type CategoryHistoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CategoryHistoryFilterInput>>>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<CategoryHistoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CategoryHistoryFilterInput>>>;
};

export enum CategoryStatus {
  Archived = 'Archived',
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published',
  Scheduled = 'Scheduled'
}

/** The "Tab" nodes' filter */
export type TabFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<TabFilterInput>>>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  content_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  description_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  description_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  description_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  description_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  disabledLabel_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  disabledLabel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  disabledLabel_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  disabledLabel_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  disabledLabel_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  disabledLabel_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  enabledLabel_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  enabledLabel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  enabledLabel_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  enabledLabel_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  enabledLabel_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  enabledLabel_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline_not?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  metas_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  metas_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  metas_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  metas_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  metas_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  metas_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  metas_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  metas_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  metas_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<TabFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TabFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<TabType>;
  type_in?: InputMaybe<Array<TabType>>;
  type_not?: InputMaybe<TabType>;
  type_not_in?: InputMaybe<Array<TabType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum TabType {
  Board = 'Board',
  Broadcast = 'Broadcast',
  People = 'People',
  Text = 'Text',
  Url = 'Url'
}

/** The "CategoryUrl" nodes' filter */
export type CategoryUrlFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<CategoryUrlFilterInput>>>;
  category?: InputMaybe<CategoryFilterInput>;
  category_not?: InputMaybe<CategoryFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<CategoryUrlFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<CategoryUrlFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  path_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum ArticleFormat {
  Rich = 'Rich',
  Slideshow = 'Slideshow',
  Video = 'Video'
}

/** The "ArticleGoodDealAiProcess" nodes' filter */
export type ArticleGoodDealAiProcessFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiProcessFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  article_not?: InputMaybe<ArticleFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  error_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  error_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  error_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  error_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  error_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiProcessFilterInput>>>;
  productTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  productTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  productTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  productTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl?: InputMaybe<Scalars['URL']['input']>;
  productUrl_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  productUrl_not?: InputMaybe<Scalars['URL']['input']>;
  productUrl_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl_not_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  productUrl_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  productUrl_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<ArticleGoodDealAiProcessStatus>;
  status_in?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiProcessStatus>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_not?: InputMaybe<ArticleGoodDealAiProcessStatus>;
  status_not_in?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiProcessStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  userId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  userId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
};

export enum ArticleGoodDealAiProcessStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

/** The "ArticleHistory" nodes' filter */
export type ArticleHistoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleHistoryFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleHistoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleHistoryFilterInput>>>;
};

/** The "Live" nodes' filter */
export type LiveFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<LiveFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  endedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  endedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<LiveFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<LiveFilterInput>>>;
  postCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  postCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  postCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  postCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  postCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  postCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  posts_every?: InputMaybe<LivePostFilterInput>;
  posts_none?: InputMaybe<LivePostFilterInput>;
  posts_some?: InputMaybe<LivePostFilterInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "LivePost" nodes' filter */
export type LivePostFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<LivePostFilterInput>>>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  live?: InputMaybe<LiveFilterInput>;
  live_not?: InputMaybe<LiveFilterInput>;
  NOT?: InputMaybe<LivePostFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<LivePostFilterInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "ArticleMachineTag" nodes' filter */
export type ArticleMachineTagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleMachineTagFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  machineTag?: InputMaybe<MachineTagFilterInput>;
  machineTag_not?: InputMaybe<MachineTagFilterInput>;
  NOT?: InputMaybe<ArticleMachineTagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleMachineTagFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

/** The "MachineTag" nodes' filter */
export type MachineTagFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<MachineTagFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleMachineTagFilterInput>;
  articles_none?: InputMaybe<ArticleMachineTagFilterInput>;
  articles_some?: InputMaybe<ArticleMachineTagFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<MachineTagFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<MachineTagFilterInput>>>;
  tag?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tag_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tag_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tag_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  tag_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tag_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tag_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tag_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  tag_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  tag_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "OpenAiProcess" nodes' filter */
export type OpenAiProcessFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<OpenAiProcessFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  article_not?: InputMaybe<ArticleFilterInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorMsg?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorMsg_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorMsg_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorMsg_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  errorMsg_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  errorMsg_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorMsg_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorMsg_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  errorMsg_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorMsg_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  generatedTitle_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  generatedTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  generatedTitle_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  generatedTitle_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  generatedTitle_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  generatedTitle_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<OpenAiProcessFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<OpenAiProcessFilterInput>>>;
  recipeNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  recipeNumber_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  recipeNumber_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipeNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  recipePaths?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  recipePaths_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  recipePaths_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  recipePaths_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  recipePaths_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  recipePaths_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  recipePaths_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  recipePaths_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  recipePaths_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  recipePaths_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  recipePaths_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slideshowSubject_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  slideshowSubject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slideshowSubject_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slideshowSubject_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  slideshowSubject_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slideshowSubject_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
  status_in?: InputMaybe<Array<OpenAiProcessStatus>>;
  status_not?: InputMaybe<OpenAiProcessStatus>;
  status_not_in?: InputMaybe<Array<OpenAiProcessStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum OpenAiProcessStatus {
  ERROR = 'ERROR',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS'
}

/** The "Push" nodes' filter */
export type PushFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<PushFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  errorReason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorReason_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorReason_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorReason_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  errorReason_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  errorReason_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorReason_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorReason_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorReason_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  errorReason_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  errorReason_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  inError_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled_not?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['URL']['input']>;
  media_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  media_not?: InputMaybe<Scalars['URL']['input']>;
  media_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_not_in?: InputMaybe<Array<Scalars['URL']['input']>>;
  media_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  media_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<PushFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PushFilterInput>>>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  scheduledAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  segmentCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segmentCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segmentCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segmentCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segmentCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segmentCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  segments_every?: InputMaybe<PushSegmentFilterInput>;
  segments_none?: InputMaybe<PushSegmentFilterInput>;
  segments_some?: InputMaybe<PushSegmentFilterInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  targetDevice?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  targetDevice_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targetDevice_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targetDevice_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  targetDevice_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  targetDevice_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targetDevice_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targetDevice_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  targetDevice_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targetDevice_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  targeting_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
  userId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['UUIDv4']['input']>>;
};

/** The "PushSegment" nodes' filter */
export type PushSegmentFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<PushSegmentFilterInput>>>;
  NOT?: InputMaybe<PushSegmentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PushSegmentFilterInput>>>;
  push?: InputMaybe<PushFilterInput>;
  push_not?: InputMaybe<PushFilterInput>;
  segment?: InputMaybe<SegmentFilterInput>;
  segment_not?: InputMaybe<SegmentFilterInput>;
};

/** The "Segment" nodes' filter */
export type SegmentFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  active_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  active_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  AND?: InputMaybe<Array<InputMaybe<SegmentFilterInput>>>;
  android_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  device?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  device_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  device_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  device_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  device_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  device_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  device_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  device_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  device_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  device_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  device_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  editorialAlert_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  ios_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SegmentFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SegmentFilterInput>>>;
  pushCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  pushes_every?: InputMaybe<PushSegmentFilterInput>;
  pushes_none?: InputMaybe<PushSegmentFilterInput>;
  pushes_some?: InputMaybe<PushSegmentFilterInput>;
  status?: InputMaybe<SegmentStatus>;
  status_in?: InputMaybe<Array<SegmentStatus>>;
  status_not?: InputMaybe<SegmentStatus>;
  status_not_in?: InputMaybe<Array<SegmentStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum SegmentStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

/** The "ArticleQualifier" nodes' filter */
export type ArticleQualifierFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleQualifierFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  NOT?: InputMaybe<ArticleQualifierFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleQualifierFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  qualifier?: InputMaybe<QualifierFilterInput>;
  qualifier_not?: InputMaybe<QualifierFilterInput>;
};

/** The "Qualifier" nodes' filter */
export type QualifierFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<QualifierFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleQualifierFilterInput>;
  articles_none?: InputMaybe<ArticleQualifierFilterInput>;
  articles_some?: InputMaybe<ArticleQualifierFilterInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<QualifierFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<QualifierFilterInput>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<QualifierStatus>;
  status_in?: InputMaybe<Array<QualifierStatus>>;
  status_not?: InputMaybe<QualifierStatus>;
  status_not_in?: InputMaybe<Array<QualifierStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum QualifierStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

/** The "Source" nodes' filter */
export type SourceFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<SourceFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleFilterInput>;
  articles_none?: InputMaybe<ArticleFilterInput>;
  articles_some?: InputMaybe<ArticleFilterInput>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<SourceFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<SourceFilterInput>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<SourceStatus>;
  status_in?: InputMaybe<Array<SourceStatus>>;
  status_not?: InputMaybe<SourceStatus>;
  status_not_in?: InputMaybe<Array<SourceStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum SourceStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

export enum ArticleStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Frozen = 'Frozen',
  Pending = 'Pending',
  Private = 'Private',
  Proposal = 'Proposal',
  Published = 'Published',
  Ready = 'Ready',
  Scheduled = 'Scheduled',
  ScheduledForRepublication = 'ScheduledForRepublication',
  Todo = 'Todo'
}

/** The "ArticleSummary" nodes' filter */
export type ArticleSummaryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleSummaryFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleSummaryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleSummaryFilterInput>>>;
  prompt?: InputMaybe<PromptFilterInput>;
  prompt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_not?: InputMaybe<PromptFilterInput>;
  status?: InputMaybe<ArticleSummaryStatus>;
  status_in?: InputMaybe<Array<ArticleSummaryStatus>>;
  status_not?: InputMaybe<ArticleSummaryStatus>;
  status_not_in?: InputMaybe<Array<ArticleSummaryStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "Prompt" nodes' filter */
export type PromptFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<PromptFilterInput>>>;
  articleSummaries_every?: InputMaybe<ArticleSummaryFilterInput>;
  articleSummaries_none?: InputMaybe<ArticleSummaryFilterInput>;
  articleSummaries_some?: InputMaybe<ArticleSummaryFilterInput>;
  articleSummaryCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleSummaryCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleSummaryCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleSummaryCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleSummaryCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleSummaryCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  field?: InputMaybe<PromptField>;
  field_in?: InputMaybe<Array<PromptField>>;
  field_not?: InputMaybe<PromptField>;
  field_not_in?: InputMaybe<Array<PromptField>>;
  icon?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  icon_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  icon_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  icon_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  icon_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  icon_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  icon_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  label?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  label_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<PromptFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PromptFilterInput>>>;
};

export enum PromptField {
  Body = 'Body',
  Clickbait = 'Clickbait',
  DiscoverTitle = 'DiscoverTitle',
  Head = 'Head',
  Title = 'Title'
}

export enum ArticleSummaryStatus {
  Draft = 'Draft',
  Published = 'Published'
}

/** The "ArticleTaxonomy" nodes' filter */
export type ArticleTaxonomyFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleTaxonomyFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  NOT?: InputMaybe<ArticleTaxonomyFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTaxonomyFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  taxonomy?: InputMaybe<TaxonomyFilterInput>;
  taxonomy_not?: InputMaybe<TaxonomyFilterInput>;
};

/** The "Taxonomy" nodes' filter */
export type TaxonomyFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<TaxonomyFilterInput>>>;
  articleCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articleCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  articles_every?: InputMaybe<ArticleTaxonomyFilterInput>;
  articles_none?: InputMaybe<ArticleTaxonomyFilterInput>;
  articles_some?: InputMaybe<ArticleTaxonomyFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  level?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  level_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  level_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  level_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  level_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  level_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  level_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  level_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  level_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  level_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<TaxonomyFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<TaxonomyFilterInput>>>;
  provider?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  provider_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  provider_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  provider_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  provider_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  provider_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  provider_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  provider_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  provider_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  provider_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type?: InputMaybe<TaxonomyType>;
  type_in?: InputMaybe<Array<TaxonomyType>>;
  type_not?: InputMaybe<TaxonomyType>;
  type_not_in?: InputMaybe<Array<TaxonomyType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  version?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  version_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
};

export enum TaxonomyType {
  IAB = 'IAB',
  Semantic = 'Semantic'
}

/** The "ArticleUrl" nodes' filter */
export type ArticleUrlFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleUrlFilterInput>>>;
  article?: InputMaybe<ArticleFilterInput>;
  article_not?: InputMaybe<ArticleFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleUrlFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleUrlFilterInput>>>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  order_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  path_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  path_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "Article" by "id", "brandKey-format-publicId" or "brandKey-platform-platformId" */
export type ArticleUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<ArticleFormat>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters. */
  platformId?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** Unique per brand and format, may be part of the URL */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** An article */
export type Article = {
  __typename?: 'Article';
  /** Number of "authors" */
  authorCount: Scalars['UnsignedInt']['output'];
  authors: Array<ArticleAuthor>;
  body?: Maybe<Scalars['DraftJS']['output']>;
  /** The medias embedded in this article's body */
  bodyMedias?: Maybe<Scalars['JSONArray']['output']>;
  bodyPeople?: Maybe<Scalars['JSONArray']['output']>;
  brandKey: BrandKey;
  /** The canonical URL based on the user device and the server environment */
  canonical?: Maybe<Scalars['URL']['output']>;
  categories: Array<ArticleCategory>;
  /** Number of "categories" */
  categoryCount: Scalars['UnsignedInt']['output'];
  /** Number of "channels" */
  channelCount: Scalars['UnsignedInt']['output'];
  channels: Array<ArticleChannel>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<OneUser>;
  creatorId?: Maybe<Scalars['UUIDv4']['output']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of "events" */
  eventCount: Scalars['UnsignedInt']['output'];
  events: Array<ArticleEvent>;
  format: ArticleFormat;
  /** Number of "goodDealAiProcesses" */
  goodDealAiProcessCount: Scalars['UnsignedInt']['output'];
  goodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** Number of "guides" */
  guideCount: Scalars['UnsignedInt']['output'];
  guides: Array<ArticleGuide>;
  histories: Array<ArticleHistory>;
  /** Number of "histories" */
  historyCount: Scalars['UnsignedInt']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  isLocked: Scalars['Boolean']['output'];
  lead?: Maybe<Scalars['DraftJS']['output']>;
  live?: Maybe<Live>;
  /** The date and time of the document's locking */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<OneUser>;
  /** The ID of the user who locked the document */
  lockerId?: Maybe<Scalars['UUIDv4']['output']>;
  /** Number of "machineTags" */
  machineTagCount: Scalars['UnsignedInt']['output'];
  machineTags: Array<ArticleMachineTag>;
  medias?: Maybe<Scalars['JSONArray']['output']>;
  newsletterFlashSenderHistories: Array<NewsletterFlashSenderHistory>;
  /** Number of "openAiProcesses" */
  openAiProcessCount: Scalars['UnsignedInt']['output'];
  openAiProcesses: Array<OpenAiProcess>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 50 characters. */
  platformId?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** Unique per brand and format, may be part of the URL */
  publicId: Scalars['UnsignedInt']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of "pushes" */
  pushCount: Scalars['UnsignedInt']['output'];
  pushes: Array<Push>;
  /** Number of "qualifiers" */
  qualifierCount: Scalars['UnsignedInt']['output'];
  qualifiers: Array<ArticleQualifier>;
  /** Number of referers, the articles that reference this article in their body or medias */
  refererCount: Scalars['UnsignedInt']['output'];
  /** Get the referers, the articles that reference this article in their body or medias */
  referers?: Maybe<Array<Article>>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  source?: Maybe<Source>;
  status: ArticleStatus;
  summaries: Array<ArticleSummary>;
  /** Number of "summaries" */
  summaryCount: Scalars['UnsignedInt']['output'];
  /** Number of "tags" */
  tagCount: Scalars['UnsignedInt']['output'];
  tags: Array<ArticleTag>;
  taxonomies: Array<ArticleTaxonomy>;
  /** Number of "taxonomies" */
  taxonomyCount: Scalars['UnsignedInt']['output'];
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  /** Number of "urls" */
  urlCount: Scalars['UnsignedInt']['output'];
  urls: Array<ArticleUrl>;
};


/** An article */
export type ArticleAuthorCountArgs = {
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


/** An article */
export type ArticleAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


/** An article */
export type ArticleCanonicalArgs = {
  device?: Device;
  env?: Env;
};


/** An article */
export type ArticleCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


/** An article */
export type ArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


/** An article */
export type ArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelFilterInput>;
};


/** An article */
export type ArticleChannelsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};


/** An article */
export type ArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventFilterInput>;
};


/** An article */
export type ArticleEventsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleEventFilterInput>;
};


/** An article */
export type ArticleGoodDealAiProcessCountArgs = {
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


/** An article */
export type ArticleGoodDealAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


/** An article */
export type ArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideFilterInput>;
};


/** An article */
export type ArticleGuidesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};


/** An article */
export type ArticleHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleHistoryFilterInput>;
};


/** An article */
export type ArticleHistoryCountArgs = {
  where?: InputMaybe<ArticleHistoryFilterInput>;
};


/** An article */
export type ArticleMachineTagCountArgs = {
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


/** An article */
export type ArticleMachineTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


/** An article */
export type ArticleOpenAiProcessCountArgs = {
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


/** An article */
export type ArticleOpenAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


/** An article */
export type ArticlePushCountArgs = {
  where?: InputMaybe<PushFilterInput>;
};


/** An article */
export type ArticlePushesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushFilterInput>;
};


/** An article */
export type ArticleQualifierCountArgs = {
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


/** An article */
export type ArticleQualifiersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


/** An article */
export type ArticleRefererCountArgs = {
  like?: InputMaybe<ArticleLikeInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  where?: InputMaybe<ArticleFilterSearchInput>;
};


/** An article */
export type ArticleReferersArgs = {
  first: Scalars['UnsignedInt']['input'];
  like?: InputMaybe<ArticleLikeInput>;
  orderBy?: InputMaybe<Array<ArticleOrderingSearchInput>>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleFilterSearchInput>;
};


/** An article */
export type ArticleSummariesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleSummaryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


/** An article */
export type ArticleSummaryCountArgs = {
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


/** An article */
export type ArticleTagCountArgs = {
  where?: InputMaybe<ArticleTagFilterInput>;
};


/** An article */
export type ArticleTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTagFilterInput>;
};


/** An article */
export type ArticleTaxonomiesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


/** An article */
export type ArticleTaxonomyCountArgs = {
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


/** An article */
export type ArticleUrlCountArgs = {
  where?: InputMaybe<ArticleUrlFilterInput>;
};


/** An article */
export type ArticleUrlsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleUrlOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleUrlFilterInput>;
};

/** Order the "ArticleAuthor" nodes */
export enum ArticleAuthorOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleAuthor = {
  __typename?: 'ArticleAuthor';
  article: Article;
  author: Author;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

export type Author = {
  __typename?: 'Author';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<ArticleAuthor>;
  /** The usage of this "Author" in rich and published articles. */
  articleUsage: ArticleUsage;
  /** Number of "attributes" */
  attributeCount: Scalars['UnsignedInt']['output'];
  attributes: Array<AuthorAttribute>;
  avatarUrl?: Maybe<Scalars['URL']['output']>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  facebookId?: Maybe<Scalars['ID']['output']>;
  googleId?: Maybe<Scalars['ID']['output']>;
  /** Either the author should have a dedicated page or not. */
  hasPublicProfile: Scalars['Boolean']['output'];
  histories: Array<AuthorHistory>;
  /** Number of "histories" */
  historyCount: Scalars['UnsignedInt']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  instagramId?: Maybe<Scalars['ID']['output']>;
  /** An author is active if he appears on at least 5 recent, rich & published articles. */
  isActive: Scalars['Boolean']['output'];
  /** Is this author a freelance ? */
  isExternal: Scalars['Boolean']['output'];
  /** Is it the main author of his user? */
  isMain: Scalars['Boolean']['output'];
  linkedinId?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<Scalars['JSONObject']['output']>;
  /** At most 200 characters with at least 2 alphanumeric characters. */
  name: Scalars['NonEmptySanitizedString']['output'];
  pinterestId?: Maybe<Scalars['ID']['output']>;
  recipeUsage?: Maybe<RecipeAuthorUsage>;
  resume?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** At most 200 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  snapchatId?: Maybe<Scalars['ID']['output']>;
  twitterId?: Maybe<Scalars['ID']['output']>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<OneUser>;
  userId?: Maybe<Scalars['UUIDv4']['output']>;
};


export type AuthorArticleCountArgs = {
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type AuthorArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type AuthorArticleUsageArgs = {
  maxAge?: Scalars['UnsignedInt']['input'];
};


export type AuthorAttributeCountArgs = {
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type AuthorAttributesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type AuthorHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorHistoryFilterInput>;
};


export type AuthorHistoryCountArgs = {
  where?: InputMaybe<AuthorHistoryFilterInput>;
};

/** The usage of a node in rich and published articles */
export type ArticleUsage = {
  __typename?: 'ArticleUsage';
  /** The number of linked articles in the last 6 months. */
  recent: Scalars['UnsignedInt']['output'];
  /** The total number of linked articles. */
  total: Scalars['UnsignedInt']['output'];
};

/** Order the "AuthorAttribute" nodes */
export enum AuthorAttributeOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type AuthorAttribute = {
  __typename?: 'AuthorAttribute';
  attribute: Attribute;
  author: Author;
  /** Order for a given "author", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

export type Attribute = {
  __typename?: 'Attribute';
  /** Number of "authors" */
  authorCount: Scalars['UnsignedInt']['output'];
  authors: Array<AuthorAttribute>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type AttributeAuthorCountArgs = {
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type AttributeAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};

/** Order the "AuthorHistory" nodes */
export enum AuthorHistoryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

export type AuthorHistory = {
  __typename?: 'AuthorHistory';
  author: Author;
  changes: Scalars['JSONArray']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  snapshot: Scalars['JSONObject']['output'];
  user?: Maybe<User>;
};

export type User = OneUser | SystemUser;

export type OneUser = {
  __typename?: 'OneUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['EmailAddress']['output'];
  id: Scalars['UUIDv4']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SystemUser = {
  __typename?: 'SystemUser';
  name: Scalars['NonEmptyTrimmedString']['output'];
};

export type RecipeAuthorUsage = {
  __typename?: 'RecipeAuthorUsage';
  /** The number of recipes written by this author published in the last 6 months. */
  recent: Scalars['UnsignedInt']['output'];
  /** The total number of recipes written by this author. */
  total: Scalars['UnsignedInt']['output'];
};

export enum Device {
  Desktop = 'Desktop',
  Mobile = 'Mobile'
}

export enum Env {
  PRD2 = 'PRD2',
  REC1 = 'REC1',
  REC2 = 'REC2',
  REC3 = 'REC3'
}

/** Order the "ArticleCategory" nodes */
export enum ArticleCategoryOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleCategory = {
  __typename?: 'ArticleCategory';
  article: Article;
  category: Category;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

export type Category = {
  __typename?: 'Category';
  articleCategories: Array<ArticleCategory>;
  /** Number of "articleCategories" */
  articleCategoryCount: Scalars['UnsignedInt']['output'];
  /** Number of "articleChannels" */
  articleChannelCount: Scalars['UnsignedInt']['output'];
  articleChannels: Array<ArticleChannel>;
  /** Number of "articleEvents" */
  articleEventCount: Scalars['UnsignedInt']['output'];
  articleEvents: Array<ArticleEvent>;
  /** Number of "articleGuides" */
  articleGuideCount: Scalars['UnsignedInt']['output'];
  articleGuides: Array<ArticleGuide>;
  body?: Maybe<Scalars['DraftJS']['output']>;
  bodyMedias?: Maybe<Scalars['JSONArray']['output']>;
  brandKey: BrandKey;
  /** The canonical URL based on the user device and the server environment */
  canonical?: Maybe<Scalars['URL']['output']>;
  /** Number of "cards" */
  cardCount: Scalars['UnsignedInt']['output'];
  cards: Array<CardCategory>;
  /** Number of "children" */
  childCount: Scalars['UnsignedInt']['output'];
  children: Array<Category>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  format: CategoryFormat;
  histories: Array<CategoryHistory>;
  /** Number of "histories" */
  historyCount: Scalars['UnsignedInt']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  isHeadlined: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** From 0 to 5, included */
  level: Scalars['UnsignedInt']['output'];
  /** The date and time of the document's locking */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<OneUser>;
  /** The ID of the user who locked the document */
  lockerId?: Maybe<Scalars['UUIDv4']['output']>;
  /** The maximum number of articles to generate for this category */
  maxBoardPinned?: Maybe<Scalars['UnsignedInt']['output']>;
  medias?: Maybe<Scalars['JSONArray']['output']>;
  metas?: Maybe<Scalars['JSONObject']['output']>;
  /** The minimum number of articles to generate for this category */
  minBoardPinned?: Maybe<Scalars['UnsignedInt']['output']>;
  order: Scalars['UnsignedInt']['output'];
  parent?: Maybe<Category>;
  /** Unique per brand and format, may be part of the URL */
  publicId: Scalars['UnsignedInt']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  status: CategoryStatus;
  subtitle?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** Number of "tabs" */
  tabCount: Scalars['UnsignedInt']['output'];
  tabs: Array<Tab>;
  /** Number of "tags" */
  tagCount: Scalars['UnsignedInt']['output'];
  tags: Array<CategoryTag>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  /** Number of "urls" */
  urlCount: Scalars['UnsignedInt']['output'];
  urls: Array<CategoryUrl>;
};


export type CategoryArticleCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type CategoryArticleCategoryCountArgs = {
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type CategoryArticleChannelCountArgs = {
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type CategoryArticleChannelsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type CategoryArticleEventCountArgs = {
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type CategoryArticleEventsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type CategoryArticleGuideCountArgs = {
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type CategoryArticleGuidesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type CategoryCanonicalArgs = {
  device?: Device;
  env?: Env;
};


export type CategoryCardCountArgs = {
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type CategoryCardsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type CategoryChildCountArgs = {
  where?: InputMaybe<CategoryFilterInput>;
};


export type CategoryChildrenArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryFilterInput>;
};


export type CategoryHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryHistoryFilterInput>;
};


export type CategoryHistoryCountArgs = {
  where?: InputMaybe<CategoryHistoryFilterInput>;
};


export type CategoryTabCountArgs = {
  where?: InputMaybe<TabFilterInput>;
};


export type CategoryTabsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TabOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TabFilterInput>;
};


export type CategoryTagCountArgs = {
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type CategoryTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type CategoryUrlCountArgs = {
  where?: InputMaybe<CategoryUrlFilterInput>;
};


export type CategoryUrlsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryUrlFilterInput>;
};

/** Order the "ArticleChannel" nodes */
export enum ArticleChannelOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleChannel = {
  __typename?: 'ArticleChannel';
  article: Article;
  category: Category;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

/** Order the "ArticleEvent" nodes */
export enum ArticleEventOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleEvent = {
  __typename?: 'ArticleEvent';
  article: Article;
  category: Category;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

/** Order the "ArticleGuide" nodes */
export enum ArticleGuideOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleGuide = {
  __typename?: 'ArticleGuide';
  article: Article;
  category: Category;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

/** Order the "CardCategory" nodes */
export enum CardCategoryOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type CardCategory = {
  __typename?: 'CardCategory';
  card: Card;
  category: Category;
  /** Order for a given "card", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

export type Card = {
  __typename?: 'Card';
  body?: Maybe<Scalars['DraftJS']['output']>;
  brandKey: BrandKey;
  categories: Array<CardCategory>;
  /** Number of "categories" */
  categoryCount: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 700 characters with at least 2 alphanumeric characters. */
  label: Scalars['NonEmptySanitizedString']['output'];
  media?: Maybe<Scalars['JSONObject']['output']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  status: CardStatus;
  /** Number of "tags" */
  tagCount: Scalars['UnsignedInt']['output'];
  tags: Array<CardTag>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};


export type CardCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type CardCategoryCountArgs = {
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type CardTagCountArgs = {
  where?: InputMaybe<CardTagFilterInput>;
};


export type CardTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardTagFilterInput>;
};

/** Order the "CardTag" nodes */
export enum CardTagOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type CardTag = {
  __typename?: 'CardTag';
  card: Card;
  /** Order for a given "card", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  tag: Tag;
};

export type Tag = {
  __typename?: 'Tag';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<ArticleTag>;
  /** The cache used by the "articleUsage" virtual-field */
  articleUsageCache?: Maybe<Scalars['JSONObject']['output']>;
  /** The usages of this "Tag" in rich and published articles, by brand. */
  articleUsages: Array<BrandedArticleUsage>;
  /** Number of "brandedContents" */
  brandedContentCount: Scalars['UnsignedInt']['output'];
  brandedContents: Array<TagBrandedContent>;
  /** Number of "cards" */
  cardCount: Scalars['UnsignedInt']['output'];
  cards: Array<CardTag>;
  categories: Array<CategoryTag>;
  /** Number of "categories" */
  categoryCount: Scalars['UnsignedInt']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** @deprecated The "isActive" virtual-field is deprecated */
  isActive: Scalars['Boolean']['output'];
  lang: TagLang;
  relationId?: Maybe<Scalars['UUID']['output']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  type: TagType;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type TagArticleCountArgs = {
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type TagArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type TagArticleUsagesArgs = {
  brandKeys?: Array<InputMaybe<BrandKey>>;
  maxAge?: Scalars['UnsignedInt']['input'];
};


export type TagBrandedContentCountArgs = {
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type TagBrandedContentsArgs = {
  first?: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type TagCardCountArgs = {
  where?: InputMaybe<CardTagFilterInput>;
};


export type TagCardsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CardTagFilterInput>;
};


export type TagCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type TagCategoryCountArgs = {
  where?: InputMaybe<CategoryTagFilterInput>;
};

/** Order the "ArticleTag" nodes */
export enum ArticleTagOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleTag = {
  __typename?: 'ArticleTag';
  article: Article;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  tag: Tag;
};

/** The usage of a node in rich and published articles, by brand */
export type BrandedArticleUsage = {
  __typename?: 'BrandedArticleUsage';
  brandKey: BrandKey;
  /** The number of linked articles in the last 6 months. */
  recent: Scalars['UnsignedInt']['output'];
  /** The total number of linked articles. */
  total: Scalars['UnsignedInt']['output'];
};

/** Order the "TagBrandedContent" nodes */
export enum TagBrandedContentOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "histories" to the highest */
  historyCount_ASC = 'historyCount_ASC',
  /** from the highest number of "histories" to the lowest */
  historyCount_DESC = 'historyCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "lockedAt" to the highest */
  lockedAt_ASC = 'lockedAt_ASC',
  /** from the highest "lockedAt" to the lowest */
  lockedAt_DESC = 'lockedAt_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TagBrandedContent = {
  __typename?: 'TagBrandedContent';
  body?: Maybe<Scalars['DraftJS']['output']>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  histories: Array<TagBrandedContentHistory>;
  /** Number of "histories" */
  historyCount: Scalars['UnsignedInt']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** The tag is active if it is published and appears on at least 5 rich & published articles. */
  isActive: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** The date and time of the document's locking */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<OneUser>;
  /** The ID of the user who locked the document */
  lockerId?: Maybe<Scalars['UUIDv4']['output']>;
  media?: Maybe<Scalars['JSONObject']['output']>;
  status: TagBrandedContentStatus;
  tag: Tag;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type TagBrandedContentHistoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentHistoryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<TagBrandedContentHistoryFilterInput>;
};


export type TagBrandedContentHistoryCountArgs = {
  where?: InputMaybe<TagBrandedContentHistoryFilterInput>;
};

/** Order the "TagBrandedContentHistory" nodes */
export enum TagBrandedContentHistoryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

export type TagBrandedContentHistory = {
  __typename?: 'TagBrandedContentHistory';
  changes: Scalars['JSONArray']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  snapshot: Scalars['JSONObject']['output'];
  tagBrandedContent: TagBrandedContent;
  user?: Maybe<User>;
};

/** Order the "CategoryTag" nodes */
export enum CategoryTagOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type CategoryTag = {
  __typename?: 'CategoryTag';
  category: Category;
  /** Order for a given "category", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  tag: Tag;
};

/** Order the "Category" nodes */
export enum CategoryOrderingInput {
  /** from the lowest number of "articleCategories" to the highest */
  articleCategoryCount_ASC = 'articleCategoryCount_ASC',
  /** from the highest number of "articleCategories" to the lowest */
  articleCategoryCount_DESC = 'articleCategoryCount_DESC',
  /** from the lowest number of "articleChannels" to the highest */
  articleChannelCount_ASC = 'articleChannelCount_ASC',
  /** from the highest number of "articleChannels" to the lowest */
  articleChannelCount_DESC = 'articleChannelCount_DESC',
  /** from the lowest number of "articleEvents" to the highest */
  articleEventCount_ASC = 'articleEventCount_ASC',
  /** from the highest number of "articleEvents" to the lowest */
  articleEventCount_DESC = 'articleEventCount_DESC',
  /** from the lowest number of "articleGuides" to the highest */
  articleGuideCount_ASC = 'articleGuideCount_ASC',
  /** from the highest number of "articleGuides" to the lowest */
  articleGuideCount_DESC = 'articleGuideCount_DESC',
  /** from the lowest number of "cards" to the highest */
  cardCount_ASC = 'cardCount_ASC',
  /** from the highest number of "cards" to the lowest */
  cardCount_DESC = 'cardCount_DESC',
  /** from the lowest number of "children" to the highest */
  childCount_ASC = 'childCount_ASC',
  /** from the highest number of "children" to the lowest */
  childCount_DESC = 'childCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "editedAt" to the highest */
  editedAt_ASC = 'editedAt_ASC',
  /** from the highest "editedAt" to the lowest */
  editedAt_DESC = 'editedAt_DESC',
  /** from the lowest number of "histories" to the highest */
  historyCount_ASC = 'historyCount_ASC',
  /** from the highest number of "histories" to the lowest */
  historyCount_DESC = 'historyCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "level" to the highest */
  level_ASC = 'level_ASC',
  /** from the highest "level" to the lowest */
  level_DESC = 'level_DESC',
  /** from the lowest "lockedAt" to the highest */
  lockedAt_ASC = 'lockedAt_ASC',
  /** from the highest "lockedAt" to the lowest */
  lockedAt_DESC = 'lockedAt_DESC',
  /** from the lowest "maxBoardPinned" to the highest */
  maxBoardPinned_ASC = 'maxBoardPinned_ASC',
  /** from the highest "maxBoardPinned" to the lowest */
  maxBoardPinned_DESC = 'maxBoardPinned_DESC',
  /** from the lowest "minBoardPinned" to the highest */
  minBoardPinned_ASC = 'minBoardPinned_ASC',
  /** from the highest "minBoardPinned" to the lowest */
  minBoardPinned_DESC = 'minBoardPinned_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest "publicId" to the highest */
  publicId_ASC = 'publicId_ASC',
  /** from the highest "publicId" to the lowest */
  publicId_DESC = 'publicId_DESC',
  /** from the lowest "publishedAt" to the highest */
  publishedAt_ASC = 'publishedAt_ASC',
  /** from the highest "publishedAt" to the lowest */
  publishedAt_DESC = 'publishedAt_DESC',
  /** from the lowest number of "tabs" to the highest */
  tabCount_ASC = 'tabCount_ASC',
  /** from the highest number of "tabs" to the lowest */
  tabCount_DESC = 'tabCount_DESC',
  /** from the lowest number of "tags" to the highest */
  tagCount_ASC = 'tagCount_ASC',
  /** from the highest number of "tags" to the lowest */
  tagCount_DESC = 'tagCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "urls" to the highest */
  urlCount_ASC = 'urlCount_ASC',
  /** from the highest number of "urls" to the lowest */
  urlCount_DESC = 'urlCount_DESC'
}

/** Order the "CategoryHistory" nodes */
export enum CategoryHistoryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

export type CategoryHistory = {
  __typename?: 'CategoryHistory';
  category: Category;
  changes: Scalars['JSONArray']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  snapshot: Scalars['JSONObject']['output'];
  user?: Maybe<User>;
};

/** Order the "Tab" nodes */
export enum TabOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Tab = {
  __typename?: 'Tab';
  category: Category;
  content?: Maybe<Scalars['JSONValue']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  disabledLabel?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  enabledLabel?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  isOnline: Scalars['Boolean']['output'];
  metas?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** Order for a given "category", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  type: TabType;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Order the "CategoryUrl" nodes */
export enum CategoryUrlOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type CategoryUrl = {
  __typename?: 'CategoryUrl';
  category: Category;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** Order for a given "category", in the interval [0, 9] */
  order: Scalars['UnsignedInt']['output'];
  origin: Scalars['URL']['output'];
  path: Scalars['NonEmptyTrimmedString']['output'];
  status: HttpStatus;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type CategoryUrlOriginArgs = {
  device?: Device;
  env?: Env;
};


/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type CategoryUrlStatusArgs = {
  device?: Device;
  env?: Env;
};

export type HttpStatus = {
  __typename?: 'HTTPStatus';
  /** The status code of the response. (This will be 200 for a success). */
  code: Scalars['UnsignedInt']['output'];
  /** A boolean indicating whether the response was successful ("code" in the range 200-299) or not. */
  ok: Scalars['Boolean']['output'];
  /** The status message corresponding to the status code. (e.g., OK for 200). */
  text: Scalars['NonEmptyTrimmedString']['output'];
  /** The final URL reached after following redirects. (This will be the same as the input URL if no redirects were followed.) */
  url: Scalars['URL']['output'];
};

/** Order the "ArticleGoodDealAiProcess" nodes */
export enum ArticleGoodDealAiProcessOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Article Good Deal AI Process */
export type ArticleGoodDealAiProcess = {
  __typename?: 'ArticleGoodDealAiProcess';
  article?: Maybe<Article>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  productTitle?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  productUrl: Scalars['URL']['output'];
  status?: Maybe<ArticleGoodDealAiProcessStatus>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['UUIDv4']['output']>;
};

/** Order the "ArticleHistory" nodes */
export enum ArticleHistoryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

export type ArticleHistory = {
  __typename?: 'ArticleHistory';
  article: Article;
  changes: Scalars['JSONArray']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  snapshot: Scalars['JSONObject']['output'];
  user?: Maybe<User>;
};

export type Live = {
  __typename?: 'Live';
  article: Article;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** Number of "posts" */
  postCount: Scalars['UnsignedInt']['output'];
  posts: Array<LivePost>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type LivePostCountArgs = {
  where?: InputMaybe<LivePostFilterInput>;
};


export type LivePostsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<LivePostFilterInput>;
};

/** Order the "LivePost" nodes */
export enum LivePostOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "publishedAt" to the highest */
  publishedAt_ASC = 'publishedAt_ASC',
  /** from the highest "publishedAt" to the lowest */
  publishedAt_DESC = 'publishedAt_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LivePost = {
  __typename?: 'LivePost';
  body?: Maybe<Scalars['DraftJS']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<OneUser>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  live: Live;
  publishedAt: Scalars['DateTime']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Order the "ArticleMachineTag" nodes */
export enum ArticleMachineTagOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleMachineTag = {
  __typename?: 'ArticleMachineTag';
  article: Article;
  machineTag: MachineTag;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
};

/**
 * A "triple-tag" or "machine-tag" uses a special syntax to define extra semantic
 * information about the tag, making it easier or more meaningful for
 * interpretation by a computer program. Triple tags comprise three parts: a
 * namespace, a predicate and a value.
 */
export type MachineTag = {
  __typename?: 'MachineTag';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<ArticleMachineTag>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  tag: Scalars['NonEmptyTrimmedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * A "triple-tag" or "machine-tag" uses a special syntax to define extra semantic
 * information about the tag, making it easier or more meaningful for
 * interpretation by a computer program. Triple tags comprise three parts: a
 * namespace, a predicate and a value.
 */
export type MachineTagArticleCountArgs = {
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


/**
 * A "triple-tag" or "machine-tag" uses a special syntax to define extra semantic
 * information about the tag, making it easier or more meaningful for
 * interpretation by a computer program. Triple tags comprise three parts: a
 * namespace, a predicate and a value.
 */
export type MachineTagArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};

export type NewsletterFlashSenderHistory = {
  __typename?: 'NewsletterFlashSenderHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUIDv4']['output'];
};

/** Order the "OpenAiProcess" nodes */
export enum OpenAiProcessOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "recipeNumber" to the highest */
  recipeNumber_ASC = 'recipeNumber_ASC',
  /** from the highest "recipeNumber" to the lowest */
  recipeNumber_DESC = 'recipeNumber_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Slideshow generation AI Process */
export type OpenAiProcess = {
  __typename?: 'OpenAiProcess';
  article?: Maybe<Article>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  generatedTitle?: Maybe<Scalars['String']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  recipeNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  recipePaths?: Maybe<Scalars['String']['output']>;
  slideshowSubject?: Maybe<Scalars['String']['output']>;
  status: OpenAiProcessStatus;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Order the "Push" nodes */
export enum PushOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "scheduledAt" to the highest */
  scheduledAt_ASC = 'scheduledAt_ASC',
  /** from the highest "scheduledAt" to the lowest */
  scheduledAt_DESC = 'scheduledAt_DESC',
  /** from the lowest number of "segments" to the highest */
  segmentCount_ASC = 'segmentCount_ASC',
  /** from the highest number of "segments" to the lowest */
  segmentCount_DESC = 'segmentCount_DESC',
  /** from the lowest "sentAt" to the highest */
  sentAt_ASC = 'sentAt_ASC',
  /** from the highest "sentAt" to the lowest */
  sentAt_DESC = 'sentAt_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Push = {
  __typename?: 'Push';
  article: Article;
  body: Scalars['NonEmptyTrimmedString']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  errorReason?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  inError: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  media: Scalars['URL']['output'];
  scheduledAt: Scalars['DateTime']['output'];
  /** Number of "segments" */
  segmentCount: Scalars['UnsignedInt']['output'];
  segments: Array<PushSegment>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  targetDevice: Scalars['NonEmptyTrimmedString']['output'];
  targeting?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<OneUser>;
  userId: Scalars['UUIDv4']['output'];
};


export type PushSegmentCountArgs = {
  where?: InputMaybe<PushSegmentFilterInput>;
};


export type PushSegmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushSegmentFilterInput>;
};

export type PushSegment = {
  __typename?: 'PushSegment';
  push: Push;
  segment: Segment;
};

export type Segment = {
  __typename?: 'Segment';
  active?: Maybe<Scalars['Boolean']['output']>;
  android?: Maybe<Scalars['JSONObject']['output']>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  device?: Maybe<Scalars['NonEmptySanitizedString']['output']>;
  editorialAlert?: Maybe<Scalars['JSONObject']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  ios?: Maybe<Scalars['JSONObject']['output']>;
  /** Number of "pushes" */
  pushCount: Scalars['UnsignedInt']['output'];
  pushes: Array<PushSegment>;
  status: SegmentStatus;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type SegmentPushCountArgs = {
  where?: InputMaybe<PushSegmentFilterInput>;
};


export type SegmentPushesArgs = {
  first: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushSegmentFilterInput>;
};

/** Order the "ArticleQualifier" nodes */
export enum ArticleQualifierOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleQualifier = {
  __typename?: 'ArticleQualifier';
  article: Article;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  qualifier: Qualifier;
};

export type Qualifier = {
  __typename?: 'Qualifier';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<ArticleQualifier>;
  /** The usage of this "Qualifier" in rich and published articles. */
  articleUsage: ArticleUsage;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  format: ArticleFormat;
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  status: QualifierStatus;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type QualifierArticleCountArgs = {
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type QualifierArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type QualifierArticleUsageArgs = {
  maxAge?: Scalars['UnsignedInt']['input'];
};

/** The "Article" nodes' more-like-this input type */
export type ArticleLikeInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  format?: InputMaybe<ArticleFormat>;
  id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lead?: InputMaybe<Scalars['DraftJS']['input']>;
  status?: InputMaybe<ArticleStatus>;
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

/** Filter the "Articles"' search results */
export type ArticleFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleFilterSearchInput>>>;
  authors_every?: InputMaybe<ArticleAuthorsFilterSearchInput>;
  authors_none?: InputMaybe<ArticleAuthorsFilterSearchInput>;
  authors_some?: InputMaybe<ArticleAuthorsFilterSearchInput>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  bodyMedias_canonical?: InputMaybe<Scalars['URL']['input']>;
  bodyMedias_credit?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  bodyMedias_site?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  bodyMedias_source?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  bodyPeople_fullName?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  bodyPeople_id?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  categories_every?: InputMaybe<ArticleCategoriesFilterSearchInput>;
  categories_none?: InputMaybe<ArticleCategoriesFilterSearchInput>;
  categories_some?: InputMaybe<ArticleCategoriesFilterSearchInput>;
  channels_every?: InputMaybe<ArticleChannelsFilterSearchInput>;
  channels_none?: InputMaybe<ArticleChannelsFilterSearchInput>;
  channels_some?: InputMaybe<ArticleChannelsFilterSearchInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['UUIDv4']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUIDv4']['input']>>>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  events_every?: InputMaybe<ArticleEventsFilterSearchInput>;
  events_none?: InputMaybe<ArticleEventsFilterSearchInput>;
  events_some?: InputMaybe<ArticleEventsFilterSearchInput>;
  format?: InputMaybe<ArticleFormat>;
  format_in?: InputMaybe<Array<ArticleFormat>>;
  format_not?: InputMaybe<ArticleFormat>;
  format_not_in?: InputMaybe<Array<ArticleFormat>>;
  guides_every?: InputMaybe<ArticleGuidesFilterSearchInput>;
  guides_none?: InputMaybe<ArticleGuidesFilterSearchInput>;
  guides_some?: InputMaybe<ArticleGuidesFilterSearchInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lead?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  lead_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  live?: InputMaybe<ArticleLiveFilterSearchInput>;
  live_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  live_not?: InputMaybe<ArticleLiveFilterSearchInput>;
  machineTags_every?: InputMaybe<ArticleMachineTagsFilterSearchInput>;
  machineTags_none?: InputMaybe<ArticleMachineTagsFilterSearchInput>;
  machineTags_some?: InputMaybe<ArticleMachineTagsFilterSearchInput>;
  medias_canonical?: InputMaybe<Scalars['URL']['input']>;
  medias_credit?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  medias_site?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  medias_source?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  NOT?: InputMaybe<ArticleFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleFilterSearchInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushes_every?: InputMaybe<ArticlePushesFilterSearchInput>;
  pushes_none?: InputMaybe<ArticlePushesFilterSearchInput>;
  pushes_some?: InputMaybe<ArticlePushesFilterSearchInput>;
  qualifiers_every?: InputMaybe<ArticleQualifiersFilterSearchInput>;
  qualifiers_none?: InputMaybe<ArticleQualifiersFilterSearchInput>;
  qualifiers_some?: InputMaybe<ArticleQualifiersFilterSearchInput>;
  source?: InputMaybe<ArticleSourceFilterSearchInput>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  source_not?: InputMaybe<ArticleSourceFilterSearchInput>;
  status?: InputMaybe<ArticleStatus>;
  status_in?: InputMaybe<Array<ArticleStatus>>;
  status_not?: InputMaybe<ArticleStatus>;
  status_not_in?: InputMaybe<Array<ArticleStatus>>;
  tags_every?: InputMaybe<ArticleTagsFilterSearchInput>;
  tags_none?: InputMaybe<ArticleTagsFilterSearchInput>;
  tags_some?: InputMaybe<ArticleTagsFilterSearchInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  urls_every?: InputMaybe<ArticleUrlsFilterSearchInput>;
  urls_none?: InputMaybe<ArticleUrlsFilterSearchInput>;
  urls_some?: InputMaybe<ArticleUrlsFilterSearchInput>;
};

/** Filter the "ArticleAuthors"' search results */
export type ArticleAuthorsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleAuthorsFilterSearchInput>>>;
  author?: InputMaybe<ArticleAuthorsAuthorFilterSearchInput>;
  author_not?: InputMaybe<ArticleAuthorsAuthorFilterSearchInput>;
  NOT?: InputMaybe<ArticleAuthorsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleAuthorsFilterSearchInput>>>;
};

/** Filter the "Authors"' search results */
export type ArticleAuthorsAuthorFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleAuthorsAuthorFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  name_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  NOT?: InputMaybe<ArticleAuthorsAuthorFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleAuthorsAuthorFilterSearchInput>>>;
};

/** Filter the "ArticleCategories"' search results */
export type ArticleCategoriesFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleCategoriesFilterSearchInput>>>;
  category?: InputMaybe<ArticleCategoriesCategoryFilterSearchInput>;
  category_not?: InputMaybe<ArticleCategoriesCategoryFilterSearchInput>;
  NOT?: InputMaybe<ArticleCategoriesFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleCategoriesFilterSearchInput>>>;
};

/** Filter the "Categories"' search results */
export type ArticleCategoriesCategoryFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleCategoriesCategoryFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleCategoriesCategoryFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleCategoriesCategoryFilterSearchInput>>>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleChannels"' search results */
export type ArticleChannelsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleChannelsFilterSearchInput>>>;
  category?: InputMaybe<ArticleChannelsCategoryFilterSearchInput>;
  category_not?: InputMaybe<ArticleChannelsCategoryFilterSearchInput>;
  NOT?: InputMaybe<ArticleChannelsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleChannelsFilterSearchInput>>>;
};

/** Filter the "Categories"' search results */
export type ArticleChannelsCategoryFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleChannelsCategoryFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleChannelsCategoryFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleChannelsCategoryFilterSearchInput>>>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleEvents"' search results */
export type ArticleEventsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleEventsFilterSearchInput>>>;
  category?: InputMaybe<ArticleEventsCategoryFilterSearchInput>;
  category_not?: InputMaybe<ArticleEventsCategoryFilterSearchInput>;
  NOT?: InputMaybe<ArticleEventsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleEventsFilterSearchInput>>>;
};

/** Filter the "Categories"' search results */
export type ArticleEventsCategoryFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleEventsCategoryFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleEventsCategoryFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleEventsCategoryFilterSearchInput>>>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleGuides"' search results */
export type ArticleGuidesFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleGuidesFilterSearchInput>>>;
  category?: InputMaybe<ArticleGuidesCategoryFilterSearchInput>;
  category_not?: InputMaybe<ArticleGuidesCategoryFilterSearchInput>;
  NOT?: InputMaybe<ArticleGuidesFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleGuidesFilterSearchInput>>>;
};

/** Filter the "Categories"' search results */
export type ArticleGuidesCategoryFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleGuidesCategoryFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  format?: InputMaybe<CategoryFormat>;
  format_in?: InputMaybe<Array<CategoryFormat>>;
  format_not?: InputMaybe<CategoryFormat>;
  format_not_in?: InputMaybe<Array<CategoryFormat>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleGuidesCategoryFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleGuidesCategoryFilterSearchInput>>>;
  status?: InputMaybe<CategoryStatus>;
  status_in?: InputMaybe<Array<CategoryStatus>>;
  status_not?: InputMaybe<CategoryStatus>;
  status_not_in?: InputMaybe<Array<CategoryStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "Lives"' search results */
export type ArticleLiveFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleLiveFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleLiveFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleLiveFilterSearchInput>>>;
  posts_every?: InputMaybe<ArticleLivePostsFilterSearchInput>;
  posts_none?: InputMaybe<ArticleLivePostsFilterSearchInput>;
  posts_some?: InputMaybe<ArticleLivePostsFilterSearchInput>;
};

/** Filter the "LivePosts"' search results */
export type ArticleLivePostsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleLivePostsFilterSearchInput>>>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  body_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleLivePostsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleLivePostsFilterSearchInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleMachineTags"' search results */
export type ArticleMachineTagsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleMachineTagsFilterSearchInput>>>;
  machineTag?: InputMaybe<ArticleMachineTagsMachineTagFilterSearchInput>;
  machineTag_not?: InputMaybe<ArticleMachineTagsMachineTagFilterSearchInput>;
  NOT?: InputMaybe<ArticleMachineTagsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleMachineTagsFilterSearchInput>>>;
};

/** Filter the "MachineTags"' search results */
export type ArticleMachineTagsMachineTagFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleMachineTagsMachineTagFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleMachineTagsMachineTagFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleMachineTagsMachineTagFilterSearchInput>>>;
  tag?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tag_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "Pushes"' search results */
export type ArticlePushesFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticlePushesFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticlePushesFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticlePushesFilterSearchInput>>>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleQualifiers"' search results */
export type ArticleQualifiersFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleQualifiersFilterSearchInput>>>;
  NOT?: InputMaybe<ArticleQualifiersFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleQualifiersFilterSearchInput>>>;
  qualifier?: InputMaybe<ArticleQualifiersQualifierFilterSearchInput>;
  qualifier_not?: InputMaybe<ArticleQualifiersQualifierFilterSearchInput>;
};

/** Filter the "Qualifiers"' search results */
export type ArticleQualifiersQualifierFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleQualifiersQualifierFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleQualifiersQualifierFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleQualifiersQualifierFilterSearchInput>>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "Sources"' search results */
export type ArticleSourceFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleSourceFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleSourceFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleSourceFilterSearchInput>>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Filter the "ArticleTags"' search results */
export type ArticleTagsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleTagsFilterSearchInput>>>;
  NOT?: InputMaybe<ArticleTagsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTagsFilterSearchInput>>>;
  tag?: InputMaybe<ArticleTagsTagFilterSearchInput>;
  tag_not?: InputMaybe<ArticleTagsTagFilterSearchInput>;
};

/** Filter the "Tags"' search results */
export type ArticleTagsTagFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleTagsTagFilterSearchInput>>>;
  brandedContents_every?: InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>;
  brandedContents_none?: InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>;
  brandedContents_some?: InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lang?: InputMaybe<TagLang>;
  lang_in?: InputMaybe<Array<TagLang>>;
  lang_not?: InputMaybe<TagLang>;
  lang_not_in?: InputMaybe<Array<TagLang>>;
  NOT?: InputMaybe<ArticleTagsTagFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTagsTagFilterSearchInput>>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  type?: InputMaybe<TagType>;
  type_in?: InputMaybe<Array<TagType>>;
  type_not?: InputMaybe<TagType>;
  type_not_in?: InputMaybe<Array<TagType>>;
};

/** Filter the "TagBrandedContents"' search results */
export type ArticleTagsTagBrandedContentsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleTagsTagBrandedContentsFilterSearchInput>>>;
  status?: InputMaybe<TagBrandedContentStatus>;
  status_in?: InputMaybe<Array<TagBrandedContentStatus>>;
  status_not?: InputMaybe<TagBrandedContentStatus>;
  status_not_in?: InputMaybe<Array<TagBrandedContentStatus>>;
};

/** Filter the "ArticleUrls"' search results */
export type ArticleUrlsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleUrlsFilterSearchInput>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleUrlsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleUrlsFilterSearchInput>>>;
  path?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  path_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  path_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Order the "Articles"' search results */
export enum ArticleOrderingSearchInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "editedAt" to the highest */
  editedAt_ASC = 'editedAt_ASC',
  /** from the highest "editedAt" to the lowest */
  editedAt_DESC = 'editedAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "publishedAt" to the highest */
  publishedAt_ASC = 'publishedAt_ASC',
  /** from the highest "publishedAt" to the lowest */
  publishedAt_DESC = 'publishedAt_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Source = {
  __typename?: 'Source';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<Article>;
  brandKey: BrandKey;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  status: SourceStatus;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type SourceArticleCountArgs = {
  where?: InputMaybe<ArticleFilterInput>;
};


export type SourceArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleFilterInput>;
};

/** Order the "Article" nodes */
export enum ArticleOrderingInput {
  /** from the lowest number of "authors" to the highest */
  authorCount_ASC = 'authorCount_ASC',
  /** from the highest number of "authors" to the lowest */
  authorCount_DESC = 'authorCount_DESC',
  /** from the lowest number of "categories" to the highest */
  categoryCount_ASC = 'categoryCount_ASC',
  /** from the highest number of "categories" to the lowest */
  categoryCount_DESC = 'categoryCount_DESC',
  /** from the lowest number of "channels" to the highest */
  channelCount_ASC = 'channelCount_ASC',
  /** from the highest number of "channels" to the lowest */
  channelCount_DESC = 'channelCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "editedAt" to the highest */
  editedAt_ASC = 'editedAt_ASC',
  /** from the highest "editedAt" to the lowest */
  editedAt_DESC = 'editedAt_DESC',
  /** from the lowest number of "events" to the highest */
  eventCount_ASC = 'eventCount_ASC',
  /** from the highest number of "events" to the lowest */
  eventCount_DESC = 'eventCount_DESC',
  /** from the lowest number of "goodDealAiProcesses" to the highest */
  goodDealAiProcessCount_ASC = 'goodDealAiProcessCount_ASC',
  /** from the highest number of "goodDealAiProcesses" to the lowest */
  goodDealAiProcessCount_DESC = 'goodDealAiProcessCount_DESC',
  /** from the lowest number of "guides" to the highest */
  guideCount_ASC = 'guideCount_ASC',
  /** from the highest number of "guides" to the lowest */
  guideCount_DESC = 'guideCount_DESC',
  /** from the lowest number of "histories" to the highest */
  historyCount_ASC = 'historyCount_ASC',
  /** from the highest number of "histories" to the lowest */
  historyCount_DESC = 'historyCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "lockedAt" to the highest */
  lockedAt_ASC = 'lockedAt_ASC',
  /** from the highest "lockedAt" to the lowest */
  lockedAt_DESC = 'lockedAt_DESC',
  /** from the lowest number of "machineTags" to the highest */
  machineTagCount_ASC = 'machineTagCount_ASC',
  /** from the highest number of "machineTags" to the lowest */
  machineTagCount_DESC = 'machineTagCount_DESC',
  /** from the lowest number of "openAiProcesses" to the highest */
  openAiProcessCount_ASC = 'openAiProcessCount_ASC',
  /** from the highest number of "openAiProcesses" to the lowest */
  openAiProcessCount_DESC = 'openAiProcessCount_DESC',
  /** from the lowest "publicId" to the highest */
  publicId_ASC = 'publicId_ASC',
  /** from the highest "publicId" to the lowest */
  publicId_DESC = 'publicId_DESC',
  /** from the lowest "publishedAt" to the highest */
  publishedAt_ASC = 'publishedAt_ASC',
  /** from the highest "publishedAt" to the lowest */
  publishedAt_DESC = 'publishedAt_DESC',
  /** from the lowest number of "pushes" to the highest */
  pushCount_ASC = 'pushCount_ASC',
  /** from the highest number of "pushes" to the lowest */
  pushCount_DESC = 'pushCount_DESC',
  /** from the lowest number of "qualifiers" to the highest */
  qualifierCount_ASC = 'qualifierCount_ASC',
  /** from the highest number of "qualifiers" to the lowest */
  qualifierCount_DESC = 'qualifierCount_DESC',
  /** from the lowest number of "summaries" to the highest */
  summaryCount_ASC = 'summaryCount_ASC',
  /** from the highest number of "summaries" to the lowest */
  summaryCount_DESC = 'summaryCount_DESC',
  /** from the lowest number of "tags" to the highest */
  tagCount_ASC = 'tagCount_ASC',
  /** from the highest number of "tags" to the lowest */
  tagCount_DESC = 'tagCount_DESC',
  /** from the lowest number of "taxonomies" to the highest */
  taxonomyCount_ASC = 'taxonomyCount_ASC',
  /** from the highest number of "taxonomies" to the lowest */
  taxonomyCount_DESC = 'taxonomyCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest number of "urls" to the highest */
  urlCount_ASC = 'urlCount_ASC',
  /** from the highest number of "urls" to the lowest */
  urlCount_DESC = 'urlCount_DESC'
}

/** Order the "ArticleSummary" nodes */
export enum ArticleSummaryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArticleSummary = {
  __typename?: 'ArticleSummary';
  article: Article;
  body: Scalars['NonEmptyTrimmedString']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  prompt?: Maybe<Prompt>;
  status: ArticleSummaryStatus;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type Prompt = {
  __typename?: 'Prompt';
  articleSummaries: Array<ArticleSummary>;
  /** Number of "articleSummaries" */
  articleSummaryCount: Scalars['UnsignedInt']['output'];
  body: Scalars['NonEmptyTrimmedString']['output'];
  brandKey: BrandKey;
  field: PromptField;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  label: Scalars['NonEmptyTrimmedString']['output'];
};


export type PromptArticleSummariesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleSummaryOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


export type PromptArticleSummaryCountArgs = {
  where?: InputMaybe<ArticleSummaryFilterInput>;
};

/** Order the "ArticleTaxonomy" nodes */
export enum ArticleTaxonomyOrderingInput {
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC'
}

export type ArticleTaxonomy = {
  __typename?: 'ArticleTaxonomy';
  article: Article;
  /** Order for a given "article", in the interval [0, ∞] */
  order: Scalars['UnsignedInt']['output'];
  taxonomy: Taxonomy;
};

/** Taxonomy data provided by the datascience team */
export type Taxonomy = {
  __typename?: 'Taxonomy';
  /** Number of "articles" */
  articleCount: Scalars['UnsignedInt']['output'];
  articles: Array<ArticleTaxonomy>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 255 characters with at least 1 alphanumeric characters. */
  level: Scalars['NonEmptySanitizedString']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  provider: Scalars['NonEmptySanitizedString']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  type: TaxonomyType;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['UnsignedInt']['output'];
};


/** Taxonomy data provided by the datascience team */
export type TaxonomyArticleCountArgs = {
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


/** Taxonomy data provided by the datascience team */
export type TaxonomyArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};

/** Order the "ArticleUrl" nodes */
export enum ArticleUrlOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "order" to the highest */
  order_ASC = 'order_ASC',
  /** from the highest "order" to the lowest */
  order_DESC = 'order_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type ArticleUrl = {
  __typename?: 'ArticleUrl';
  article: Article;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** Order for a given "article", in the interval [0, 9] */
  order: Scalars['UnsignedInt']['output'];
  origin: Scalars['URL']['output'];
  path: Scalars['NonEmptyTrimmedString']['output'];
  status: HttpStatus;
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type ArticleUrlOriginArgs = {
  device?: Device;
  env?: Env;
};


/** An URL as described in the RFC: https://url.spec.whatwg.org */
export type ArticleUrlStatusArgs = {
  device?: Device;
  env?: Env;
};

/** Identifies exactly one "ArticleAuthor" by "article-author" or "article-order" */
export type ArticleAuthorUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  author?: InputMaybe<AuthorUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "Author" by "id" or "brandKey-slug" */
export type AuthorUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 200 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

/** Identifies exactly one "ArticleCategory" by "article-category" or "article-order" */
export type ArticleCategoryUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "Category" by "id", "parent-order", "parent-brandKey-slug" or "brandKey-format-publicId" */
export type CategoryUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<CategoryFormat>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<CategoryUniqueFilterInput>;
  /** Unique per brand and format, may be part of the URL */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

/** Identifies exactly one "ArticleChannel" by "article-category" or "article-order" */
export type ArticleChannelUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "ArticleEvent" by "article-category" or "article-order" */
export type ArticleEventUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "ArticleGoodDealAiProcess" by "id" */
export type ArticleGoodDealAiProcessUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** The "ArticleGoodDealAiPrompt" nodes' filter */
export type ArticleGoodDealAiPromptFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiPromptFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ArticleGoodDealAiPromptFilterInput>>>;
  prompt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  prompt_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prompt_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prompt_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  prompt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  prompt_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prompt_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prompt_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  prompt_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  prompt_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  promptOrder?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  promptOrder_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  promptOrder_not_in?: InputMaybe<Array<Scalars['UnsignedInt']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "ArticleGoodDealAiPrompt" by "id" or "promptOrder" */
export type ArticleGoodDealAiPromptUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  promptOrder?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Article Good Deal AI Prompts */
export type ArticleGoodDealAiPrompt = {
  __typename?: 'ArticleGoodDealAiPrompt';
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  promptOrder: Scalars['UnsignedInt']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Order the "ArticleGoodDealAiPrompt" nodes */
export enum ArticleGoodDealAiPromptOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "promptOrder" to the highest */
  promptOrder_ASC = 'promptOrder_ASC',
  /** from the highest "promptOrder" to the lowest */
  promptOrder_DESC = 'promptOrder_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "ArticleGuide" by "article-category" or "article-order" */
export type ArticleGuideUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "ArticleHistory" by "id" */
export type ArticleHistoryUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Identifies exactly one "ArticleMachineTag" by "article-machineTag" or "article-order" */
export type ArticleMachineTagUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  machineTag?: InputMaybe<MachineTagUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "MachineTag" by "id" or "tag" */
export type MachineTagUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  tag?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Identifies exactly one "ArticleQualifier" by "article-qualifier" or "article-order" */
export type ArticleQualifierUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifier?: InputMaybe<QualifierUniqueFilterInput>;
};

/** Identifies exactly one "Qualifier" by "id", "brandKey-format-slug" or "brandKey-format-title" */
export type QualifierUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  format?: InputMaybe<ArticleFormat>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

/** Identifies exactly one "ArticleSummary" by "id" or "article-prompt" */
export type ArticleSummaryUniqueFilterInput = {
  article?: InputMaybe<ArticleUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  prompt?: InputMaybe<PromptUniqueFilterInput>;
};

/** Identifies exactly one "Prompt" by "id" or "brandKey-field-label" */
export type PromptUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  field?: InputMaybe<PromptField>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  label?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** Identifies exactly one "ArticleTag" by "article-tag" or "article-order" */
export type ArticleTagUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

/** Identifies exactly one "Tag" by "id", "type-lang-slug", "type-lang-title" or "type-relationId" */
export type TagUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  lang?: InputMaybe<TagLang>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  type?: InputMaybe<TagType>;
};

/** Identifies exactly one "ArticleTaxonomy" by "article-taxonomy" or "article-order" */
export type ArticleTaxonomyUniqueFilterInput = {
  article: ArticleUniqueFilterInput;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomy?: InputMaybe<TaxonomyUniqueFilterInput>;
};

/** Identifies exactly one "Taxonomy" by "id", "type-level-provider-version-slug" or "type-level-provider-version-title" */
export type TaxonomyUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 255 characters with at least 1 alphanumeric characters. */
  level?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  provider?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  type?: InputMaybe<TaxonomyType>;
  version?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "ArticleUrl" by "id" or "article-order" */
export type ArticleUrlUniqueFilterInput = {
  article?: InputMaybe<ArticleUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Order for a given "article", in the interval [0, 9] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "Attribute" by "id" or "brandKey-slug" */
export type AttributeUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

/** Order the "Attribute" nodes */
export enum AttributeOrderingInput {
  /** from the lowest number of "authors" to the highest */
  authorCount_ASC = 'authorCount_ASC',
  /** from the highest number of "authors" to the lowest */
  authorCount_DESC = 'authorCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "AuthorAttribute" by "author-attribute" or "author-order" */
export type AuthorAttributeUniqueFilterInput = {
  attribute?: InputMaybe<AttributeUniqueFilterInput>;
  author: AuthorUniqueFilterInput;
  /** Order for a given "author", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Identifies exactly one "AuthorHistory" by "id" */
export type AuthorHistoryUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Order the "Author" nodes */
export enum AuthorOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest number of "attributes" to the highest */
  attributeCount_ASC = 'attributeCount_ASC',
  /** from the highest number of "attributes" to the lowest */
  attributeCount_DESC = 'attributeCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest number of "histories" to the highest */
  historyCount_ASC = 'historyCount_ASC',
  /** from the highest number of "histories" to the lowest */
  historyCount_DESC = 'historyCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "name" to the highest */
  name_ASC = 'name_ASC',
  /** from the highest "name" to the lowest */
  name_DESC = 'name_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "Card" by "id" */
export type CardUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Identifies exactly one "CardCategory" by "card-category" or "card-order" */
export type CardCategoryUniqueFilterInput = {
  card: CardUniqueFilterInput;
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** Order the "Card" nodes */
export enum CardOrderingInput {
  /** from the lowest number of "categories" to the highest */
  categoryCount_ASC = 'categoryCount_ASC',
  /** from the highest number of "categories" to the lowest */
  categoryCount_DESC = 'categoryCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "tags" to the highest */
  tagCount_ASC = 'tagCount_ASC',
  /** from the highest number of "tags" to the lowest */
  tagCount_DESC = 'tagCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "CardTag" by "card-tag" or "card-order" */
export type CardTagUniqueFilterInput = {
  card: CardUniqueFilterInput;
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

/** Identifies exactly one "CategoryHistory" by "id" */
export type CategoryHistoryUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Identifies exactly one "CategoryTag" by "category-tag" or "category-order" */
export type CategoryTagUniqueFilterInput = {
  category: CategoryUniqueFilterInput;
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

/** Identifies exactly one "CategoryUrl" by "id" or "category-order" */
export type CategoryUrlUniqueFilterInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Order for a given "category", in the interval [0, 9] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "DailymotionLog" nodes' filter */
export type DailymotionLogFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<DailymotionLogFilterInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  error_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  error_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  error_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  error_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  error_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  error_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  log?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  log_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  log_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  log_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  log_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  log_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  log_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  log_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  log_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  log_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  log_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  NOT?: InputMaybe<DailymotionLogFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<DailymotionLogFilterInput>>>;
  privateId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  privateId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  privateId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  privateId_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  privateId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  privateId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  privateId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  privateId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  privateId_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  privateId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  privateId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  response_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  response_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  response_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  response_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  response_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  response_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  status?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['UnsignedInt']['input']>>>;
  videoId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  videoId_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  videoId_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  videoId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  videoId_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  videoId_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  videoId_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  videoId_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  videoId_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** Identifies exactly one "DailymotionLog" by "id" */
export type DailymotionLogUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

export type DailymotionLog = {
  __typename?: 'DailymotionLog';
  brandKey: BrandKey;
  context: Scalars['JSONObject']['output'];
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  log?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  privateId?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  response?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  status?: Maybe<Scalars['UnsignedInt']['output']>;
  videoId?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
};

/** Order the "DailymotionLog" nodes */
export enum DailymotionLogOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "status" to the highest */
  status_ASC = 'status_ASC',
  /** from the highest "status" to the lowest */
  status_DESC = 'status_DESC'
}

export type DailymotionUploadUrl = {
  __typename?: 'DailymotionUploadURL';
  progressUrl: Scalars['URL']['output'];
  uploadUrl: Scalars['URL']['output'];
};

export type ImagePrompt = {
  __typename?: 'ImagePrompt';
  b64Json: Scalars['NonEmptyTrimmedString']['output'];
};

export type TextPrompt = {
  __typename?: 'TextPrompt';
  content: Scalars['NonEmptyTrimmedString']['output'];
};

export type LinkInput = {
  blockKey: Scalars['String']['input'];
  sentence: Scalars['String']['input'];
  url: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type GetBodyWithSuggestedLinksResult = {
  __typename?: 'GetBodyWithSuggestedLinksResult';
  updatedBody: Scalars['String']['output'];
};

/** The "ImageSource" nodes' filter */
export type ImageSourceFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ImageSourceFilterInput>>>;
  category?: InputMaybe<ImageSourceCategoryFilterInput>;
  category_not?: InputMaybe<ImageSourceCategoryFilterInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ImageSourceFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ImageSourceFilterInput>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** The "ImageSourceCategory" nodes' filter */
export type ImageSourceCategoryFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<ImageSourceCategoryFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<ImageSourceCategoryFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<ImageSourceCategoryFilterInput>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  slug_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  slug_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  sourceCount?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceCount_gt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceCount_gte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceCount_lt?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceCount_lte?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sourceCount_not?: InputMaybe<Scalars['UnsignedInt']['input']>;
  sources_every?: InputMaybe<ImageSourceFilterInput>;
  sources_none?: InputMaybe<ImageSourceFilterInput>;
  sources_some?: InputMaybe<ImageSourceFilterInput>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_gt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_gte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_lt?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_lte?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "ImageSource" by "id", "title" or "slug" */
export type ImageSourceUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ImageSource = {
  __typename?: 'ImageSource';
  category: ImageSourceCategory;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ImageSourceCategory = {
  __typename?: 'ImageSourceCategory';
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug: Scalars['Slug']['output'];
  /** Number of "sources" */
  sourceCount: Scalars['UnsignedInt']['output'];
  sources: Array<ImageSource>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


export type ImageSourceCategorySourceCountArgs = {
  where?: InputMaybe<ImageSourceFilterInput>;
};


export type ImageSourceCategorySourcesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderingInput>>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<ImageSourceFilterInput>;
};

/** Order the "ImageSource" nodes */
export enum ImageSourceOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "ImageSourceCategory" nodes */
export enum ImageSourceCategoryOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "sources" to the highest */
  sourceCount_ASC = 'sourceCount_ASC',
  /** from the highest number of "sources" to the lowest */
  sourceCount_DESC = 'sourceCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "ImageSourceCategory" by "id", "title" or "slug" */
export type ImageSourceCategoryUniqueFilterInput = {
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

/** Identifies exactly one "Live" by "id" or "article" */
export type LiveUniqueFilterInput = {
  article?: InputMaybe<ArticleUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Identifies exactly one "LivePost" by "id" */
export type LivePostUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Order the "Live" nodes */
export enum LiveOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "endedAt" to the highest */
  endedAt_ASC = 'endedAt_ASC',
  /** from the highest "endedAt" to the lowest */
  endedAt_DESC = 'endedAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "posts" to the highest */
  postCount_ASC = 'postCount_ASC',
  /** from the highest number of "posts" to the lowest */
  postCount_DESC = 'postCount_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "MachineTag" nodes */
export enum MachineTagOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "OpenAiProcess" by "id" */
export type OpenAiProcessUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** The "OrphanPage" nodes' filter */
export type OrphanPageFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<OrphanPageFilterInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  content?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  content_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  content_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  content_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  content_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['NonEmptyTrimmedString']['input']>>>;
  content_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  content_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isAdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAdsEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen_not?: InputMaybe<Scalars['Boolean']['input']>;
  metas_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<OrphanPageFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<OrphanPageFilterInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<OrphanPageStatus>;
  status_in?: InputMaybe<Array<OrphanPageStatus>>;
  status_not?: InputMaybe<OrphanPageStatus>;
  status_not_in?: InputMaybe<Array<OrphanPageStatus>>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  title_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uri?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  uri_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  uri_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  uri_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  uri_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  uri_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  uri_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  uri_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  uri_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  uri_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export enum OrphanPageStatus {
  Archived = 'Archived',
  Deleted = 'Deleted',
  Draft = 'Draft',
  Published = 'Published'
}

/** Identifies exactly one "OrphanPage" by "id" or "brandKey-uri" */
export type OrphanPageUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 500 characters. */
  uri?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type OrphanPage = {
  __typename?: 'OrphanPage';
  brandKey: BrandKey;
  content?: Maybe<Scalars['NonEmptyString']['output']>;
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The public ID */
  id: Scalars['UUID']['output'];
  isAdsEnabled: Scalars['Boolean']['output'];
  isCMPEnabled: Scalars['Boolean']['output'];
  isFullScreen: Scalars['Boolean']['output'];
  /** An arbitrary list of strings */
  metas?: Maybe<Scalars['JSONArray']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrphanPageStatus;
  /** At most 2000 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['output'];
  /** The date and time of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  /** At most 500 characters. */
  uri: Scalars['NonEmptySanitizedString']['output'];
};

/** Order the "OrphanPage" nodes */
export enum OrphanPageOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "editedAt" to the highest */
  editedAt_ASC = 'editedAt_ASC',
  /** from the highest "editedAt" to the lowest */
  editedAt_DESC = 'editedAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "publishedAt" to the highest */
  publishedAt_ASC = 'publishedAt_ASC',
  /** from the highest "publishedAt" to the lowest */
  publishedAt_DESC = 'publishedAt_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "Prompt" nodes */
export enum PromptOrderingInput {
  /** from the lowest number of "articleSummaries" to the highest */
  articleSummaryCount_ASC = 'articleSummaryCount_ASC',
  /** from the highest number of "articleSummaries" to the lowest */
  articleSummaryCount_DESC = 'articleSummaryCount_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

/** Identifies exactly one "Push" by "id" */
export type PushUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** The "PushError" nodes' filter */
export type PushErrorFilterInput = {
  AND?: InputMaybe<Array<InputMaybe<PushErrorFilterInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  NOT?: InputMaybe<PushErrorFilterInput>;
  OR?: InputMaybe<Array<InputMaybe<PushErrorFilterInput>>>;
  reason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  reason_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  reason_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  reason_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  reason_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  reason_not_contains?: InputMaybe<Scalars['NonEmptyString']['input']>;
  reason_not_ends_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  reason_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  reason_not_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
  reason_starts_with?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** Identifies exactly one "PushError" by "id" */
export type PushErrorUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

export type PushError = {
  __typename?: 'PushError';
  /** The date and time, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID */
  id: Scalars['UUID']['output'];
  reason: Scalars['NonEmptyTrimmedString']['output'];
};

/** Order the "PushError" nodes */
export enum PushErrorOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC'
}

export enum TargetedDevice {
  android = 'android',
  editorialAlert = 'editorialAlert',
  ios = 'ios'
}

export type PushNotificationCampaign = {
  __typename?: 'PushNotificationCampaign';
  campaign_token?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  dev_only?: Maybe<Scalars['Boolean']['output']>;
  from_api?: Maybe<Scalars['Boolean']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  messages: Array<Maybe<PushNotificationMessage>>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  push_time?: Maybe<Scalars['String']['output']>;
  push_type?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationMessage = {
  __typename?: 'PushNotificationMessage';
  body?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationCampaignsItem = {
  __typename?: 'PushNotificationCampaignsItem';
  campaign_token?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  deeplink?: Maybe<Scalars['String']['output']>;
  dev_only?: Maybe<Scalars['Boolean']['output']>;
  from_api?: Maybe<Scalars['Boolean']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  push_time?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationSegmentationsItem = {
  __typename?: 'PushNotificationSegmentationsItem';
  name: Scalars['String']['output'];
  query: Scalars['String']['output'];
};

/** Identifies exactly one "PushSegment" by "push-segment" */
export type PushSegmentUniqueFilterInput = {
  push: PushUniqueFilterInput;
  segment: SegmentUniqueFilterInput;
};

/** Identifies exactly one "Segment" by "id" */
export type SegmentUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Order the "Qualifier" nodes */
export enum QualifierOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum AffilizzDesignOriginType {
  AFFILIZZ = 'AFFILIZZ',
  USER = 'USER'
}

export enum AffilizzDesignRenderingType {
  BOX = 'BOX',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  CTA = 'CTA',
  LINK = 'LINK',
  PAGE = 'PAGE'
}

export enum AffilizzDesignState {
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_BUT_AMENDED = 'PUBLISHED_BUT_AMENDED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export type SearchAffilizzDesignResult = {
  __typename?: 'searchAffilizzDesignResult';
  defaultDesign: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originType: AffilizzDesignOriginTypeResult;
  publishedAt: Scalars['DateTime']['output'];
  renderingType: AffilizzDesignRenderingTypeResult;
  state: AffilizzDesignStateResult;
};

export enum AffilizzDesignOriginTypeResult {
  AFFILIZZ = 'AFFILIZZ',
  USER = 'USER'
}

export enum AffilizzDesignRenderingTypeResult {
  BOX = 'BOX',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  CTA = 'CTA',
  LINK = 'LINK',
  PAGE = 'PAGE'
}

export enum AffilizzDesignStateResult {
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_BUT_AMENDED = 'PUBLISHED_BUT_AMENDED',
  UNPUBLISHED = 'UNPUBLISHED'
}

export enum AffilizzProductSearchSort {
  NB_OFFERS = 'NB_OFFERS',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  RELEVANCE = 'RELEVANCE'
}

export type SearchAffilizzProductResult = {
  __typename?: 'searchAffilizzProductResult';
  content: Array<AffilizzProduct>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['UnsignedInt']['output']>;
  numberOfElements?: Maybe<Scalars['UnsignedInt']['output']>;
  pageable?: Maybe<SearchAffilizzProductResultPageable>;
  size?: Maybe<Scalars['UnsignedInt']['output']>;
  sort?: Maybe<SearchAffilizzProductResultSort>;
  totalElements?: Maybe<Scalars['UnsignedInt']['output']>;
  totalPages?: Maybe<Scalars['UnsignedInt']['output']>;
};

export type AffilizzProduct = {
  __typename?: 'AffilizzProduct';
  currencyCode?: Maybe<Scalars['String']['output']>;
  defaultImage: Scalars['String']['output'];
  downsides?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  maxPrice?: Maybe<Scalars['Float']['output']>;
  minPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['UnsignedInt']['output'];
  productId: Scalars['String']['output'];
  productLocalizedId: Scalars['String']['output'];
  type: AffilizzProductType;
  upsides?: Maybe<Array<Scalars['String']['output']>>;
};

export enum AffilizzProductType {
  CatalogProduct = 'CatalogProduct',
  Product = 'Product'
}

export type SearchAffilizzProductResultPageable = {
  __typename?: 'searchAffilizzProductResultPageable';
  offset?: Maybe<Scalars['UnsignedInt']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  pageNumber?: Maybe<Scalars['UnsignedInt']['output']>;
  pageSize?: Maybe<Scalars['UnsignedInt']['output']>;
  sort?: Maybe<SearchAffilizzProductResultPageableSort>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchAffilizzProductResultPageableSort = {
  __typename?: 'searchAffilizzProductResultPageableSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchAffilizzProductResultSort = {
  __typename?: 'searchAffilizzProductResultSort';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export enum ImageProviderName {
  Getty = 'Getty',
  Pixabay = 'Pixabay',
  Unsplash = 'Unsplash'
}

export type PhotoSearchResult = {
  __typename?: 'PhotoSearchResult';
  items: Array<ImageProviderResult>;
  name: ImageProviderName;
};

export type ImageProviderResult = {
  __typename?: 'ImageProviderResult';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  large?: Maybe<Scalars['URL']['output']>;
  medium?: Maybe<Scalars['URL']['output']>;
  preview?: Maybe<PhotoPreview>;
  small?: Maybe<Scalars['URL']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type PhotoPreview = {
  __typename?: 'PhotoPreview';
  height: Scalars['Int']['output'];
  url: Scalars['URL']['output'];
  width: Scalars['Int']['output'];
};

/** The "Tag" nodes' more-like-this input type */
export type TagLikeInput = {
  id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lang?: InputMaybe<TagLang>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['Slug']['input']>;
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  type?: InputMaybe<TagType>;
};

/** Filter the "Tags"' search results */
export type TagFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<TagFilterSearchInput>>>;
  brandedContents_every?: InputMaybe<TagBrandedContentsFilterSearchInput>;
  brandedContents_none?: InputMaybe<TagBrandedContentsFilterSearchInput>;
  brandedContents_some?: InputMaybe<TagBrandedContentsFilterSearchInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  id_gt?: InputMaybe<Scalars['UUID']['input']>;
  id_gte?: InputMaybe<Scalars['UUID']['input']>;
  id_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id_lt?: InputMaybe<Scalars['UUID']['input']>;
  id_lte?: InputMaybe<Scalars['UUID']['input']>;
  id_not?: InputMaybe<Scalars['UUID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  lang?: InputMaybe<TagLang>;
  lang_in?: InputMaybe<Array<TagLang>>;
  lang_not?: InputMaybe<TagLang>;
  lang_not_in?: InputMaybe<Array<TagLang>>;
  NOT?: InputMaybe<TagFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<TagFilterSearchInput>>>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  relationId_in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  relationId_not?: InputMaybe<Scalars['UUID']['input']>;
  relationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  slug?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  slug_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  title_not?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  type?: InputMaybe<TagType>;
  type_in?: InputMaybe<Array<TagType>>;
  type_not?: InputMaybe<TagType>;
  type_not_in?: InputMaybe<Array<TagType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Filter the "TagBrandedContents"' search results */
export type TagBrandedContentsFilterSearchInput = {
  AND?: InputMaybe<Array<InputMaybe<TagBrandedContentsFilterSearchInput>>>;
  brandKey?: InputMaybe<BrandKey>;
  brandKey_in?: InputMaybe<Array<BrandKey>>;
  brandKey_not?: InputMaybe<BrandKey>;
  brandKey_not_in?: InputMaybe<Array<BrandKey>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TagBrandedContentsFilterSearchInput>;
  OR?: InputMaybe<Array<InputMaybe<TagBrandedContentsFilterSearchInput>>>;
  status?: InputMaybe<TagBrandedContentStatus>;
  status_in?: InputMaybe<Array<TagBrandedContentStatus>>;
  status_not?: InputMaybe<TagBrandedContentStatus>;
  status_not_in?: InputMaybe<Array<TagBrandedContentStatus>>;
};

/** Order the "Tags"' search results */
export enum TagOrderingSearchInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum TvSearchContextType {
  Rich = 'Rich',
  Video = 'Video'
}

export type TvCollection = {
  __typename?: 'TvCollection';
  boneUUID: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  season?: Maybe<Scalars['UnsignedInt']['output']>;
  title: Scalars['NonEmptyTrimmedString']['output'];
  type: Scalars['NonEmptyTrimmedString']['output'];
};

export enum TvSearchProgramType {
  Broadcast = 'Broadcast',
  Cinema = 'Cinema',
  VOD = 'VOD'
}

export type TvProgram = {
  __typename?: 'TvProgram';
  boneUUID: Scalars['UUID']['output'];
  channel?: Maybe<Scalars['NonEmptyTrimmedString']['output']>;
  id: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['NonEmptyTrimmedString']['output'];
};

/** Order the "Segment" nodes */
export enum SegmentOrderingInput {
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest number of "pushes" to the highest */
  pushCount_ASC = 'pushCount_ASC',
  /** from the highest number of "pushes" to the lowest */
  pushCount_DESC = 'pushCount_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "Source" by "id" or "brandKey-slug" */
export type SourceUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

/** Order the "Source" nodes */
export enum SourceOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SuggestInternalLinksResult = {
  __typename?: 'suggestInternalLinksResult';
  blockKey: Scalars['String']['output'];
  relevance: Scalars['String']['output'];
  sentence: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  word: Scalars['String']['output'];
};

/** Identifies exactly one "Tab" by "id", "category-slug" or "category-order" */
export type TabUniqueFilterInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

/** Identifies exactly one "TagBrandedContent" by "id" or "tag-brandKey" */
export type TagBrandedContentUniqueFilterInput = {
  brandKey?: InputMaybe<BrandKey>;
  /** The public ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

/** Identifies exactly one "TagBrandedContentHistory" by "id" */
export type TagBrandedContentHistoryUniqueFilterInput = {
  /** The public ID */
  id: Scalars['UUID']['input'];
};

/** Order the "Tag" nodes */
export enum TagOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest number of "brandedContents" to the highest */
  brandedContentCount_ASC = 'brandedContentCount_ASC',
  /** from the highest number of "brandedContents" to the lowest */
  brandedContentCount_DESC = 'brandedContentCount_DESC',
  /** from the lowest number of "cards" to the highest */
  cardCount_ASC = 'cardCount_ASC',
  /** from the highest number of "cards" to the lowest */
  cardCount_DESC = 'cardCount_DESC',
  /** from the lowest number of "categories" to the highest */
  categoryCount_ASC = 'categoryCount_ASC',
  /** from the highest number of "categories" to the lowest */
  categoryCount_DESC = 'categoryCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "title" to the highest */
  title_ASC = 'title_ASC',
  /** from the highest "title" to the lowest */
  title_DESC = 'title_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Order the "Taxonomy" nodes */
export enum TaxonomyOrderingInput {
  /** from the lowest number of "articles" to the highest */
  articleCount_ASC = 'articleCount_ASC',
  /** from the highest number of "articles" to the lowest */
  articleCount_DESC = 'articleCount_DESC',
  /** from the lowest "createdAt" to the highest */
  createdAt_ASC = 'createdAt_ASC',
  /** from the highest "createdAt" to the lowest */
  createdAt_DESC = 'createdAt_DESC',
  /** from the lowest "id" to the highest */
  id_ASC = 'id_ASC',
  /** from the highest "id" to the lowest */
  id_DESC = 'id_DESC',
  /** from the lowest "updatedAt" to the highest */
  updatedAt_ASC = 'updatedAt_ASC',
  /** from the highest "updatedAt" to the lowest */
  updatedAt_DESC = 'updatedAt_DESC',
  /** from the lowest "version" to the highest */
  version_ASC = 'version_ASC',
  /** from the highest "version" to the lowest */
  version_DESC = 'version_DESC'
}

export type VertexAiQueryResult = {
  __typename?: 'vertexAiQueryResult';
  body?: Maybe<Scalars['String']['output']>;
  body_summary?: Maybe<Scalars['String']['output']>;
  brand_trigram?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  has_video?: Maybe<Scalars['String']['output']>;
  heat_score?: Maybe<Scalars['UnsignedFloat']['output']>;
  image_uri?: Maybe<Scalars['String']['output']>;
  isvalidrecipe?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  miscellaneous?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  nb_visits?: Maybe<Scalars['Int']['output']>;
  organizations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  personalities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  published_date?: Maybe<Scalars['String']['output']>;
  published_date_unix_sec?: Maybe<Scalars['Int']['output']>;
  qualifiers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recipe_calorie?: Maybe<Scalars['String']['output']>;
  recipe_cooktime?: Maybe<Scalars['Int']['output']>;
  recipe_cost?: Maybe<Scalars['String']['output']>;
  recipe_difficulty?: Maybe<Scalars['String']['output']>;
  recipe_ingredients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recipe_preptime?: Maybe<Scalars['Int']['output']>;
  reviews_avg?: Maybe<Scalars['UnsignedFloat']['output']>;
  reviews_cnt?: Maybe<Scalars['Int']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  update_date_unix_sec?: Maybe<Scalars['UnsignedInt']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'mutation';
  /** Add a secondary url to an article, for redirection */
  addSecondaryArticleUrl: ArticleUrl;
  /** Add a secondary url to a category, for redirection */
  addSecondaryCategoryUrl: CategoryUrl;
  /** Complete existing AI slideshow with ChatGPT */
  completeAISlideshow: OpenAiProcess;
  /** Create affiliation card using affilizz api */
  createAffiliationCard: AffilizzCard;
  /** Create affiliation catalog product using affilizz api */
  createAffiliationCatalogProduct: AffilizzCataglogProductCreation;
  /** Creates one "Article", throws an error if it already exists */
  createArticle: Article;
  /** Creates one "ArticleAuthor", throws an error if it already exists */
  createArticleAuthor: ArticleAuthor;
  /** Creates one "ArticleAuthor" if it does not exist, returns the existing otherwise */
  createArticleAuthorIfNotExists: ArticleAuthor;
  /** Creates some "ArticleAuthor", throws an error if they already exist */
  createArticleAuthors: Array<ArticleAuthor>;
  /** Creates some "ArticleCategory", throws an error if they already exist */
  createArticleCategories: Array<ArticleCategory>;
  /** Creates one "ArticleCategory", throws an error if it already exists */
  createArticleCategory: ArticleCategory;
  /** Creates one "ArticleCategory" if it does not exist, returns the existing otherwise */
  createArticleCategoryIfNotExists: ArticleCategory;
  /** Creates one "ArticleChannel", throws an error if it already exists */
  createArticleChannel: ArticleChannel;
  /** Creates one "ArticleChannel" if it does not exist, returns the existing otherwise */
  createArticleChannelIfNotExists: ArticleChannel;
  /** Creates some "ArticleChannel", throws an error if they already exist */
  createArticleChannels: Array<ArticleChannel>;
  /** Creates one "ArticleEvent", throws an error if it already exists */
  createArticleEvent: ArticleEvent;
  /** Creates one "ArticleEvent" if it does not exist, returns the existing otherwise */
  createArticleEventIfNotExists: ArticleEvent;
  /** Creates some "ArticleEvent", throws an error if they already exist */
  createArticleEvents: Array<ArticleEvent>;
  /** Creates one "ArticleGoodDealAiProcess", throws an error if it already exists */
  createArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Creates some "ArticleGoodDealAiProcess", throws an error if they already exist */
  createArticleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** Creates one "ArticleGoodDealAiProcess" if it does not exist, returns the existing otherwise */
  createArticleGoodDealAiProcessIfNotExists: ArticleGoodDealAiProcess;
  /** Creates one "ArticleGoodDealAiPrompt", throws an error if it already exists */
  createArticleGoodDealAiPrompt: ArticleGoodDealAiPrompt;
  /** Creates one "ArticleGoodDealAiPrompt" if it does not exist, returns the existing otherwise */
  createArticleGoodDealAiPromptIfNotExists: ArticleGoodDealAiPrompt;
  /** Creates some "ArticleGoodDealAiPrompt", throws an error if they already exist */
  createArticleGoodDealAiPrompts: Array<ArticleGoodDealAiPrompt>;
  /** Creates one "ArticleGuide", throws an error if it already exists */
  createArticleGuide: ArticleGuide;
  /** Creates one "ArticleGuide" if it does not exist, returns the existing otherwise */
  createArticleGuideIfNotExists: ArticleGuide;
  /** Creates some "ArticleGuide", throws an error if they already exist */
  createArticleGuides: Array<ArticleGuide>;
  /** Creates one "Article" if it does not exist, returns the existing otherwise */
  createArticleIfNotExists: Article;
  /** Creates one "ArticleMachineTag", throws an error if it already exists */
  createArticleMachineTag: ArticleMachineTag;
  /** Creates one "ArticleMachineTag" if it does not exist, returns the existing otherwise */
  createArticleMachineTagIfNotExists: ArticleMachineTag;
  /** Creates some "ArticleMachineTag", throws an error if they already exist */
  createArticleMachineTags: Array<ArticleMachineTag>;
  /** Creates one "ArticleQualifier", throws an error if it already exists */
  createArticleQualifier: ArticleQualifier;
  /** Creates one "ArticleQualifier" if it does not exist, returns the existing otherwise */
  createArticleQualifierIfNotExists: ArticleQualifier;
  /** Creates some "ArticleQualifier", throws an error if they already exist */
  createArticleQualifiers: Array<ArticleQualifier>;
  /** Creates some "Article", throws an error if they already exist */
  createArticles: Array<Article>;
  /** Creates some "ArticleSummary", throws an error if they already exist */
  createArticleSummaries: Array<ArticleSummary>;
  /** Creates one "ArticleSummary", throws an error if it already exists */
  createArticleSummary: ArticleSummary;
  /** Creates one "ArticleSummary" if it does not exist, returns the existing otherwise */
  createArticleSummaryIfNotExists: ArticleSummary;
  /** Creates one "ArticleTag", throws an error if it already exists */
  createArticleTag: ArticleTag;
  /** Creates one "ArticleTag" if it does not exist, returns the existing otherwise */
  createArticleTagIfNotExists: ArticleTag;
  /** Creates some "ArticleTag", throws an error if they already exist */
  createArticleTags: Array<ArticleTag>;
  /** Creates some "ArticleTaxonomy", throws an error if they already exist */
  createArticleTaxonomies: Array<ArticleTaxonomy>;
  /** Creates one "ArticleTaxonomy", throws an error if it already exists */
  createArticleTaxonomy: ArticleTaxonomy;
  /** Creates one "ArticleTaxonomy" if it does not exist, returns the existing otherwise */
  createArticleTaxonomyIfNotExists: ArticleTaxonomy;
  /** Creates one "Attribute", throws an error if it already exists */
  createAttribute: Attribute;
  /** Creates one "Attribute" if it does not exist, returns the existing otherwise */
  createAttributeIfNotExists: Attribute;
  /** Creates some "Attribute", throws an error if they already exist */
  createAttributes: Array<Attribute>;
  /** Creates one "Author", throws an error if it already exists */
  createAuthor: Author;
  /** Creates one "AuthorAttribute", throws an error if it already exists */
  createAuthorAttribute: AuthorAttribute;
  /** Creates one "AuthorAttribute" if it does not exist, returns the existing otherwise */
  createAuthorAttributeIfNotExists: AuthorAttribute;
  /** Creates some "AuthorAttribute", throws an error if they already exist */
  createAuthorAttributes: Array<AuthorAttribute>;
  /** Creates one "Author" if it does not exist, returns the existing otherwise */
  createAuthorIfNotExists: Author;
  /** Creates some "Author", throws an error if they already exist */
  createAuthors: Array<Author>;
  /** Creates one "Card", throws an error if it already exists */
  createCard: Card;
  /** Creates some "CardCategory", throws an error if they already exist */
  createCardCategories: Array<CardCategory>;
  /** Creates one "CardCategory", throws an error if it already exists */
  createCardCategory: CardCategory;
  /** Creates one "CardCategory" if it does not exist, returns the existing otherwise */
  createCardCategoryIfNotExists: CardCategory;
  /** Creates one "Card" if it does not exist, returns the existing otherwise */
  createCardIfNotExists: Card;
  /** Creates some "Card", throws an error if they already exist */
  createCards: Array<Card>;
  /** Creates one "CardTag", throws an error if it already exists */
  createCardTag: CardTag;
  /** Creates one "CardTag" if it does not exist, returns the existing otherwise */
  createCardTagIfNotExists: CardTag;
  /** Creates some "CardTag", throws an error if they already exist */
  createCardTags: Array<CardTag>;
  /** Creates some "Category", throws an error if they already exist */
  createCategories: Array<Category>;
  /** Creates one "Category", throws an error if it already exists */
  createCategory: Category;
  /** Creates one "Category" if it does not exist, returns the existing otherwise */
  createCategoryIfNotExists: Category;
  /** Creates one "CategoryTag", throws an error if it already exists */
  createCategoryTag: CategoryTag;
  /** Creates one "CategoryTag" if it does not exist, returns the existing otherwise */
  createCategoryTagIfNotExists: CategoryTag;
  /** Creates some "CategoryTag", throws an error if they already exist */
  createCategoryTags: Array<CategoryTag>;
  /** Creates one "DailymotionLog", throws an error if it already exists */
  createDailymotionLog: DailymotionLog;
  /** Creates one "DailymotionLog" if it does not exist, returns the existing otherwise */
  createDailymotionLogIfNotExists: DailymotionLog;
  /** Creates some "DailymotionLog", throws an error if they already exist */
  createDailymotionLogs: Array<DailymotionLog>;
  /** Creates one "ImageSource", throws an error if it already exists */
  createImageSource: ImageSource;
  /** Creates some "ImageSourceCategory", throws an error if they already exist */
  createImageSourceCategories: Array<ImageSourceCategory>;
  /** Creates one "ImageSourceCategory", throws an error if it already exists */
  createImageSourceCategory: ImageSourceCategory;
  /** Creates one "ImageSourceCategory" if it does not exist, returns the existing otherwise */
  createImageSourceCategoryIfNotExists: ImageSourceCategory;
  /** Creates one "ImageSource" if it does not exist, returns the existing otherwise */
  createImageSourceIfNotExists: ImageSource;
  /** Creates some "ImageSource", throws an error if they already exist */
  createImageSources: Array<ImageSource>;
  /** Creates one "Live", throws an error if it already exists */
  createLive: Live;
  /** Creates one "Live" if it does not exist, returns the existing otherwise */
  createLiveIfNotExists: Live;
  /** Creates one "LivePost", throws an error if it already exists */
  createLivePost: LivePost;
  /** Creates one "LivePost" if it does not exist, returns the existing otherwise */
  createLivePostIfNotExists: LivePost;
  /** Creates some "LivePost", throws an error if they already exist */
  createLivePosts: Array<LivePost>;
  /** Creates some "Live", throws an error if they already exist */
  createLives: Array<Live>;
  /** Creates one "MachineTag", throws an error if it already exists */
  createMachineTag: MachineTag;
  /** Creates one "MachineTag" if it does not exist, returns the existing otherwise */
  createMachineTagIfNotExists: MachineTag;
  /** Creates some "MachineTag", throws an error if they already exist */
  createMachineTags: Array<MachineTag>;
  /** Creates one "OpenAiProcess", throws an error if it already exists */
  createOpenAiProcess: OpenAiProcess;
  /** Creates some "OpenAiProcess", throws an error if they already exist */
  createOpenAiProcesses: Array<OpenAiProcess>;
  /** Creates one "OpenAiProcess" if it does not exist, returns the existing otherwise */
  createOpenAiProcessIfNotExists: OpenAiProcess;
  /** Creates one "OrphanPage", throws an error if it already exists */
  createOrphanPage: OrphanPage;
  /** Creates one "OrphanPage" if it does not exist, returns the existing otherwise */
  createOrphanPageIfNotExists: OrphanPage;
  /** Creates some "OrphanPage", throws an error if they already exist */
  createOrphanPages: Array<OrphanPage>;
  /** Creates one "Prompt", throws an error if it already exists */
  createPrompt: Prompt;
  /** Creates one "Prompt" if it does not exist, returns the existing otherwise */
  createPromptIfNotExists: Prompt;
  /** Creates some "Prompt", throws an error if they already exist */
  createPrompts: Array<Prompt>;
  /** Creates one "Push", throws an error if it already exists */
  createPush: Push;
  /** Creates one "PushError", throws an error if it already exists */
  createPushError: PushError;
  /** Creates one "PushError" if it does not exist, returns the existing otherwise */
  createPushErrorIfNotExists: PushError;
  /** Creates some "PushError", throws an error if they already exist */
  createPushErrors: Array<PushError>;
  /** Creates some "Push", throws an error if they already exist */
  createPushes: Array<Push>;
  /** Creates one "Push" if it does not exist, returns the existing otherwise */
  createPushIfNotExists: Push;
  /** Create one push-notification campaign, and get its campaign-token. */
  createPushNotificationCampaign: Scalars['ID']['output'];
  /** Creates one "PushSegment", throws an error if it already exists */
  createPushSegment: PushSegment;
  /** Creates one "PushSegment" if it does not exist, returns the existing otherwise */
  createPushSegmentIfNotExists: PushSegment;
  /** Creates some "PushSegment", throws an error if they already exist */
  createPushSegments: Array<PushSegment>;
  /** Creates one "Qualifier", throws an error if it already exists */
  createQualifier: Qualifier;
  /** Creates one "Qualifier" if it does not exist, returns the existing otherwise */
  createQualifierIfNotExists: Qualifier;
  /** Creates some "Qualifier", throws an error if they already exist */
  createQualifiers: Array<Qualifier>;
  /** Creates one "Segment", throws an error if it already exists */
  createSegment: Segment;
  /** Creates one "Segment" if it does not exist, returns the existing otherwise */
  createSegmentIfNotExists: Segment;
  /** Creates some "Segment", throws an error if they already exist */
  createSegments: Array<Segment>;
  /** Creates one "Source", throws an error if it already exists */
  createSource: Source;
  /** Creates one "Source" if it does not exist, returns the existing otherwise */
  createSourceIfNotExists: Source;
  /** Creates some "Source", throws an error if they already exist */
  createSources: Array<Source>;
  /** Creates one "Tab", throws an error if it already exists */
  createTab: Tab;
  /** Creates one "Tab" if it does not exist, returns the existing otherwise */
  createTabIfNotExists: Tab;
  /** Creates some "Tab", throws an error if they already exist */
  createTabs: Array<Tab>;
  /** Creates one "Tag", throws an error if it already exists */
  createTag: Tag;
  /** Creates one "TagBrandedContent", throws an error if it already exists */
  createTagBrandedContent: TagBrandedContent;
  /** Creates one "TagBrandedContent" if it does not exist, returns the existing otherwise */
  createTagBrandedContentIfNotExists: TagBrandedContent;
  /** Creates some "TagBrandedContent", throws an error if they already exist */
  createTagBrandedContents: Array<TagBrandedContent>;
  /** Creates one "Tag" if it does not exist, returns the existing otherwise */
  createTagIfNotExists: Tag;
  /** Creates some "Tag", throws an error if they already exist */
  createTags: Array<Tag>;
  /** Creates some "Taxonomy", throws an error if they already exist */
  createTaxonomies: Array<Taxonomy>;
  /** Creates one "Taxonomy", throws an error if it already exists */
  createTaxonomy: Taxonomy;
  /** Creates one "Taxonomy" if it does not exist, returns the existing otherwise */
  createTaxonomyIfNotExists: Taxonomy;
  /** Deletes one "Article", throws an error if it does not exists */
  deleteArticle: Article;
  /** Deletes one "ArticleAuthor", throws an error if it does not exists */
  deleteArticleAuthor: ArticleAuthor;
  /** Deletes one "ArticleAuthor" if it exists, returns null otherwise */
  deleteArticleAuthorIfExists?: Maybe<ArticleAuthor>;
  /** Deletes many "ArticleAuthors" */
  deleteArticleAuthors: Array<ArticleAuthor>;
  /** Deletes many "ArticleCategories" */
  deleteArticleCategories: Array<ArticleCategory>;
  /** Deletes one "ArticleCategory", throws an error if it does not exists */
  deleteArticleCategory: ArticleCategory;
  /** Deletes one "ArticleCategory" if it exists, returns null otherwise */
  deleteArticleCategoryIfExists?: Maybe<ArticleCategory>;
  /** Deletes one "ArticleChannel", throws an error if it does not exists */
  deleteArticleChannel: ArticleChannel;
  /** Deletes one "ArticleChannel" if it exists, returns null otherwise */
  deleteArticleChannelIfExists?: Maybe<ArticleChannel>;
  /** Deletes many "ArticleChannels" */
  deleteArticleChannels: Array<ArticleChannel>;
  /** Deletes one "ArticleEvent", throws an error if it does not exists */
  deleteArticleEvent: ArticleEvent;
  /** Deletes one "ArticleEvent" if it exists, returns null otherwise */
  deleteArticleEventIfExists?: Maybe<ArticleEvent>;
  /** Deletes many "ArticleEvents" */
  deleteArticleEvents: Array<ArticleEvent>;
  /** Deletes one "ArticleGoodDealAiProcess", throws an error if it does not exists */
  deleteArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Deletes many "ArticleGoodDealAiProcesses" */
  deleteArticleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** Deletes one "ArticleGoodDealAiProcess" if it exists, returns null otherwise */
  deleteArticleGoodDealAiProcessIfExists?: Maybe<ArticleGoodDealAiProcess>;
  /** Deletes one "ArticleGoodDealAiPrompt", throws an error if it does not exists */
  deleteArticleGoodDealAiPrompt: ArticleGoodDealAiPrompt;
  /** Deletes one "ArticleGoodDealAiPrompt" if it exists, returns null otherwise */
  deleteArticleGoodDealAiPromptIfExists?: Maybe<ArticleGoodDealAiPrompt>;
  /** Deletes many "ArticleGoodDealAiPrompts" */
  deleteArticleGoodDealAiPrompts: Array<ArticleGoodDealAiPrompt>;
  /** Deletes one "ArticleGuide", throws an error if it does not exists */
  deleteArticleGuide: ArticleGuide;
  /** Deletes one "ArticleGuide" if it exists, returns null otherwise */
  deleteArticleGuideIfExists?: Maybe<ArticleGuide>;
  /** Deletes many "ArticleGuides" */
  deleteArticleGuides: Array<ArticleGuide>;
  /** Deletes one "Article" if it exists, returns null otherwise */
  deleteArticleIfExists?: Maybe<Article>;
  /** Deletes one "ArticleMachineTag", throws an error if it does not exists */
  deleteArticleMachineTag: ArticleMachineTag;
  /** Deletes one "ArticleMachineTag" if it exists, returns null otherwise */
  deleteArticleMachineTagIfExists?: Maybe<ArticleMachineTag>;
  /** Deletes many "ArticleMachineTags" */
  deleteArticleMachineTags: Array<ArticleMachineTag>;
  /** Deletes one "ArticleQualifier", throws an error if it does not exists */
  deleteArticleQualifier: ArticleQualifier;
  /** Deletes one "ArticleQualifier" if it exists, returns null otherwise */
  deleteArticleQualifierIfExists?: Maybe<ArticleQualifier>;
  /** Deletes many "ArticleQualifiers" */
  deleteArticleQualifiers: Array<ArticleQualifier>;
  /** Deletes many "Articles" */
  deleteArticles: Array<Article>;
  /** Deletes many "ArticleSummaries" */
  deleteArticleSummaries: Array<ArticleSummary>;
  /** Deletes one "ArticleSummary", throws an error if it does not exists */
  deleteArticleSummary: ArticleSummary;
  /** Deletes one "ArticleSummary" if it exists, returns null otherwise */
  deleteArticleSummaryIfExists?: Maybe<ArticleSummary>;
  /** Deletes one "ArticleTag", throws an error if it does not exists */
  deleteArticleTag: ArticleTag;
  /** Deletes one "ArticleTag" if it exists, returns null otherwise */
  deleteArticleTagIfExists?: Maybe<ArticleTag>;
  /** Deletes many "ArticleTags" */
  deleteArticleTags: Array<ArticleTag>;
  /** Deletes many "ArticleTaxonomies" */
  deleteArticleTaxonomies: Array<ArticleTaxonomy>;
  /** Deletes one "ArticleTaxonomy", throws an error if it does not exists */
  deleteArticleTaxonomy: ArticleTaxonomy;
  /** Deletes one "ArticleTaxonomy" if it exists, returns null otherwise */
  deleteArticleTaxonomyIfExists?: Maybe<ArticleTaxonomy>;
  /** Deletes one "Attribute", throws an error if it does not exists */
  deleteAttribute: Attribute;
  /** Deletes one "Attribute" if it exists, returns null otherwise */
  deleteAttributeIfExists?: Maybe<Attribute>;
  /** Deletes many "Attributes" */
  deleteAttributes: Array<Attribute>;
  /** Deletes one "Author", throws an error if it does not exists */
  deleteAuthor: Author;
  /** Deletes one "AuthorAttribute", throws an error if it does not exists */
  deleteAuthorAttribute: AuthorAttribute;
  /** Deletes one "AuthorAttribute" if it exists, returns null otherwise */
  deleteAuthorAttributeIfExists?: Maybe<AuthorAttribute>;
  /** Deletes many "AuthorAttributes" */
  deleteAuthorAttributes: Array<AuthorAttribute>;
  /** Deletes one "Author" if it exists, returns null otherwise */
  deleteAuthorIfExists?: Maybe<Author>;
  /** Deletes many "Authors" */
  deleteAuthors: Array<Author>;
  /** Deletes one "Card", throws an error if it does not exists */
  deleteCard: Card;
  /** Deletes many "CardCategories" */
  deleteCardCategories: Array<CardCategory>;
  /** Deletes one "CardCategory", throws an error if it does not exists */
  deleteCardCategory: CardCategory;
  /** Deletes one "CardCategory" if it exists, returns null otherwise */
  deleteCardCategoryIfExists?: Maybe<CardCategory>;
  /** Deletes one "Card" if it exists, returns null otherwise */
  deleteCardIfExists?: Maybe<Card>;
  /** Deletes many "Cards" */
  deleteCards: Array<Card>;
  /** Deletes one "CardTag", throws an error if it does not exists */
  deleteCardTag: CardTag;
  /** Deletes one "CardTag" if it exists, returns null otherwise */
  deleteCardTagIfExists?: Maybe<CardTag>;
  /** Deletes many "CardTags" */
  deleteCardTags: Array<CardTag>;
  /** Deletes many "Categories" */
  deleteCategories: Array<Category>;
  /** Deletes one "Category", throws an error if it does not exists */
  deleteCategory: Category;
  /** Deletes one "Category" if it exists, returns null otherwise */
  deleteCategoryIfExists?: Maybe<Category>;
  /** Deletes one "CategoryTag", throws an error if it does not exists */
  deleteCategoryTag: CategoryTag;
  /** Deletes one "CategoryTag" if it exists, returns null otherwise */
  deleteCategoryTagIfExists?: Maybe<CategoryTag>;
  /** Deletes many "CategoryTags" */
  deleteCategoryTags: Array<CategoryTag>;
  /** Deletes one "DailymotionLog", throws an error if it does not exists */
  deleteDailymotionLog: DailymotionLog;
  /** Deletes one "DailymotionLog" if it exists, returns null otherwise */
  deleteDailymotionLogIfExists?: Maybe<DailymotionLog>;
  /** Deletes many "DailymotionLogs" */
  deleteDailymotionLogs: Array<DailymotionLog>;
  /** Deletes one "ImageSource", throws an error if it does not exists */
  deleteImageSource: ImageSource;
  /** Deletes many "ImageSourceCategories" */
  deleteImageSourceCategories: Array<ImageSourceCategory>;
  /** Deletes one "ImageSourceCategory", throws an error if it does not exists */
  deleteImageSourceCategory: ImageSourceCategory;
  /** Deletes one "ImageSourceCategory" if it exists, returns null otherwise */
  deleteImageSourceCategoryIfExists?: Maybe<ImageSourceCategory>;
  /** Deletes one "ImageSource" if it exists, returns null otherwise */
  deleteImageSourceIfExists?: Maybe<ImageSource>;
  /** Deletes many "ImageSources" */
  deleteImageSources: Array<ImageSource>;
  /** Deletes one "Live", throws an error if it does not exists */
  deleteLive: Live;
  /** Deletes one "Live" if it exists, returns null otherwise */
  deleteLiveIfExists?: Maybe<Live>;
  /** Deletes one "LivePost", throws an error if it does not exists */
  deleteLivePost: LivePost;
  /** Deletes one "LivePost" if it exists, returns null otherwise */
  deleteLivePostIfExists?: Maybe<LivePost>;
  /** Deletes many "LivePosts" */
  deleteLivePosts: Array<LivePost>;
  /** Deletes many "Lives" */
  deleteLives: Array<Live>;
  /** Deletes one "MachineTag", throws an error if it does not exists */
  deleteMachineTag: MachineTag;
  /** Deletes one "MachineTag" if it exists, returns null otherwise */
  deleteMachineTagIfExists?: Maybe<MachineTag>;
  /** Deletes many "MachineTags" */
  deleteMachineTags: Array<MachineTag>;
  /** Deletes one "OpenAiProcess", throws an error if it does not exists */
  deleteOpenAiProcess: OpenAiProcess;
  /** Deletes many "OpenAiProcesses" */
  deleteOpenAiProcesses: Array<OpenAiProcess>;
  /** Deletes one "OpenAiProcess" if it exists, returns null otherwise */
  deleteOpenAiProcessIfExists?: Maybe<OpenAiProcess>;
  /** Deletes one "OrphanPage", throws an error if it does not exists */
  deleteOrphanPage: OrphanPage;
  /** Deletes one "OrphanPage" if it exists, returns null otherwise */
  deleteOrphanPageIfExists?: Maybe<OrphanPage>;
  /** Deletes many "OrphanPages" */
  deleteOrphanPages: Array<OrphanPage>;
  /** Deletes one "Prompt", throws an error if it does not exists */
  deletePrompt: Prompt;
  /** Deletes one "Prompt" if it exists, returns null otherwise */
  deletePromptIfExists?: Maybe<Prompt>;
  /** Deletes many "Prompts" */
  deletePrompts: Array<Prompt>;
  /** Deletes one "Push", throws an error if it does not exists */
  deletePush: Push;
  /** Deletes one "PushError", throws an error if it does not exists */
  deletePushError: PushError;
  /** Deletes one "PushError" if it exists, returns null otherwise */
  deletePushErrorIfExists?: Maybe<PushError>;
  /** Deletes many "PushErrors" */
  deletePushErrors: Array<PushError>;
  /** Deletes many "Pushes" */
  deletePushes: Array<Push>;
  /** Deletes one "Push" if it exists, returns null otherwise */
  deletePushIfExists?: Maybe<Push>;
  /** Delete one push-notification campaign */
  deletePushNotificationCampaign: Scalars['Boolean']['output'];
  /** Deletes one "PushSegment", throws an error if it does not exists */
  deletePushSegment: PushSegment;
  /** Deletes one "PushSegment" if it exists, returns null otherwise */
  deletePushSegmentIfExists?: Maybe<PushSegment>;
  /** Deletes many "PushSegments" */
  deletePushSegments: Array<PushSegment>;
  /** Deletes one "Qualifier", throws an error if it does not exists */
  deleteQualifier: Qualifier;
  /** Deletes one "Qualifier" if it exists, returns null otherwise */
  deleteQualifierIfExists?: Maybe<Qualifier>;
  /** Deletes many "Qualifiers" */
  deleteQualifiers: Array<Qualifier>;
  /** Deletes one "Segment", throws an error if it does not exists */
  deleteSegment: Segment;
  /** Deletes one "Segment" if it exists, returns null otherwise */
  deleteSegmentIfExists?: Maybe<Segment>;
  /** Deletes many "Segments" */
  deleteSegments: Array<Segment>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleAuthors" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleAuthorsInOrder: Array<ArticleAuthor>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleAuthors" then returns their old values, or null, in the same order
   */
  deleteSomeArticleAuthorsInOrderIfExists: Array<Maybe<ArticleAuthor>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleCategories" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleCategoriesInOrder: Array<ArticleCategory>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleCategories" then returns their old values, or null, in the same order
   */
  deleteSomeArticleCategoriesInOrderIfExists: Array<Maybe<ArticleCategory>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleChannels" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleChannelsInOrder: Array<ArticleChannel>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleChannels" then returns their old values, or null, in the same order
   */
  deleteSomeArticleChannelsInOrderIfExists: Array<Maybe<ArticleChannel>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleEvents" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleEventsInOrder: Array<ArticleEvent>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleEvents" then returns their old values, or null, in the same order
   */
  deleteSomeArticleEventsInOrderIfExists: Array<Maybe<ArticleEvent>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGoodDealAiProcesses" then returns their old values in the same order,
   * throws an error if one does not exist
   */
  deleteSomeArticleGoodDealAiProcessesInOrder: Array<ArticleGoodDealAiProcess>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGoodDealAiProcesses" then returns their old values, or null, in the same order
   */
  deleteSomeArticleGoodDealAiProcessesInOrderIfExists: Array<Maybe<ArticleGoodDealAiProcess>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGoodDealAiPrompts" then returns their old values in the same order,
   * throws an error if one does not exist
   */
  deleteSomeArticleGoodDealAiPromptsInOrder: Array<ArticleGoodDealAiPrompt>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGoodDealAiPrompts" then returns their old values, or null, in the same order
   */
  deleteSomeArticleGoodDealAiPromptsInOrderIfExists: Array<Maybe<ArticleGoodDealAiPrompt>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGuides" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleGuidesInOrder: Array<ArticleGuide>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleGuides" then returns their old values, or null, in the same order
   */
  deleteSomeArticleGuidesInOrderIfExists: Array<Maybe<ArticleGuide>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleMachineTags" then returns their old values in the same order, throws
   * an error if one does not exist
   */
  deleteSomeArticleMachineTagsInOrder: Array<ArticleMachineTag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleMachineTags" then returns their old values, or null, in the same order
   */
  deleteSomeArticleMachineTagsInOrderIfExists: Array<Maybe<ArticleMachineTag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleQualifiers" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleQualifiersInOrder: Array<ArticleQualifier>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleQualifiers" then returns their old values, or null, in the same order
   */
  deleteSomeArticleQualifiersInOrderIfExists: Array<Maybe<ArticleQualifier>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Articles"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeArticlesInOrder: Array<Article>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Articles"
   * then returns their old values, or null, in the same order
   */
  deleteSomeArticlesInOrderIfExists: Array<Maybe<Article>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleSummaries" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleSummariesInOrder: Array<ArticleSummary>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleSummaries" then returns their old values, or null, in the same order
   */
  deleteSomeArticleSummariesInOrderIfExists: Array<Maybe<ArticleSummary>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "ArticleTags"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeArticleTagsInOrder: Array<ArticleTag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "ArticleTags"
   * then returns their old values, or null, in the same order
   */
  deleteSomeArticleTagsInOrderIfExists: Array<Maybe<ArticleTag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleTaxonomies" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeArticleTaxonomiesInOrder: Array<ArticleTaxonomy>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ArticleTaxonomies" then returns their old values, or null, in the same order
   */
  deleteSomeArticleTaxonomiesInOrderIfExists: Array<Maybe<ArticleTaxonomy>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Attributes"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeAttributesInOrder: Array<Attribute>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Attributes"
   * then returns their old values, or null, in the same order
   */
  deleteSomeAttributesInOrderIfExists: Array<Maybe<Attribute>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "AuthorAttributes" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeAuthorAttributesInOrder: Array<AuthorAttribute>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "AuthorAttributes" then returns their old values, or null, in the same order
   */
  deleteSomeAuthorAttributesInOrderIfExists: Array<Maybe<AuthorAttribute>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Authors"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeAuthorsInOrder: Array<Author>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Authors"
   * then returns their old values, or null, in the same order
   */
  deleteSomeAuthorsInOrderIfExists: Array<Maybe<Author>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CardCategories" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeCardCategoriesInOrder: Array<CardCategory>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CardCategories" then returns their old values, or null, in the same order
   */
  deleteSomeCardCategoriesInOrderIfExists: Array<Maybe<CardCategory>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Cards" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeCardsInOrder: Array<Card>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Cards" then
   * returns their old values, or null, in the same order
   */
  deleteSomeCardsInOrderIfExists: Array<Maybe<Card>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "CardTags"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeCardTagsInOrder: Array<CardTag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "CardTags"
   * then returns their old values, or null, in the same order
   */
  deleteSomeCardTagsInOrderIfExists: Array<Maybe<CardTag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Categories"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeCategoriesInOrder: Array<Category>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Categories"
   * then returns their old values, or null, in the same order
   */
  deleteSomeCategoriesInOrderIfExists: Array<Maybe<Category>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CategoryTags" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeCategoryTagsInOrder: Array<CategoryTag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "CategoryTags" then returns their old values, or null, in the same order
   */
  deleteSomeCategoryTagsInOrderIfExists: Array<Maybe<CategoryTag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "DailymotionLogs" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeDailymotionLogsInOrder: Array<DailymotionLog>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "DailymotionLogs" then returns their old values, or null, in the same order
   */
  deleteSomeDailymotionLogsInOrderIfExists: Array<Maybe<DailymotionLog>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ImageSourceCategories" then returns their old values in the same order,
   * throws an error if one does not exist
   */
  deleteSomeImageSourceCategoriesInOrder: Array<ImageSourceCategory>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ImageSourceCategories" then returns their old values, or null, in the same order
   */
  deleteSomeImageSourceCategoriesInOrderIfExists: Array<Maybe<ImageSourceCategory>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ImageSources" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeImageSourcesInOrder: Array<ImageSource>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "ImageSources" then returns their old values, or null, in the same order
   */
  deleteSomeImageSourcesInOrderIfExists: Array<Maybe<ImageSource>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "LivePosts"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeLivePostsInOrder: Array<LivePost>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "LivePosts"
   * then returns their old values, or null, in the same order
   */
  deleteSomeLivePostsInOrderIfExists: Array<Maybe<LivePost>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Lives" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeLivesInOrder: Array<Live>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Lives" then
   * returns their old values, or null, in the same order
   */
  deleteSomeLivesInOrderIfExists: Array<Maybe<Live>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "MachineTags"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeMachineTagsInOrder: Array<MachineTag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "MachineTags"
   * then returns their old values, or null, in the same order
   */
  deleteSomeMachineTagsInOrderIfExists: Array<Maybe<MachineTag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "OpenAiProcesses" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomeOpenAiProcessesInOrder: Array<OpenAiProcess>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "OpenAiProcesses" then returns their old values, or null, in the same order
   */
  deleteSomeOpenAiProcessesInOrderIfExists: Array<Maybe<OpenAiProcess>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "OrphanPages"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeOrphanPagesInOrder: Array<OrphanPage>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "OrphanPages"
   * then returns their old values, or null, in the same order
   */
  deleteSomeOrphanPagesInOrderIfExists: Array<Maybe<OrphanPage>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Prompts"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomePromptsInOrder: Array<Prompt>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Prompts"
   * then returns their old values, or null, in the same order
   */
  deleteSomePromptsInOrderIfExists: Array<Maybe<Prompt>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "PushErrors"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomePushErrorsInOrder: Array<PushError>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "PushErrors"
   * then returns their old values, or null, in the same order
   */
  deleteSomePushErrorsInOrderIfExists: Array<Maybe<PushError>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Pushes" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomePushesInOrder: Array<Push>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Pushes" then
   * returns their old values, or null, in the same order
   */
  deleteSomePushesInOrderIfExists: Array<Maybe<Push>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PushSegments" then returns their old values in the same order, throws an
   * error if one does not exist
   */
  deleteSomePushSegmentsInOrder: Array<PushSegment>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "PushSegments" then returns their old values, or null, in the same order
   */
  deleteSomePushSegmentsInOrderIfExists: Array<Maybe<PushSegment>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Qualifiers"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeQualifiersInOrder: Array<Qualifier>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Qualifiers"
   * then returns their old values, or null, in the same order
   */
  deleteSomeQualifiersInOrderIfExists: Array<Maybe<Qualifier>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Segments"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeSegmentsInOrder: Array<Segment>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Segments"
   * then returns their old values, or null, in the same order
   */
  deleteSomeSegmentsInOrderIfExists: Array<Maybe<Segment>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Sources"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeSourcesInOrder: Array<Source>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Sources"
   * then returns their old values, or null, in the same order
   */
  deleteSomeSourcesInOrderIfExists: Array<Maybe<Source>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Tabs" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeTabsInOrder: Array<Tab>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Tabs" then
   * returns their old values, or null, in the same order
   */
  deleteSomeTabsInOrderIfExists: Array<Maybe<Tab>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "TagBrandedContents" then returns their old values in the same order, throws
   * an error if one does not exist
   */
  deleteSomeTagBrandedContentsInOrder: Array<TagBrandedContent>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding
   * "TagBrandedContents" then returns their old values, or null, in the same order
   */
  deleteSomeTagBrandedContentsInOrderIfExists: Array<Maybe<TagBrandedContent>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Tags" then
   * returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeTagsInOrder: Array<Tag>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Tags" then
   * returns their old values, or null, in the same order
   */
  deleteSomeTagsInOrderIfExists: Array<Maybe<Tag>>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Taxonomies"
   * then returns their old values in the same order, throws an error if one does not exist
   */
  deleteSomeTaxonomiesInOrder: Array<Taxonomy>;
  /**
   * Given a list of unique-filter's value, deletes the corresponding "Taxonomies"
   * then returns their old values, or null, in the same order
   */
  deleteSomeTaxonomiesInOrderIfExists: Array<Maybe<Taxonomy>>;
  /** Deletes one "Source", throws an error if it does not exists */
  deleteSource: Source;
  /** Deletes one "Source" if it exists, returns null otherwise */
  deleteSourceIfExists?: Maybe<Source>;
  /** Deletes many "Sources" */
  deleteSources: Array<Source>;
  /** Deletes one "Tab", throws an error if it does not exists */
  deleteTab: Tab;
  /** Deletes one "Tab" if it exists, returns null otherwise */
  deleteTabIfExists?: Maybe<Tab>;
  /** Deletes many "Tabs" */
  deleteTabs: Array<Tab>;
  /** Deletes one "Tag", throws an error if it does not exists */
  deleteTag: Tag;
  /** Deletes one "TagBrandedContent", throws an error if it does not exists */
  deleteTagBrandedContent: TagBrandedContent;
  /** Deletes one "TagBrandedContent" if it exists, returns null otherwise */
  deleteTagBrandedContentIfExists?: Maybe<TagBrandedContent>;
  /** Deletes many "TagBrandedContents" */
  deleteTagBrandedContents: Array<TagBrandedContent>;
  /** Deletes one "Tag" if it exists, returns null otherwise */
  deleteTagIfExists?: Maybe<Tag>;
  /** Deletes many "Tags" */
  deleteTags: Array<Tag>;
  /** Deletes many "Taxonomies" */
  deleteTaxonomies: Array<Taxonomy>;
  /** Deletes one "Taxonomy", throws an error if it does not exists */
  deleteTaxonomy: Taxonomy;
  /** Deletes one "Taxonomy" if it exists, returns null otherwise */
  deleteTaxonomyIfExists?: Maybe<Taxonomy>;
  /** Generate good deal article with ChatGPT base on a product URL */
  generateAIGoodDealArticle: ArticleGoodDealAiProcess;
  /** Generate Slideshow with Vertex AI and ChatGPT */
  generateAISlideshow: OpenAiProcess;
  /** Generate an article's summary, using AI */
  generateArticleSummary: ArticleSummary;
  /**
   * Import article with html body/lead and non-iframely medias. Expect the whole
   * article as a state, in case of update, all old relation will be removed and
   * replace by the new Undefined param will be ignored, null param will set the
   * field to null or delete all relations
   */
  importArticleFromHtml: Article;
  /** Import a video from Dailymotion, using its Dailymotion's ID */
  importDailymotionVideo: Article;
  /** Lock the Article */
  lockArticle: Scalars['Boolean']['output'];
  /** Lock the Category */
  lockCategory: Scalars['Boolean']['output'];
  /** Lock the TagBrandedContent */
  lockTagBrandedContent: Scalars['Boolean']['output'];
  /**
   * Merge some "from" tag(s) into a "to" tag. It will link the "to" tag to the
   * nodes linked to the "from" tag(s) then delete the "from" tag(s). It returns the "to" tag.
   */
  mergeTags: Tag;
  /** Update a Dailymotion video's thumbnail, using its Dailymotion's ID */
  refreshArticleMedias: Article;
  /** Refresh some nodes' article usages */
  refreshSomeAuthorsArticleUsage: Array<Author>;
  /** Refresh some nodes' article usages */
  refreshSomeQualifiersArticleUsage: Array<Qualifier>;
  /** Refresh some tags' activation */
  refreshSomeTagsActivation: Array<Tag>;
  /** Refresh some nodes' article usages */
  refreshSomeTagsArticleUsage: Array<Tag>;
  /** Retain the lock on the Article */
  retainArticleLock: Scalars['Boolean']['output'];
  /** Retain the lock on the Category */
  retainCategoryLock: Scalars['Boolean']['output'];
  /** Retain the lock on the TagBrandedContent */
  retainTagBrandedContentLock: Scalars['Boolean']['output'];
  /** Unlock the Article */
  unlockArticle: Scalars['Boolean']['output'];
  /** Unlock the Category */
  unlockCategory: Scalars['Boolean']['output'];
  /** Unlock the TagBrandedContent */
  unlockTagBrandedContent: Scalars['Boolean']['output'];
  /** Updates one "Article", throws an error if it does not exists */
  updateArticle: Article;
  /** Updates one "ArticleAuthor", throws an error if it does not exists */
  updateArticleAuthor: ArticleAuthor;
  /** Updates one "ArticleAuthor" if it exists, returns null otherwise */
  updateArticleAuthorIfExists?: Maybe<ArticleAuthor>;
  /** Updates many "ArticleAuthors" */
  updateArticleAuthors: Array<ArticleAuthor>;
  /** Updates many "ArticleCategories" */
  updateArticleCategories: Array<ArticleCategory>;
  /** Updates one "ArticleCategory", throws an error if it does not exists */
  updateArticleCategory: ArticleCategory;
  /** Updates one "ArticleCategory" if it exists, returns null otherwise */
  updateArticleCategoryIfExists?: Maybe<ArticleCategory>;
  /** Updates one "ArticleChannel", throws an error if it does not exists */
  updateArticleChannel: ArticleChannel;
  /** Updates one "ArticleChannel" if it exists, returns null otherwise */
  updateArticleChannelIfExists?: Maybe<ArticleChannel>;
  /** Updates many "ArticleChannels" */
  updateArticleChannels: Array<ArticleChannel>;
  /** Updates one "ArticleEvent", throws an error if it does not exists */
  updateArticleEvent: ArticleEvent;
  /** Updates one "ArticleEvent" if it exists, returns null otherwise */
  updateArticleEventIfExists?: Maybe<ArticleEvent>;
  /** Updates many "ArticleEvents" */
  updateArticleEvents: Array<ArticleEvent>;
  /** Updates one "ArticleGoodDealAiProcess", throws an error if it does not exists */
  updateArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Updates many "ArticleGoodDealAiProcesses" */
  updateArticleGoodDealAiProcesses: Array<ArticleGoodDealAiProcess>;
  /** Updates one "ArticleGoodDealAiProcess" if it exists, returns null otherwise */
  updateArticleGoodDealAiProcessIfExists?: Maybe<ArticleGoodDealAiProcess>;
  /** Updates one "ArticleGoodDealAiPrompt", throws an error if it does not exists */
  updateArticleGoodDealAiPrompt: ArticleGoodDealAiPrompt;
  /** Updates one "ArticleGoodDealAiPrompt" if it exists, returns null otherwise */
  updateArticleGoodDealAiPromptIfExists?: Maybe<ArticleGoodDealAiPrompt>;
  /** Updates many "ArticleGoodDealAiPrompts" */
  updateArticleGoodDealAiPrompts: Array<ArticleGoodDealAiPrompt>;
  /** Updates one "ArticleGuide", throws an error if it does not exists */
  updateArticleGuide: ArticleGuide;
  /** Updates one "ArticleGuide" if it exists, returns null otherwise */
  updateArticleGuideIfExists?: Maybe<ArticleGuide>;
  /** Updates many "ArticleGuides" */
  updateArticleGuides: Array<ArticleGuide>;
  /** Updates one "Article" if it exists, returns null otherwise */
  updateArticleIfExists?: Maybe<Article>;
  /** Updates one "ArticleMachineTag", throws an error if it does not exists */
  updateArticleMachineTag: ArticleMachineTag;
  /** Updates one "ArticleMachineTag" if it exists, returns null otherwise */
  updateArticleMachineTagIfExists?: Maybe<ArticleMachineTag>;
  /** Updates many "ArticleMachineTags" */
  updateArticleMachineTags: Array<ArticleMachineTag>;
  /** Updates one "ArticleQualifier", throws an error if it does not exists */
  updateArticleQualifier: ArticleQualifier;
  /** Updates one "ArticleQualifier" if it exists, returns null otherwise */
  updateArticleQualifierIfExists?: Maybe<ArticleQualifier>;
  /** Updates many "ArticleQualifiers" */
  updateArticleQualifiers: Array<ArticleQualifier>;
  /** Updates many "Articles" */
  updateArticles: Array<Article>;
  /** Updates many "ArticleSummaries" */
  updateArticleSummaries: Array<ArticleSummary>;
  /** Updates one "ArticleSummary", throws an error if it does not exists */
  updateArticleSummary: ArticleSummary;
  /** Updates one "ArticleSummary" if it exists, returns null otherwise */
  updateArticleSummaryIfExists?: Maybe<ArticleSummary>;
  /** Updates one "ArticleTag", throws an error if it does not exists */
  updateArticleTag: ArticleTag;
  /** Updates one "ArticleTag" if it exists, returns null otherwise */
  updateArticleTagIfExists?: Maybe<ArticleTag>;
  /** Updates many "ArticleTags" */
  updateArticleTags: Array<ArticleTag>;
  /** Updates many "ArticleTaxonomies" */
  updateArticleTaxonomies: Array<ArticleTaxonomy>;
  /** Updates one "ArticleTaxonomy", throws an error if it does not exists */
  updateArticleTaxonomy: ArticleTaxonomy;
  /** Updates one "ArticleTaxonomy" if it exists, returns null otherwise */
  updateArticleTaxonomyIfExists?: Maybe<ArticleTaxonomy>;
  /** Updates one "Attribute", throws an error if it does not exists */
  updateAttribute: Attribute;
  /** Updates one "Attribute" if it exists, returns null otherwise */
  updateAttributeIfExists?: Maybe<Attribute>;
  /** Updates many "Attributes" */
  updateAttributes: Array<Attribute>;
  /** Updates one "Author", throws an error if it does not exists */
  updateAuthor: Author;
  /** Updates one "AuthorAttribute", throws an error if it does not exists */
  updateAuthorAttribute: AuthorAttribute;
  /** Updates one "AuthorAttribute" if it exists, returns null otherwise */
  updateAuthorAttributeIfExists?: Maybe<AuthorAttribute>;
  /** Updates many "AuthorAttributes" */
  updateAuthorAttributes: Array<AuthorAttribute>;
  /** Updates one "Author" if it exists, returns null otherwise */
  updateAuthorIfExists?: Maybe<Author>;
  /** Updates many "Authors" */
  updateAuthors: Array<Author>;
  /** Updates one "Card", throws an error if it does not exists */
  updateCard: Card;
  /** Updates many "CardCategories" */
  updateCardCategories: Array<CardCategory>;
  /** Updates one "CardCategory", throws an error if it does not exists */
  updateCardCategory: CardCategory;
  /** Updates one "CardCategory" if it exists, returns null otherwise */
  updateCardCategoryIfExists?: Maybe<CardCategory>;
  /** Updates one "Card" if it exists, returns null otherwise */
  updateCardIfExists?: Maybe<Card>;
  /** Updates many "Cards" */
  updateCards: Array<Card>;
  /** Updates one "CardTag", throws an error if it does not exists */
  updateCardTag: CardTag;
  /** Updates one "CardTag" if it exists, returns null otherwise */
  updateCardTagIfExists?: Maybe<CardTag>;
  /** Updates many "CardTags" */
  updateCardTags: Array<CardTag>;
  /** Updates many "Categories" */
  updateCategories: Array<Category>;
  /** Updates one "Category", throws an error if it does not exists */
  updateCategory: Category;
  /** Updates one "Category" if it exists, returns null otherwise */
  updateCategoryIfExists?: Maybe<Category>;
  /** Updates one "CategoryTag", throws an error if it does not exists */
  updateCategoryTag: CategoryTag;
  /** Updates one "CategoryTag" if it exists, returns null otherwise */
  updateCategoryTagIfExists?: Maybe<CategoryTag>;
  /** Updates many "CategoryTags" */
  updateCategoryTags: Array<CategoryTag>;
  /** Update a Dailymotion video's thumbnail, using its Dailymotion's ID */
  updateDailymotionVideoThumbnail: Scalars['Boolean']['output'];
  /** Updates one "ImageSource", throws an error if it does not exists */
  updateImageSource: ImageSource;
  /** Updates many "ImageSourceCategories" */
  updateImageSourceCategories: Array<ImageSourceCategory>;
  /** Updates one "ImageSourceCategory", throws an error if it does not exists */
  updateImageSourceCategory: ImageSourceCategory;
  /** Updates one "ImageSourceCategory" if it exists, returns null otherwise */
  updateImageSourceCategoryIfExists?: Maybe<ImageSourceCategory>;
  /** Updates one "ImageSource" if it exists, returns null otherwise */
  updateImageSourceIfExists?: Maybe<ImageSource>;
  /** Updates many "ImageSources" */
  updateImageSources: Array<ImageSource>;
  /** Updates one "Live", throws an error if it does not exists */
  updateLive: Live;
  /** Updates one "Live" if it exists, returns null otherwise */
  updateLiveIfExists?: Maybe<Live>;
  /** Updates one "LivePost", throws an error if it does not exists */
  updateLivePost: LivePost;
  /** Updates one "LivePost" if it exists, returns null otherwise */
  updateLivePostIfExists?: Maybe<LivePost>;
  /** Updates many "LivePosts" */
  updateLivePosts: Array<LivePost>;
  /** Updates many "Lives" */
  updateLives: Array<Live>;
  /** Updates one "MachineTag", throws an error if it does not exists */
  updateMachineTag: MachineTag;
  /** Updates one "MachineTag" if it exists, returns null otherwise */
  updateMachineTagIfExists?: Maybe<MachineTag>;
  /** Updates many "MachineTags" */
  updateMachineTags: Array<MachineTag>;
  /** Updates one "OpenAiProcess", throws an error if it does not exists */
  updateOpenAiProcess: OpenAiProcess;
  /** Updates many "OpenAiProcesses" */
  updateOpenAiProcesses: Array<OpenAiProcess>;
  /** Updates one "OpenAiProcess" if it exists, returns null otherwise */
  updateOpenAiProcessIfExists?: Maybe<OpenAiProcess>;
  /** Updates one "OrphanPage", throws an error if it does not exists */
  updateOrphanPage: OrphanPage;
  /** Updates one "OrphanPage" if it exists, returns null otherwise */
  updateOrphanPageIfExists?: Maybe<OrphanPage>;
  /** Updates many "OrphanPages" */
  updateOrphanPages: Array<OrphanPage>;
  /** Updates one "Prompt", throws an error if it does not exists */
  updatePrompt: Prompt;
  /** Updates one "Prompt" if it exists, returns null otherwise */
  updatePromptIfExists?: Maybe<Prompt>;
  /** Updates many "Prompts" */
  updatePrompts: Array<Prompt>;
  /** Updates one "Push", throws an error if it does not exists */
  updatePush: Push;
  /** Updates many "Pushes" */
  updatePushes: Array<Push>;
  /** Updates one "Push" if it exists, returns null otherwise */
  updatePushIfExists?: Maybe<Push>;
  /** Update one push-notification campaign */
  updatePushNotificationCampaign: Scalars['Boolean']['output'];
  /** Updates one "Qualifier", throws an error if it does not exists */
  updateQualifier: Qualifier;
  /** Updates one "Qualifier" if it exists, returns null otherwise */
  updateQualifierIfExists?: Maybe<Qualifier>;
  /** Updates many "Qualifiers" */
  updateQualifiers: Array<Qualifier>;
  /** Updates one "Segment", throws an error if it does not exists */
  updateSegment: Segment;
  /** Updates one "Segment" if it exists, returns null otherwise */
  updateSegmentIfExists?: Maybe<Segment>;
  /** Updates many "Segments" */
  updateSegments: Array<Segment>;
  /** Complete existing AI slideshow with ChatGPT */
  updateSlidehowRecipesDescriptions: OpenAiProcess;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleAuthors" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleAuthorsInOrder: Array<ArticleAuthor>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleAuthors" then returns their new values, or null, in the same order
   */
  updateSomeArticleAuthorsInOrderIfExists: Array<Maybe<ArticleAuthor>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleCategories" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleCategoriesInOrder: Array<ArticleCategory>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleCategories" then returns their new values, or null, in the same order
   */
  updateSomeArticleCategoriesInOrderIfExists: Array<Maybe<ArticleCategory>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleChannels" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleChannelsInOrder: Array<ArticleChannel>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleChannels" then returns their new values, or null, in the same order
   */
  updateSomeArticleChannelsInOrderIfExists: Array<Maybe<ArticleChannel>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleEvents" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleEventsInOrder: Array<ArticleEvent>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleEvents" then returns their new values, or null, in the same order
   */
  updateSomeArticleEventsInOrderIfExists: Array<Maybe<ArticleEvent>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGoodDealAiProcesses" then returns their new values in the same order,
   * throws an error if one does not exist
   */
  updateSomeArticleGoodDealAiProcessesInOrder: Array<ArticleGoodDealAiProcess>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGoodDealAiProcesses" then returns their new values, or null, in the same order
   */
  updateSomeArticleGoodDealAiProcessesInOrderIfExists: Array<Maybe<ArticleGoodDealAiProcess>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGoodDealAiPrompts" then returns their new values in the same order,
   * throws an error if one does not exist
   */
  updateSomeArticleGoodDealAiPromptsInOrder: Array<ArticleGoodDealAiPrompt>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGoodDealAiPrompts" then returns their new values, or null, in the same order
   */
  updateSomeArticleGoodDealAiPromptsInOrderIfExists: Array<Maybe<ArticleGoodDealAiPrompt>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGuides" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleGuidesInOrder: Array<ArticleGuide>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleGuides" then returns their new values, or null, in the same order
   */
  updateSomeArticleGuidesInOrderIfExists: Array<Maybe<ArticleGuide>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleMachineTags" then returns their new values in the same order, throws
   * an error if one does not exist
   */
  updateSomeArticleMachineTagsInOrder: Array<ArticleMachineTag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleMachineTags" then returns their new values, or null, in the same order
   */
  updateSomeArticleMachineTagsInOrderIfExists: Array<Maybe<ArticleMachineTag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleQualifiers" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleQualifiersInOrder: Array<ArticleQualifier>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleQualifiers" then returns their new values, or null, in the same order
   */
  updateSomeArticleQualifiersInOrderIfExists: Array<Maybe<ArticleQualifier>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Articles"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeArticlesInOrder: Array<Article>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Articles"
   * then returns their new values, or null, in the same order
   */
  updateSomeArticlesInOrderIfExists: Array<Maybe<Article>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleSummaries" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleSummariesInOrder: Array<ArticleSummary>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleSummaries" then returns their new values, or null, in the same order
   */
  updateSomeArticleSummariesInOrderIfExists: Array<Maybe<ArticleSummary>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "ArticleTags"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeArticleTagsInOrder: Array<ArticleTag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "ArticleTags"
   * then returns their new values, or null, in the same order
   */
  updateSomeArticleTagsInOrderIfExists: Array<Maybe<ArticleTag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleTaxonomies" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeArticleTaxonomiesInOrder: Array<ArticleTaxonomy>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ArticleTaxonomies" then returns their new values, or null, in the same order
   */
  updateSomeArticleTaxonomiesInOrderIfExists: Array<Maybe<ArticleTaxonomy>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Attributes"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeAttributesInOrder: Array<Attribute>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Attributes"
   * then returns their new values, or null, in the same order
   */
  updateSomeAttributesInOrderIfExists: Array<Maybe<Attribute>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "AuthorAttributes" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeAuthorAttributesInOrder: Array<AuthorAttribute>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "AuthorAttributes" then returns their new values, or null, in the same order
   */
  updateSomeAuthorAttributesInOrderIfExists: Array<Maybe<AuthorAttribute>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Authors"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeAuthorsInOrder: Array<Author>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Authors"
   * then returns their new values, or null, in the same order
   */
  updateSomeAuthorsInOrderIfExists: Array<Maybe<Author>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CardCategories" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeCardCategoriesInOrder: Array<CardCategory>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CardCategories" then returns their new values, or null, in the same order
   */
  updateSomeCardCategoriesInOrderIfExists: Array<Maybe<CardCategory>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Cards" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeCardsInOrder: Array<Card>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Cards" then
   * returns their new values, or null, in the same order
   */
  updateSomeCardsInOrderIfExists: Array<Maybe<Card>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "CardTags"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeCardTagsInOrder: Array<CardTag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "CardTags"
   * then returns their new values, or null, in the same order
   */
  updateSomeCardTagsInOrderIfExists: Array<Maybe<CardTag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Categories"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeCategoriesInOrder: Array<Category>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Categories"
   * then returns their new values, or null, in the same order
   */
  updateSomeCategoriesInOrderIfExists: Array<Maybe<Category>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CategoryTags" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeCategoryTagsInOrder: Array<CategoryTag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "CategoryTags" then returns their new values, or null, in the same order
   */
  updateSomeCategoryTagsInOrderIfExists: Array<Maybe<CategoryTag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ImageSourceCategories" then returns their new values in the same order,
   * throws an error if one does not exist
   */
  updateSomeImageSourceCategoriesInOrder: Array<ImageSourceCategory>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ImageSourceCategories" then returns their new values, or null, in the same order
   */
  updateSomeImageSourceCategoriesInOrderIfExists: Array<Maybe<ImageSourceCategory>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ImageSources" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeImageSourcesInOrder: Array<ImageSource>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "ImageSources" then returns their new values, or null, in the same order
   */
  updateSomeImageSourcesInOrderIfExists: Array<Maybe<ImageSource>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "LivePosts"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeLivePostsInOrder: Array<LivePost>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "LivePosts"
   * then returns their new values, or null, in the same order
   */
  updateSomeLivePostsInOrderIfExists: Array<Maybe<LivePost>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Lives" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeLivesInOrder: Array<Live>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Lives" then
   * returns their new values, or null, in the same order
   */
  updateSomeLivesInOrderIfExists: Array<Maybe<Live>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "MachineTags"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeMachineTagsInOrder: Array<MachineTag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "MachineTags"
   * then returns their new values, or null, in the same order
   */
  updateSomeMachineTagsInOrderIfExists: Array<Maybe<MachineTag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "OpenAiProcesses" then returns their new values in the same order, throws an
   * error if one does not exist
   */
  updateSomeOpenAiProcessesInOrder: Array<OpenAiProcess>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "OpenAiProcesses" then returns their new values, or null, in the same order
   */
  updateSomeOpenAiProcessesInOrderIfExists: Array<Maybe<OpenAiProcess>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "OrphanPages"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeOrphanPagesInOrder: Array<OrphanPage>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "OrphanPages"
   * then returns their new values, or null, in the same order
   */
  updateSomeOrphanPagesInOrderIfExists: Array<Maybe<OrphanPage>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Prompts"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomePromptsInOrder: Array<Prompt>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Prompts"
   * then returns their new values, or null, in the same order
   */
  updateSomePromptsInOrderIfExists: Array<Maybe<Prompt>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Pushes" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomePushesInOrder: Array<Push>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Pushes" then
   * returns their new values, or null, in the same order
   */
  updateSomePushesInOrderIfExists: Array<Maybe<Push>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Qualifiers"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeQualifiersInOrder: Array<Qualifier>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Qualifiers"
   * then returns their new values, or null, in the same order
   */
  updateSomeQualifiersInOrderIfExists: Array<Maybe<Qualifier>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Segments"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeSegmentsInOrder: Array<Segment>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Segments"
   * then returns their new values, or null, in the same order
   */
  updateSomeSegmentsInOrderIfExists: Array<Maybe<Segment>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Sources"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeSourcesInOrder: Array<Source>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Sources"
   * then returns their new values, or null, in the same order
   */
  updateSomeSourcesInOrderIfExists: Array<Maybe<Source>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Tabs" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeTabsInOrder: Array<Tab>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Tabs" then
   * returns their new values, or null, in the same order
   */
  updateSomeTabsInOrderIfExists: Array<Maybe<Tab>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "TagBrandedContents" then returns their new values in the same order, throws
   * an error if one does not exist
   */
  updateSomeTagBrandedContentsInOrder: Array<TagBrandedContent>;
  /**
   * Given a list of unique-filter's value, updates the corresponding
   * "TagBrandedContents" then returns their new values, or null, in the same order
   */
  updateSomeTagBrandedContentsInOrderIfExists: Array<Maybe<TagBrandedContent>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Tags" then
   * returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeTagsInOrder: Array<Tag>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Tags" then
   * returns their new values, or null, in the same order
   */
  updateSomeTagsInOrderIfExists: Array<Maybe<Tag>>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Taxonomies"
   * then returns their new values in the same order, throws an error if one does not exist
   */
  updateSomeTaxonomiesInOrder: Array<Taxonomy>;
  /**
   * Given a list of unique-filter's value, updates the corresponding "Taxonomies"
   * then returns their new values, or null, in the same order
   */
  updateSomeTaxonomiesInOrderIfExists: Array<Maybe<Taxonomy>>;
  /** Updates one "Source", throws an error if it does not exists */
  updateSource: Source;
  /** Updates one "Source" if it exists, returns null otherwise */
  updateSourceIfExists?: Maybe<Source>;
  /** Updates many "Sources" */
  updateSources: Array<Source>;
  /** Updates one "Tab", throws an error if it does not exists */
  updateTab: Tab;
  /** Updates one "Tab" if it exists, returns null otherwise */
  updateTabIfExists?: Maybe<Tab>;
  /** Updates many "Tabs" */
  updateTabs: Array<Tab>;
  /** Updates one "Tag", throws an error if it does not exists */
  updateTag: Tag;
  /** Updates one "TagBrandedContent", throws an error if it does not exists */
  updateTagBrandedContent: TagBrandedContent;
  /** Updates one "TagBrandedContent" if it exists, returns null otherwise */
  updateTagBrandedContentIfExists?: Maybe<TagBrandedContent>;
  /** Updates many "TagBrandedContents" */
  updateTagBrandedContents: Array<TagBrandedContent>;
  /** Updates one "Tag" if it exists, returns null otherwise */
  updateTagIfExists?: Maybe<Tag>;
  /** Updates many "Tags" */
  updateTags: Array<Tag>;
  /** Updates many "Taxonomies" */
  updateTaxonomies: Array<Taxonomy>;
  /** Updates one "Taxonomy", throws an error if it does not exists */
  updateTaxonomy: Taxonomy;
  /** Updates one "Taxonomy" if it exists, returns null otherwise */
  updateTaxonomyIfExists?: Maybe<Taxonomy>;
  /** Updates an existing "Article" or creates a new one */
  upsertArticle: Article;
  /** Updates an existing "ArticleAuthor" or creates a new one */
  upsertArticleAuthor: ArticleAuthor;
  /** Updates an existing "ArticleCategory" or creates a new one */
  upsertArticleCategory: ArticleCategory;
  /** Updates an existing "ArticleChannel" or creates a new one */
  upsertArticleChannel: ArticleChannel;
  /** Updates an existing "ArticleEvent" or creates a new one */
  upsertArticleEvent: ArticleEvent;
  /** Updates an existing "ArticleGoodDealAiProcess" or creates a new one */
  upsertArticleGoodDealAiProcess: ArticleGoodDealAiProcess;
  /** Updates an existing "ArticleGoodDealAiPrompt" or creates a new one */
  upsertArticleGoodDealAiPrompt: ArticleGoodDealAiPrompt;
  /** Updates an existing "ArticleGuide" or creates a new one */
  upsertArticleGuide: ArticleGuide;
  /** Updates an existing "ArticleMachineTag" or creates a new one */
  upsertArticleMachineTag: ArticleMachineTag;
  /** Updates an existing "ArticleQualifier" or creates a new one */
  upsertArticleQualifier: ArticleQualifier;
  /** Updates an existing "ArticleSummary" or creates a new one */
  upsertArticleSummary: ArticleSummary;
  /** Updates an existing "ArticleTag" or creates a new one */
  upsertArticleTag: ArticleTag;
  /** Updates an existing "ArticleTaxonomy" or creates a new one */
  upsertArticleTaxonomy: ArticleTaxonomy;
  /** Updates an existing "Attribute" or creates a new one */
  upsertAttribute: Attribute;
  /** Updates an existing "Author" or creates a new one */
  upsertAuthor: Author;
  /** Updates an existing "AuthorAttribute" or creates a new one */
  upsertAuthorAttribute: AuthorAttribute;
  /** Updates an existing "Card" or creates a new one */
  upsertCard: Card;
  /** Updates an existing "CardCategory" or creates a new one */
  upsertCardCategory: CardCategory;
  /** Updates an existing "CardTag" or creates a new one */
  upsertCardTag: CardTag;
  /** Updates an existing "Category" or creates a new one */
  upsertCategory: Category;
  /** Updates an existing "CategoryTag" or creates a new one */
  upsertCategoryTag: CategoryTag;
  /** Updates an existing "ImageSource" or creates a new one */
  upsertImageSource: ImageSource;
  /** Updates an existing "ImageSourceCategory" or creates a new one */
  upsertImageSourceCategory: ImageSourceCategory;
  /** Updates an existing "Live" or creates a new one */
  upsertLive: Live;
  /** Updates an existing "LivePost" or creates a new one */
  upsertLivePost: LivePost;
  /** Updates an existing "MachineTag" or creates a new one */
  upsertMachineTag: MachineTag;
  /** Updates an existing "OpenAiProcess" or creates a new one */
  upsertOpenAiProcess: OpenAiProcess;
  /** Updates an existing "OrphanPage" or creates a new one */
  upsertOrphanPage: OrphanPage;
  /** Updates an existing "Prompt" or creates a new one */
  upsertPrompt: Prompt;
  /** Updates an existing "Push" or creates a new one */
  upsertPush: Push;
  /** Updates an existing "Qualifier" or creates a new one */
  upsertQualifier: Qualifier;
  /** Updates an existing "Segment" or creates a new one */
  upsertSegment: Segment;
  /** Updates an existing "Source" or creates a new one */
  upsertSource: Source;
  /** Updates an existing "Tab" or creates a new one */
  upsertTab: Tab;
  /** Updates an existing "Tag" or creates a new one */
  upsertTag: Tag;
  /** Updates an existing "TagBrandedContent" or creates a new one */
  upsertTagBrandedContent: TagBrandedContent;
  /** Updates an existing "Taxonomy" or creates a new one */
  upsertTaxonomy: Taxonomy;
};


export type MutationAddSecondaryArticleUrlArgs = {
  article: ArticleUniqueFilterInput;
  path: Scalars['NonEmptyTrimmedString']['input'];
  prepend?: Scalars['Boolean']['input'];
};


export type MutationAddSecondaryCategoryUrlArgs = {
  category: CategoryUniqueFilterInput;
  path: Scalars['NonEmptyTrimmedString']['input'];
  prepend?: Scalars['Boolean']['input'];
};


export type MutationCompleteAiSlideshowArgs = {
  brandKey: BrandKey;
  recipeIds: Array<Scalars['String']['input']>;
  recipeNumber: Scalars['Int']['input'];
  slideshowEditionId: Scalars['UUIDv4']['input'];
  slideshowSubject: Scalars['NonEmptyString']['input'];
};


export type MutationCreateAffiliationCardArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  localizedProductId: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
  negativePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  positivePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateAffiliationCatalogProductArgs = {
  localizedProductId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateArticleArgs = {
  data: ArticleCreationInput;
};


export type MutationCreateArticleAuthorArgs = {
  data: ArticleAuthorCreationInput;
};


export type MutationCreateArticleAuthorIfNotExistsArgs = {
  data: ArticleAuthorCreationInput;
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationCreateArticleAuthorsArgs = {
  data: Array<ArticleAuthorCreationInput>;
};


export type MutationCreateArticleCategoriesArgs = {
  data: Array<ArticleCategoryCreationInput>;
};


export type MutationCreateArticleCategoryArgs = {
  data: ArticleCategoryCreationInput;
};


export type MutationCreateArticleCategoryIfNotExistsArgs = {
  data: ArticleCategoryCreationInput;
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationCreateArticleChannelArgs = {
  data: ArticleChannelCreationInput;
};


export type MutationCreateArticleChannelIfNotExistsArgs = {
  data: ArticleChannelCreationInput;
  where: ArticleChannelUniqueFilterInput;
};


export type MutationCreateArticleChannelsArgs = {
  data: Array<ArticleChannelCreationInput>;
};


export type MutationCreateArticleEventArgs = {
  data: ArticleEventCreationInput;
};


export type MutationCreateArticleEventIfNotExistsArgs = {
  data: ArticleEventCreationInput;
  where: ArticleEventUniqueFilterInput;
};


export type MutationCreateArticleEventsArgs = {
  data: Array<ArticleEventCreationInput>;
};


export type MutationCreateArticleGoodDealAiProcessArgs = {
  data: ArticleGoodDealAiProcessCreationInput;
};


export type MutationCreateArticleGoodDealAiProcessesArgs = {
  data: Array<ArticleGoodDealAiProcessCreationInput>;
};


export type MutationCreateArticleGoodDealAiProcessIfNotExistsArgs = {
  data: ArticleGoodDealAiProcessCreationInput;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationCreateArticleGoodDealAiPromptArgs = {
  data: ArticleGoodDealAiPromptCreationInput;
};


export type MutationCreateArticleGoodDealAiPromptIfNotExistsArgs = {
  data: ArticleGoodDealAiPromptCreationInput;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationCreateArticleGoodDealAiPromptsArgs = {
  data: Array<ArticleGoodDealAiPromptCreationInput>;
};


export type MutationCreateArticleGuideArgs = {
  data: ArticleGuideCreationInput;
};


export type MutationCreateArticleGuideIfNotExistsArgs = {
  data: ArticleGuideCreationInput;
  where: ArticleGuideUniqueFilterInput;
};


export type MutationCreateArticleGuidesArgs = {
  data: Array<ArticleGuideCreationInput>;
};


export type MutationCreateArticleIfNotExistsArgs = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};


export type MutationCreateArticleMachineTagArgs = {
  data: ArticleMachineTagCreationInput;
};


export type MutationCreateArticleMachineTagIfNotExistsArgs = {
  data: ArticleMachineTagCreationInput;
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationCreateArticleMachineTagsArgs = {
  data: Array<ArticleMachineTagCreationInput>;
};


export type MutationCreateArticleQualifierArgs = {
  data: ArticleQualifierCreationInput;
};


export type MutationCreateArticleQualifierIfNotExistsArgs = {
  data: ArticleQualifierCreationInput;
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationCreateArticleQualifiersArgs = {
  data: Array<ArticleQualifierCreationInput>;
};


export type MutationCreateArticlesArgs = {
  data: Array<ArticleCreationInput>;
};


export type MutationCreateArticleSummariesArgs = {
  data: Array<ArticleSummaryCreationInput>;
};


export type MutationCreateArticleSummaryArgs = {
  data: ArticleSummaryCreationInput;
};


export type MutationCreateArticleSummaryIfNotExistsArgs = {
  data: ArticleSummaryCreationInput;
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationCreateArticleTagArgs = {
  data: ArticleTagCreationInput;
};


export type MutationCreateArticleTagIfNotExistsArgs = {
  data: ArticleTagCreationInput;
  where: ArticleTagUniqueFilterInput;
};


export type MutationCreateArticleTagsArgs = {
  data: Array<ArticleTagCreationInput>;
};


export type MutationCreateArticleTaxonomiesArgs = {
  data: Array<ArticleTaxonomyCreationInput>;
};


export type MutationCreateArticleTaxonomyArgs = {
  data: ArticleTaxonomyCreationInput;
};


export type MutationCreateArticleTaxonomyIfNotExistsArgs = {
  data: ArticleTaxonomyCreationInput;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationCreateAttributeArgs = {
  data: AttributeCreationInput;
};


export type MutationCreateAttributeIfNotExistsArgs = {
  data: AttributeCreationInput;
  where: AttributeUniqueFilterInput;
};


export type MutationCreateAttributesArgs = {
  data: Array<AttributeCreationInput>;
};


export type MutationCreateAuthorArgs = {
  data: AuthorCreationInput;
};


export type MutationCreateAuthorAttributeArgs = {
  data: AuthorAttributeCreationInput;
};


export type MutationCreateAuthorAttributeIfNotExistsArgs = {
  data: AuthorAttributeCreationInput;
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationCreateAuthorAttributesArgs = {
  data: Array<AuthorAttributeCreationInput>;
};


export type MutationCreateAuthorIfNotExistsArgs = {
  data: AuthorCreationInput;
  where: AuthorUniqueFilterInput;
};


export type MutationCreateAuthorsArgs = {
  data: Array<AuthorCreationInput>;
};


export type MutationCreateCardArgs = {
  data: CardCreationInput;
};


export type MutationCreateCardCategoriesArgs = {
  data: Array<CardCategoryCreationInput>;
};


export type MutationCreateCardCategoryArgs = {
  data: CardCategoryCreationInput;
};


export type MutationCreateCardCategoryIfNotExistsArgs = {
  data: CardCategoryCreationInput;
  where: CardCategoryUniqueFilterInput;
};


export type MutationCreateCardIfNotExistsArgs = {
  data: CardCreationInput;
  where: CardUniqueFilterInput;
};


export type MutationCreateCardsArgs = {
  data: Array<CardCreationInput>;
};


export type MutationCreateCardTagArgs = {
  data: CardTagCreationInput;
};


export type MutationCreateCardTagIfNotExistsArgs = {
  data: CardTagCreationInput;
  where: CardTagUniqueFilterInput;
};


export type MutationCreateCardTagsArgs = {
  data: Array<CardTagCreationInput>;
};


export type MutationCreateCategoriesArgs = {
  data: Array<CategoryCreationInput>;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreationInput;
};


export type MutationCreateCategoryIfNotExistsArgs = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};


export type MutationCreateCategoryTagArgs = {
  data: CategoryTagCreationInput;
};


export type MutationCreateCategoryTagIfNotExistsArgs = {
  data: CategoryTagCreationInput;
  where: CategoryTagUniqueFilterInput;
};


export type MutationCreateCategoryTagsArgs = {
  data: Array<CategoryTagCreationInput>;
};


export type MutationCreateDailymotionLogArgs = {
  data: DailymotionLogCreationInput;
};


export type MutationCreateDailymotionLogIfNotExistsArgs = {
  data: DailymotionLogCreationInput;
  where: DailymotionLogUniqueFilterInput;
};


export type MutationCreateDailymotionLogsArgs = {
  data: Array<DailymotionLogCreationInput>;
};


export type MutationCreateImageSourceArgs = {
  data: ImageSourceCreationInput;
};


export type MutationCreateImageSourceCategoriesArgs = {
  data: Array<ImageSourceCategoryCreationInput>;
};


export type MutationCreateImageSourceCategoryArgs = {
  data: ImageSourceCategoryCreationInput;
};


export type MutationCreateImageSourceCategoryIfNotExistsArgs = {
  data: ImageSourceCategoryCreationInput;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationCreateImageSourceIfNotExistsArgs = {
  data: ImageSourceCreationInput;
  where: ImageSourceUniqueFilterInput;
};


export type MutationCreateImageSourcesArgs = {
  data: Array<ImageSourceCreationInput>;
};


export type MutationCreateLiveArgs = {
  data: LiveCreationInput;
};


export type MutationCreateLiveIfNotExistsArgs = {
  data: LiveCreationInput;
  where: LiveUniqueFilterInput;
};


export type MutationCreateLivePostArgs = {
  data: LivePostCreationInput;
};


export type MutationCreateLivePostIfNotExistsArgs = {
  data: LivePostCreationInput;
  where: LivePostUniqueFilterInput;
};


export type MutationCreateLivePostsArgs = {
  data: Array<LivePostCreationInput>;
};


export type MutationCreateLivesArgs = {
  data: Array<LiveCreationInput>;
};


export type MutationCreateMachineTagArgs = {
  data: MachineTagCreationInput;
};


export type MutationCreateMachineTagIfNotExistsArgs = {
  data: MachineTagCreationInput;
  where: MachineTagUniqueFilterInput;
};


export type MutationCreateMachineTagsArgs = {
  data: Array<MachineTagCreationInput>;
};


export type MutationCreateOpenAiProcessArgs = {
  data: OpenAiProcessCreationInput;
};


export type MutationCreateOpenAiProcessesArgs = {
  data: Array<OpenAiProcessCreationInput>;
};


export type MutationCreateOpenAiProcessIfNotExistsArgs = {
  data: OpenAiProcessCreationInput;
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationCreateOrphanPageArgs = {
  data: OrphanPageCreationInput;
};


export type MutationCreateOrphanPageIfNotExistsArgs = {
  data: OrphanPageCreationInput;
  where: OrphanPageUniqueFilterInput;
};


export type MutationCreateOrphanPagesArgs = {
  data: Array<OrphanPageCreationInput>;
};


export type MutationCreatePromptArgs = {
  data: PromptCreationInput;
};


export type MutationCreatePromptIfNotExistsArgs = {
  data: PromptCreationInput;
  where: PromptUniqueFilterInput;
};


export type MutationCreatePromptsArgs = {
  data: Array<PromptCreationInput>;
};


export type MutationCreatePushArgs = {
  data: PushCreationInput;
};


export type MutationCreatePushErrorArgs = {
  data: PushErrorCreationInput;
};


export type MutationCreatePushErrorIfNotExistsArgs = {
  data: PushErrorCreationInput;
  where: PushErrorUniqueFilterInput;
};


export type MutationCreatePushErrorsArgs = {
  data: Array<PushErrorCreationInput>;
};


export type MutationCreatePushesArgs = {
  data: Array<PushCreationInput>;
};


export type MutationCreatePushIfNotExistsArgs = {
  data: PushCreationInput;
  where: PushUniqueFilterInput;
};


export type MutationCreatePushNotificationCampaignArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
};


export type MutationCreatePushSegmentArgs = {
  data: PushSegmentCreationInput;
};


export type MutationCreatePushSegmentIfNotExistsArgs = {
  data: PushSegmentCreationInput;
  where: PushSegmentUniqueFilterInput;
};


export type MutationCreatePushSegmentsArgs = {
  data: Array<PushSegmentCreationInput>;
};


export type MutationCreateQualifierArgs = {
  data: QualifierCreationInput;
};


export type MutationCreateQualifierIfNotExistsArgs = {
  data: QualifierCreationInput;
  where: QualifierUniqueFilterInput;
};


export type MutationCreateQualifiersArgs = {
  data: Array<QualifierCreationInput>;
};


export type MutationCreateSegmentArgs = {
  data: SegmentCreationInput;
};


export type MutationCreateSegmentIfNotExistsArgs = {
  data: SegmentCreationInput;
  where: SegmentUniqueFilterInput;
};


export type MutationCreateSegmentsArgs = {
  data: Array<SegmentCreationInput>;
};


export type MutationCreateSourceArgs = {
  data: SourceCreationInput;
};


export type MutationCreateSourceIfNotExistsArgs = {
  data: SourceCreationInput;
  where: SourceUniqueFilterInput;
};


export type MutationCreateSourcesArgs = {
  data: Array<SourceCreationInput>;
};


export type MutationCreateTabArgs = {
  data: TabCreationInput;
};


export type MutationCreateTabIfNotExistsArgs = {
  data: TabCreationInput;
  where: TabUniqueFilterInput;
};


export type MutationCreateTabsArgs = {
  data: Array<TabCreationInput>;
};


export type MutationCreateTagArgs = {
  data: TagCreationInput;
};


export type MutationCreateTagBrandedContentArgs = {
  data: TagBrandedContentCreationInput;
};


export type MutationCreateTagBrandedContentIfNotExistsArgs = {
  data: TagBrandedContentCreationInput;
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationCreateTagBrandedContentsArgs = {
  data: Array<TagBrandedContentCreationInput>;
};


export type MutationCreateTagIfNotExistsArgs = {
  data: TagCreationInput;
  where: TagUniqueFilterInput;
};


export type MutationCreateTagsArgs = {
  data: Array<TagCreationInput>;
};


export type MutationCreateTaxonomiesArgs = {
  data: Array<TaxonomyCreationInput>;
};


export type MutationCreateTaxonomyArgs = {
  data: TaxonomyCreationInput;
};


export type MutationCreateTaxonomyIfNotExistsArgs = {
  data: TaxonomyCreationInput;
  where: TaxonomyUniqueFilterInput;
};


export type MutationDeleteArticleArgs = {
  where: ArticleUniqueFilterInput;
};


export type MutationDeleteArticleAuthorArgs = {
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationDeleteArticleAuthorIfExistsArgs = {
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationDeleteArticleAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderingInput>>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type MutationDeleteArticleCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderingInput>>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type MutationDeleteArticleCategoryArgs = {
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationDeleteArticleCategoryIfExistsArgs = {
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationDeleteArticleChannelArgs = {
  where: ArticleChannelUniqueFilterInput;
};


export type MutationDeleteArticleChannelIfExistsArgs = {
  where: ArticleChannelUniqueFilterInput;
};


export type MutationDeleteArticleChannelsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderingInput>>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type MutationDeleteArticleEventArgs = {
  where: ArticleEventUniqueFilterInput;
};


export type MutationDeleteArticleEventIfExistsArgs = {
  where: ArticleEventUniqueFilterInput;
};


export type MutationDeleteArticleEventsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderingInput>>;
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type MutationDeleteArticleGoodDealAiProcessArgs = {
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationDeleteArticleGoodDealAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderingInput>>;
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


export type MutationDeleteArticleGoodDealAiProcessIfExistsArgs = {
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationDeleteArticleGoodDealAiPromptArgs = {
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationDeleteArticleGoodDealAiPromptIfExistsArgs = {
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationDeleteArticleGoodDealAiPromptsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiPromptOrderingInput>>;
  where?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
};


export type MutationDeleteArticleGuideArgs = {
  where: ArticleGuideUniqueFilterInput;
};


export type MutationDeleteArticleGuideIfExistsArgs = {
  where: ArticleGuideUniqueFilterInput;
};


export type MutationDeleteArticleGuidesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderingInput>>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type MutationDeleteArticleIfExistsArgs = {
  where: ArticleUniqueFilterInput;
};


export type MutationDeleteArticleMachineTagArgs = {
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationDeleteArticleMachineTagIfExistsArgs = {
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationDeleteArticleMachineTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderingInput>>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


export type MutationDeleteArticleQualifierArgs = {
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationDeleteArticleQualifierIfExistsArgs = {
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationDeleteArticleQualifiersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderingInput>>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type MutationDeleteArticlesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingInput>>;
  where?: InputMaybe<ArticleFilterInput>;
};


export type MutationDeleteArticleSummariesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleSummaryOrderingInput>>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


export type MutationDeleteArticleSummaryArgs = {
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationDeleteArticleSummaryIfExistsArgs = {
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationDeleteArticleTagArgs = {
  where: ArticleTagUniqueFilterInput;
};


export type MutationDeleteArticleTagIfExistsArgs = {
  where: ArticleTagUniqueFilterInput;
};


export type MutationDeleteArticleTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderingInput>>;
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type MutationDeleteArticleTaxonomiesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderingInput>>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


export type MutationDeleteArticleTaxonomyArgs = {
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationDeleteArticleTaxonomyIfExistsArgs = {
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationDeleteAttributeArgs = {
  where: AttributeUniqueFilterInput;
};


export type MutationDeleteAttributeIfExistsArgs = {
  where: AttributeUniqueFilterInput;
};


export type MutationDeleteAttributesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttributeOrderingInput>>;
  where?: InputMaybe<AttributeFilterInput>;
};


export type MutationDeleteAuthorArgs = {
  where: AuthorUniqueFilterInput;
};


export type MutationDeleteAuthorAttributeArgs = {
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationDeleteAuthorAttributeIfExistsArgs = {
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationDeleteAuthorAttributesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderingInput>>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type MutationDeleteAuthorIfExistsArgs = {
  where: AuthorUniqueFilterInput;
};


export type MutationDeleteAuthorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorOrderingInput>>;
  where?: InputMaybe<AuthorFilterInput>;
};


export type MutationDeleteCardArgs = {
  where: CardUniqueFilterInput;
};


export type MutationDeleteCardCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderingInput>>;
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type MutationDeleteCardCategoryArgs = {
  where: CardCategoryUniqueFilterInput;
};


export type MutationDeleteCardCategoryIfExistsArgs = {
  where: CardCategoryUniqueFilterInput;
};


export type MutationDeleteCardIfExistsArgs = {
  where: CardUniqueFilterInput;
};


export type MutationDeleteCardsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardOrderingInput>>;
  where?: InputMaybe<CardFilterInput>;
};


export type MutationDeleteCardTagArgs = {
  where: CardTagUniqueFilterInput;
};


export type MutationDeleteCardTagIfExistsArgs = {
  where: CardTagUniqueFilterInput;
};


export type MutationDeleteCardTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderingInput>>;
  where?: InputMaybe<CardTagFilterInput>;
};


export type MutationDeleteCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderingInput>>;
  where?: InputMaybe<CategoryFilterInput>;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryUniqueFilterInput;
};


export type MutationDeleteCategoryIfExistsArgs = {
  where: CategoryUniqueFilterInput;
};


export type MutationDeleteCategoryTagArgs = {
  where: CategoryTagUniqueFilterInput;
};


export type MutationDeleteCategoryTagIfExistsArgs = {
  where: CategoryTagUniqueFilterInput;
};


export type MutationDeleteCategoryTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryTagOrderingInput>>;
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type MutationDeleteDailymotionLogArgs = {
  where: DailymotionLogUniqueFilterInput;
};


export type MutationDeleteDailymotionLogIfExistsArgs = {
  where: DailymotionLogUniqueFilterInput;
};


export type MutationDeleteDailymotionLogsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<DailymotionLogOrderingInput>>;
  where?: InputMaybe<DailymotionLogFilterInput>;
};


export type MutationDeleteImageSourceArgs = {
  where: ImageSourceUniqueFilterInput;
};


export type MutationDeleteImageSourceCategoriesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceCategoryOrderingInput>>;
  where?: InputMaybe<ImageSourceCategoryFilterInput>;
};


export type MutationDeleteImageSourceCategoryArgs = {
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationDeleteImageSourceCategoryIfExistsArgs = {
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationDeleteImageSourceIfExistsArgs = {
  where: ImageSourceUniqueFilterInput;
};


export type MutationDeleteImageSourcesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderingInput>>;
  where?: InputMaybe<ImageSourceFilterInput>;
};


export type MutationDeleteLiveArgs = {
  where: LiveUniqueFilterInput;
};


export type MutationDeleteLiveIfExistsArgs = {
  where: LiveUniqueFilterInput;
};


export type MutationDeleteLivePostArgs = {
  where: LivePostUniqueFilterInput;
};


export type MutationDeleteLivePostIfExistsArgs = {
  where: LivePostUniqueFilterInput;
};


export type MutationDeleteLivePostsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderingInput>>;
  where?: InputMaybe<LivePostFilterInput>;
};


export type MutationDeleteLivesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LiveOrderingInput>>;
  where?: InputMaybe<LiveFilterInput>;
};


export type MutationDeleteMachineTagArgs = {
  where: MachineTagUniqueFilterInput;
};


export type MutationDeleteMachineTagIfExistsArgs = {
  where: MachineTagUniqueFilterInput;
};


export type MutationDeleteMachineTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MachineTagOrderingInput>>;
  where?: InputMaybe<MachineTagFilterInput>;
};


export type MutationDeleteOpenAiProcessArgs = {
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationDeleteOpenAiProcessesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderingInput>>;
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


export type MutationDeleteOpenAiProcessIfExistsArgs = {
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationDeleteOrphanPageArgs = {
  where: OrphanPageUniqueFilterInput;
};


export type MutationDeleteOrphanPageIfExistsArgs = {
  where: OrphanPageUniqueFilterInput;
};


export type MutationDeleteOrphanPagesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OrphanPageOrderingInput>>;
  where?: InputMaybe<OrphanPageFilterInput>;
};


export type MutationDeletePromptArgs = {
  where: PromptUniqueFilterInput;
};


export type MutationDeletePromptIfExistsArgs = {
  where: PromptUniqueFilterInput;
};


export type MutationDeletePromptsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PromptOrderingInput>>;
  where?: InputMaybe<PromptFilterInput>;
};


export type MutationDeletePushArgs = {
  where: PushUniqueFilterInput;
};


export type MutationDeletePushErrorArgs = {
  where: PushErrorUniqueFilterInput;
};


export type MutationDeletePushErrorIfExistsArgs = {
  where: PushErrorUniqueFilterInput;
};


export type MutationDeletePushErrorsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushErrorOrderingInput>>;
  where?: InputMaybe<PushErrorFilterInput>;
};


export type MutationDeletePushesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushOrderingInput>>;
  where?: InputMaybe<PushFilterInput>;
};


export type MutationDeletePushIfExistsArgs = {
  where: PushUniqueFilterInput;
};


export type MutationDeletePushNotificationCampaignArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
  pushId: Scalars['ID']['input'];
};


export type MutationDeletePushSegmentArgs = {
  where: PushSegmentUniqueFilterInput;
};


export type MutationDeletePushSegmentIfExistsArgs = {
  where: PushSegmentUniqueFilterInput;
};


export type MutationDeletePushSegmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<PushSegmentFilterInput>;
};


export type MutationDeleteQualifierArgs = {
  where: QualifierUniqueFilterInput;
};


export type MutationDeleteQualifierIfExistsArgs = {
  where: QualifierUniqueFilterInput;
};


export type MutationDeleteQualifiersArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<QualifierOrderingInput>>;
  where?: InputMaybe<QualifierFilterInput>;
};


export type MutationDeleteSegmentArgs = {
  where: SegmentUniqueFilterInput;
};


export type MutationDeleteSegmentIfExistsArgs = {
  where: SegmentUniqueFilterInput;
};


export type MutationDeleteSegmentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SegmentOrderingInput>>;
  where?: InputMaybe<SegmentFilterInput>;
};


export type MutationDeleteSomeArticleAuthorsInOrderArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type MutationDeleteSomeArticleAuthorsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type MutationDeleteSomeArticleCategoriesInOrderArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeArticleCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeArticleChannelsInOrderArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type MutationDeleteSomeArticleChannelsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type MutationDeleteSomeArticleEventsInOrderArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type MutationDeleteSomeArticleEventsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGoodDealAiProcessesInOrderArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGoodDealAiProcessesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGoodDealAiPromptsInOrderArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGoodDealAiPromptsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGuidesInOrderArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type MutationDeleteSomeArticleGuidesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type MutationDeleteSomeArticleMachineTagsInOrderArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type MutationDeleteSomeArticleMachineTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type MutationDeleteSomeArticleQualifiersInOrderArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type MutationDeleteSomeArticleQualifiersInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type MutationDeleteSomeArticlesInOrderArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type MutationDeleteSomeArticlesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type MutationDeleteSomeArticleSummariesInOrderArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type MutationDeleteSomeArticleSummariesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTagsInOrderArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTaxonomiesInOrderArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type MutationDeleteSomeArticleTaxonomiesInOrderIfExistsArgs = {
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type MutationDeleteSomeAttributesInOrderArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type MutationDeleteSomeAttributesInOrderIfExistsArgs = {
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type MutationDeleteSomeAuthorAttributesInOrderArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type MutationDeleteSomeAuthorAttributesInOrderIfExistsArgs = {
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type MutationDeleteSomeAuthorsInOrderArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type MutationDeleteSomeAuthorsInOrderIfExistsArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type MutationDeleteSomeCardCategoriesInOrderArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeCardCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeCardsInOrderArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type MutationDeleteSomeCardsInOrderIfExistsArgs = {
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type MutationDeleteSomeCardTagsInOrderArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type MutationDeleteSomeCardTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type MutationDeleteSomeCategoriesInOrderArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type MutationDeleteSomeCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type MutationDeleteSomeCategoryTagsInOrderArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type MutationDeleteSomeCategoryTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type MutationDeleteSomeDailymotionLogsInOrderArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: Array<DailymotionLogUniqueFilterInput>;
};


export type MutationDeleteSomeDailymotionLogsInOrderIfExistsArgs = {
  subset?: InputMaybe<DailymotionLogFilterInput>;
  where: Array<DailymotionLogUniqueFilterInput>;
};


export type MutationDeleteSomeImageSourceCategoriesInOrderArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeImageSourceCategoriesInOrderIfExistsArgs = {
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type MutationDeleteSomeImageSourcesInOrderArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type MutationDeleteSomeImageSourcesInOrderIfExistsArgs = {
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type MutationDeleteSomeLivePostsInOrderArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type MutationDeleteSomeLivePostsInOrderIfExistsArgs = {
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type MutationDeleteSomeLivesInOrderArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type MutationDeleteSomeLivesInOrderIfExistsArgs = {
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type MutationDeleteSomeMachineTagsInOrderArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type MutationDeleteSomeMachineTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type MutationDeleteSomeOpenAiProcessesInOrderArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type MutationDeleteSomeOpenAiProcessesInOrderIfExistsArgs = {
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type MutationDeleteSomeOrphanPagesInOrderArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type MutationDeleteSomeOrphanPagesInOrderIfExistsArgs = {
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type MutationDeleteSomePromptsInOrderArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type MutationDeleteSomePromptsInOrderIfExistsArgs = {
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type MutationDeleteSomePushErrorsInOrderArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: Array<PushErrorUniqueFilterInput>;
};


export type MutationDeleteSomePushErrorsInOrderIfExistsArgs = {
  subset?: InputMaybe<PushErrorFilterInput>;
  where: Array<PushErrorUniqueFilterInput>;
};


export type MutationDeleteSomePushesInOrderArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type MutationDeleteSomePushesInOrderIfExistsArgs = {
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type MutationDeleteSomePushSegmentsInOrderArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: Array<PushSegmentUniqueFilterInput>;
};


export type MutationDeleteSomePushSegmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<PushSegmentFilterInput>;
  where: Array<PushSegmentUniqueFilterInput>;
};


export type MutationDeleteSomeQualifiersInOrderArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type MutationDeleteSomeQualifiersInOrderIfExistsArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type MutationDeleteSomeSegmentsInOrderArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type MutationDeleteSomeSegmentsInOrderIfExistsArgs = {
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type MutationDeleteSomeSourcesInOrderArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type MutationDeleteSomeSourcesInOrderIfExistsArgs = {
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type MutationDeleteSomeTabsInOrderArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type MutationDeleteSomeTabsInOrderIfExistsArgs = {
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type MutationDeleteSomeTagBrandedContentsInOrderArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type MutationDeleteSomeTagBrandedContentsInOrderIfExistsArgs = {
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type MutationDeleteSomeTagsInOrderArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationDeleteSomeTagsInOrderIfExistsArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationDeleteSomeTaxonomiesInOrderArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type MutationDeleteSomeTaxonomiesInOrderIfExistsArgs = {
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type MutationDeleteSourceArgs = {
  where: SourceUniqueFilterInput;
};


export type MutationDeleteSourceIfExistsArgs = {
  where: SourceUniqueFilterInput;
};


export type MutationDeleteSourcesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SourceOrderingInput>>;
  where?: InputMaybe<SourceFilterInput>;
};


export type MutationDeleteTabArgs = {
  where: TabUniqueFilterInput;
};


export type MutationDeleteTabIfExistsArgs = {
  where: TabUniqueFilterInput;
};


export type MutationDeleteTabsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TabOrderingInput>>;
  where?: InputMaybe<TabFilterInput>;
};


export type MutationDeleteTagArgs = {
  where: TagUniqueFilterInput;
};


export type MutationDeleteTagBrandedContentArgs = {
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationDeleteTagBrandedContentIfExistsArgs = {
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationDeleteTagBrandedContentsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentOrderingInput>>;
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type MutationDeleteTagIfExistsArgs = {
  where: TagUniqueFilterInput;
};


export type MutationDeleteTagsArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagOrderingInput>>;
  where?: InputMaybe<TagFilterInput>;
};


export type MutationDeleteTaxonomiesArgs = {
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TaxonomyOrderingInput>>;
  where?: InputMaybe<TaxonomyFilterInput>;
};


export type MutationDeleteTaxonomyArgs = {
  where: TaxonomyUniqueFilterInput;
};


export type MutationDeleteTaxonomyIfExistsArgs = {
  where: TaxonomyUniqueFilterInput;
};


export type MutationGenerateAiGoodDealArticleArgs = {
  productUrl: Scalars['URL']['input'];
};


export type MutationGenerateAiSlideshowArgs = {
  brandKey: BrandKey;
  recipeIds: Array<Scalars['String']['input']>;
  recipeNumber: Scalars['Int']['input'];
  slideshowSubject: Scalars['NonEmptyString']['input'];
};


export type MutationGenerateArticleSummaryArgs = {
  article: ArticleUniqueFilterInput;
  prompt?: PromptUniqueFilterInput;
};


export type MutationImportArticleFromHtmlArgs = {
  data: ArticleImportFromHtmlInput;
};


export type MutationImportDailymotionVideoArgs = {
  brandKey: BrandKey;
  dailymotionPublicId: Scalars['ID']['input'];
};


export type MutationLockArticleArgs = {
  where: ArticleUniqueFilterInput;
};


export type MutationLockCategoryArgs = {
  where: CategoryUniqueFilterInput;
};


export type MutationLockTagBrandedContentArgs = {
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationMergeTagsArgs = {
  from: Array<TagUniqueFilterInput>;
  to: TagUniqueFilterInput;
};


export type MutationRefreshArticleMediasArgs = {
  fieldsToRefresh?: InputMaybe<Array<MediaFieldToRefresh>>;
  id: Scalars['UUID']['input'];
  sitesToRefreshOn?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRefreshSomeAuthorsArticleUsageArgs = {
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type MutationRefreshSomeQualifiersArticleUsageArgs = {
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type MutationRefreshSomeTagsActivationArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationRefreshSomeTagsArticleUsageArgs = {
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationRetainArticleLockArgs = {
  where: ArticleUniqueFilterInput;
};


export type MutationRetainCategoryLockArgs = {
  where: CategoryUniqueFilterInput;
};


export type MutationRetainTagBrandedContentLockArgs = {
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationUnlockArticleArgs = {
  where: ArticleUniqueFilterInput;
};


export type MutationUnlockCategoryArgs = {
  where: CategoryUniqueFilterInput;
};


export type MutationUnlockTagBrandedContentArgs = {
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationUpdateArticleArgs = {
  data?: InputMaybe<ArticleUpdateInput>;
  where: ArticleUniqueFilterInput;
};


export type MutationUpdateArticleAuthorArgs = {
  data?: InputMaybe<ArticleAuthorUpdateInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationUpdateArticleAuthorIfExistsArgs = {
  data?: InputMaybe<ArticleAuthorUpdateInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationUpdateArticleAuthorsArgs = {
  data?: InputMaybe<ArticleAuthorUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleAuthorOrderingInput>>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};


export type MutationUpdateArticleCategoriesArgs = {
  data?: InputMaybe<ArticleCategoryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleCategoryOrderingInput>>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};


export type MutationUpdateArticleCategoryArgs = {
  data?: InputMaybe<ArticleCategoryUpdateInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationUpdateArticleCategoryIfExistsArgs = {
  data?: InputMaybe<ArticleCategoryUpdateInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationUpdateArticleChannelArgs = {
  data?: InputMaybe<ArticleChannelUpdateInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type MutationUpdateArticleChannelIfExistsArgs = {
  data?: InputMaybe<ArticleChannelUpdateInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type MutationUpdateArticleChannelsArgs = {
  data?: InputMaybe<ArticleChannelUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleChannelOrderingInput>>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};


export type MutationUpdateArticleEventArgs = {
  data?: InputMaybe<ArticleEventUpdateInput>;
  where: ArticleEventUniqueFilterInput;
};


export type MutationUpdateArticleEventIfExistsArgs = {
  data?: InputMaybe<ArticleEventUpdateInput>;
  where: ArticleEventUniqueFilterInput;
};


export type MutationUpdateArticleEventsArgs = {
  data?: InputMaybe<ArticleEventUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleEventOrderingInput>>;
  where?: InputMaybe<ArticleEventFilterInput>;
};


export type MutationUpdateArticleGoodDealAiProcessArgs = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationUpdateArticleGoodDealAiProcessesArgs = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiProcessOrderingInput>>;
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};


export type MutationUpdateArticleGoodDealAiProcessIfExistsArgs = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationUpdateArticleGoodDealAiPromptArgs = {
  data?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationUpdateArticleGoodDealAiPromptIfExistsArgs = {
  data?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationUpdateArticleGoodDealAiPromptsArgs = {
  data?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGoodDealAiPromptOrderingInput>>;
  where?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
};


export type MutationUpdateArticleGuideArgs = {
  data?: InputMaybe<ArticleGuideUpdateInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type MutationUpdateArticleGuideIfExistsArgs = {
  data?: InputMaybe<ArticleGuideUpdateInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type MutationUpdateArticleGuidesArgs = {
  data?: InputMaybe<ArticleGuideUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleGuideOrderingInput>>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};


export type MutationUpdateArticleIfExistsArgs = {
  data?: InputMaybe<ArticleUpdateInput>;
  where: ArticleUniqueFilterInput;
};


export type MutationUpdateArticleMachineTagArgs = {
  data?: InputMaybe<ArticleMachineTagUpdateInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationUpdateArticleMachineTagIfExistsArgs = {
  data?: InputMaybe<ArticleMachineTagUpdateInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationUpdateArticleMachineTagsArgs = {
  data?: InputMaybe<ArticleMachineTagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleMachineTagOrderingInput>>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};


export type MutationUpdateArticleQualifierArgs = {
  data?: InputMaybe<ArticleQualifierUpdateInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationUpdateArticleQualifierIfExistsArgs = {
  data?: InputMaybe<ArticleQualifierUpdateInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationUpdateArticleQualifiersArgs = {
  data?: InputMaybe<ArticleQualifierUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleQualifierOrderingInput>>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};


export type MutationUpdateArticlesArgs = {
  data?: InputMaybe<ArticleUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingInput>>;
  where?: InputMaybe<ArticleFilterInput>;
};


export type MutationUpdateArticleSummariesArgs = {
  data?: InputMaybe<ArticleSummaryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleSummaryOrderingInput>>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};


export type MutationUpdateArticleSummaryArgs = {
  data?: InputMaybe<ArticleSummaryUpdateInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationUpdateArticleSummaryIfExistsArgs = {
  data?: InputMaybe<ArticleSummaryUpdateInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationUpdateArticleTagArgs = {
  data?: InputMaybe<ArticleTagUpdateInput>;
  where: ArticleTagUniqueFilterInput;
};


export type MutationUpdateArticleTagIfExistsArgs = {
  data?: InputMaybe<ArticleTagUpdateInput>;
  where: ArticleTagUniqueFilterInput;
};


export type MutationUpdateArticleTagsArgs = {
  data?: InputMaybe<ArticleTagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTagOrderingInput>>;
  where?: InputMaybe<ArticleTagFilterInput>;
};


export type MutationUpdateArticleTaxonomiesArgs = {
  data?: InputMaybe<ArticleTaxonomyUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleTaxonomyOrderingInput>>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};


export type MutationUpdateArticleTaxonomyArgs = {
  data?: InputMaybe<ArticleTaxonomyUpdateInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationUpdateArticleTaxonomyIfExistsArgs = {
  data?: InputMaybe<ArticleTaxonomyUpdateInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationUpdateAttributeArgs = {
  data?: InputMaybe<AttributeUpdateInput>;
  where: AttributeUniqueFilterInput;
};


export type MutationUpdateAttributeIfExistsArgs = {
  data?: InputMaybe<AttributeUpdateInput>;
  where: AttributeUniqueFilterInput;
};


export type MutationUpdateAttributesArgs = {
  data?: InputMaybe<AttributeUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AttributeOrderingInput>>;
  where?: InputMaybe<AttributeFilterInput>;
};


export type MutationUpdateAuthorArgs = {
  data?: InputMaybe<AuthorUpdateInput>;
  where: AuthorUniqueFilterInput;
};


export type MutationUpdateAuthorAttributeArgs = {
  data?: InputMaybe<AuthorAttributeUpdateInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationUpdateAuthorAttributeIfExistsArgs = {
  data?: InputMaybe<AuthorAttributeUpdateInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationUpdateAuthorAttributesArgs = {
  data?: InputMaybe<AuthorAttributeUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorAttributeOrderingInput>>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};


export type MutationUpdateAuthorIfExistsArgs = {
  data?: InputMaybe<AuthorUpdateInput>;
  where: AuthorUniqueFilterInput;
};


export type MutationUpdateAuthorsArgs = {
  data?: InputMaybe<AuthorUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<AuthorOrderingInput>>;
  where?: InputMaybe<AuthorFilterInput>;
};


export type MutationUpdateCardArgs = {
  data?: InputMaybe<CardUpdateInput>;
  where: CardUniqueFilterInput;
};


export type MutationUpdateCardCategoriesArgs = {
  data?: InputMaybe<CardCategoryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardCategoryOrderingInput>>;
  where?: InputMaybe<CardCategoryFilterInput>;
};


export type MutationUpdateCardCategoryArgs = {
  data?: InputMaybe<CardCategoryUpdateInput>;
  where: CardCategoryUniqueFilterInput;
};


export type MutationUpdateCardCategoryIfExistsArgs = {
  data?: InputMaybe<CardCategoryUpdateInput>;
  where: CardCategoryUniqueFilterInput;
};


export type MutationUpdateCardIfExistsArgs = {
  data?: InputMaybe<CardUpdateInput>;
  where: CardUniqueFilterInput;
};


export type MutationUpdateCardsArgs = {
  data?: InputMaybe<CardUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardOrderingInput>>;
  where?: InputMaybe<CardFilterInput>;
};


export type MutationUpdateCardTagArgs = {
  data?: InputMaybe<CardTagUpdateInput>;
  where: CardTagUniqueFilterInput;
};


export type MutationUpdateCardTagIfExistsArgs = {
  data?: InputMaybe<CardTagUpdateInput>;
  where: CardTagUniqueFilterInput;
};


export type MutationUpdateCardTagsArgs = {
  data?: InputMaybe<CardTagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CardTagOrderingInput>>;
  where?: InputMaybe<CardTagFilterInput>;
};


export type MutationUpdateCategoriesArgs = {
  data?: InputMaybe<CategoryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderingInput>>;
  where?: InputMaybe<CategoryFilterInput>;
};


export type MutationUpdateCategoryArgs = {
  data?: InputMaybe<CategoryUpdateInput>;
  where: CategoryUniqueFilterInput;
};


export type MutationUpdateCategoryIfExistsArgs = {
  data?: InputMaybe<CategoryUpdateInput>;
  where: CategoryUniqueFilterInput;
};


export type MutationUpdateCategoryTagArgs = {
  data?: InputMaybe<CategoryTagUpdateInput>;
  where: CategoryTagUniqueFilterInput;
};


export type MutationUpdateCategoryTagIfExistsArgs = {
  data?: InputMaybe<CategoryTagUpdateInput>;
  where: CategoryTagUniqueFilterInput;
};


export type MutationUpdateCategoryTagsArgs = {
  data?: InputMaybe<CategoryTagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<CategoryTagOrderingInput>>;
  where?: InputMaybe<CategoryTagFilterInput>;
};


export type MutationUpdateDailymotionVideoThumbnailArgs = {
  brandKey: BrandKey;
  dailymotionPublicId: Scalars['ID']['input'];
  thumbnailUrl: Scalars['URL']['input'];
};


export type MutationUpdateImageSourceArgs = {
  data?: InputMaybe<ImageSourceUpdateInput>;
  where: ImageSourceUniqueFilterInput;
};


export type MutationUpdateImageSourceCategoriesArgs = {
  data?: InputMaybe<ImageSourceCategoryUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceCategoryOrderingInput>>;
  where?: InputMaybe<ImageSourceCategoryFilterInput>;
};


export type MutationUpdateImageSourceCategoryArgs = {
  data?: InputMaybe<ImageSourceCategoryUpdateInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationUpdateImageSourceCategoryIfExistsArgs = {
  data?: InputMaybe<ImageSourceCategoryUpdateInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationUpdateImageSourceIfExistsArgs = {
  data?: InputMaybe<ImageSourceUpdateInput>;
  where: ImageSourceUniqueFilterInput;
};


export type MutationUpdateImageSourcesArgs = {
  data?: InputMaybe<ImageSourceUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ImageSourceOrderingInput>>;
  where?: InputMaybe<ImageSourceFilterInput>;
};


export type MutationUpdateLiveArgs = {
  data?: InputMaybe<LiveUpdateInput>;
  where: LiveUniqueFilterInput;
};


export type MutationUpdateLiveIfExistsArgs = {
  data?: InputMaybe<LiveUpdateInput>;
  where: LiveUniqueFilterInput;
};


export type MutationUpdateLivePostArgs = {
  data?: InputMaybe<LivePostUpdateInput>;
  where: LivePostUniqueFilterInput;
};


export type MutationUpdateLivePostIfExistsArgs = {
  data?: InputMaybe<LivePostUpdateInput>;
  where: LivePostUniqueFilterInput;
};


export type MutationUpdateLivePostsArgs = {
  data?: InputMaybe<LivePostUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LivePostOrderingInput>>;
  where?: InputMaybe<LivePostFilterInput>;
};


export type MutationUpdateLivesArgs = {
  data?: InputMaybe<LiveUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<LiveOrderingInput>>;
  where?: InputMaybe<LiveFilterInput>;
};


export type MutationUpdateMachineTagArgs = {
  data?: InputMaybe<MachineTagUpdateInput>;
  where: MachineTagUniqueFilterInput;
};


export type MutationUpdateMachineTagIfExistsArgs = {
  data?: InputMaybe<MachineTagUpdateInput>;
  where: MachineTagUniqueFilterInput;
};


export type MutationUpdateMachineTagsArgs = {
  data?: InputMaybe<MachineTagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<MachineTagOrderingInput>>;
  where?: InputMaybe<MachineTagFilterInput>;
};


export type MutationUpdateOpenAiProcessArgs = {
  data?: InputMaybe<OpenAiProcessUpdateInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationUpdateOpenAiProcessesArgs = {
  data?: InputMaybe<OpenAiProcessUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OpenAiProcessOrderingInput>>;
  where?: InputMaybe<OpenAiProcessFilterInput>;
};


export type MutationUpdateOpenAiProcessIfExistsArgs = {
  data?: InputMaybe<OpenAiProcessUpdateInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationUpdateOrphanPageArgs = {
  data?: InputMaybe<OrphanPageUpdateInput>;
  where: OrphanPageUniqueFilterInput;
};


export type MutationUpdateOrphanPageIfExistsArgs = {
  data?: InputMaybe<OrphanPageUpdateInput>;
  where: OrphanPageUniqueFilterInput;
};


export type MutationUpdateOrphanPagesArgs = {
  data?: InputMaybe<OrphanPageUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<OrphanPageOrderingInput>>;
  where?: InputMaybe<OrphanPageFilterInput>;
};


export type MutationUpdatePromptArgs = {
  data?: InputMaybe<PromptUpdateInput>;
  where: PromptUniqueFilterInput;
};


export type MutationUpdatePromptIfExistsArgs = {
  data?: InputMaybe<PromptUpdateInput>;
  where: PromptUniqueFilterInput;
};


export type MutationUpdatePromptsArgs = {
  data?: InputMaybe<PromptUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PromptOrderingInput>>;
  where?: InputMaybe<PromptFilterInput>;
};


export type MutationUpdatePushArgs = {
  data?: InputMaybe<PushUpdateInput>;
  where: PushUniqueFilterInput;
};


export type MutationUpdatePushesArgs = {
  data?: InputMaybe<PushUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<PushOrderingInput>>;
  where?: InputMaybe<PushFilterInput>;
};


export type MutationUpdatePushIfExistsArgs = {
  data?: InputMaybe<PushUpdateInput>;
  where: PushUniqueFilterInput;
};


export type MutationUpdatePushNotificationCampaignArgs = {
  brandKey: BrandKey;
  device: TargetedDevice;
};


export type MutationUpdateQualifierArgs = {
  data?: InputMaybe<QualifierUpdateInput>;
  where: QualifierUniqueFilterInput;
};


export type MutationUpdateQualifierIfExistsArgs = {
  data?: InputMaybe<QualifierUpdateInput>;
  where: QualifierUniqueFilterInput;
};


export type MutationUpdateQualifiersArgs = {
  data?: InputMaybe<QualifierUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<QualifierOrderingInput>>;
  where?: InputMaybe<QualifierFilterInput>;
};


export type MutationUpdateSegmentArgs = {
  data?: InputMaybe<SegmentUpdateInput>;
  where: SegmentUniqueFilterInput;
};


export type MutationUpdateSegmentIfExistsArgs = {
  data?: InputMaybe<SegmentUpdateInput>;
  where: SegmentUniqueFilterInput;
};


export type MutationUpdateSegmentsArgs = {
  data?: InputMaybe<SegmentUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SegmentOrderingInput>>;
  where?: InputMaybe<SegmentFilterInput>;
};


export type MutationUpdateSlidehowRecipesDescriptionsArgs = {
  brandKey: BrandKey;
  recipesUrls: Array<InputMaybe<Scalars['String']['input']>>;
  slideshowEditionId: Scalars['String']['input'];
};


export type MutationUpdateSomeArticleAuthorsInOrderArgs = {
  data?: InputMaybe<ArticleAuthorUpdateInput>;
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type MutationUpdateSomeArticleAuthorsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleAuthorUpdateInput>;
  subset?: InputMaybe<ArticleAuthorFilterInput>;
  where: Array<ArticleAuthorUniqueFilterInput>;
};


export type MutationUpdateSomeArticleCategoriesInOrderArgs = {
  data?: InputMaybe<ArticleCategoryUpdateInput>;
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeArticleCategoriesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleCategoryUpdateInput>;
  subset?: InputMaybe<ArticleCategoryFilterInput>;
  where: Array<ArticleCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeArticleChannelsInOrderArgs = {
  data?: InputMaybe<ArticleChannelUpdateInput>;
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type MutationUpdateSomeArticleChannelsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleChannelUpdateInput>;
  subset?: InputMaybe<ArticleChannelFilterInput>;
  where: Array<ArticleChannelUniqueFilterInput>;
};


export type MutationUpdateSomeArticleEventsInOrderArgs = {
  data?: InputMaybe<ArticleEventUpdateInput>;
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type MutationUpdateSomeArticleEventsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleEventUpdateInput>;
  subset?: InputMaybe<ArticleEventFilterInput>;
  where: Array<ArticleEventUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGoodDealAiProcessesInOrderArgs = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGoodDealAiProcessesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  subset?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  where: Array<ArticleGoodDealAiProcessUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGoodDealAiPromptsInOrderArgs = {
  data?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGoodDealAiPromptsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  subset?: InputMaybe<ArticleGoodDealAiPromptFilterInput>;
  where: Array<ArticleGoodDealAiPromptUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGuidesInOrderArgs = {
  data?: InputMaybe<ArticleGuideUpdateInput>;
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type MutationUpdateSomeArticleGuidesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleGuideUpdateInput>;
  subset?: InputMaybe<ArticleGuideFilterInput>;
  where: Array<ArticleGuideUniqueFilterInput>;
};


export type MutationUpdateSomeArticleMachineTagsInOrderArgs = {
  data?: InputMaybe<ArticleMachineTagUpdateInput>;
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type MutationUpdateSomeArticleMachineTagsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleMachineTagUpdateInput>;
  subset?: InputMaybe<ArticleMachineTagFilterInput>;
  where: Array<ArticleMachineTagUniqueFilterInput>;
};


export type MutationUpdateSomeArticleQualifiersInOrderArgs = {
  data?: InputMaybe<ArticleQualifierUpdateInput>;
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type MutationUpdateSomeArticleQualifiersInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleQualifierUpdateInput>;
  subset?: InputMaybe<ArticleQualifierFilterInput>;
  where: Array<ArticleQualifierUniqueFilterInput>;
};


export type MutationUpdateSomeArticlesInOrderArgs = {
  data?: InputMaybe<ArticleUpdateInput>;
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type MutationUpdateSomeArticlesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleUpdateInput>;
  subset?: InputMaybe<ArticleFilterInput>;
  where: Array<ArticleUniqueFilterInput>;
};


export type MutationUpdateSomeArticleSummariesInOrderArgs = {
  data?: InputMaybe<ArticleSummaryUpdateInput>;
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type MutationUpdateSomeArticleSummariesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleSummaryUpdateInput>;
  subset?: InputMaybe<ArticleSummaryFilterInput>;
  where: Array<ArticleSummaryUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTagsInOrderArgs = {
  data?: InputMaybe<ArticleTagUpdateInput>;
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTagsInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleTagUpdateInput>;
  subset?: InputMaybe<ArticleTagFilterInput>;
  where: Array<ArticleTagUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTaxonomiesInOrderArgs = {
  data?: InputMaybe<ArticleTaxonomyUpdateInput>;
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type MutationUpdateSomeArticleTaxonomiesInOrderIfExistsArgs = {
  data?: InputMaybe<ArticleTaxonomyUpdateInput>;
  subset?: InputMaybe<ArticleTaxonomyFilterInput>;
  where: Array<ArticleTaxonomyUniqueFilterInput>;
};


export type MutationUpdateSomeAttributesInOrderArgs = {
  data?: InputMaybe<AttributeUpdateInput>;
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type MutationUpdateSomeAttributesInOrderIfExistsArgs = {
  data?: InputMaybe<AttributeUpdateInput>;
  subset?: InputMaybe<AttributeFilterInput>;
  where: Array<AttributeUniqueFilterInput>;
};


export type MutationUpdateSomeAuthorAttributesInOrderArgs = {
  data?: InputMaybe<AuthorAttributeUpdateInput>;
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type MutationUpdateSomeAuthorAttributesInOrderIfExistsArgs = {
  data?: InputMaybe<AuthorAttributeUpdateInput>;
  subset?: InputMaybe<AuthorAttributeFilterInput>;
  where: Array<AuthorAttributeUniqueFilterInput>;
};


export type MutationUpdateSomeAuthorsInOrderArgs = {
  data?: InputMaybe<AuthorUpdateInput>;
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type MutationUpdateSomeAuthorsInOrderIfExistsArgs = {
  data?: InputMaybe<AuthorUpdateInput>;
  subset?: InputMaybe<AuthorFilterInput>;
  where: Array<AuthorUniqueFilterInput>;
};


export type MutationUpdateSomeCardCategoriesInOrderArgs = {
  data?: InputMaybe<CardCategoryUpdateInput>;
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeCardCategoriesInOrderIfExistsArgs = {
  data?: InputMaybe<CardCategoryUpdateInput>;
  subset?: InputMaybe<CardCategoryFilterInput>;
  where: Array<CardCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeCardsInOrderArgs = {
  data?: InputMaybe<CardUpdateInput>;
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type MutationUpdateSomeCardsInOrderIfExistsArgs = {
  data?: InputMaybe<CardUpdateInput>;
  subset?: InputMaybe<CardFilterInput>;
  where: Array<CardUniqueFilterInput>;
};


export type MutationUpdateSomeCardTagsInOrderArgs = {
  data?: InputMaybe<CardTagUpdateInput>;
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type MutationUpdateSomeCardTagsInOrderIfExistsArgs = {
  data?: InputMaybe<CardTagUpdateInput>;
  subset?: InputMaybe<CardTagFilterInput>;
  where: Array<CardTagUniqueFilterInput>;
};


export type MutationUpdateSomeCategoriesInOrderArgs = {
  data?: InputMaybe<CategoryUpdateInput>;
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type MutationUpdateSomeCategoriesInOrderIfExistsArgs = {
  data?: InputMaybe<CategoryUpdateInput>;
  subset?: InputMaybe<CategoryFilterInput>;
  where: Array<CategoryUniqueFilterInput>;
};


export type MutationUpdateSomeCategoryTagsInOrderArgs = {
  data?: InputMaybe<CategoryTagUpdateInput>;
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type MutationUpdateSomeCategoryTagsInOrderIfExistsArgs = {
  data?: InputMaybe<CategoryTagUpdateInput>;
  subset?: InputMaybe<CategoryTagFilterInput>;
  where: Array<CategoryTagUniqueFilterInput>;
};


export type MutationUpdateSomeImageSourceCategoriesInOrderArgs = {
  data?: InputMaybe<ImageSourceCategoryUpdateInput>;
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeImageSourceCategoriesInOrderIfExistsArgs = {
  data?: InputMaybe<ImageSourceCategoryUpdateInput>;
  subset?: InputMaybe<ImageSourceCategoryFilterInput>;
  where: Array<ImageSourceCategoryUniqueFilterInput>;
};


export type MutationUpdateSomeImageSourcesInOrderArgs = {
  data?: InputMaybe<ImageSourceUpdateInput>;
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type MutationUpdateSomeImageSourcesInOrderIfExistsArgs = {
  data?: InputMaybe<ImageSourceUpdateInput>;
  subset?: InputMaybe<ImageSourceFilterInput>;
  where: Array<ImageSourceUniqueFilterInput>;
};


export type MutationUpdateSomeLivePostsInOrderArgs = {
  data?: InputMaybe<LivePostUpdateInput>;
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type MutationUpdateSomeLivePostsInOrderIfExistsArgs = {
  data?: InputMaybe<LivePostUpdateInput>;
  subset?: InputMaybe<LivePostFilterInput>;
  where: Array<LivePostUniqueFilterInput>;
};


export type MutationUpdateSomeLivesInOrderArgs = {
  data?: InputMaybe<LiveUpdateInput>;
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type MutationUpdateSomeLivesInOrderIfExistsArgs = {
  data?: InputMaybe<LiveUpdateInput>;
  subset?: InputMaybe<LiveFilterInput>;
  where: Array<LiveUniqueFilterInput>;
};


export type MutationUpdateSomeMachineTagsInOrderArgs = {
  data?: InputMaybe<MachineTagUpdateInput>;
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type MutationUpdateSomeMachineTagsInOrderIfExistsArgs = {
  data?: InputMaybe<MachineTagUpdateInput>;
  subset?: InputMaybe<MachineTagFilterInput>;
  where: Array<MachineTagUniqueFilterInput>;
};


export type MutationUpdateSomeOpenAiProcessesInOrderArgs = {
  data?: InputMaybe<OpenAiProcessUpdateInput>;
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type MutationUpdateSomeOpenAiProcessesInOrderIfExistsArgs = {
  data?: InputMaybe<OpenAiProcessUpdateInput>;
  subset?: InputMaybe<OpenAiProcessFilterInput>;
  where: Array<OpenAiProcessUniqueFilterInput>;
};


export type MutationUpdateSomeOrphanPagesInOrderArgs = {
  data?: InputMaybe<OrphanPageUpdateInput>;
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type MutationUpdateSomeOrphanPagesInOrderIfExistsArgs = {
  data?: InputMaybe<OrphanPageUpdateInput>;
  subset?: InputMaybe<OrphanPageFilterInput>;
  where: Array<OrphanPageUniqueFilterInput>;
};


export type MutationUpdateSomePromptsInOrderArgs = {
  data?: InputMaybe<PromptUpdateInput>;
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type MutationUpdateSomePromptsInOrderIfExistsArgs = {
  data?: InputMaybe<PromptUpdateInput>;
  subset?: InputMaybe<PromptFilterInput>;
  where: Array<PromptUniqueFilterInput>;
};


export type MutationUpdateSomePushesInOrderArgs = {
  data?: InputMaybe<PushUpdateInput>;
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type MutationUpdateSomePushesInOrderIfExistsArgs = {
  data?: InputMaybe<PushUpdateInput>;
  subset?: InputMaybe<PushFilterInput>;
  where: Array<PushUniqueFilterInput>;
};


export type MutationUpdateSomeQualifiersInOrderArgs = {
  data?: InputMaybe<QualifierUpdateInput>;
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type MutationUpdateSomeQualifiersInOrderIfExistsArgs = {
  data?: InputMaybe<QualifierUpdateInput>;
  subset?: InputMaybe<QualifierFilterInput>;
  where: Array<QualifierUniqueFilterInput>;
};


export type MutationUpdateSomeSegmentsInOrderArgs = {
  data?: InputMaybe<SegmentUpdateInput>;
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type MutationUpdateSomeSegmentsInOrderIfExistsArgs = {
  data?: InputMaybe<SegmentUpdateInput>;
  subset?: InputMaybe<SegmentFilterInput>;
  where: Array<SegmentUniqueFilterInput>;
};


export type MutationUpdateSomeSourcesInOrderArgs = {
  data?: InputMaybe<SourceUpdateInput>;
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type MutationUpdateSomeSourcesInOrderIfExistsArgs = {
  data?: InputMaybe<SourceUpdateInput>;
  subset?: InputMaybe<SourceFilterInput>;
  where: Array<SourceUniqueFilterInput>;
};


export type MutationUpdateSomeTabsInOrderArgs = {
  data?: InputMaybe<TabUpdateInput>;
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type MutationUpdateSomeTabsInOrderIfExistsArgs = {
  data?: InputMaybe<TabUpdateInput>;
  subset?: InputMaybe<TabFilterInput>;
  where: Array<TabUniqueFilterInput>;
};


export type MutationUpdateSomeTagBrandedContentsInOrderArgs = {
  data?: InputMaybe<TagBrandedContentUpdateInput>;
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type MutationUpdateSomeTagBrandedContentsInOrderIfExistsArgs = {
  data?: InputMaybe<TagBrandedContentUpdateInput>;
  subset?: InputMaybe<TagBrandedContentFilterInput>;
  where: Array<TagBrandedContentUniqueFilterInput>;
};


export type MutationUpdateSomeTagsInOrderArgs = {
  data?: InputMaybe<TagUpdateInput>;
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationUpdateSomeTagsInOrderIfExistsArgs = {
  data?: InputMaybe<TagUpdateInput>;
  subset?: InputMaybe<TagFilterInput>;
  where: Array<TagUniqueFilterInput>;
};


export type MutationUpdateSomeTaxonomiesInOrderArgs = {
  data?: InputMaybe<TaxonomyUpdateInput>;
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type MutationUpdateSomeTaxonomiesInOrderIfExistsArgs = {
  data?: InputMaybe<TaxonomyUpdateInput>;
  subset?: InputMaybe<TaxonomyFilterInput>;
  where: Array<TaxonomyUniqueFilterInput>;
};


export type MutationUpdateSourceArgs = {
  data?: InputMaybe<SourceUpdateInput>;
  where: SourceUniqueFilterInput;
};


export type MutationUpdateSourceIfExistsArgs = {
  data?: InputMaybe<SourceUpdateInput>;
  where: SourceUniqueFilterInput;
};


export type MutationUpdateSourcesArgs = {
  data?: InputMaybe<SourceUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<SourceOrderingInput>>;
  where?: InputMaybe<SourceFilterInput>;
};


export type MutationUpdateTabArgs = {
  data?: InputMaybe<TabUpdateInput>;
  where: TabUniqueFilterInput;
};


export type MutationUpdateTabIfExistsArgs = {
  data?: InputMaybe<TabUpdateInput>;
  where: TabUniqueFilterInput;
};


export type MutationUpdateTabsArgs = {
  data?: InputMaybe<TabUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TabOrderingInput>>;
  where?: InputMaybe<TabFilterInput>;
};


export type MutationUpdateTagArgs = {
  data?: InputMaybe<TagUpdateInput>;
  where: TagUniqueFilterInput;
};


export type MutationUpdateTagBrandedContentArgs = {
  data?: InputMaybe<TagBrandedContentUpdateInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationUpdateTagBrandedContentIfExistsArgs = {
  data?: InputMaybe<TagBrandedContentUpdateInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationUpdateTagBrandedContentsArgs = {
  data?: InputMaybe<TagBrandedContentUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagBrandedContentOrderingInput>>;
  where?: InputMaybe<TagBrandedContentFilterInput>;
};


export type MutationUpdateTagIfExistsArgs = {
  data?: InputMaybe<TagUpdateInput>;
  where: TagUniqueFilterInput;
};


export type MutationUpdateTagsArgs = {
  data?: InputMaybe<TagUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TagOrderingInput>>;
  where?: InputMaybe<TagFilterInput>;
};


export type MutationUpdateTaxonomiesArgs = {
  data?: InputMaybe<TaxonomyUpdateInput>;
  first: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<TaxonomyOrderingInput>>;
  where?: InputMaybe<TaxonomyFilterInput>;
};


export type MutationUpdateTaxonomyArgs = {
  data?: InputMaybe<TaxonomyUpdateInput>;
  where: TaxonomyUniqueFilterInput;
};


export type MutationUpdateTaxonomyIfExistsArgs = {
  data?: InputMaybe<TaxonomyUpdateInput>;
  where: TaxonomyUniqueFilterInput;
};


export type MutationUpsertArticleArgs = {
  create: ArticleCreationInput;
  update?: InputMaybe<ArticleUpdateInput>;
  where: ArticleUniqueFilterInput;
};


export type MutationUpsertArticleAuthorArgs = {
  create: ArticleAuthorCreationInput;
  update?: InputMaybe<ArticleAuthorUpdateInput>;
  where: ArticleAuthorUniqueFilterInput;
};


export type MutationUpsertArticleCategoryArgs = {
  create: ArticleCategoryCreationInput;
  update?: InputMaybe<ArticleCategoryUpdateInput>;
  where: ArticleCategoryUniqueFilterInput;
};


export type MutationUpsertArticleChannelArgs = {
  create: ArticleChannelCreationInput;
  update?: InputMaybe<ArticleChannelUpdateInput>;
  where: ArticleChannelUniqueFilterInput;
};


export type MutationUpsertArticleEventArgs = {
  create: ArticleEventCreationInput;
  update?: InputMaybe<ArticleEventUpdateInput>;
  where: ArticleEventUniqueFilterInput;
};


export type MutationUpsertArticleGoodDealAiProcessArgs = {
  create: ArticleGoodDealAiProcessCreationInput;
  update?: InputMaybe<ArticleGoodDealAiProcessUpdateInput>;
  where: ArticleGoodDealAiProcessUniqueFilterInput;
};


export type MutationUpsertArticleGoodDealAiPromptArgs = {
  create: ArticleGoodDealAiPromptCreationInput;
  update?: InputMaybe<ArticleGoodDealAiPromptUpdateInput>;
  where: ArticleGoodDealAiPromptUniqueFilterInput;
};


export type MutationUpsertArticleGuideArgs = {
  create: ArticleGuideCreationInput;
  update?: InputMaybe<ArticleGuideUpdateInput>;
  where: ArticleGuideUniqueFilterInput;
};


export type MutationUpsertArticleMachineTagArgs = {
  create: ArticleMachineTagCreationInput;
  update?: InputMaybe<ArticleMachineTagUpdateInput>;
  where: ArticleMachineTagUniqueFilterInput;
};


export type MutationUpsertArticleQualifierArgs = {
  create: ArticleQualifierCreationInput;
  update?: InputMaybe<ArticleQualifierUpdateInput>;
  where: ArticleQualifierUniqueFilterInput;
};


export type MutationUpsertArticleSummaryArgs = {
  create: ArticleSummaryCreationInput;
  update?: InputMaybe<ArticleSummaryUpdateInput>;
  where: ArticleSummaryUniqueFilterInput;
};


export type MutationUpsertArticleTagArgs = {
  create: ArticleTagCreationInput;
  update?: InputMaybe<ArticleTagUpdateInput>;
  where: ArticleTagUniqueFilterInput;
};


export type MutationUpsertArticleTaxonomyArgs = {
  create: ArticleTaxonomyCreationInput;
  update?: InputMaybe<ArticleTaxonomyUpdateInput>;
  where: ArticleTaxonomyUniqueFilterInput;
};


export type MutationUpsertAttributeArgs = {
  create: AttributeCreationInput;
  update?: InputMaybe<AttributeUpdateInput>;
  where: AttributeUniqueFilterInput;
};


export type MutationUpsertAuthorArgs = {
  create: AuthorCreationInput;
  update?: InputMaybe<AuthorUpdateInput>;
  where: AuthorUniqueFilterInput;
};


export type MutationUpsertAuthorAttributeArgs = {
  create: AuthorAttributeCreationInput;
  update?: InputMaybe<AuthorAttributeUpdateInput>;
  where: AuthorAttributeUniqueFilterInput;
};


export type MutationUpsertCardArgs = {
  create: CardCreationInput;
  update?: InputMaybe<CardUpdateInput>;
  where: CardUniqueFilterInput;
};


export type MutationUpsertCardCategoryArgs = {
  create: CardCategoryCreationInput;
  update?: InputMaybe<CardCategoryUpdateInput>;
  where: CardCategoryUniqueFilterInput;
};


export type MutationUpsertCardTagArgs = {
  create: CardTagCreationInput;
  update?: InputMaybe<CardTagUpdateInput>;
  where: CardTagUniqueFilterInput;
};


export type MutationUpsertCategoryArgs = {
  create: CategoryCreationInput;
  update?: InputMaybe<CategoryUpdateInput>;
  where: CategoryUniqueFilterInput;
};


export type MutationUpsertCategoryTagArgs = {
  create: CategoryTagCreationInput;
  update?: InputMaybe<CategoryTagUpdateInput>;
  where: CategoryTagUniqueFilterInput;
};


export type MutationUpsertImageSourceArgs = {
  create: ImageSourceCreationInput;
  update?: InputMaybe<ImageSourceUpdateInput>;
  where: ImageSourceUniqueFilterInput;
};


export type MutationUpsertImageSourceCategoryArgs = {
  create: ImageSourceCategoryCreationInput;
  update?: InputMaybe<ImageSourceCategoryUpdateInput>;
  where: ImageSourceCategoryUniqueFilterInput;
};


export type MutationUpsertLiveArgs = {
  create: LiveCreationInput;
  update?: InputMaybe<LiveUpdateInput>;
  where: LiveUniqueFilterInput;
};


export type MutationUpsertLivePostArgs = {
  create: LivePostCreationInput;
  update?: InputMaybe<LivePostUpdateInput>;
  where: LivePostUniqueFilterInput;
};


export type MutationUpsertMachineTagArgs = {
  create: MachineTagCreationInput;
  update?: InputMaybe<MachineTagUpdateInput>;
  where: MachineTagUniqueFilterInput;
};


export type MutationUpsertOpenAiProcessArgs = {
  create: OpenAiProcessCreationInput;
  update?: InputMaybe<OpenAiProcessUpdateInput>;
  where: OpenAiProcessUniqueFilterInput;
};


export type MutationUpsertOrphanPageArgs = {
  create: OrphanPageCreationInput;
  update?: InputMaybe<OrphanPageUpdateInput>;
  where: OrphanPageUniqueFilterInput;
};


export type MutationUpsertPromptArgs = {
  create: PromptCreationInput;
  update?: InputMaybe<PromptUpdateInput>;
  where: PromptUniqueFilterInput;
};


export type MutationUpsertPushArgs = {
  create: PushCreationInput;
  update?: InputMaybe<PushUpdateInput>;
  where: PushUniqueFilterInput;
};


export type MutationUpsertQualifierArgs = {
  create: QualifierCreationInput;
  update?: InputMaybe<QualifierUpdateInput>;
  where: QualifierUniqueFilterInput;
};


export type MutationUpsertSegmentArgs = {
  create: SegmentCreationInput;
  update?: InputMaybe<SegmentUpdateInput>;
  where: SegmentUniqueFilterInput;
};


export type MutationUpsertSourceArgs = {
  create: SourceCreationInput;
  update?: InputMaybe<SourceUpdateInput>;
  where: SourceUniqueFilterInput;
};


export type MutationUpsertTabArgs = {
  create: TabCreationInput;
  update?: InputMaybe<TabUpdateInput>;
  where: TabUniqueFilterInput;
};


export type MutationUpsertTagArgs = {
  create: TagCreationInput;
  update?: InputMaybe<TagUpdateInput>;
  where: TagUniqueFilterInput;
};


export type MutationUpsertTagBrandedContentArgs = {
  create: TagBrandedContentCreationInput;
  update?: InputMaybe<TagBrandedContentUpdateInput>;
  where: TagBrandedContentUniqueFilterInput;
};


export type MutationUpsertTaxonomyArgs = {
  create: TaxonomyCreationInput;
  update?: InputMaybe<TaxonomyUpdateInput>;
  where: TaxonomyUniqueFilterInput;
};

export type AffilizzCard = {
  __typename?: 'AffilizzCard';
  contents: Array<AffilizzCardContent>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AffilizzCardContent = {
  __typename?: 'AffilizzCardContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  items: Array<AffilizzCardItem>;
  negativePoints: Array<Maybe<Scalars['String']['output']>>;
  offerButtonContent: Scalars['String']['output'];
  positivePoints: Array<Maybe<Scalars['String']['output']>>;
  tag?: Maybe<Scalars['String']['output']>;
  tinyCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<AffilizzPublicationType>;
};

export type AffilizzCardItem = {
  __typename?: 'AffilizzCardItem';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['UnsignedInt']['output'];
};

export enum AffilizzPublicationType {
  CARD = 'CARD'
}

export type AffilizzCataglogProductCreation = {
  __typename?: 'AffilizzCataglogProductCreation';
  catalogId: Scalars['String']['output'];
  defaultImage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productCatalogId: Scalars['String']['output'];
  productCatalogLocalizedId: Scalars['String']['output'];
  products: Array<AffilizzCatalogProduct>;
  tinyCode: Scalars['String']['output'];
};

export type AffilizzCatalogProduct = {
  __typename?: 'AffilizzCatalogProduct';
  id: Scalars['String']['output'];
  items: Array<AffilizzCatalogProductItem>;
};

export type AffilizzCatalogProductItem = {
  __typename?: 'AffilizzCatalogProductItem';
  image: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nbOffers: Scalars['UnsignedInt']['output'];
  productLocalizedIds: Array<Scalars['String']['output']>;
};

/** The "Article" node's creation */
export type ArticleCreationInput = {
  authors?: InputMaybe<ArticleCreationAuthorsInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey: BrandKey;
  categories?: InputMaybe<ArticleCreationCategoriesInput>;
  channels?: InputMaybe<ArticleCreationChannelsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<ArticleCreationEventsInput>;
  format?: ArticleFormat;
  goodDealAiProcesses?: InputMaybe<ArticleCreationGoodDealAiProcessesInput>;
  guides?: InputMaybe<ArticleCreationGuidesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['DraftJS']['input']>;
  live?: InputMaybe<ArticleCreationLiveInput>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  machineTags?: InputMaybe<ArticleCreationMachineTagsInput>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  openAiProcesses?: InputMaybe<ArticleCreationOpenAiProcessesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters. */
  platformId?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** You can either provide a "publicId" or let one be generated for you */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pushes?: InputMaybe<ArticleCreationPushesInput>;
  qualifiers?: InputMaybe<ArticleCreationQualifiersInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  source?: InputMaybe<ArticleCreationSourceInput>;
  status?: ArticleStatus;
  summaries?: InputMaybe<ArticleCreationSummariesInput>;
  tags?: InputMaybe<ArticleCreationTagsInput>;
  taxonomies?: InputMaybe<ArticleCreationTaxonomiesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ArticleCreationAuthorsInput = {
  create?: InputMaybe<Array<ArticleAuthorCreationWithoutArticleInput>>;
};

/** The "ArticleAuthor" node's creation */
export type ArticleAuthorCreationWithoutArticleInput = {
  author: ArticleAuthorCreationAuthorInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleAuthorCreationAuthorInput = {
  /** Connect an "Author" to a new "ArticleAuthor" through the "ArticleAuthor.author" edge, throw an error if it does not exist. */
  connect?: InputMaybe<AuthorUniqueFilterInput>;
  /** Create an "Author" and connect it to a new "ArticleAuthor" through the "ArticleAuthor.author" edge. */
  create?: InputMaybe<AuthorCreationInput>;
  /** Create an "Author" if it does not exist, and connect it to a new "ArticleAuthor" through the "ArticleAuthor.author" edge. */
  createIfNotExists?: InputMaybe<ArticleAuthorCreationAuthorCreateIfNotExistsInput>;
};

/** The "Author" node's creation */
export type AuthorCreationInput = {
  articles?: InputMaybe<AuthorCreationArticlesInput>;
  attributes?: InputMaybe<AuthorCreationAttributesInput>;
  avatarUrl?: InputMaybe<Scalars['URL']['input']>;
  brandKey: BrandKey;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  facebookId?: InputMaybe<Scalars['ID']['input']>;
  googleId?: InputMaybe<Scalars['ID']['input']>;
  /** Either the author should have a dedicated page or not. */
  hasPublicProfile?: Scalars['Boolean']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  instagramId?: InputMaybe<Scalars['ID']['input']>;
  /** Is this author a freelance ? */
  isExternal?: Scalars['Boolean']['input'];
  /** Is it the main author of his user? */
  isMain?: Scalars['Boolean']['input'];
  linkedinId?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  /** At most 200 characters with at least 2 alphanumeric characters. */
  name: Scalars['NonEmptySanitizedString']['input'];
  pinterestId?: InputMaybe<Scalars['ID']['input']>;
  resume?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  snapchatId?: InputMaybe<Scalars['ID']['input']>;
  twitterId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

export type AuthorCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleAuthorCreationWithoutAuthorInput>>;
};

/** The "ArticleAuthor" node's creation */
export type ArticleAuthorCreationWithoutAuthorInput = {
  article: ArticleAuthorCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleAuthorCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleAuthor" through the
   * "ArticleAuthor.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleAuthor" through the "ArticleAuthor.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleAuthor" through the "ArticleAuthor.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleAuthorCreationArticleCreateIfNotExistsInput>;
};

export type ArticleAuthorCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type AuthorCreationAttributesInput = {
  create?: InputMaybe<Array<AuthorAttributeCreationWithoutAuthorInput>>;
};

/** The "AuthorAttribute" node's creation */
export type AuthorAttributeCreationWithoutAuthorInput = {
  attribute: AuthorAttributeCreationAttributeInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AuthorAttributeCreationAttributeInput = {
  /**
   * Connect an "Attribute" to a new "AuthorAttribute" through the
   * "AuthorAttribute.attribute" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AttributeUniqueFilterInput>;
  /** Create an "Attribute" and connect it to a new "AuthorAttribute" through the "AuthorAttribute.attribute" edge. */
  create?: InputMaybe<AttributeCreationInput>;
  /**
   * Create an "Attribute" if it does not exist, and connect it to a new
   * "AuthorAttribute" through the "AuthorAttribute.attribute" edge.
   */
  createIfNotExists?: InputMaybe<AuthorAttributeCreationAttributeCreateIfNotExistsInput>;
};

/** The "Attribute" node's creation */
export type AttributeCreationInput = {
  authors?: InputMaybe<AttributeCreationAuthorsInput>;
  brandKey: BrandKey;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type AttributeCreationAuthorsInput = {
  create?: InputMaybe<Array<AuthorAttributeCreationWithoutAttributeInput>>;
};

/** The "AuthorAttribute" node's creation */
export type AuthorAttributeCreationWithoutAttributeInput = {
  author: AuthorAttributeCreationAuthorInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AuthorAttributeCreationAuthorInput = {
  /**
   * Connect an "Author" to a new "AuthorAttribute" through the
   * "AuthorAttribute.author" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<AuthorUniqueFilterInput>;
  /** Create an "Author" and connect it to a new "AuthorAttribute" through the "AuthorAttribute.author" edge. */
  create?: InputMaybe<AuthorCreationInput>;
  /**
   * Create an "Author" if it does not exist, and connect it to a new
   * "AuthorAttribute" through the "AuthorAttribute.author" edge.
   */
  createIfNotExists?: InputMaybe<AuthorAttributeCreationAuthorCreateIfNotExistsInput>;
};

export type AuthorAttributeCreationAuthorCreateIfNotExistsInput = {
  data: AuthorCreationInput;
  where: AuthorUniqueFilterInput;
};

export type AuthorAttributeCreationAttributeCreateIfNotExistsInput = {
  data: AttributeCreationInput;
  where: AttributeUniqueFilterInput;
};

export type ArticleAuthorCreationAuthorCreateIfNotExistsInput = {
  data: AuthorCreationInput;
  where: AuthorUniqueFilterInput;
};

export type ArticleCreationCategoriesInput = {
  create?: InputMaybe<Array<ArticleCategoryCreationWithoutArticleInput>>;
};

/** The "ArticleCategory" node's creation */
export type ArticleCategoryCreationWithoutArticleInput = {
  category: ArticleCategoryCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleCategoryCreationCategoryInput = {
  /**
   * Connect a "Category" to a new "ArticleCategory" through the
   * "ArticleCategory.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "ArticleCategory" through the "ArticleCategory.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /**
   * Create a "Category" if it does not exist, and connect it to a new
   * "ArticleCategory" through the "ArticleCategory.category" edge.
   */
  createIfNotExists?: InputMaybe<ArticleCategoryCreationCategoryCreateIfNotExistsInput>;
};

/** The "Category" node's creation */
export type CategoryCreationInput = {
  articleCategories?: InputMaybe<CategoryCreationArticleCategoriesInput>;
  articleChannels?: InputMaybe<CategoryCreationArticleChannelsInput>;
  articleEvents?: InputMaybe<CategoryCreationArticleEventsInput>;
  articleGuides?: InputMaybe<CategoryCreationArticleGuidesInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  cards?: InputMaybe<CategoryCreationCardsInput>;
  children?: InputMaybe<CategoryCreationChildrenInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isHeadlined?: Scalars['Boolean']['input'];
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The maximum number of articles to generate for this category */
  maxBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  metas?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The minimum number of articles to generate for this category */
  minBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  parent?: InputMaybe<CategoryCreationParentInput>;
  /** You can either provide a "publicId" or let one be generated for you */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  status?: CategoryStatus;
  subtitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tabs?: InputMaybe<CategoryCreationTabsInput>;
  tags?: InputMaybe<CategoryCreationTagsInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type CategoryCreationArticleCategoriesInput = {
  create?: InputMaybe<Array<ArticleCategoryCreationWithoutCategoryInput>>;
};

/** The "ArticleCategory" node's creation */
export type ArticleCategoryCreationWithoutCategoryInput = {
  article: ArticleCategoryCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleCategoryCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleCategory" through the
   * "ArticleCategory.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleCategory" through the "ArticleCategory.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleCategory" through the "ArticleCategory.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleCategoryCreationArticleCreateIfNotExistsInput>;
};

export type ArticleCategoryCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type CategoryCreationArticleChannelsInput = {
  create?: InputMaybe<Array<ArticleChannelCreationWithoutCategoryInput>>;
};

/** The "ArticleChannel" node's creation */
export type ArticleChannelCreationWithoutCategoryInput = {
  article: ArticleChannelCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleChannelCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleChannel" through the
   * "ArticleChannel.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleChannel" through the "ArticleChannel.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleChannel" through the "ArticleChannel.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleChannelCreationArticleCreateIfNotExistsInput>;
};

export type ArticleChannelCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type CategoryCreationArticleEventsInput = {
  create?: InputMaybe<Array<ArticleEventCreationWithoutCategoryInput>>;
};

/** The "ArticleEvent" node's creation */
export type ArticleEventCreationWithoutCategoryInput = {
  article: ArticleEventCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleEventCreationArticleInput = {
  /** Connect an "Article" to a new "ArticleEvent" through the "ArticleEvent.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleEvent" through the "ArticleEvent.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to a new "ArticleEvent" through the "ArticleEvent.article" edge. */
  createIfNotExists?: InputMaybe<ArticleEventCreationArticleCreateIfNotExistsInput>;
};

export type ArticleEventCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type CategoryCreationArticleGuidesInput = {
  create?: InputMaybe<Array<ArticleGuideCreationWithoutCategoryInput>>;
};

/** The "ArticleGuide" node's creation */
export type ArticleGuideCreationWithoutCategoryInput = {
  article: ArticleGuideCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleGuideCreationArticleInput = {
  /** Connect an "Article" to a new "ArticleGuide" through the "ArticleGuide.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleGuide" through the "ArticleGuide.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to a new "ArticleGuide" through the "ArticleGuide.article" edge. */
  createIfNotExists?: InputMaybe<ArticleGuideCreationArticleCreateIfNotExistsInput>;
};

export type ArticleGuideCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type CategoryCreationCardsInput = {
  create?: InputMaybe<Array<CardCategoryCreationWithoutCategoryInput>>;
};

/** The "CardCategory" node's creation */
export type CardCategoryCreationWithoutCategoryInput = {
  card: CardCategoryCreationCardInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardCategoryCreationCardInput = {
  /** Connect a "Card" to a new "CardCategory" through the "CardCategory.card" edge, throw an error if it does not exist. */
  connect?: InputMaybe<CardUniqueFilterInput>;
  /** Create a "Card" and connect it to a new "CardCategory" through the "CardCategory.card" edge. */
  create?: InputMaybe<CardCreationInput>;
  /** Create a "Card" if it does not exist, and connect it to a new "CardCategory" through the "CardCategory.card" edge. */
  createIfNotExists?: InputMaybe<CardCategoryCreationCardCreateIfNotExistsInput>;
};

/** The "Card" node's creation */
export type CardCreationInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey: BrandKey;
  categories?: InputMaybe<CardCreationCategoriesInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  label: Scalars['NonEmptySanitizedString']['input'];
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  status?: CardStatus;
  tags?: InputMaybe<CardCreationTagsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  url: Scalars['URL']['input'];
};

export type CardCreationCategoriesInput = {
  create?: InputMaybe<Array<CardCategoryCreationWithoutCardInput>>;
};

/** The "CardCategory" node's creation */
export type CardCategoryCreationWithoutCardInput = {
  category: CardCategoryCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardCategoryCreationCategoryInput = {
  /**
   * Connect a "Category" to a new "CardCategory" through the
   * "CardCategory.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "CardCategory" through the "CardCategory.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "CardCategory" through the "CardCategory.category" edge. */
  createIfNotExists?: InputMaybe<CardCategoryCreationCategoryCreateIfNotExistsInput>;
};

export type CardCategoryCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type CardCreationTagsInput = {
  create?: InputMaybe<Array<CardTagCreationWithoutCardInput>>;
};

/** The "CardTag" node's creation */
export type CardTagCreationWithoutCardInput = {
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: CardTagCreationTagInput;
};

export type CardTagCreationTagInput = {
  /** Connect a "Tag" to a new "CardTag" through the "CardTag.tag" edge, throw an error if it does not exist. */
  connect?: InputMaybe<TagUniqueFilterInput>;
  /** Create a "Tag" and connect it to a new "CardTag" through the "CardTag.tag" edge. */
  create?: InputMaybe<TagCreationInput>;
  /** Create a "Tag" if it does not exist, and connect it to a new "CardTag" through the "CardTag.tag" edge. */
  createIfNotExists?: InputMaybe<CardTagCreationTagCreateIfNotExistsInput>;
};

/** The "Tag" node's creation */
export type TagCreationInput = {
  articles?: InputMaybe<TagCreationArticlesInput>;
  /** The cache used by the "articleUsage" virtual-field */
  articleUsageCache?: InputMaybe<Scalars['JSONObject']['input']>;
  brandedContents?: InputMaybe<TagCreationBrandedContentsInput>;
  cards?: InputMaybe<TagCreationCardsInput>;
  categories?: InputMaybe<TagCreationCategoriesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lang?: TagLang;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The slug is generated automatically from the "title" and the "language", but
   * it can be overridden for the "person" tag-type.
   */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  type?: TagType;
};

export type TagCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleTagCreationWithoutTagInput>>;
};

/** The "ArticleTag" node's creation */
export type ArticleTagCreationWithoutTagInput = {
  article: ArticleTagCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleTagCreationArticleInput = {
  /** Connect an "Article" to a new "ArticleTag" through the "ArticleTag.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleTag" through the "ArticleTag.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to a new "ArticleTag" through the "ArticleTag.article" edge. */
  createIfNotExists?: InputMaybe<ArticleTagCreationArticleCreateIfNotExistsInput>;
};

export type ArticleTagCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type TagCreationBrandedContentsInput = {
  create?: InputMaybe<Array<TagBrandedContentCreationWithoutTagInput>>;
};

/** The "TagBrandedContent" node's creation */
export type TagBrandedContentCreationWithoutTagInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey: BrandKey;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  status?: TagBrandedContentStatus;
};

export type TagCreationCardsInput = {
  create?: InputMaybe<Array<CardTagCreationWithoutTagInput>>;
};

/** The "CardTag" node's creation */
export type CardTagCreationWithoutTagInput = {
  card: CardTagCreationCardInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardTagCreationCardInput = {
  /** Connect a "Card" to a new "CardTag" through the "CardTag.card" edge, throw an error if it does not exist. */
  connect?: InputMaybe<CardUniqueFilterInput>;
  /** Create a "Card" and connect it to a new "CardTag" through the "CardTag.card" edge. */
  create?: InputMaybe<CardCreationInput>;
  /** Create a "Card" if it does not exist, and connect it to a new "CardTag" through the "CardTag.card" edge. */
  createIfNotExists?: InputMaybe<CardTagCreationCardCreateIfNotExistsInput>;
};

export type CardTagCreationCardCreateIfNotExistsInput = {
  data: CardCreationInput;
  where: CardUniqueFilterInput;
};

export type TagCreationCategoriesInput = {
  create?: InputMaybe<Array<CategoryTagCreationWithoutTagInput>>;
};

/** The "CategoryTag" node's creation */
export type CategoryTagCreationWithoutTagInput = {
  category: CategoryTagCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryTagCreationCategoryInput = {
  /** Connect a "Category" to a new "CategoryTag" through the "CategoryTag.category" edge, throw an error if it does not exist. */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "CategoryTag" through the "CategoryTag.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "CategoryTag" through the "CategoryTag.category" edge. */
  createIfNotExists?: InputMaybe<CategoryTagCreationCategoryCreateIfNotExistsInput>;
};

export type CategoryTagCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type CardTagCreationTagCreateIfNotExistsInput = {
  data: TagCreationInput;
  where: TagUniqueFilterInput;
};

export type CardCategoryCreationCardCreateIfNotExistsInput = {
  data: CardCreationInput;
  where: CardUniqueFilterInput;
};

export type CategoryCreationChildrenInput = {
  create?: InputMaybe<Array<CategoryCreationWithoutParentInput>>;
};

/** The "Category" node's creation */
export type CategoryCreationWithoutParentInput = {
  articleCategories?: InputMaybe<CategoryCreationArticleCategoriesInput>;
  articleChannels?: InputMaybe<CategoryCreationArticleChannelsInput>;
  articleEvents?: InputMaybe<CategoryCreationArticleEventsInput>;
  articleGuides?: InputMaybe<CategoryCreationArticleGuidesInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  cards?: InputMaybe<CategoryCreationCardsInput>;
  children?: InputMaybe<CategoryCreationChildrenInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isHeadlined?: Scalars['Boolean']['input'];
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The maximum number of articles to generate for this category */
  maxBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  metas?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The minimum number of articles to generate for this category */
  minBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** You can either provide a "publicId" or let one be generated for you */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  status?: CategoryStatus;
  subtitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tabs?: InputMaybe<CategoryCreationTabsInput>;
  tags?: InputMaybe<CategoryCreationTagsInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type CategoryCreationTabsInput = {
  create?: InputMaybe<Array<TabCreationWithoutCategoryInput>>;
};

/** The "Tab" node's creation */
export type TabCreationWithoutCategoryInput = {
  content?: InputMaybe<Scalars['JSONValue']['input']>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  disabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  enabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isOnline?: Scalars['Boolean']['input'];
  metas?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  type: TabType;
};

export type CategoryCreationTagsInput = {
  create?: InputMaybe<Array<CategoryTagCreationWithoutCategoryInput>>;
};

/** The "CategoryTag" node's creation */
export type CategoryTagCreationWithoutCategoryInput = {
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: CategoryTagCreationTagInput;
};

export type CategoryTagCreationTagInput = {
  /** Connect a "Tag" to a new "CategoryTag" through the "CategoryTag.tag" edge, throw an error if it does not exist. */
  connect?: InputMaybe<TagUniqueFilterInput>;
  /** Create a "Tag" and connect it to a new "CategoryTag" through the "CategoryTag.tag" edge. */
  create?: InputMaybe<TagCreationInput>;
  /** Create a "Tag" if it does not exist, and connect it to a new "CategoryTag" through the "CategoryTag.tag" edge. */
  createIfNotExists?: InputMaybe<CategoryTagCreationTagCreateIfNotExistsInput>;
};

export type CategoryTagCreationTagCreateIfNotExistsInput = {
  data: TagCreationInput;
  where: TagUniqueFilterInput;
};

export type CategoryCreationParentInput = {
  /** Connect a "Category" to a new "Category" through the "Category.parent" edge, throw an error if it does not exist. */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Connect a "Category" to a new "Category" through the "Category.parent" edge, if it exists. */
  connectIfExists?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "Category" through the "Category.parent" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "Category" through the "Category.parent" edge. */
  createIfNotExists?: InputMaybe<CategoryCreationParentCreateIfNotExistsInput>;
};

export type CategoryCreationParentCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type ArticleCategoryCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type ArticleCreationChannelsInput = {
  create?: InputMaybe<Array<ArticleChannelCreationWithoutArticleInput>>;
};

/** The "ArticleChannel" node's creation */
export type ArticleChannelCreationWithoutArticleInput = {
  category: ArticleChannelCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleChannelCreationCategoryInput = {
  /**
   * Connect a "Category" to a new "ArticleChannel" through the
   * "ArticleChannel.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "ArticleChannel" through the "ArticleChannel.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /**
   * Create a "Category" if it does not exist, and connect it to a new
   * "ArticleChannel" through the "ArticleChannel.category" edge.
   */
  createIfNotExists?: InputMaybe<ArticleChannelCreationCategoryCreateIfNotExistsInput>;
};

export type ArticleChannelCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type ArticleCreationEventsInput = {
  create?: InputMaybe<Array<ArticleEventCreationWithoutArticleInput>>;
};

/** The "ArticleEvent" node's creation */
export type ArticleEventCreationWithoutArticleInput = {
  category: ArticleEventCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleEventCreationCategoryInput = {
  /**
   * Connect a "Category" to a new "ArticleEvent" through the
   * "ArticleEvent.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "ArticleEvent" through the "ArticleEvent.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "ArticleEvent" through the "ArticleEvent.category" edge. */
  createIfNotExists?: InputMaybe<ArticleEventCreationCategoryCreateIfNotExistsInput>;
};

export type ArticleEventCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type ArticleCreationGoodDealAiProcessesInput = {
  create?: InputMaybe<Array<ArticleGoodDealAiProcessCreationWithoutArticleInput>>;
};

/** The "ArticleGoodDealAiProcess" node's creation */
export type ArticleGoodDealAiProcessCreationWithoutArticleInput = {
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  productTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productUrl: Scalars['URL']['input'];
  status?: InputMaybe<ArticleGoodDealAiProcessStatus>;
};

export type ArticleCreationGuidesInput = {
  create?: InputMaybe<Array<ArticleGuideCreationWithoutArticleInput>>;
};

/** The "ArticleGuide" node's creation */
export type ArticleGuideCreationWithoutArticleInput = {
  category: ArticleGuideCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleGuideCreationCategoryInput = {
  /**
   * Connect a "Category" to a new "ArticleGuide" through the
   * "ArticleGuide.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "ArticleGuide" through the "ArticleGuide.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "ArticleGuide" through the "ArticleGuide.category" edge. */
  createIfNotExists?: InputMaybe<ArticleGuideCreationCategoryCreateIfNotExistsInput>;
};

export type ArticleGuideCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

export type ArticleCreationLiveInput = {
  create?: InputMaybe<LiveCreationWithoutArticleInput>;
};

/** The "Live" node's creation */
export type LiveCreationWithoutArticleInput = {
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  posts?: InputMaybe<LiveCreationPostsInput>;
};

export type LiveCreationPostsInput = {
  create?: InputMaybe<Array<LivePostCreationWithoutLiveInput>>;
};

/** The "LivePost" node's creation */
export type LivePostCreationWithoutLiveInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ArticleCreationMachineTagsInput = {
  create?: InputMaybe<Array<ArticleMachineTagCreationWithoutArticleInput>>;
};

/** The "ArticleMachineTag" node's creation */
export type ArticleMachineTagCreationWithoutArticleInput = {
  machineTag: ArticleMachineTagCreationMachineTagInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleMachineTagCreationMachineTagInput = {
  /**
   * Connect a "MachineTag" to a new "ArticleMachineTag" through the
   * "ArticleMachineTag.machineTag" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<MachineTagUniqueFilterInput>;
  /** Create a "MachineTag" and connect it to a new "ArticleMachineTag" through the "ArticleMachineTag.machineTag" edge. */
  create?: InputMaybe<MachineTagCreationInput>;
  /**
   * Create a "MachineTag" if it does not exist, and connect it to a new
   * "ArticleMachineTag" through the "ArticleMachineTag.machineTag" edge.
   */
  createIfNotExists?: InputMaybe<ArticleMachineTagCreationMachineTagCreateIfNotExistsInput>;
};

/** The "MachineTag" node's creation */
export type MachineTagCreationInput = {
  articles?: InputMaybe<MachineTagCreationArticlesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  tag: Scalars['NonEmptyTrimmedString']['input'];
};

export type MachineTagCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleMachineTagCreationWithoutMachineTagInput>>;
};

/** The "ArticleMachineTag" node's creation */
export type ArticleMachineTagCreationWithoutMachineTagInput = {
  article: ArticleMachineTagCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleMachineTagCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleMachineTag" through the
   * "ArticleMachineTag.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleMachineTag" through the "ArticleMachineTag.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleMachineTag" through the "ArticleMachineTag.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleMachineTagCreationArticleCreateIfNotExistsInput>;
};

export type ArticleMachineTagCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type ArticleMachineTagCreationMachineTagCreateIfNotExistsInput = {
  data: MachineTagCreationInput;
  where: MachineTagUniqueFilterInput;
};

export type ArticleCreationOpenAiProcessesInput = {
  create?: InputMaybe<Array<OpenAiProcessCreationWithoutArticleInput>>;
};

/** The "OpenAiProcess" node's creation */
export type OpenAiProcessCreationWithoutArticleInput = {
  brandKey: BrandKey;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  recipeNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status: OpenAiProcessStatus;
};

export type ArticleCreationPushesInput = {
  create?: InputMaybe<Array<PushCreationWithoutArticleInput>>;
};

/** The "Push" node's creation */
export type PushCreationWithoutArticleInput = {
  body: Scalars['NonEmptyTrimmedString']['input'];
  errorReason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  inError?: Scalars['Boolean']['input'];
  isCancelled?: Scalars['Boolean']['input'];
  media: Scalars['URL']['input'];
  scheduledAt: Scalars['DateTime']['input'];
  segments?: InputMaybe<PushCreationSegmentsInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice: Scalars['NonEmptyTrimmedString']['input'];
  targeting?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

export type PushCreationSegmentsInput = {
  create?: InputMaybe<Array<PushSegmentCreationWithoutPushInput>>;
};

/** The "PushSegment" node's creation */
export type PushSegmentCreationWithoutPushInput = {
  segment: PushSegmentCreationSegmentInput;
};

export type PushSegmentCreationSegmentInput = {
  /** Connect a "Segment" to a new "PushSegment" through the "PushSegment.segment" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SegmentUniqueFilterInput>;
  /** Create a "Segment" and connect it to a new "PushSegment" through the "PushSegment.segment" edge. */
  create?: InputMaybe<SegmentCreationInput>;
  /** Create a "Segment" if it does not exist, and connect it to a new "PushSegment" through the "PushSegment.segment" edge. */
  createIfNotExists?: InputMaybe<PushSegmentCreationSegmentCreateIfNotExistsInput>;
};

/** The "Segment" node's creation */
export type SegmentCreationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  android?: InputMaybe<Scalars['JSONObject']['input']>;
  brandKey: BrandKey;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  device?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editorialAlert?: InputMaybe<Scalars['JSONObject']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  ios?: InputMaybe<Scalars['JSONObject']['input']>;
  pushes?: InputMaybe<SegmentCreationPushesInput>;
  status?: SegmentStatus;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type SegmentCreationPushesInput = {
  create?: InputMaybe<Array<PushSegmentCreationWithoutSegmentInput>>;
};

/** The "PushSegment" node's creation */
export type PushSegmentCreationWithoutSegmentInput = {
  push: PushSegmentCreationPushInput;
};

export type PushSegmentCreationPushInput = {
  /** Connect a "Push" to a new "PushSegment" through the "PushSegment.push" edge, throw an error if it does not exist. */
  connect?: InputMaybe<PushUniqueFilterInput>;
  /** Create a "Push" and connect it to a new "PushSegment" through the "PushSegment.push" edge. */
  create?: InputMaybe<PushCreationInput>;
  /** Create a "Push" if it does not exist, and connect it to a new "PushSegment" through the "PushSegment.push" edge. */
  createIfNotExists?: InputMaybe<PushSegmentCreationPushCreateIfNotExistsInput>;
};

/** The "Push" node's creation */
export type PushCreationInput = {
  article: PushCreationArticleInput;
  body: Scalars['NonEmptyTrimmedString']['input'];
  errorReason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  inError?: Scalars['Boolean']['input'];
  isCancelled?: Scalars['Boolean']['input'];
  media: Scalars['URL']['input'];
  scheduledAt: Scalars['DateTime']['input'];
  segments?: InputMaybe<PushCreationSegmentsInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice: Scalars['NonEmptyTrimmedString']['input'];
  targeting?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

export type PushCreationArticleInput = {
  /** Connect an "Article" to a new "Push" through the "Push.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "Push" through the "Push.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to a new "Push" through the "Push.article" edge. */
  createIfNotExists?: InputMaybe<PushCreationArticleCreateIfNotExistsInput>;
};

export type PushCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type PushSegmentCreationPushCreateIfNotExistsInput = {
  data: PushCreationInput;
  where: PushUniqueFilterInput;
};

export type PushSegmentCreationSegmentCreateIfNotExistsInput = {
  data: SegmentCreationInput;
  where: SegmentUniqueFilterInput;
};

export type ArticleCreationQualifiersInput = {
  create?: InputMaybe<Array<ArticleQualifierCreationWithoutArticleInput>>;
};

/** The "ArticleQualifier" node's creation */
export type ArticleQualifierCreationWithoutArticleInput = {
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifier: ArticleQualifierCreationQualifierInput;
};

export type ArticleQualifierCreationQualifierInput = {
  /**
   * Connect a "Qualifier" to a new "ArticleQualifier" through the
   * "ArticleQualifier.qualifier" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<QualifierUniqueFilterInput>;
  /** Create a "Qualifier" and connect it to a new "ArticleQualifier" through the "ArticleQualifier.qualifier" edge. */
  create?: InputMaybe<QualifierCreationInput>;
  /**
   * Create a "Qualifier" if it does not exist, and connect it to a new
   * "ArticleQualifier" through the "ArticleQualifier.qualifier" edge.
   */
  createIfNotExists?: InputMaybe<ArticleQualifierCreationQualifierCreateIfNotExistsInput>;
};

/** The "Qualifier" node's creation */
export type QualifierCreationInput = {
  articles?: InputMaybe<QualifierCreationArticlesInput>;
  brandKey: BrandKey;
  format?: ArticleFormat;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  status?: QualifierStatus;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type QualifierCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleQualifierCreationWithoutQualifierInput>>;
};

/** The "ArticleQualifier" node's creation */
export type ArticleQualifierCreationWithoutQualifierInput = {
  article: ArticleQualifierCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleQualifierCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleQualifier" through the
   * "ArticleQualifier.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleQualifier" through the "ArticleQualifier.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleQualifier" through the "ArticleQualifier.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleQualifierCreationArticleCreateIfNotExistsInput>;
};

export type ArticleQualifierCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type ArticleQualifierCreationQualifierCreateIfNotExistsInput = {
  data: QualifierCreationInput;
  where: QualifierUniqueFilterInput;
};

export type ArticleCreationSourceInput = {
  /** Connect a "Source" to a new "Article" through the "Article.source" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SourceUniqueFilterInput>;
  /** Connect a "Source" to a new "Article" through the "Article.source" edge, if it exists. */
  connectIfExists?: InputMaybe<SourceUniqueFilterInput>;
  /** Create a "Source" and connect it to a new "Article" through the "Article.source" edge. */
  create?: InputMaybe<SourceCreationInput>;
  /** Create a "Source" if it does not exist, and connect it to a new "Article" through the "Article.source" edge. */
  createIfNotExists?: InputMaybe<ArticleCreationSourceCreateIfNotExistsInput>;
};

/** The "Source" node's creation */
export type SourceCreationInput = {
  articles?: InputMaybe<SourceCreationArticlesInput>;
  brandKey: BrandKey;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  status?: SourceStatus;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type SourceCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleCreationWithoutSourceInput>>;
};

/** The "Article" node's creation */
export type ArticleCreationWithoutSourceInput = {
  authors?: InputMaybe<ArticleCreationAuthorsInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey: BrandKey;
  categories?: InputMaybe<ArticleCreationCategoriesInput>;
  channels?: InputMaybe<ArticleCreationChannelsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<ArticleCreationEventsInput>;
  format?: ArticleFormat;
  goodDealAiProcesses?: InputMaybe<ArticleCreationGoodDealAiProcessesInput>;
  guides?: InputMaybe<ArticleCreationGuidesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['DraftJS']['input']>;
  live?: InputMaybe<ArticleCreationLiveInput>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  machineTags?: InputMaybe<ArticleCreationMachineTagsInput>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  openAiProcesses?: InputMaybe<ArticleCreationOpenAiProcessesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters. */
  platformId?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** You can either provide a "publicId" or let one be generated for you */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pushes?: InputMaybe<ArticleCreationPushesInput>;
  qualifiers?: InputMaybe<ArticleCreationQualifiersInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  status?: ArticleStatus;
  summaries?: InputMaybe<ArticleCreationSummariesInput>;
  tags?: InputMaybe<ArticleCreationTagsInput>;
  taxonomies?: InputMaybe<ArticleCreationTaxonomiesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ArticleCreationSummariesInput = {
  create?: InputMaybe<Array<ArticleSummaryCreationWithoutArticleInput>>;
};

/** The "ArticleSummary" node's creation */
export type ArticleSummaryCreationWithoutArticleInput = {
  body: Scalars['NonEmptyTrimmedString']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  prompt?: InputMaybe<ArticleSummaryCreationPromptInput>;
  status?: ArticleSummaryStatus;
};

export type ArticleSummaryCreationPromptInput = {
  /**
   * Connect a "Prompt" to a new "ArticleSummary" through the
   * "ArticleSummary.prompt" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PromptUniqueFilterInput>;
  /** Connect a "Prompt" to a new "ArticleSummary" through the "ArticleSummary.prompt" edge, if it exists. */
  connectIfExists?: InputMaybe<PromptUniqueFilterInput>;
  /** Create a "Prompt" and connect it to a new "ArticleSummary" through the "ArticleSummary.prompt" edge. */
  create?: InputMaybe<PromptCreationInput>;
  /** Create a "Prompt" if it does not exist, and connect it to a new "ArticleSummary" through the "ArticleSummary.prompt" edge. */
  createIfNotExists?: InputMaybe<ArticleSummaryCreationPromptCreateIfNotExistsInput>;
};

/** The "Prompt" node's creation */
export type PromptCreationInput = {
  articleSummaries?: InputMaybe<PromptCreationArticleSummariesInput>;
  body: Scalars['NonEmptyTrimmedString']['input'];
  brandKey: BrandKey;
  field: PromptField;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  label: Scalars['NonEmptyTrimmedString']['input'];
};

export type PromptCreationArticleSummariesInput = {
  create?: InputMaybe<Array<ArticleSummaryCreationWithoutPromptInput>>;
};

/** The "ArticleSummary" node's creation */
export type ArticleSummaryCreationWithoutPromptInput = {
  article: ArticleSummaryCreationArticleInput;
  body: Scalars['NonEmptyTrimmedString']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  status?: ArticleSummaryStatus;
};

export type ArticleSummaryCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleSummary" through the
   * "ArticleSummary.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleSummary" through the "ArticleSummary.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleSummary" through the "ArticleSummary.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleSummaryCreationArticleCreateIfNotExistsInput>;
};

export type ArticleSummaryCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type ArticleSummaryCreationPromptCreateIfNotExistsInput = {
  data: PromptCreationInput;
  where: PromptUniqueFilterInput;
};

export type ArticleCreationTagsInput = {
  create?: InputMaybe<Array<ArticleTagCreationWithoutArticleInput>>;
};

/** The "ArticleTag" node's creation */
export type ArticleTagCreationWithoutArticleInput = {
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: ArticleTagCreationTagInput;
};

export type ArticleTagCreationTagInput = {
  /** Connect a "Tag" to a new "ArticleTag" through the "ArticleTag.tag" edge, throw an error if it does not exist. */
  connect?: InputMaybe<TagUniqueFilterInput>;
  /** Create a "Tag" and connect it to a new "ArticleTag" through the "ArticleTag.tag" edge. */
  create?: InputMaybe<TagCreationInput>;
  /** Create a "Tag" if it does not exist, and connect it to a new "ArticleTag" through the "ArticleTag.tag" edge. */
  createIfNotExists?: InputMaybe<ArticleTagCreationTagCreateIfNotExistsInput>;
};

export type ArticleTagCreationTagCreateIfNotExistsInput = {
  data: TagCreationInput;
  where: TagUniqueFilterInput;
};

export type ArticleCreationTaxonomiesInput = {
  create?: InputMaybe<Array<ArticleTaxonomyCreationWithoutArticleInput>>;
};

/** The "ArticleTaxonomy" node's creation */
export type ArticleTaxonomyCreationWithoutArticleInput = {
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomy: ArticleTaxonomyCreationTaxonomyInput;
};

export type ArticleTaxonomyCreationTaxonomyInput = {
  /**
   * Connect a "Taxonomy" to a new "ArticleTaxonomy" through the
   * "ArticleTaxonomy.taxonomy" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<TaxonomyUniqueFilterInput>;
  /** Create a "Taxonomy" and connect it to a new "ArticleTaxonomy" through the "ArticleTaxonomy.taxonomy" edge. */
  create?: InputMaybe<TaxonomyCreationInput>;
  /**
   * Create a "Taxonomy" if it does not exist, and connect it to a new
   * "ArticleTaxonomy" through the "ArticleTaxonomy.taxonomy" edge.
   */
  createIfNotExists?: InputMaybe<ArticleTaxonomyCreationTaxonomyCreateIfNotExistsInput>;
};

/** The "Taxonomy" node's creation */
export type TaxonomyCreationInput = {
  articles?: InputMaybe<TaxonomyCreationArticlesInput>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** At most 255 characters with at least 1 alphanumeric characters. */
  level: Scalars['NonEmptySanitizedString']['input'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  provider: Scalars['NonEmptySanitizedString']['input'];
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  type: TaxonomyType;
  version: Scalars['UnsignedInt']['input'];
};

export type TaxonomyCreationArticlesInput = {
  create?: InputMaybe<Array<ArticleTaxonomyCreationWithoutTaxonomyInput>>;
};

/** The "ArticleTaxonomy" node's creation */
export type ArticleTaxonomyCreationWithoutTaxonomyInput = {
  article: ArticleTaxonomyCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleTaxonomyCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleTaxonomy" through the
   * "ArticleTaxonomy.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "ArticleTaxonomy" through the "ArticleTaxonomy.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleTaxonomy" through the "ArticleTaxonomy.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleTaxonomyCreationArticleCreateIfNotExistsInput>;
};

export type ArticleTaxonomyCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

export type ArticleTaxonomyCreationTaxonomyCreateIfNotExistsInput = {
  data: TaxonomyCreationInput;
  where: TaxonomyUniqueFilterInput;
};

export type ArticleCreationSourceCreateIfNotExistsInput = {
  data: SourceCreationInput;
  where: SourceUniqueFilterInput;
};

/** The "ArticleAuthor" node's creation */
export type ArticleAuthorCreationInput = {
  article: ArticleAuthorCreationArticleInput;
  author: ArticleAuthorCreationAuthorInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleCategory" node's creation */
export type ArticleCategoryCreationInput = {
  article: ArticleCategoryCreationArticleInput;
  category: ArticleCategoryCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleChannel" node's creation */
export type ArticleChannelCreationInput = {
  article: ArticleChannelCreationArticleInput;
  category: ArticleChannelCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleEvent" node's creation */
export type ArticleEventCreationInput = {
  article: ArticleEventCreationArticleInput;
  category: ArticleEventCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleGoodDealAiProcess" node's creation */
export type ArticleGoodDealAiProcessCreationInput = {
  article?: InputMaybe<ArticleGoodDealAiProcessCreationArticleInput>;
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  productTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productUrl: Scalars['URL']['input'];
  status?: InputMaybe<ArticleGoodDealAiProcessStatus>;
};

export type ArticleGoodDealAiProcessCreationArticleInput = {
  /**
   * Connect an "Article" to a new "ArticleGoodDealAiProcess" through the
   * "ArticleGoodDealAiProcess.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /**
   * Connect an "Article" to a new "ArticleGoodDealAiProcess" through the
   * "ArticleGoodDealAiProcess.article" edge, if it exists.
   */
  connectIfExists?: InputMaybe<ArticleUniqueFilterInput>;
  /**
   * Create an "Article" and connect it to a new "ArticleGoodDealAiProcess" through
   * the "ArticleGoodDealAiProcess.article" edge.
   */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "ArticleGoodDealAiProcess" through the "ArticleGoodDealAiProcess.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleGoodDealAiProcessCreationArticleCreateIfNotExistsInput>;
};

export type ArticleGoodDealAiProcessCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "ArticleGoodDealAiPrompt" node's creation */
export type ArticleGoodDealAiPromptCreationInput = {
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  promptOrder: Scalars['UnsignedInt']['input'];
};

/** The "ArticleGuide" node's creation */
export type ArticleGuideCreationInput = {
  article: ArticleGuideCreationArticleInput;
  category: ArticleGuideCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleMachineTag" node's creation */
export type ArticleMachineTagCreationInput = {
  article: ArticleMachineTagCreationArticleInput;
  machineTag: ArticleMachineTagCreationMachineTagInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleQualifier" node's creation */
export type ArticleQualifierCreationInput = {
  article: ArticleQualifierCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifier: ArticleQualifierCreationQualifierInput;
};

/** The "ArticleSummary" node's creation */
export type ArticleSummaryCreationInput = {
  article: ArticleSummaryCreationArticleInput;
  body: Scalars['NonEmptyTrimmedString']['input'];
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  prompt?: InputMaybe<ArticleSummaryCreationPromptInput>;
  status?: ArticleSummaryStatus;
};

/** The "ArticleTag" node's creation */
export type ArticleTagCreationInput = {
  article: ArticleTagCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: ArticleTagCreationTagInput;
};

/** The "ArticleTaxonomy" node's creation */
export type ArticleTaxonomyCreationInput = {
  article: ArticleTaxonomyCreationArticleInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomy: ArticleTaxonomyCreationTaxonomyInput;
};

/** The "AuthorAttribute" node's creation */
export type AuthorAttributeCreationInput = {
  attribute: AuthorAttributeCreationAttributeInput;
  author: AuthorAttributeCreationAuthorInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "CardCategory" node's creation */
export type CardCategoryCreationInput = {
  card: CardCategoryCreationCardInput;
  category: CardCategoryCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "CardTag" node's creation */
export type CardTagCreationInput = {
  card: CardTagCreationCardInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: CardTagCreationTagInput;
};

/** The "CategoryTag" node's creation */
export type CategoryTagCreationInput = {
  category: CategoryTagCreationCategoryInput;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag: CategoryTagCreationTagInput;
};

/** The "DailymotionLog" node's creation */
export type DailymotionLogCreationInput = {
  brandKey: BrandKey;
  context: Scalars['JSONObject']['input'];
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  log?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  privateId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  response?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  status?: InputMaybe<Scalars['UnsignedInt']['input']>;
  videoId?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

/** The "ImageSource" node's creation */
export type ImageSourceCreationInput = {
  category: ImageSourceCreationCategoryInput;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ImageSourceCreationCategoryInput = {
  /**
   * Connect an "ImageSourceCategory" to a new "ImageSource" through the
   * "ImageSource.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ImageSourceCategoryUniqueFilterInput>;
  /** Create an "ImageSourceCategory" and connect it to a new "ImageSource" through the "ImageSource.category" edge. */
  create?: InputMaybe<ImageSourceCategoryCreationInput>;
  /**
   * Create an "ImageSourceCategory" if it does not exist, and connect it to a new
   * "ImageSource" through the "ImageSource.category" edge.
   */
  createIfNotExists?: InputMaybe<ImageSourceCreationCategoryCreateIfNotExistsInput>;
};

/** The "ImageSourceCategory" node's creation */
export type ImageSourceCategoryCreationInput = {
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  sources?: InputMaybe<ImageSourceCategoryCreationSourcesInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ImageSourceCategoryCreationSourcesInput = {
  create?: InputMaybe<Array<ImageSourceCreationWithoutCategoryInput>>;
};

/** The "ImageSource" node's creation */
export type ImageSourceCreationWithoutCategoryInput = {
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ImageSourceCreationCategoryCreateIfNotExistsInput = {
  data: ImageSourceCategoryCreationInput;
  where: ImageSourceCategoryUniqueFilterInput;
};

/** The "Live" node's creation */
export type LiveCreationInput = {
  article: LiveCreationArticleInput;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  posts?: InputMaybe<LiveCreationPostsInput>;
};

export type LiveCreationArticleInput = {
  /** Connect an "Article" to a new "Live" through the "Live.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "Live" through the "Live.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to a new "Live" through the "Live.article" edge. */
  createIfNotExists?: InputMaybe<LiveCreationArticleCreateIfNotExistsInput>;
};

export type LiveCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "LivePost" node's creation */
export type LivePostCreationInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  live: LivePostCreationLiveInput;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type LivePostCreationLiveInput = {
  /** Connect a "Live" to a new "LivePost" through the "LivePost.live" edge, throw an error if it does not exist. */
  connect?: InputMaybe<LiveUniqueFilterInput>;
  /** Create a "Live" and connect it to a new "LivePost" through the "LivePost.live" edge. */
  create?: InputMaybe<LiveCreationInput>;
  /** Create a "Live" if it does not exist, and connect it to a new "LivePost" through the "LivePost.live" edge. */
  createIfNotExists?: InputMaybe<LivePostCreationLiveCreateIfNotExistsInput>;
};

export type LivePostCreationLiveCreateIfNotExistsInput = {
  data: LiveCreationInput;
  where: LiveUniqueFilterInput;
};

/** The "OpenAiProcess" node's creation */
export type OpenAiProcessCreationInput = {
  article?: InputMaybe<OpenAiProcessCreationArticleInput>;
  brandKey: BrandKey;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  recipeNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status: OpenAiProcessStatus;
};

export type OpenAiProcessCreationArticleInput = {
  /**
   * Connect an "Article" to a new "OpenAiProcess" through the
   * "OpenAiProcess.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Connect an "Article" to a new "OpenAiProcess" through the "OpenAiProcess.article" edge, if it exists. */
  connectIfExists?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to a new "OpenAiProcess" through the "OpenAiProcess.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to a new
   * "OpenAiProcess" through the "OpenAiProcess.article" edge.
   */
  createIfNotExists?: InputMaybe<OpenAiProcessCreationArticleCreateIfNotExistsInput>;
};

export type OpenAiProcessCreationArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "OrphanPage" node's creation */
export type OrphanPageCreationInput = {
  brandKey: BrandKey;
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isAdsEnabled?: Scalars['Boolean']['input'];
  isCMPEnabled?: Scalars['Boolean']['input'];
  isFullScreen?: Scalars['Boolean']['input'];
  /** An arbitrary list of strings */
  metas?: InputMaybe<Scalars['JSONArray']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: OrphanPageStatus;
  /** At most 2000 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  /** At most 500 characters. */
  uri: Scalars['NonEmptySanitizedString']['input'];
};

/** The "PushError" node's creation */
export type PushErrorCreationInput = {
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  reason: Scalars['NonEmptyTrimmedString']['input'];
};

/** The "PushSegment" node's creation */
export type PushSegmentCreationInput = {
  push: PushSegmentCreationPushInput;
  segment: PushSegmentCreationSegmentInput;
};

/** The "Tab" node's creation */
export type TabCreationInput = {
  category: TabCreationCategoryInput;
  content?: InputMaybe<Scalars['JSONValue']['input']>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  disabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  enabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  isOnline?: Scalars['Boolean']['input'];
  metas?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** You can either provide it, in the interval [0, ∞], or let it be generated for you */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
  type: TabType;
};

export type TabCreationCategoryInput = {
  /** Connect a "Category" to a new "Tab" through the "Tab.category" edge, throw an error if it does not exist. */
  connect?: InputMaybe<CategoryUniqueFilterInput>;
  /** Create a "Category" and connect it to a new "Tab" through the "Tab.category" edge. */
  create?: InputMaybe<CategoryCreationInput>;
  /** Create a "Category" if it does not exist, and connect it to a new "Tab" through the "Tab.category" edge. */
  createIfNotExists?: InputMaybe<TabCreationCategoryCreateIfNotExistsInput>;
};

export type TabCreationCategoryCreateIfNotExistsInput = {
  data: CategoryCreationInput;
  where: CategoryUniqueFilterInput;
};

/** The "TagBrandedContent" node's creation */
export type TagBrandedContentCreationInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  brandKey: BrandKey;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  status?: TagBrandedContentStatus;
  tag: TagBrandedContentCreationTagInput;
};

export type TagBrandedContentCreationTagInput = {
  /**
   * Connect a "Tag" to a new "TagBrandedContent" through the
   * "TagBrandedContent.tag" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<TagUniqueFilterInput>;
  /** Create a "Tag" and connect it to a new "TagBrandedContent" through the "TagBrandedContent.tag" edge. */
  create?: InputMaybe<TagCreationInput>;
  /** Create a "Tag" if it does not exist, and connect it to a new "TagBrandedContent" through the "TagBrandedContent.tag" edge. */
  createIfNotExists?: InputMaybe<TagBrandedContentCreationTagCreateIfNotExistsInput>;
};

export type TagBrandedContentCreationTagCreateIfNotExistsInput = {
  data: TagCreationInput;
  where: TagUniqueFilterInput;
};

export type ArticleImportFromHtmlInput = {
  /** List of "authors", based on their "name" */
  authors?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  brandKey: BrandKey;
  /** List of "categories", based on their "id" */
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** List of "channels", based on their "id" */
  channels?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of "events", based on their "id" */
  events?: InputMaybe<Array<Scalars['UUID']['input']>>;
  format?: ArticleFormat;
  /** List of "guides", based on their "id" */
  guides?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** You can either provide an UUIDv4 or let one be generated for you */
  id?: InputMaybe<Scalars['UUIDv4']['input']>;
  lead?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** List of "machineTags", based on their "tag" */
  machineTags?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  medias?: InputMaybe<Array<ArticleMediaImportFromHtmlInput>>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform: Scalars['NonEmptySanitizedString']['input'];
  /** At most 50 characters. */
  platformId: Scalars['NonEmptySanitizedString']['input'];
  /** You can either provide a "publicId" or let one be generated for you */
  publicId?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of "qualifiers", based on their "title" */
  qualifiers?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']>>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** The "source", based on its "title" */
  source?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  status?: ArticleStatus;
  /** List of "tags", based on their "title" */
  tags?: InputMaybe<Array<ArticleTagImportFromHtmlInput>>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title: Scalars['NonEmptySanitizedString']['input'];
};

export type ArticleMediaImportFromHtmlInput = {
  credit?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  format?: InputMaybe<MediaFormat>;
  source?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  type?: InputMaybe<MediaType>;
  url: Scalars['URL']['input'];
};

export enum MediaFormat {
  Article = 'Article',
  Dailymotion = 'Dailymotion',
  Facebook = 'Facebook',
  Pinterest = 'Pinterest'
}

export enum MediaType {
  Generic = 'Generic',
  Image = 'Image'
}

export type ArticleTagImportFromHtmlInput = {
  lang?: TagLang;
  title: Scalars['NonEmptySanitizedString']['input'];
  type?: TagType;
};

export enum MediaFieldToRefresh {
  Body = 'Body',
  Medias = 'Medias'
}

/** The "Article" node's update */
export type ArticleUpdateInput = {
  authors?: InputMaybe<ArticleUpdateAuthorsInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  categories?: InputMaybe<ArticleUpdateCategoriesInput>;
  channels?: InputMaybe<ArticleUpdateChannelsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<ArticleUpdateEventsInput>;
  goodDealAiProcesses?: InputMaybe<ArticleUpdateGoodDealAiProcessesInput>;
  guides?: InputMaybe<ArticleUpdateGuidesInput>;
  lead?: InputMaybe<Scalars['DraftJS']['input']>;
  live?: InputMaybe<ArticleUpdateLiveInput>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  machineTags?: InputMaybe<ArticleUpdateMachineTagsInput>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  openAiProcesses?: InputMaybe<ArticleUpdateOpenAiProcessesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters. */
  platformId?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pushes?: InputMaybe<ArticleUpdatePushesInput>;
  qualifiers?: InputMaybe<ArticleUpdateQualifiersInput>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  source?: InputMaybe<ArticleUpdateSourceInput>;
  status?: InputMaybe<ArticleStatus>;
  summaries?: InputMaybe<ArticleUpdateSummariesInput>;
  tags?: InputMaybe<ArticleUpdateTagsInput>;
  taxonomies?: InputMaybe<ArticleUpdateTaxonomiesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ArticleUpdateAuthorsInput = {
  create?: InputMaybe<Array<ArticleAuthorCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateAuthorsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleAuthorUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleAuthorUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleAuthorFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateAuthorsUpdateInput>>;
  updateAll?: InputMaybe<ArticleAuthorUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateAuthorsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateAuthorsUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateAuthorsUpsertInput>>;
};

export type ArticleUpdateAuthorsCreateIfNotExistsInput = {
  data: ArticleAuthorCreationWithoutArticleInput;
  where: ArticleAuthorUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleAuthor" by "author" or "order" */
export type ArticleAuthorUniqueFilterWithoutArticleInput = {
  author?: InputMaybe<AuthorUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateAuthorsUpdateInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutArticleInput>;
  where: ArticleAuthorUniqueFilterWithoutArticleInput;
};

/** The "ArticleAuthor" node's update */
export type ArticleAuthorUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateAuthorsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutArticleInput>;
  where: ArticleAuthorUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateAuthorsUpdateManyInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};

export type ArticleUpdateAuthorsUpsertInput = {
  create: ArticleAuthorCreationWithoutArticleInput;
  update?: InputMaybe<ArticleAuthorUpdateWithoutArticleInput>;
  where: ArticleAuthorUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateCategoriesInput = {
  create?: InputMaybe<Array<ArticleCategoryCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateCategoriesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleCategoryUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleCategoryUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleCategoryFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateCategoriesUpdateInput>>;
  updateAll?: InputMaybe<ArticleCategoryUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateCategoriesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateCategoriesUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateCategoriesUpsertInput>>;
};

export type ArticleUpdateCategoriesCreateIfNotExistsInput = {
  data: ArticleCategoryCreationWithoutArticleInput;
  where: ArticleCategoryUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleCategory" by "category" or "order" */
export type ArticleCategoryUniqueFilterWithoutArticleInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateCategoriesUpdateInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutArticleInput>;
  where: ArticleCategoryUniqueFilterWithoutArticleInput;
};

/** The "ArticleCategory" node's update */
export type ArticleCategoryUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateCategoriesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutArticleInput>;
  where: ArticleCategoryUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateCategoriesUpdateManyInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};

export type ArticleUpdateCategoriesUpsertInput = {
  create: ArticleCategoryCreationWithoutArticleInput;
  update?: InputMaybe<ArticleCategoryUpdateWithoutArticleInput>;
  where: ArticleCategoryUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateChannelsInput = {
  create?: InputMaybe<Array<ArticleChannelCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateChannelsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleChannelUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleChannelUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleChannelFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateChannelsUpdateInput>>;
  updateAll?: InputMaybe<ArticleChannelUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateChannelsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateChannelsUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateChannelsUpsertInput>>;
};

export type ArticleUpdateChannelsCreateIfNotExistsInput = {
  data: ArticleChannelCreationWithoutArticleInput;
  where: ArticleChannelUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleChannel" by "category" or "order" */
export type ArticleChannelUniqueFilterWithoutArticleInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateChannelsUpdateInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutArticleInput>;
  where: ArticleChannelUniqueFilterWithoutArticleInput;
};

/** The "ArticleChannel" node's update */
export type ArticleChannelUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateChannelsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutArticleInput>;
  where: ArticleChannelUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateChannelsUpdateManyInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};

export type ArticleUpdateChannelsUpsertInput = {
  create: ArticleChannelCreationWithoutArticleInput;
  update?: InputMaybe<ArticleChannelUpdateWithoutArticleInput>;
  where: ArticleChannelUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateEventsInput = {
  create?: InputMaybe<Array<ArticleEventCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateEventsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleEventUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleEventUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleEventFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateEventsUpdateInput>>;
  updateAll?: InputMaybe<ArticleEventUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateEventsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateEventsUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateEventsUpsertInput>>;
};

export type ArticleUpdateEventsCreateIfNotExistsInput = {
  data: ArticleEventCreationWithoutArticleInput;
  where: ArticleEventUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleEvent" by "category" or "order" */
export type ArticleEventUniqueFilterWithoutArticleInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateEventsUpdateInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutArticleInput>;
  where: ArticleEventUniqueFilterWithoutArticleInput;
};

/** The "ArticleEvent" node's update */
export type ArticleEventUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateEventsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutArticleInput>;
  where: ArticleEventUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateEventsUpdateManyInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleEventFilterInput>;
};

export type ArticleUpdateEventsUpsertInput = {
  create: ArticleEventCreationWithoutArticleInput;
  update?: InputMaybe<ArticleEventUpdateWithoutArticleInput>;
  where: ArticleEventUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateGoodDealAiProcessesInput = {
  create?: InputMaybe<Array<ArticleGoodDealAiProcessCreationWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
  updateAll?: InputMaybe<ArticleGoodDealAiProcessUpdateWithoutArticleInput>;
  updateMany?: InputMaybe<Array<ArticleUpdateGoodDealAiProcessesUpdateManyInput>>;
};

/** The "ArticleGoodDealAiProcess" node's update */
export type ArticleGoodDealAiProcessUpdateWithoutArticleInput = {
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  status?: InputMaybe<ArticleGoodDealAiProcessStatus>;
};

export type ArticleUpdateGoodDealAiProcessesUpdateManyInput = {
  data?: InputMaybe<ArticleGoodDealAiProcessUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleGoodDealAiProcessFilterInput>;
};

export type ArticleUpdateGuidesInput = {
  create?: InputMaybe<Array<ArticleGuideCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateGuidesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleGuideUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleGuideUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleGuideFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateGuidesUpdateInput>>;
  updateAll?: InputMaybe<ArticleGuideUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateGuidesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateGuidesUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateGuidesUpsertInput>>;
};

export type ArticleUpdateGuidesCreateIfNotExistsInput = {
  data: ArticleGuideCreationWithoutArticleInput;
  where: ArticleGuideUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleGuide" by "category" or "order" */
export type ArticleGuideUniqueFilterWithoutArticleInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateGuidesUpdateInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutArticleInput>;
  where: ArticleGuideUniqueFilterWithoutArticleInput;
};

/** The "ArticleGuide" node's update */
export type ArticleGuideUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateGuidesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutArticleInput>;
  where: ArticleGuideUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateGuidesUpdateManyInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};

export type ArticleUpdateGuidesUpsertInput = {
  create: ArticleGuideCreationWithoutArticleInput;
  update?: InputMaybe<ArticleGuideUpdateWithoutArticleInput>;
  where: ArticleGuideUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateLiveInput = {
  create?: InputMaybe<LiveCreationWithoutArticleInput>;
  createIfNotExists?: InputMaybe<LiveCreationWithoutArticleInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<LiveUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<LiveUpdateWithoutArticleInput>;
  upsert?: InputMaybe<ArticleUpdateLiveUpsertInput>;
};

/** The "Live" node's update */
export type LiveUpdateWithoutArticleInput = {
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  posts?: InputMaybe<LiveUpdatePostsInput>;
};

export type LiveUpdatePostsInput = {
  create?: InputMaybe<Array<LivePostCreationWithoutLiveInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<LivePostFilterInput>;
  updateAll?: InputMaybe<LivePostUpdateWithoutLiveInput>;
  updateMany?: InputMaybe<Array<LiveUpdatePostsUpdateManyInput>>;
};

/** The "LivePost" node's update */
export type LivePostUpdateWithoutLiveInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type LiveUpdatePostsUpdateManyInput = {
  data?: InputMaybe<LivePostUpdateWithoutLiveInput>;
  where?: InputMaybe<LivePostFilterInput>;
};

export type ArticleUpdateLiveUpsertInput = {
  create: LiveCreationWithoutArticleInput;
  update?: InputMaybe<LiveUpdateWithoutArticleInput>;
};

export type ArticleUpdateMachineTagsInput = {
  create?: InputMaybe<Array<ArticleMachineTagCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateMachineTagsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleMachineTagUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleMachineTagUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleMachineTagFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateMachineTagsUpdateInput>>;
  updateAll?: InputMaybe<ArticleMachineTagUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateMachineTagsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateMachineTagsUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateMachineTagsUpsertInput>>;
};

export type ArticleUpdateMachineTagsCreateIfNotExistsInput = {
  data: ArticleMachineTagCreationWithoutArticleInput;
  where: ArticleMachineTagUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleMachineTag" by "machineTag" or "order" */
export type ArticleMachineTagUniqueFilterWithoutArticleInput = {
  machineTag?: InputMaybe<MachineTagUniqueFilterInput>;
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateMachineTagsUpdateInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutArticleInput>;
  where: ArticleMachineTagUniqueFilterWithoutArticleInput;
};

/** The "ArticleMachineTag" node's update */
export type ArticleMachineTagUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateMachineTagsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutArticleInput>;
  where: ArticleMachineTagUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateMachineTagsUpdateManyInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};

export type ArticleUpdateMachineTagsUpsertInput = {
  create: ArticleMachineTagCreationWithoutArticleInput;
  update?: InputMaybe<ArticleMachineTagUpdateWithoutArticleInput>;
  where: ArticleMachineTagUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateOpenAiProcessesInput = {
  create?: InputMaybe<Array<OpenAiProcessCreationWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<OpenAiProcessFilterInput>;
  updateAll?: InputMaybe<OpenAiProcessUpdateWithoutArticleInput>;
  updateMany?: InputMaybe<Array<ArticleUpdateOpenAiProcessesUpdateManyInput>>;
};

/** The "OpenAiProcess" node's update */
export type OpenAiProcessUpdateWithoutArticleInput = {
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  recipeNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
};

export type ArticleUpdateOpenAiProcessesUpdateManyInput = {
  data?: InputMaybe<OpenAiProcessUpdateWithoutArticleInput>;
  where?: InputMaybe<OpenAiProcessFilterInput>;
};

export type ArticleUpdatePushesInput = {
  create?: InputMaybe<Array<PushCreationWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<PushFilterInput>;
  updateAll?: InputMaybe<PushUpdateWithoutArticleInput>;
  updateMany?: InputMaybe<Array<ArticleUpdatePushesUpdateManyInput>>;
};

/** The "Push" node's update */
export type PushUpdateWithoutArticleInput = {
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorReason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['URL']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  segments?: InputMaybe<PushUpdateSegmentsInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  targeting?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

export type PushUpdateSegmentsInput = {
  create?: InputMaybe<Array<PushSegmentCreationWithoutPushInput>>;
  createIfNotExists?: InputMaybe<Array<PushUpdateSegmentsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PushSegmentUniqueFilterWithoutPushInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PushSegmentUniqueFilterWithoutPushInput>>;
  deleteMany?: InputMaybe<PushSegmentFilterInput>;
};

export type PushUpdateSegmentsCreateIfNotExistsInput = {
  data: PushSegmentCreationWithoutPushInput;
  where: PushSegmentUniqueFilterWithoutPushInput;
};

/** Given a "push", identifies exactly one "PushSegment" by "segment" */
export type PushSegmentUniqueFilterWithoutPushInput = {
  segment: SegmentUniqueFilterInput;
};

export type ArticleUpdatePushesUpdateManyInput = {
  data?: InputMaybe<PushUpdateWithoutArticleInput>;
  where?: InputMaybe<PushFilterInput>;
};

export type ArticleUpdateQualifiersInput = {
  create?: InputMaybe<Array<ArticleQualifierCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateQualifiersCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleQualifierUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleQualifierUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleQualifierFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateQualifiersUpdateInput>>;
  updateAll?: InputMaybe<ArticleQualifierUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateQualifiersUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateQualifiersUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateQualifiersUpsertInput>>;
};

export type ArticleUpdateQualifiersCreateIfNotExistsInput = {
  data: ArticleQualifierCreationWithoutArticleInput;
  where: ArticleQualifierUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleQualifier" by "qualifier" or "order" */
export type ArticleQualifierUniqueFilterWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  qualifier?: InputMaybe<QualifierUniqueFilterInput>;
};

export type ArticleUpdateQualifiersUpdateInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutArticleInput>;
  where: ArticleQualifierUniqueFilterWithoutArticleInput;
};

/** The "ArticleQualifier" node's update */
export type ArticleQualifierUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateQualifiersUpdateIfExistsInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutArticleInput>;
  where: ArticleQualifierUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateQualifiersUpdateManyInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};

export type ArticleUpdateQualifiersUpsertInput = {
  create: ArticleQualifierCreationWithoutArticleInput;
  update?: InputMaybe<ArticleQualifierUpdateWithoutArticleInput>;
  where: ArticleQualifierUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateSourceInput = {
  /** Connect a "Source" to an existing "Article" through the "Article.source" edge, throw an error if it does not exist. */
  connect?: InputMaybe<SourceUniqueFilterInput>;
  /** Connect a "Source" to an existing "Article" through the "Article.source" edge, if it exists. */
  connectIfExists?: InputMaybe<SourceUniqueFilterInput>;
  /** Create a "Source" and connect it to an existing "Article" through the "Article.source" edge. */
  create?: InputMaybe<SourceCreationInput>;
  /** Create a "Source" if it does not exist, and connect it to an existing "Article" through the "Article.source" edge. */
  createIfNotExists?: InputMaybe<ArticleUpdateSourceCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Source", throw an error if the "Article.source" edge does not exist. */
  update?: InputMaybe<SourceUpdateInput>;
  /** Update the connected "Source", if the "Article.source" edge exists. */
  updateIfExists?: InputMaybe<SourceUpdateInput>;
};

export type ArticleUpdateSourceCreateIfNotExistsInput = {
  data: SourceCreationInput;
  where: SourceUniqueFilterInput;
};

/** The "Source" node's update */
export type SourceUpdateInput = {
  articles?: InputMaybe<SourceUpdateArticlesInput>;
  status?: InputMaybe<SourceStatus>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type SourceUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleCreationWithoutSourceInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<ArticleFilterInput>;
  updateAll?: InputMaybe<ArticleUpdateWithoutSourceInput>;
  updateMany?: InputMaybe<Array<SourceUpdateArticlesUpdateManyInput>>;
};

/** The "Article" node's update */
export type ArticleUpdateWithoutSourceInput = {
  authors?: InputMaybe<ArticleUpdateAuthorsInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  categories?: InputMaybe<ArticleUpdateCategoriesInput>;
  channels?: InputMaybe<ArticleUpdateChannelsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  discoverTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<ArticleUpdateEventsInput>;
  goodDealAiProcesses?: InputMaybe<ArticleUpdateGoodDealAiProcessesInput>;
  guides?: InputMaybe<ArticleUpdateGuidesInput>;
  lead?: InputMaybe<Scalars['DraftJS']['input']>;
  live?: InputMaybe<ArticleUpdateLiveInput>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  machineTags?: InputMaybe<ArticleUpdateMachineTagsInput>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  openAiProcesses?: InputMaybe<ArticleUpdateOpenAiProcessesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  partnerTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters with at least 2 alphanumeric characters. */
  platform?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 50 characters. */
  platformId?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pushes?: InputMaybe<ArticleUpdatePushesInput>;
  qualifiers?: InputMaybe<ArticleUpdateQualifiersInput>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  signature?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  status?: InputMaybe<ArticleStatus>;
  summaries?: InputMaybe<ArticleUpdateSummariesInput>;
  tags?: InputMaybe<ArticleUpdateTagsInput>;
  taxonomies?: InputMaybe<ArticleUpdateTaxonomiesInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ArticleUpdateSummariesInput = {
  create?: InputMaybe<Array<ArticleSummaryCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateSummariesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleSummaryUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleSummaryUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleSummaryFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateSummariesUpdateInput>>;
  updateAll?: InputMaybe<ArticleSummaryUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateSummariesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateSummariesUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateSummariesUpsertInput>>;
};

export type ArticleUpdateSummariesCreateIfNotExistsInput = {
  data: ArticleSummaryCreationWithoutArticleInput;
  where: ArticleSummaryUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleSummary" by "prompt" */
export type ArticleSummaryUniqueFilterWithoutArticleInput = {
  prompt?: InputMaybe<PromptUniqueFilterInput>;
};

export type ArticleUpdateSummariesUpdateInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutArticleInput>;
  where: ArticleSummaryUniqueFilterWithoutArticleInput;
};

/** The "ArticleSummary" node's update */
export type ArticleSummaryUpdateWithoutArticleInput = {
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  prompt?: InputMaybe<ArticleSummaryUpdatePromptInput>;
  status?: InputMaybe<ArticleSummaryStatus>;
};

export type ArticleSummaryUpdatePromptInput = {
  /**
   * Connect a "Prompt" to an existing "ArticleSummary" through the
   * "ArticleSummary.prompt" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<PromptUniqueFilterInput>;
  /** Connect a "Prompt" to an existing "ArticleSummary" through the "ArticleSummary.prompt" edge, if it exists. */
  connectIfExists?: InputMaybe<PromptUniqueFilterInput>;
  /** Create a "Prompt" and connect it to an existing "ArticleSummary" through the "ArticleSummary.prompt" edge. */
  create?: InputMaybe<PromptCreationInput>;
  /**
   * Create a "Prompt" if it does not exist, and connect it to an existing
   * "ArticleSummary" through the "ArticleSummary.prompt" edge.
   */
  createIfNotExists?: InputMaybe<ArticleSummaryUpdatePromptCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Prompt", throw an error if the "ArticleSummary.prompt" edge does not exist. */
  update?: InputMaybe<PromptUpdateInput>;
  /** Update the connected "Prompt", if the "ArticleSummary.prompt" edge exists. */
  updateIfExists?: InputMaybe<PromptUpdateInput>;
};

export type ArticleSummaryUpdatePromptCreateIfNotExistsInput = {
  data: PromptCreationInput;
  where: PromptUniqueFilterInput;
};

/** The "Prompt" node's update */
export type PromptUpdateInput = {
  articleSummaries?: InputMaybe<PromptUpdateArticleSummariesInput>;
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** Icon's name in the Material Design Icons set: https://fonts.google.com/icons */
  icon?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

export type PromptUpdateArticleSummariesInput = {
  create?: InputMaybe<Array<ArticleSummaryCreationWithoutPromptInput>>;
  createIfNotExists?: InputMaybe<Array<PromptUpdateArticleSummariesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleSummaryUniqueFilterWithoutPromptInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleSummaryUniqueFilterWithoutPromptInput>>;
  deleteMany?: InputMaybe<ArticleSummaryFilterInput>;
  update?: InputMaybe<Array<PromptUpdateArticleSummariesUpdateInput>>;
  updateAll?: InputMaybe<ArticleSummaryUpdateWithoutPromptInput>;
  updateIfExists?: InputMaybe<Array<PromptUpdateArticleSummariesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<PromptUpdateArticleSummariesUpdateManyInput>>;
  upsert?: InputMaybe<Array<PromptUpdateArticleSummariesUpsertInput>>;
};

export type PromptUpdateArticleSummariesCreateIfNotExistsInput = {
  data: ArticleSummaryCreationWithoutPromptInput;
  where: ArticleSummaryUniqueFilterWithoutPromptInput;
};

/** Given a "prompt", identifies exactly one "ArticleSummary" by "article" */
export type ArticleSummaryUniqueFilterWithoutPromptInput = {
  article: ArticleUniqueFilterInput;
};

export type PromptUpdateArticleSummariesUpdateInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutPromptInput>;
  where: ArticleSummaryUniqueFilterWithoutPromptInput;
};

/** The "ArticleSummary" node's update */
export type ArticleSummaryUpdateWithoutPromptInput = {
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  status?: InputMaybe<ArticleSummaryStatus>;
};

export type PromptUpdateArticleSummariesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutPromptInput>;
  where: ArticleSummaryUniqueFilterWithoutPromptInput;
};

export type PromptUpdateArticleSummariesUpdateManyInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutPromptInput>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};

export type PromptUpdateArticleSummariesUpsertInput = {
  create: ArticleSummaryCreationWithoutPromptInput;
  update?: InputMaybe<ArticleSummaryUpdateWithoutPromptInput>;
  where: ArticleSummaryUniqueFilterWithoutPromptInput;
};

export type ArticleUpdateSummariesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutArticleInput>;
  where: ArticleSummaryUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateSummariesUpdateManyInput = {
  data?: InputMaybe<ArticleSummaryUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleSummaryFilterInput>;
};

export type ArticleUpdateSummariesUpsertInput = {
  create: ArticleSummaryCreationWithoutArticleInput;
  update?: InputMaybe<ArticleSummaryUpdateWithoutArticleInput>;
  where: ArticleSummaryUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateTagsInput = {
  create?: InputMaybe<Array<ArticleTagCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateTagsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleTagUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleTagUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleTagFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateTagsUpdateInput>>;
  updateAll?: InputMaybe<ArticleTagUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateTagsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateTagsUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateTagsUpsertInput>>;
};

export type ArticleUpdateTagsCreateIfNotExistsInput = {
  data: ArticleTagCreationWithoutArticleInput;
  where: ArticleTagUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleTag" by "tag" or "order" */
export type ArticleTagUniqueFilterWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

export type ArticleUpdateTagsUpdateInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutArticleInput>;
  where: ArticleTagUniqueFilterWithoutArticleInput;
};

/** The "ArticleTag" node's update */
export type ArticleTagUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateTagsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutArticleInput>;
  where: ArticleTagUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateTagsUpdateManyInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleTagFilterInput>;
};

export type ArticleUpdateTagsUpsertInput = {
  create: ArticleTagCreationWithoutArticleInput;
  update?: InputMaybe<ArticleTagUpdateWithoutArticleInput>;
  where: ArticleTagUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateTaxonomiesInput = {
  create?: InputMaybe<Array<ArticleTaxonomyCreationWithoutArticleInput>>;
  createIfNotExists?: InputMaybe<Array<ArticleUpdateTaxonomiesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleTaxonomyUniqueFilterWithoutArticleInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleTaxonomyUniqueFilterWithoutArticleInput>>;
  deleteMany?: InputMaybe<ArticleTaxonomyFilterInput>;
  update?: InputMaybe<Array<ArticleUpdateTaxonomiesUpdateInput>>;
  updateAll?: InputMaybe<ArticleTaxonomyUpdateWithoutArticleInput>;
  updateIfExists?: InputMaybe<Array<ArticleUpdateTaxonomiesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<ArticleUpdateTaxonomiesUpdateManyInput>>;
  upsert?: InputMaybe<Array<ArticleUpdateTaxonomiesUpsertInput>>;
};

export type ArticleUpdateTaxonomiesCreateIfNotExistsInput = {
  data: ArticleTaxonomyCreationWithoutArticleInput;
  where: ArticleTaxonomyUniqueFilterWithoutArticleInput;
};

/** Given an "article", identifies exactly one "ArticleTaxonomy" by "taxonomy" or "order" */
export type ArticleTaxonomyUniqueFilterWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  taxonomy?: InputMaybe<TaxonomyUniqueFilterInput>;
};

export type ArticleUpdateTaxonomiesUpdateInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutArticleInput>;
  where: ArticleTaxonomyUniqueFilterWithoutArticleInput;
};

/** The "ArticleTaxonomy" node's update */
export type ArticleTaxonomyUpdateWithoutArticleInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type ArticleUpdateTaxonomiesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutArticleInput>;
  where: ArticleTaxonomyUniqueFilterWithoutArticleInput;
};

export type ArticleUpdateTaxonomiesUpdateManyInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutArticleInput>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};

export type ArticleUpdateTaxonomiesUpsertInput = {
  create: ArticleTaxonomyCreationWithoutArticleInput;
  update?: InputMaybe<ArticleTaxonomyUpdateWithoutArticleInput>;
  where: ArticleTaxonomyUniqueFilterWithoutArticleInput;
};

export type SourceUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleUpdateWithoutSourceInput>;
  where?: InputMaybe<ArticleFilterInput>;
};

/** The "ArticleAuthor" node's update */
export type ArticleAuthorUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleCategory" node's update */
export type ArticleCategoryUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleChannel" node's update */
export type ArticleChannelUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleEvent" node's update */
export type ArticleEventUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleGoodDealAiProcess" node's update */
export type ArticleGoodDealAiProcessUpdateInput = {
  article?: InputMaybe<ArticleGoodDealAiProcessUpdateArticleInput>;
  error?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  productTitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  status?: InputMaybe<ArticleGoodDealAiProcessStatus>;
};

export type ArticleGoodDealAiProcessUpdateArticleInput = {
  /**
   * Connect an "Article" to an existing "ArticleGoodDealAiProcess" through the
   * "ArticleGoodDealAiProcess.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /**
   * Connect an "Article" to an existing "ArticleGoodDealAiProcess" through the
   * "ArticleGoodDealAiProcess.article" edge, if it exists.
   */
  connectIfExists?: InputMaybe<ArticleUniqueFilterInput>;
  /**
   * Create an "Article" and connect it to an existing "ArticleGoodDealAiProcess"
   * through the "ArticleGoodDealAiProcess.article" edge.
   */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to an existing
   * "ArticleGoodDealAiProcess" through the "ArticleGoodDealAiProcess.article" edge.
   */
  createIfNotExists?: InputMaybe<ArticleGoodDealAiProcessUpdateArticleCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Article", throw an error if the "ArticleGoodDealAiProcess.article" edge does not exist. */
  update?: InputMaybe<ArticleUpdateInput>;
  /** Update the connected "Article", if the "ArticleGoodDealAiProcess.article" edge exists. */
  updateIfExists?: InputMaybe<ArticleUpdateInput>;
};

export type ArticleGoodDealAiProcessUpdateArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "ArticleGoodDealAiPrompt" node's update */
export type ArticleGoodDealAiPromptUpdateInput = {
  prompt?: InputMaybe<Scalars['String']['input']>;
  promptOrder?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleGuide" node's update */
export type ArticleGuideUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleMachineTag" node's update */
export type ArticleMachineTagUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleQualifier" node's update */
export type ArticleQualifierUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleSummary" node's update */
export type ArticleSummaryUpdateInput = {
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  prompt?: InputMaybe<ArticleSummaryUpdatePromptInput>;
  status?: InputMaybe<ArticleSummaryStatus>;
};

/** The "ArticleTag" node's update */
export type ArticleTagUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ArticleTaxonomy" node's update */
export type ArticleTaxonomyUpdateInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "Attribute" node's update */
export type AttributeUpdateInput = {
  authors?: InputMaybe<AttributeUpdateAuthorsInput>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type AttributeUpdateAuthorsInput = {
  create?: InputMaybe<Array<AuthorAttributeCreationWithoutAttributeInput>>;
  createIfNotExists?: InputMaybe<Array<AttributeUpdateAuthorsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<AuthorAttributeUniqueFilterWithoutAttributeInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<AuthorAttributeUniqueFilterWithoutAttributeInput>>;
  deleteMany?: InputMaybe<AuthorAttributeFilterInput>;
  update?: InputMaybe<Array<AttributeUpdateAuthorsUpdateInput>>;
  updateAll?: InputMaybe<AuthorAttributeUpdateWithoutAttributeInput>;
  updateIfExists?: InputMaybe<Array<AttributeUpdateAuthorsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<AttributeUpdateAuthorsUpdateManyInput>>;
  upsert?: InputMaybe<Array<AttributeUpdateAuthorsUpsertInput>>;
};

export type AttributeUpdateAuthorsCreateIfNotExistsInput = {
  data: AuthorAttributeCreationWithoutAttributeInput;
  where: AuthorAttributeUniqueFilterWithoutAttributeInput;
};

/** Given an "attribute", identifies exactly one "AuthorAttribute" by "author" */
export type AuthorAttributeUniqueFilterWithoutAttributeInput = {
  author: AuthorUniqueFilterInput;
};

export type AttributeUpdateAuthorsUpdateInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAttributeInput>;
  where: AuthorAttributeUniqueFilterWithoutAttributeInput;
};

/** The "AuthorAttribute" node's update */
export type AuthorAttributeUpdateWithoutAttributeInput = {
  /** Order for a given "author", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AttributeUpdateAuthorsUpdateIfExistsInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAttributeInput>;
  where: AuthorAttributeUniqueFilterWithoutAttributeInput;
};

export type AttributeUpdateAuthorsUpdateManyInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAttributeInput>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};

export type AttributeUpdateAuthorsUpsertInput = {
  create: AuthorAttributeCreationWithoutAttributeInput;
  update?: InputMaybe<AuthorAttributeUpdateWithoutAttributeInput>;
  where: AuthorAttributeUniqueFilterWithoutAttributeInput;
};

/** The "Author" node's update */
export type AuthorUpdateInput = {
  articles?: InputMaybe<AuthorUpdateArticlesInput>;
  attributes?: InputMaybe<AuthorUpdateAttributesInput>;
  avatarUrl?: InputMaybe<Scalars['URL']['input']>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  facebookId?: InputMaybe<Scalars['ID']['input']>;
  googleId?: InputMaybe<Scalars['ID']['input']>;
  /** Either the author should have a dedicated page or not. */
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  instagramId?: InputMaybe<Scalars['ID']['input']>;
  /** Is this author a freelance ? */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is it the main author of his user? */
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinId?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  /** At most 200 characters with at least 2 alphanumeric characters. */
  name?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  pinterestId?: InputMaybe<Scalars['ID']['input']>;
  resume?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  snapchatId?: InputMaybe<Scalars['ID']['input']>;
  twitterId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

export type AuthorUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleAuthorCreationWithoutAuthorInput>>;
  createIfNotExists?: InputMaybe<Array<AuthorUpdateArticlesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleAuthorUniqueFilterWithoutAuthorInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleAuthorUniqueFilterWithoutAuthorInput>>;
  deleteMany?: InputMaybe<ArticleAuthorFilterInput>;
  update?: InputMaybe<Array<AuthorUpdateArticlesUpdateInput>>;
  updateAll?: InputMaybe<ArticleAuthorUpdateWithoutAuthorInput>;
  updateIfExists?: InputMaybe<Array<AuthorUpdateArticlesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<AuthorUpdateArticlesUpdateManyInput>>;
  upsert?: InputMaybe<Array<AuthorUpdateArticlesUpsertInput>>;
};

export type AuthorUpdateArticlesCreateIfNotExistsInput = {
  data: ArticleAuthorCreationWithoutAuthorInput;
  where: ArticleAuthorUniqueFilterWithoutAuthorInput;
};

/** Given an "author", identifies exactly one "ArticleAuthor" by "article" */
export type ArticleAuthorUniqueFilterWithoutAuthorInput = {
  article: ArticleUniqueFilterInput;
};

export type AuthorUpdateArticlesUpdateInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutAuthorInput>;
  where: ArticleAuthorUniqueFilterWithoutAuthorInput;
};

/** The "ArticleAuthor" node's update */
export type ArticleAuthorUpdateWithoutAuthorInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AuthorUpdateArticlesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutAuthorInput>;
  where: ArticleAuthorUniqueFilterWithoutAuthorInput;
};

export type AuthorUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleAuthorUpdateWithoutAuthorInput>;
  where?: InputMaybe<ArticleAuthorFilterInput>;
};

export type AuthorUpdateArticlesUpsertInput = {
  create: ArticleAuthorCreationWithoutAuthorInput;
  update?: InputMaybe<ArticleAuthorUpdateWithoutAuthorInput>;
  where: ArticleAuthorUniqueFilterWithoutAuthorInput;
};

export type AuthorUpdateAttributesInput = {
  create?: InputMaybe<Array<AuthorAttributeCreationWithoutAuthorInput>>;
  createIfNotExists?: InputMaybe<Array<AuthorUpdateAttributesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<AuthorAttributeUniqueFilterWithoutAuthorInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<AuthorAttributeUniqueFilterWithoutAuthorInput>>;
  deleteMany?: InputMaybe<AuthorAttributeFilterInput>;
  update?: InputMaybe<Array<AuthorUpdateAttributesUpdateInput>>;
  updateAll?: InputMaybe<AuthorAttributeUpdateWithoutAuthorInput>;
  updateIfExists?: InputMaybe<Array<AuthorUpdateAttributesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<AuthorUpdateAttributesUpdateManyInput>>;
  upsert?: InputMaybe<Array<AuthorUpdateAttributesUpsertInput>>;
};

export type AuthorUpdateAttributesCreateIfNotExistsInput = {
  data: AuthorAttributeCreationWithoutAuthorInput;
  where: AuthorAttributeUniqueFilterWithoutAuthorInput;
};

/** Given an "author", identifies exactly one "AuthorAttribute" by "attribute" or "order" */
export type AuthorAttributeUniqueFilterWithoutAuthorInput = {
  attribute?: InputMaybe<AttributeUniqueFilterInput>;
  /** Order for a given "author", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AuthorUpdateAttributesUpdateInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAuthorInput>;
  where: AuthorAttributeUniqueFilterWithoutAuthorInput;
};

/** The "AuthorAttribute" node's update */
export type AuthorAttributeUpdateWithoutAuthorInput = {
  /** Order for a given "author", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type AuthorUpdateAttributesUpdateIfExistsInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAuthorInput>;
  where: AuthorAttributeUniqueFilterWithoutAuthorInput;
};

export type AuthorUpdateAttributesUpdateManyInput = {
  data?: InputMaybe<AuthorAttributeUpdateWithoutAuthorInput>;
  where?: InputMaybe<AuthorAttributeFilterInput>;
};

export type AuthorUpdateAttributesUpsertInput = {
  create: AuthorAttributeCreationWithoutAuthorInput;
  update?: InputMaybe<AuthorAttributeUpdateWithoutAuthorInput>;
  where: AuthorAttributeUniqueFilterWithoutAuthorInput;
};

/** The "AuthorAttribute" node's update */
export type AuthorAttributeUpdateInput = {
  /** Order for a given "author", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "Card" node's update */
export type CardUpdateInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  categories?: InputMaybe<CardUpdateCategoriesInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  label?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  secondaryTitle?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  status?: InputMaybe<CardStatus>;
  tags?: InputMaybe<CardUpdateTagsInput>;
  /** At most 700 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type CardUpdateCategoriesInput = {
  create?: InputMaybe<Array<CardCategoryCreationWithoutCardInput>>;
  createIfNotExists?: InputMaybe<Array<CardUpdateCategoriesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CardCategoryUniqueFilterWithoutCardInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CardCategoryUniqueFilterWithoutCardInput>>;
  deleteMany?: InputMaybe<CardCategoryFilterInput>;
  update?: InputMaybe<Array<CardUpdateCategoriesUpdateInput>>;
  updateAll?: InputMaybe<CardCategoryUpdateWithoutCardInput>;
  updateIfExists?: InputMaybe<Array<CardUpdateCategoriesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CardUpdateCategoriesUpdateManyInput>>;
  upsert?: InputMaybe<Array<CardUpdateCategoriesUpsertInput>>;
};

export type CardUpdateCategoriesCreateIfNotExistsInput = {
  data: CardCategoryCreationWithoutCardInput;
  where: CardCategoryUniqueFilterWithoutCardInput;
};

/** Given a "card", identifies exactly one "CardCategory" by "category" or "order" */
export type CardCategoryUniqueFilterWithoutCardInput = {
  category?: InputMaybe<CategoryUniqueFilterInput>;
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardUpdateCategoriesUpdateInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCardInput>;
  where: CardCategoryUniqueFilterWithoutCardInput;
};

/** The "CardCategory" node's update */
export type CardCategoryUpdateWithoutCardInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardUpdateCategoriesUpdateIfExistsInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCardInput>;
  where: CardCategoryUniqueFilterWithoutCardInput;
};

export type CardUpdateCategoriesUpdateManyInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCardInput>;
  where?: InputMaybe<CardCategoryFilterInput>;
};

export type CardUpdateCategoriesUpsertInput = {
  create: CardCategoryCreationWithoutCardInput;
  update?: InputMaybe<CardCategoryUpdateWithoutCardInput>;
  where: CardCategoryUniqueFilterWithoutCardInput;
};

export type CardUpdateTagsInput = {
  create?: InputMaybe<Array<CardTagCreationWithoutCardInput>>;
  createIfNotExists?: InputMaybe<Array<CardUpdateTagsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CardTagUniqueFilterWithoutCardInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CardTagUniqueFilterWithoutCardInput>>;
  deleteMany?: InputMaybe<CardTagFilterInput>;
  update?: InputMaybe<Array<CardUpdateTagsUpdateInput>>;
  updateAll?: InputMaybe<CardTagUpdateWithoutCardInput>;
  updateIfExists?: InputMaybe<Array<CardUpdateTagsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CardUpdateTagsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CardUpdateTagsUpsertInput>>;
};

export type CardUpdateTagsCreateIfNotExistsInput = {
  data: CardTagCreationWithoutCardInput;
  where: CardTagUniqueFilterWithoutCardInput;
};

/** Given a "card", identifies exactly one "CardTag" by "tag" or "order" */
export type CardTagUniqueFilterWithoutCardInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

export type CardUpdateTagsUpdateInput = {
  data?: InputMaybe<CardTagUpdateWithoutCardInput>;
  where: CardTagUniqueFilterWithoutCardInput;
};

/** The "CardTag" node's update */
export type CardTagUpdateWithoutCardInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CardUpdateTagsUpdateIfExistsInput = {
  data?: InputMaybe<CardTagUpdateWithoutCardInput>;
  where: CardTagUniqueFilterWithoutCardInput;
};

export type CardUpdateTagsUpdateManyInput = {
  data?: InputMaybe<CardTagUpdateWithoutCardInput>;
  where?: InputMaybe<CardTagFilterInput>;
};

export type CardUpdateTagsUpsertInput = {
  create: CardTagCreationWithoutCardInput;
  update?: InputMaybe<CardTagUpdateWithoutCardInput>;
  where: CardTagUniqueFilterWithoutCardInput;
};

/** The "CardCategory" node's update */
export type CardCategoryUpdateInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "CardTag" node's update */
export type CardTagUpdateInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "Category" node's update */
export type CategoryUpdateInput = {
  articleCategories?: InputMaybe<CategoryUpdateArticleCategoriesInput>;
  articleChannels?: InputMaybe<CategoryUpdateArticleChannelsInput>;
  articleEvents?: InputMaybe<CategoryUpdateArticleEventsInput>;
  articleGuides?: InputMaybe<CategoryUpdateArticleGuidesInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  cards?: InputMaybe<CategoryUpdateCardsInput>;
  children?: InputMaybe<CategoryUpdateChildrenInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The maximum number of articles to generate for this category */
  maxBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  metas?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The minimum number of articles to generate for this category */
  minBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  status?: InputMaybe<CategoryStatus>;
  subtitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tabs?: InputMaybe<CategoryUpdateTabsInput>;
  tags?: InputMaybe<CategoryUpdateTagsInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type CategoryUpdateArticleCategoriesInput = {
  create?: InputMaybe<Array<ArticleCategoryCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateArticleCategoriesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleCategoryUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleCategoryUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<ArticleCategoryFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateArticleCategoriesUpdateInput>>;
  updateAll?: InputMaybe<ArticleCategoryUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateArticleCategoriesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateArticleCategoriesUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateArticleCategoriesUpsertInput>>;
};

export type CategoryUpdateArticleCategoriesCreateIfNotExistsInput = {
  data: ArticleCategoryCreationWithoutCategoryInput;
  where: ArticleCategoryUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "ArticleCategory" by "article" */
export type ArticleCategoryUniqueFilterWithoutCategoryInput = {
  article: ArticleUniqueFilterInput;
};

export type CategoryUpdateArticleCategoriesUpdateInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutCategoryInput>;
  where: ArticleCategoryUniqueFilterWithoutCategoryInput;
};

/** The "ArticleCategory" node's update */
export type ArticleCategoryUpdateWithoutCategoryInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateArticleCategoriesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutCategoryInput>;
  where: ArticleCategoryUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleCategoriesUpdateManyInput = {
  data?: InputMaybe<ArticleCategoryUpdateWithoutCategoryInput>;
  where?: InputMaybe<ArticleCategoryFilterInput>;
};

export type CategoryUpdateArticleCategoriesUpsertInput = {
  create: ArticleCategoryCreationWithoutCategoryInput;
  update?: InputMaybe<ArticleCategoryUpdateWithoutCategoryInput>;
  where: ArticleCategoryUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleChannelsInput = {
  create?: InputMaybe<Array<ArticleChannelCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateArticleChannelsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleChannelUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleChannelUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<ArticleChannelFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateArticleChannelsUpdateInput>>;
  updateAll?: InputMaybe<ArticleChannelUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateArticleChannelsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateArticleChannelsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateArticleChannelsUpsertInput>>;
};

export type CategoryUpdateArticleChannelsCreateIfNotExistsInput = {
  data: ArticleChannelCreationWithoutCategoryInput;
  where: ArticleChannelUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "ArticleChannel" by "article" */
export type ArticleChannelUniqueFilterWithoutCategoryInput = {
  article: ArticleUniqueFilterInput;
};

export type CategoryUpdateArticleChannelsUpdateInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutCategoryInput>;
  where: ArticleChannelUniqueFilterWithoutCategoryInput;
};

/** The "ArticleChannel" node's update */
export type ArticleChannelUpdateWithoutCategoryInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateArticleChannelsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutCategoryInput>;
  where: ArticleChannelUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleChannelsUpdateManyInput = {
  data?: InputMaybe<ArticleChannelUpdateWithoutCategoryInput>;
  where?: InputMaybe<ArticleChannelFilterInput>;
};

export type CategoryUpdateArticleChannelsUpsertInput = {
  create: ArticleChannelCreationWithoutCategoryInput;
  update?: InputMaybe<ArticleChannelUpdateWithoutCategoryInput>;
  where: ArticleChannelUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleEventsInput = {
  create?: InputMaybe<Array<ArticleEventCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateArticleEventsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleEventUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleEventUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<ArticleEventFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateArticleEventsUpdateInput>>;
  updateAll?: InputMaybe<ArticleEventUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateArticleEventsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateArticleEventsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateArticleEventsUpsertInput>>;
};

export type CategoryUpdateArticleEventsCreateIfNotExistsInput = {
  data: ArticleEventCreationWithoutCategoryInput;
  where: ArticleEventUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "ArticleEvent" by "article" */
export type ArticleEventUniqueFilterWithoutCategoryInput = {
  article: ArticleUniqueFilterInput;
};

export type CategoryUpdateArticleEventsUpdateInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutCategoryInput>;
  where: ArticleEventUniqueFilterWithoutCategoryInput;
};

/** The "ArticleEvent" node's update */
export type ArticleEventUpdateWithoutCategoryInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateArticleEventsUpdateIfExistsInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutCategoryInput>;
  where: ArticleEventUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleEventsUpdateManyInput = {
  data?: InputMaybe<ArticleEventUpdateWithoutCategoryInput>;
  where?: InputMaybe<ArticleEventFilterInput>;
};

export type CategoryUpdateArticleEventsUpsertInput = {
  create: ArticleEventCreationWithoutCategoryInput;
  update?: InputMaybe<ArticleEventUpdateWithoutCategoryInput>;
  where: ArticleEventUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleGuidesInput = {
  create?: InputMaybe<Array<ArticleGuideCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateArticleGuidesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleGuideUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleGuideUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<ArticleGuideFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateArticleGuidesUpdateInput>>;
  updateAll?: InputMaybe<ArticleGuideUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateArticleGuidesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateArticleGuidesUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateArticleGuidesUpsertInput>>;
};

export type CategoryUpdateArticleGuidesCreateIfNotExistsInput = {
  data: ArticleGuideCreationWithoutCategoryInput;
  where: ArticleGuideUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "ArticleGuide" by "article" */
export type ArticleGuideUniqueFilterWithoutCategoryInput = {
  article: ArticleUniqueFilterInput;
};

export type CategoryUpdateArticleGuidesUpdateInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutCategoryInput>;
  where: ArticleGuideUniqueFilterWithoutCategoryInput;
};

/** The "ArticleGuide" node's update */
export type ArticleGuideUpdateWithoutCategoryInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateArticleGuidesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutCategoryInput>;
  where: ArticleGuideUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateArticleGuidesUpdateManyInput = {
  data?: InputMaybe<ArticleGuideUpdateWithoutCategoryInput>;
  where?: InputMaybe<ArticleGuideFilterInput>;
};

export type CategoryUpdateArticleGuidesUpsertInput = {
  create: ArticleGuideCreationWithoutCategoryInput;
  update?: InputMaybe<ArticleGuideUpdateWithoutCategoryInput>;
  where: ArticleGuideUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateCardsInput = {
  create?: InputMaybe<Array<CardCategoryCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateCardsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CardCategoryUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CardCategoryUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<CardCategoryFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateCardsUpdateInput>>;
  updateAll?: InputMaybe<CardCategoryUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateCardsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateCardsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateCardsUpsertInput>>;
};

export type CategoryUpdateCardsCreateIfNotExistsInput = {
  data: CardCategoryCreationWithoutCategoryInput;
  where: CardCategoryUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "CardCategory" by "card" */
export type CardCategoryUniqueFilterWithoutCategoryInput = {
  card: CardUniqueFilterInput;
};

export type CategoryUpdateCardsUpdateInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCategoryInput>;
  where: CardCategoryUniqueFilterWithoutCategoryInput;
};

/** The "CardCategory" node's update */
export type CardCategoryUpdateWithoutCategoryInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateCardsUpdateIfExistsInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCategoryInput>;
  where: CardCategoryUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateCardsUpdateManyInput = {
  data?: InputMaybe<CardCategoryUpdateWithoutCategoryInput>;
  where?: InputMaybe<CardCategoryFilterInput>;
};

export type CategoryUpdateCardsUpsertInput = {
  create: CardCategoryCreationWithoutCategoryInput;
  update?: InputMaybe<CardCategoryUpdateWithoutCategoryInput>;
  where: CardCategoryUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateChildrenInput = {
  create?: InputMaybe<Array<CategoryCreationWithoutParentInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateChildrenCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CategoryUniqueFilterWithoutParentInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CategoryUniqueFilterWithoutParentInput>>;
  deleteMany?: InputMaybe<CategoryFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateChildrenUpdateInput>>;
  updateAll?: InputMaybe<CategoryUpdateWithoutParentInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateChildrenUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateChildrenUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateChildrenUpsertInput>>;
};

export type CategoryUpdateChildrenCreateIfNotExistsInput = {
  data: CategoryCreationWithoutParentInput;
  where: CategoryUniqueFilterWithoutParentInput;
};

/** Given a "parent", identifies exactly one "Category" by "order" or "brandKey-slug" */
export type CategoryUniqueFilterWithoutParentInput = {
  brandKey?: InputMaybe<BrandKey>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

export type CategoryUpdateChildrenUpdateInput = {
  data?: InputMaybe<CategoryUpdateWithoutParentInput>;
  where: CategoryUniqueFilterWithoutParentInput;
};

/** The "Category" node's update */
export type CategoryUpdateWithoutParentInput = {
  articleCategories?: InputMaybe<CategoryUpdateArticleCategoriesInput>;
  articleChannels?: InputMaybe<CategoryUpdateArticleChannelsInput>;
  articleEvents?: InputMaybe<CategoryUpdateArticleEventsInput>;
  articleGuides?: InputMaybe<CategoryUpdateArticleGuidesInput>;
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  cards?: InputMaybe<CategoryUpdateCardsInput>;
  children?: InputMaybe<CategoryUpdateChildrenInput>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isHeadlined?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  /** The maximum number of articles to generate for this category */
  maxBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  medias?: InputMaybe<Scalars['JSONArray']['input']>;
  metas?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The minimum number of articles to generate for this category */
  minBoardPinned?: InputMaybe<Scalars['UnsignedInt']['input']>;
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  status?: InputMaybe<CategoryStatus>;
  subtitle?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  tabs?: InputMaybe<CategoryUpdateTabsInput>;
  tags?: InputMaybe<CategoryUpdateTagsInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type CategoryUpdateTabsInput = {
  create?: InputMaybe<Array<TabCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateTabsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<TabUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<TabUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<TabFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateTabsUpdateInput>>;
  updateAll?: InputMaybe<TabUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateTabsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateTabsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateTabsUpsertInput>>;
};

export type CategoryUpdateTabsCreateIfNotExistsInput = {
  data: TabCreationWithoutCategoryInput;
  where: TabUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "Tab" by "slug" or "order" */
export type TabUniqueFilterWithoutCategoryInput = {
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
};

export type CategoryUpdateTabsUpdateInput = {
  data?: InputMaybe<TabUpdateWithoutCategoryInput>;
  where: TabUniqueFilterWithoutCategoryInput;
};

/** The "Tab" node's update */
export type TabUpdateWithoutCategoryInput = {
  content?: InputMaybe<Scalars['JSONValue']['input']>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  disabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  enabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type CategoryUpdateTabsUpdateIfExistsInput = {
  data?: InputMaybe<TabUpdateWithoutCategoryInput>;
  where: TabUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateTabsUpdateManyInput = {
  data?: InputMaybe<TabUpdateWithoutCategoryInput>;
  where?: InputMaybe<TabFilterInput>;
};

export type CategoryUpdateTabsUpsertInput = {
  create: TabCreationWithoutCategoryInput;
  update?: InputMaybe<TabUpdateWithoutCategoryInput>;
  where: TabUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateTagsInput = {
  create?: InputMaybe<Array<CategoryTagCreationWithoutCategoryInput>>;
  createIfNotExists?: InputMaybe<Array<CategoryUpdateTagsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CategoryTagUniqueFilterWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CategoryTagUniqueFilterWithoutCategoryInput>>;
  deleteMany?: InputMaybe<CategoryTagFilterInput>;
  update?: InputMaybe<Array<CategoryUpdateTagsUpdateInput>>;
  updateAll?: InputMaybe<CategoryTagUpdateWithoutCategoryInput>;
  updateIfExists?: InputMaybe<Array<CategoryUpdateTagsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateTagsUpdateManyInput>>;
  upsert?: InputMaybe<Array<CategoryUpdateTagsUpsertInput>>;
};

export type CategoryUpdateTagsCreateIfNotExistsInput = {
  data: CategoryTagCreationWithoutCategoryInput;
  where: CategoryTagUniqueFilterWithoutCategoryInput;
};

/** Given a "category", identifies exactly one "CategoryTag" by "tag" or "order" */
export type CategoryTagUniqueFilterWithoutCategoryInput = {
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  tag?: InputMaybe<TagUniqueFilterInput>;
};

export type CategoryUpdateTagsUpdateInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutCategoryInput>;
  where: CategoryTagUniqueFilterWithoutCategoryInput;
};

/** The "CategoryTag" node's update */
export type CategoryTagUpdateWithoutCategoryInput = {
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type CategoryUpdateTagsUpdateIfExistsInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutCategoryInput>;
  where: CategoryTagUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateTagsUpdateManyInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutCategoryInput>;
  where?: InputMaybe<CategoryTagFilterInput>;
};

export type CategoryUpdateTagsUpsertInput = {
  create: CategoryTagCreationWithoutCategoryInput;
  update?: InputMaybe<CategoryTagUpdateWithoutCategoryInput>;
  where: CategoryTagUniqueFilterWithoutCategoryInput;
};

export type CategoryUpdateChildrenUpdateIfExistsInput = {
  data?: InputMaybe<CategoryUpdateWithoutParentInput>;
  where: CategoryUniqueFilterWithoutParentInput;
};

export type CategoryUpdateChildrenUpdateManyInput = {
  data?: InputMaybe<CategoryUpdateWithoutParentInput>;
  where?: InputMaybe<CategoryFilterInput>;
};

export type CategoryUpdateChildrenUpsertInput = {
  create: CategoryCreationWithoutParentInput;
  update?: InputMaybe<CategoryUpdateWithoutParentInput>;
  where: CategoryUniqueFilterWithoutParentInput;
};

/** The "CategoryTag" node's update */
export type CategoryTagUpdateInput = {
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

/** The "ImageSource" node's update */
export type ImageSourceUpdateInput = {
  category?: InputMaybe<ImageSourceUpdateCategoryInput>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ImageSourceUpdateCategoryInput = {
  /**
   * Connect an "ImageSourceCategory" to an existing "ImageSource" through the
   * "ImageSource.category" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ImageSourceCategoryUniqueFilterInput>;
  /** Create an "ImageSourceCategory" and connect it to an existing "ImageSource" through the "ImageSource.category" edge. */
  create?: InputMaybe<ImageSourceCategoryCreationInput>;
  /**
   * Create an "ImageSourceCategory" if it does not exist, and connect it to an
   * existing "ImageSource" through the "ImageSource.category" edge.
   */
  createIfNotExists?: InputMaybe<ImageSourceUpdateCategoryCreateIfNotExistsInput>;
  /** Update the connected "ImageSourceCategory", throw an error if the "ImageSource.category" edge does not exist. */
  update?: InputMaybe<ImageSourceCategoryUpdateInput>;
};

export type ImageSourceUpdateCategoryCreateIfNotExistsInput = {
  data: ImageSourceCategoryCreationInput;
  where: ImageSourceCategoryUniqueFilterInput;
};

/** The "ImageSourceCategory" node's update */
export type ImageSourceCategoryUpdateInput = {
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  sources?: InputMaybe<ImageSourceCategoryUpdateSourcesInput>;
};

export type ImageSourceCategoryUpdateSourcesInput = {
  create?: InputMaybe<Array<ImageSourceCreationWithoutCategoryInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteMany?: InputMaybe<ImageSourceFilterInput>;
  updateAll?: InputMaybe<ImageSourceUpdateWithoutCategoryInput>;
  updateMany?: InputMaybe<Array<ImageSourceCategoryUpdateSourcesUpdateManyInput>>;
};

/** The "ImageSource" node's update */
export type ImageSourceUpdateWithoutCategoryInput = {
  /** At most 100 characters with at least 2 alphanumeric characters. */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type ImageSourceCategoryUpdateSourcesUpdateManyInput = {
  data?: InputMaybe<ImageSourceUpdateWithoutCategoryInput>;
  where?: InputMaybe<ImageSourceFilterInput>;
};

/** The "Live" node's update */
export type LiveUpdateInput = {
  article?: InputMaybe<LiveUpdateArticleInput>;
  endedAt?: InputMaybe<Scalars['DateTime']['input']>;
  posts?: InputMaybe<LiveUpdatePostsInput>;
};

export type LiveUpdateArticleInput = {
  /** Connect an "Article" to an existing "Live" through the "Live.article" edge, throw an error if it does not exist. */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to an existing "Live" through the "Live.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /** Create an "Article" if it does not exist, and connect it to an existing "Live" through the "Live.article" edge. */
  createIfNotExists?: InputMaybe<LiveUpdateArticleCreateIfNotExistsInput>;
  /** Update the connected "Article", throw an error if the "Live.article" edge does not exist. */
  update?: InputMaybe<ArticleUpdateInput>;
};

export type LiveUpdateArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "LivePost" node's update */
export type LivePostUpdateInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  live?: InputMaybe<LivePostUpdateLiveInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type LivePostUpdateLiveInput = {
  /** Connect a "Live" to an existing "LivePost" through the "LivePost.live" edge, throw an error if it does not exist. */
  connect?: InputMaybe<LiveUniqueFilterInput>;
  /** Create a "Live" and connect it to an existing "LivePost" through the "LivePost.live" edge. */
  create?: InputMaybe<LiveCreationInput>;
  /** Create a "Live" if it does not exist, and connect it to an existing "LivePost" through the "LivePost.live" edge. */
  createIfNotExists?: InputMaybe<LivePostUpdateLiveCreateIfNotExistsInput>;
  /** Update the connected "Live", throw an error if the "LivePost.live" edge does not exist. */
  update?: InputMaybe<LiveUpdateInput>;
};

export type LivePostUpdateLiveCreateIfNotExistsInput = {
  data: LiveCreationInput;
  where: LiveUniqueFilterInput;
};

/** The "MachineTag" node's update */
export type MachineTagUpdateInput = {
  articles?: InputMaybe<MachineTagUpdateArticlesInput>;
  tag?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
};

export type MachineTagUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleMachineTagCreationWithoutMachineTagInput>>;
  createIfNotExists?: InputMaybe<Array<MachineTagUpdateArticlesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleMachineTagUniqueFilterWithoutMachineTagInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleMachineTagUniqueFilterWithoutMachineTagInput>>;
  deleteMany?: InputMaybe<ArticleMachineTagFilterInput>;
  update?: InputMaybe<Array<MachineTagUpdateArticlesUpdateInput>>;
  updateAll?: InputMaybe<ArticleMachineTagUpdateWithoutMachineTagInput>;
  updateIfExists?: InputMaybe<Array<MachineTagUpdateArticlesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<MachineTagUpdateArticlesUpdateManyInput>>;
  upsert?: InputMaybe<Array<MachineTagUpdateArticlesUpsertInput>>;
};

export type MachineTagUpdateArticlesCreateIfNotExistsInput = {
  data: ArticleMachineTagCreationWithoutMachineTagInput;
  where: ArticleMachineTagUniqueFilterWithoutMachineTagInput;
};

/** Given a "machineTag", identifies exactly one "ArticleMachineTag" by "article" */
export type ArticleMachineTagUniqueFilterWithoutMachineTagInput = {
  article: ArticleUniqueFilterInput;
};

export type MachineTagUpdateArticlesUpdateInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutMachineTagInput>;
  where: ArticleMachineTagUniqueFilterWithoutMachineTagInput;
};

/** The "ArticleMachineTag" node's update */
export type ArticleMachineTagUpdateWithoutMachineTagInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type MachineTagUpdateArticlesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutMachineTagInput>;
  where: ArticleMachineTagUniqueFilterWithoutMachineTagInput;
};

export type MachineTagUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleMachineTagUpdateWithoutMachineTagInput>;
  where?: InputMaybe<ArticleMachineTagFilterInput>;
};

export type MachineTagUpdateArticlesUpsertInput = {
  create: ArticleMachineTagCreationWithoutMachineTagInput;
  update?: InputMaybe<ArticleMachineTagUpdateWithoutMachineTagInput>;
  where: ArticleMachineTagUniqueFilterWithoutMachineTagInput;
};

/** The "OpenAiProcess" node's update */
export type OpenAiProcessUpdateInput = {
  article?: InputMaybe<OpenAiProcessUpdateArticleInput>;
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  generatedTitle?: InputMaybe<Scalars['String']['input']>;
  recipeNumber?: InputMaybe<Scalars['UnsignedInt']['input']>;
  recipePaths?: InputMaybe<Scalars['String']['input']>;
  slideshowSubject?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpenAiProcessStatus>;
};

export type OpenAiProcessUpdateArticleInput = {
  /**
   * Connect an "Article" to an existing "OpenAiProcess" through the
   * "OpenAiProcess.article" edge, throw an error if it does not exist.
   */
  connect?: InputMaybe<ArticleUniqueFilterInput>;
  /** Connect an "Article" to an existing "OpenAiProcess" through the "OpenAiProcess.article" edge, if it exists. */
  connectIfExists?: InputMaybe<ArticleUniqueFilterInput>;
  /** Create an "Article" and connect it to an existing "OpenAiProcess" through the "OpenAiProcess.article" edge. */
  create?: InputMaybe<ArticleCreationInput>;
  /**
   * Create an "Article" if it does not exist, and connect it to an existing
   * "OpenAiProcess" through the "OpenAiProcess.article" edge.
   */
  createIfNotExists?: InputMaybe<OpenAiProcessUpdateArticleCreateIfNotExistsInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  disconnectIfExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the connected "Article", throw an error if the "OpenAiProcess.article" edge does not exist. */
  update?: InputMaybe<ArticleUpdateInput>;
  /** Update the connected "Article", if the "OpenAiProcess.article" edge exists. */
  updateIfExists?: InputMaybe<ArticleUpdateInput>;
};

export type OpenAiProcessUpdateArticleCreateIfNotExistsInput = {
  data: ArticleCreationInput;
  where: ArticleUniqueFilterInput;
};

/** The "OrphanPage" node's update */
export type OrphanPageUpdateInput = {
  content?: InputMaybe<Scalars['NonEmptyString']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  isAdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCMPEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** An arbitrary list of strings */
  metas?: InputMaybe<Scalars['JSONArray']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrphanPageStatus>;
  /** At most 2000 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 500 characters. */
  uri?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

/** The "Push" node's update */
export type PushUpdateInput = {
  body?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  errorReason?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  inError?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['URL']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  segments?: InputMaybe<PushUpdateSegmentsInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetDevice?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  targeting?: InputMaybe<Scalars['JSONObject']['input']>;
  title?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
};

/** The "Qualifier" node's update */
export type QualifierUpdateInput = {
  articles?: InputMaybe<QualifierUpdateArticlesInput>;
  format?: InputMaybe<ArticleFormat>;
  status?: InputMaybe<QualifierStatus>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type QualifierUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleQualifierCreationWithoutQualifierInput>>;
  createIfNotExists?: InputMaybe<Array<QualifierUpdateArticlesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleQualifierUniqueFilterWithoutQualifierInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleQualifierUniqueFilterWithoutQualifierInput>>;
  deleteMany?: InputMaybe<ArticleQualifierFilterInput>;
  update?: InputMaybe<Array<QualifierUpdateArticlesUpdateInput>>;
  updateAll?: InputMaybe<ArticleQualifierUpdateWithoutQualifierInput>;
  updateIfExists?: InputMaybe<Array<QualifierUpdateArticlesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<QualifierUpdateArticlesUpdateManyInput>>;
  upsert?: InputMaybe<Array<QualifierUpdateArticlesUpsertInput>>;
};

export type QualifierUpdateArticlesCreateIfNotExistsInput = {
  data: ArticleQualifierCreationWithoutQualifierInput;
  where: ArticleQualifierUniqueFilterWithoutQualifierInput;
};

/** Given a "qualifier", identifies exactly one "ArticleQualifier" by "article" */
export type ArticleQualifierUniqueFilterWithoutQualifierInput = {
  article: ArticleUniqueFilterInput;
};

export type QualifierUpdateArticlesUpdateInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutQualifierInput>;
  where: ArticleQualifierUniqueFilterWithoutQualifierInput;
};

/** The "ArticleQualifier" node's update */
export type ArticleQualifierUpdateWithoutQualifierInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type QualifierUpdateArticlesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutQualifierInput>;
  where: ArticleQualifierUniqueFilterWithoutQualifierInput;
};

export type QualifierUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleQualifierUpdateWithoutQualifierInput>;
  where?: InputMaybe<ArticleQualifierFilterInput>;
};

export type QualifierUpdateArticlesUpsertInput = {
  create: ArticleQualifierCreationWithoutQualifierInput;
  update?: InputMaybe<ArticleQualifierUpdateWithoutQualifierInput>;
  where: ArticleQualifierUniqueFilterWithoutQualifierInput;
};

/** The "Segment" node's update */
export type SegmentUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  android?: InputMaybe<Scalars['JSONObject']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  device?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  editorialAlert?: InputMaybe<Scalars['JSONObject']['input']>;
  ios?: InputMaybe<Scalars['JSONObject']['input']>;
  pushes?: InputMaybe<SegmentUpdatePushesInput>;
  status?: InputMaybe<SegmentStatus>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type SegmentUpdatePushesInput = {
  create?: InputMaybe<Array<PushSegmentCreationWithoutSegmentInput>>;
  createIfNotExists?: InputMaybe<Array<SegmentUpdatePushesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<PushSegmentUniqueFilterWithoutSegmentInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<PushSegmentUniqueFilterWithoutSegmentInput>>;
  deleteMany?: InputMaybe<PushSegmentFilterInput>;
};

export type SegmentUpdatePushesCreateIfNotExistsInput = {
  data: PushSegmentCreationWithoutSegmentInput;
  where: PushSegmentUniqueFilterWithoutSegmentInput;
};

/** Given a "segment", identifies exactly one "PushSegment" by "push" */
export type PushSegmentUniqueFilterWithoutSegmentInput = {
  push: PushUniqueFilterInput;
};

/** The "Tab" node's update */
export type TabUpdateInput = {
  content?: InputMaybe<Scalars['JSONValue']['input']>;
  description?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  disabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 100 characters with at least 2 alphanumeric characters. */
  enabledLabel?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  metas?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

/** The "TagBrandedContent" node's update */
export type TagBrandedContentUpdateInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TagBrandedContentStatus>;
};

/** The "Tag" node's update */
export type TagUpdateInput = {
  articles?: InputMaybe<TagUpdateArticlesInput>;
  /** The cache used by the "articleUsage" virtual-field */
  articleUsageCache?: InputMaybe<Scalars['JSONObject']['input']>;
  brandedContents?: InputMaybe<TagUpdateBrandedContentsInput>;
  cards?: InputMaybe<TagUpdateCardsInput>;
  categories?: InputMaybe<TagUpdateCategoriesInput>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * The slug is generated automatically from the "title" and the "language", but
   * it can be overridden for the "person" tag-type.
   */
  slug?: InputMaybe<Scalars['Slug']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
};

export type TagUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleTagCreationWithoutTagInput>>;
  createIfNotExists?: InputMaybe<Array<TagUpdateArticlesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleTagUniqueFilterWithoutTagInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleTagUniqueFilterWithoutTagInput>>;
  deleteMany?: InputMaybe<ArticleTagFilterInput>;
  update?: InputMaybe<Array<TagUpdateArticlesUpdateInput>>;
  updateAll?: InputMaybe<ArticleTagUpdateWithoutTagInput>;
  updateIfExists?: InputMaybe<Array<TagUpdateArticlesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<TagUpdateArticlesUpdateManyInput>>;
  upsert?: InputMaybe<Array<TagUpdateArticlesUpsertInput>>;
};

export type TagUpdateArticlesCreateIfNotExistsInput = {
  data: ArticleTagCreationWithoutTagInput;
  where: ArticleTagUniqueFilterWithoutTagInput;
};

/** Given a "tag", identifies exactly one "ArticleTag" by "article" */
export type ArticleTagUniqueFilterWithoutTagInput = {
  article: ArticleUniqueFilterInput;
};

export type TagUpdateArticlesUpdateInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutTagInput>;
  where: ArticleTagUniqueFilterWithoutTagInput;
};

/** The "ArticleTag" node's update */
export type ArticleTagUpdateWithoutTagInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type TagUpdateArticlesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutTagInput>;
  where: ArticleTagUniqueFilterWithoutTagInput;
};

export type TagUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleTagUpdateWithoutTagInput>;
  where?: InputMaybe<ArticleTagFilterInput>;
};

export type TagUpdateArticlesUpsertInput = {
  create: ArticleTagCreationWithoutTagInput;
  update?: InputMaybe<ArticleTagUpdateWithoutTagInput>;
  where: ArticleTagUniqueFilterWithoutTagInput;
};

export type TagUpdateBrandedContentsInput = {
  create?: InputMaybe<Array<TagBrandedContentCreationWithoutTagInput>>;
  createIfNotExists?: InputMaybe<Array<TagUpdateBrandedContentsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<TagBrandedContentUniqueFilterWithoutTagInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<TagBrandedContentUniqueFilterWithoutTagInput>>;
  deleteMany?: InputMaybe<TagBrandedContentFilterInput>;
  update?: InputMaybe<Array<TagUpdateBrandedContentsUpdateInput>>;
  updateAll?: InputMaybe<TagBrandedContentUpdateWithoutTagInput>;
  updateIfExists?: InputMaybe<Array<TagUpdateBrandedContentsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<TagUpdateBrandedContentsUpdateManyInput>>;
  upsert?: InputMaybe<Array<TagUpdateBrandedContentsUpsertInput>>;
};

export type TagUpdateBrandedContentsCreateIfNotExistsInput = {
  data: TagBrandedContentCreationWithoutTagInput;
  where: TagBrandedContentUniqueFilterWithoutTagInput;
};

/** Given a "tag", identifies exactly one "TagBrandedContent" by "brandKey" */
export type TagBrandedContentUniqueFilterWithoutTagInput = {
  brandKey: BrandKey;
};

export type TagUpdateBrandedContentsUpdateInput = {
  data?: InputMaybe<TagBrandedContentUpdateWithoutTagInput>;
  where: TagBrandedContentUniqueFilterWithoutTagInput;
};

/** The "TagBrandedContent" node's update */
export type TagBrandedContentUpdateWithoutTagInput = {
  body?: InputMaybe<Scalars['DraftJS']['input']>;
  /** The ID of the user who locked the document */
  lockerId?: InputMaybe<Scalars['UUIDv4']['input']>;
  media?: InputMaybe<Scalars['JSONObject']['input']>;
  retainLock?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TagBrandedContentStatus>;
};

export type TagUpdateBrandedContentsUpdateIfExistsInput = {
  data?: InputMaybe<TagBrandedContentUpdateWithoutTagInput>;
  where: TagBrandedContentUniqueFilterWithoutTagInput;
};

export type TagUpdateBrandedContentsUpdateManyInput = {
  data?: InputMaybe<TagBrandedContentUpdateWithoutTagInput>;
  where?: InputMaybe<TagBrandedContentFilterInput>;
};

export type TagUpdateBrandedContentsUpsertInput = {
  create: TagBrandedContentCreationWithoutTagInput;
  update?: InputMaybe<TagBrandedContentUpdateWithoutTagInput>;
  where: TagBrandedContentUniqueFilterWithoutTagInput;
};

export type TagUpdateCardsInput = {
  create?: InputMaybe<Array<CardTagCreationWithoutTagInput>>;
  createIfNotExists?: InputMaybe<Array<TagUpdateCardsCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CardTagUniqueFilterWithoutTagInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CardTagUniqueFilterWithoutTagInput>>;
  deleteMany?: InputMaybe<CardTagFilterInput>;
  update?: InputMaybe<Array<TagUpdateCardsUpdateInput>>;
  updateAll?: InputMaybe<CardTagUpdateWithoutTagInput>;
  updateIfExists?: InputMaybe<Array<TagUpdateCardsUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<TagUpdateCardsUpdateManyInput>>;
  upsert?: InputMaybe<Array<TagUpdateCardsUpsertInput>>;
};

export type TagUpdateCardsCreateIfNotExistsInput = {
  data: CardTagCreationWithoutTagInput;
  where: CardTagUniqueFilterWithoutTagInput;
};

/** Given a "tag", identifies exactly one "CardTag" by "card" */
export type CardTagUniqueFilterWithoutTagInput = {
  card: CardUniqueFilterInput;
};

export type TagUpdateCardsUpdateInput = {
  data?: InputMaybe<CardTagUpdateWithoutTagInput>;
  where: CardTagUniqueFilterWithoutTagInput;
};

/** The "CardTag" node's update */
export type CardTagUpdateWithoutTagInput = {
  /** Order for a given "card", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type TagUpdateCardsUpdateIfExistsInput = {
  data?: InputMaybe<CardTagUpdateWithoutTagInput>;
  where: CardTagUniqueFilterWithoutTagInput;
};

export type TagUpdateCardsUpdateManyInput = {
  data?: InputMaybe<CardTagUpdateWithoutTagInput>;
  where?: InputMaybe<CardTagFilterInput>;
};

export type TagUpdateCardsUpsertInput = {
  create: CardTagCreationWithoutTagInput;
  update?: InputMaybe<CardTagUpdateWithoutTagInput>;
  where: CardTagUniqueFilterWithoutTagInput;
};

export type TagUpdateCategoriesInput = {
  create?: InputMaybe<Array<CategoryTagCreationWithoutTagInput>>;
  createIfNotExists?: InputMaybe<Array<TagUpdateCategoriesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<CategoryTagUniqueFilterWithoutTagInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<CategoryTagUniqueFilterWithoutTagInput>>;
  deleteMany?: InputMaybe<CategoryTagFilterInput>;
  update?: InputMaybe<Array<TagUpdateCategoriesUpdateInput>>;
  updateAll?: InputMaybe<CategoryTagUpdateWithoutTagInput>;
  updateIfExists?: InputMaybe<Array<TagUpdateCategoriesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<TagUpdateCategoriesUpdateManyInput>>;
  upsert?: InputMaybe<Array<TagUpdateCategoriesUpsertInput>>;
};

export type TagUpdateCategoriesCreateIfNotExistsInput = {
  data: CategoryTagCreationWithoutTagInput;
  where: CategoryTagUniqueFilterWithoutTagInput;
};

/** Given a "tag", identifies exactly one "CategoryTag" by "category" */
export type CategoryTagUniqueFilterWithoutTagInput = {
  category: CategoryUniqueFilterInput;
};

export type TagUpdateCategoriesUpdateInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutTagInput>;
  where: CategoryTagUniqueFilterWithoutTagInput;
};

/** The "CategoryTag" node's update */
export type CategoryTagUpdateWithoutTagInput = {
  /** Order for a given "category", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type TagUpdateCategoriesUpdateIfExistsInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutTagInput>;
  where: CategoryTagUniqueFilterWithoutTagInput;
};

export type TagUpdateCategoriesUpdateManyInput = {
  data?: InputMaybe<CategoryTagUpdateWithoutTagInput>;
  where?: InputMaybe<CategoryTagFilterInput>;
};

export type TagUpdateCategoriesUpsertInput = {
  create: CategoryTagCreationWithoutTagInput;
  update?: InputMaybe<CategoryTagUpdateWithoutTagInput>;
  where: CategoryTagUniqueFilterWithoutTagInput;
};

/** The "Taxonomy" node's update */
export type TaxonomyUpdateInput = {
  articles?: InputMaybe<TaxonomyUpdateArticlesInput>;
  /** At most 255 characters with at least 1 alphanumeric characters. */
  level?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  provider?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  /** At most 255 characters with at least 2 alphanumeric characters. */
  title?: InputMaybe<Scalars['NonEmptySanitizedString']['input']>;
  type?: InputMaybe<TaxonomyType>;
  version?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type TaxonomyUpdateArticlesInput = {
  create?: InputMaybe<Array<ArticleTaxonomyCreationWithoutTaxonomyInput>>;
  createIfNotExists?: InputMaybe<Array<TaxonomyUpdateArticlesCreateIfNotExistsInput>>;
  delete?: InputMaybe<Array<ArticleTaxonomyUniqueFilterWithoutTaxonomyInput>>;
  deleteAll?: InputMaybe<Scalars['Boolean']['input']>;
  deleteIfExists?: InputMaybe<Array<ArticleTaxonomyUniqueFilterWithoutTaxonomyInput>>;
  deleteMany?: InputMaybe<ArticleTaxonomyFilterInput>;
  update?: InputMaybe<Array<TaxonomyUpdateArticlesUpdateInput>>;
  updateAll?: InputMaybe<ArticleTaxonomyUpdateWithoutTaxonomyInput>;
  updateIfExists?: InputMaybe<Array<TaxonomyUpdateArticlesUpdateIfExistsInput>>;
  updateMany?: InputMaybe<Array<TaxonomyUpdateArticlesUpdateManyInput>>;
  upsert?: InputMaybe<Array<TaxonomyUpdateArticlesUpsertInput>>;
};

export type TaxonomyUpdateArticlesCreateIfNotExistsInput = {
  data: ArticleTaxonomyCreationWithoutTaxonomyInput;
  where: ArticleTaxonomyUniqueFilterWithoutTaxonomyInput;
};

/** Given a "taxonomy", identifies exactly one "ArticleTaxonomy" by "article" */
export type ArticleTaxonomyUniqueFilterWithoutTaxonomyInput = {
  article: ArticleUniqueFilterInput;
};

export type TaxonomyUpdateArticlesUpdateInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutTaxonomyInput>;
  where: ArticleTaxonomyUniqueFilterWithoutTaxonomyInput;
};

/** The "ArticleTaxonomy" node's update */
export type ArticleTaxonomyUpdateWithoutTaxonomyInput = {
  /** Order for a given "article", in the interval [0, ∞] */
  order?: InputMaybe<Scalars['UnsignedInt']['input']>;
};

export type TaxonomyUpdateArticlesUpdateIfExistsInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutTaxonomyInput>;
  where: ArticleTaxonomyUniqueFilterWithoutTaxonomyInput;
};

export type TaxonomyUpdateArticlesUpdateManyInput = {
  data?: InputMaybe<ArticleTaxonomyUpdateWithoutTaxonomyInput>;
  where?: InputMaybe<ArticleTaxonomyFilterInput>;
};

export type TaxonomyUpdateArticlesUpsertInput = {
  create: ArticleTaxonomyCreationWithoutTaxonomyInput;
  update?: InputMaybe<ArticleTaxonomyUpdateWithoutTaxonomyInput>;
  where: ArticleTaxonomyUniqueFilterWithoutTaxonomyInput;
};

export type LivePostFragment_LivePost_live_Live = {
  __typename?: 'Live',
  id: string,
  endedAt?: string | null
};

export type LivePostFragment = {
  __typename?: 'LivePost',
  id: string,
  publishedAt: string,
  title?: string | null,
  body?: any | null,
  live: LivePostFragment_LivePost_live_Live
};

export type LiveFragment_Live_posts_LivePost = {
  __typename?: 'LivePost',
  id: string,
  publishedAt: string,
  title?: string | null,
  body?: any | null
};

export type LiveFragment = {
  __typename?: 'Live',
  id: string,
  endedAt?: string | null,
  posts: Array<LiveFragment_Live_posts_LivePost>
};

export type CreateAffiliationCatalogProductMutation_mutation_createAffiliationCatalogProduct_AffilizzCataglogProductCreation = {
  __typename?: 'AffilizzCataglogProductCreation',
  productCatalogLocalizedId: string
};

export type CreateAffiliationCatalogProductMutation_mutation = {
  __typename?: 'mutation',
  createAffiliationCatalogProduct: CreateAffiliationCatalogProductMutation_mutation_createAffiliationCatalogProduct_AffilizzCataglogProductCreation
};


export type CreateAffiliationCatalogProductMutationVariables = Exact<{
  localizedProductId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateAffiliationCatalogProductMutation = CreateAffiliationCatalogProductMutation_mutation;

export type CreateAffiliationCardMutation_mutation_createAffiliationCard_AffilizzCard_contents_AffilizzCardContent = {
  __typename?: 'AffilizzCardContent',
  id: string
};

export type CreateAffiliationCardMutation_mutation_createAffiliationCard_AffilizzCard = {
  __typename?: 'AffilizzCard',
  id: string,
  name: string,
  contents: Array<CreateAffiliationCardMutation_mutation_createAffiliationCard_AffilizzCard_contents_AffilizzCardContent>
};

export type CreateAffiliationCardMutation_mutation = {
  __typename?: 'mutation',
  createAffiliationCard: CreateAffiliationCardMutation_mutation_createAffiliationCard_AffilizzCard
};


export type CreateAffiliationCardMutationVariables = Exact<{
  localizedProductId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mediaId: Scalars['String']['input'];
  positivePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  negativePoints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAffiliationCardMutation = CreateAffiliationCardMutation_mutation;

export type UpsertArticleMutation_mutation_upsertArticle_Article_live_Live = {
  __typename?: 'Live',
  postCount: number,
  endedAt?: string | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: UpsertArticleMutation_mutation_upsertArticle_Article_categories_ArticleCategory_category_Category
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: UpsertArticleMutation_mutation_upsertArticle_Article_channels_ArticleChannel_category_Category
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier_qualifier_Qualifier = {
  __typename?: 'Qualifier',
  id: string,
  title: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier = {
  __typename?: 'ArticleQualifier',
  order: number,
  qualifier: UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier_qualifier_Qualifier
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_tags_ArticleTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  relationId?: string | null,
  title: string,
  type: TagType
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_tags_ArticleTag = {
  __typename?: 'ArticleTag',
  order: number,
  tag: UpsertArticleMutation_mutation_upsertArticle_Article_tags_ArticleTag_tag_Tag
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor_author_Author_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  user?: UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor_author_Author_user_OneUser | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  order: number,
  author: UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor_author_Author
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_source_Source = {
  __typename?: 'Source',
  id: string,
  title: string,
  status: SourceStatus
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: UpsertArticleMutation_mutation_upsertArticle_Article_events_ArticleEvent_category_Category
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_guides_ArticleGuide_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_guides_ArticleGuide = {
  __typename?: 'ArticleGuide',
  order: number,
  category: UpsertArticleMutation_mutation_upsertArticle_Article_guides_ArticleGuide_category_Category
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_machineTags_ArticleMachineTag_machineTag_MachineTag = {
  __typename?: 'MachineTag',
  id: string,
  tag: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_machineTags_ArticleMachineTag = {
  __typename?: 'ArticleMachineTag',
  order: number,
  machineTag: UpsertArticleMutation_mutation_upsertArticle_Article_machineTags_ArticleMachineTag_machineTag_MachineTag
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user = UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user_OneUser | UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user_SystemUser;

export type UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_article_Article = {
  __typename?: 'Article',
  id: string
};

export type UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  id: string,
  createdAt: string,
  user?: UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_user | null,
  article: UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory_article_Article
};

export type UpsertArticleMutation_mutation_upsertArticle_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  pushCount: number,
  canonical?: string | null,
  lockedAt?: string | null,
  secondaryTitle?: string | null,
  partnerTitle?: string | null,
  discoverTitle?: string | null,
  lead?: any | null,
  slug?: string | null,
  platformId?: string | null,
  live?: UpsertArticleMutation_mutation_upsertArticle_Article_live_Live | null,
  categories: Array<UpsertArticleMutation_mutation_upsertArticle_Article_categories_ArticleCategory>,
  channels: Array<UpsertArticleMutation_mutation_upsertArticle_Article_channels_ArticleChannel>,
  creator?: UpsertArticleMutation_mutation_upsertArticle_Article_creator_OneUser | null,
  urls: Array<UpsertArticleMutation_mutation_upsertArticle_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: UpsertArticleMutation_mutation_upsertArticle_Article_lockedBy_OneUser | null,
  tags: Array<UpsertArticleMutation_mutation_upsertArticle_Article_tags_ArticleTag>,
  authors: Array<UpsertArticleMutation_mutation_upsertArticle_Article_authors_ArticleAuthor>,
  source?: UpsertArticleMutation_mutation_upsertArticle_Article_source_Source | null,
  events: Array<UpsertArticleMutation_mutation_upsertArticle_Article_events_ArticleEvent>,
  guides: Array<UpsertArticleMutation_mutation_upsertArticle_Article_guides_ArticleGuide>,
  machineTags: Array<UpsertArticleMutation_mutation_upsertArticle_Article_machineTags_ArticleMachineTag>,
  histories: Array<UpsertArticleMutation_mutation_upsertArticle_Article_histories_ArticleHistory>
};

export type UpsertArticleMutation_mutation = {
  __typename?: 'mutation',
  upsertArticle: UpsertArticleMutation_mutation_upsertArticle_Article
};


export type UpsertArticleMutationVariables = Exact<{
  create: ArticleCreationInput;
  update: ArticleUpdateInput;
  where: ArticleUniqueFilterInput;
}>;


export type UpsertArticleMutation = UpsertArticleMutation_mutation;

export type UpdateArticleMutation_mutation_updateArticle_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: UpdateArticleMutation_mutation_updateArticle_Article_categories_ArticleCategory_category_Category
};

export type UpdateArticleMutation_mutation_updateArticle_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: UpdateArticleMutation_mutation_updateArticle_Article_channels_ArticleChannel_category_Category
};

export type UpdateArticleMutation_mutation_updateArticle_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type UpdateArticleMutation_mutation_updateArticle_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type UpdateArticleMutation_mutation_updateArticle_Article_tags_ArticleTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  relationId?: string | null,
  title: string,
  type: TagType
};

export type UpdateArticleMutation_mutation_updateArticle_Article_tags_ArticleTag = {
  __typename?: 'ArticleTag',
  order: number,
  tag: UpdateArticleMutation_mutation_updateArticle_Article_tags_ArticleTag_tag_Tag
};

export type UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor_author_Author_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  user?: UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor_author_Author_user_OneUser | null
};

export type UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  order: number,
  author: UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor_author_Author
};

export type UpdateArticleMutation_mutation_updateArticle_Article_source_Source = {
  __typename?: 'Source',
  id: string,
  title: string,
  status: SourceStatus
};

export type UpdateArticleMutation_mutation_updateArticle_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: UpdateArticleMutation_mutation_updateArticle_Article_events_ArticleEvent_category_Category
};

export type UpdateArticleMutation_mutation_updateArticle_Article_guides_ArticleGuide_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_guides_ArticleGuide = {
  __typename?: 'ArticleGuide',
  order: number,
  category: UpdateArticleMutation_mutation_updateArticle_Article_guides_ArticleGuide_category_Category
};

export type UpdateArticleMutation_mutation_updateArticle_Article_machineTags_ArticleMachineTag_machineTag_MachineTag = {
  __typename?: 'MachineTag',
  id: string,
  tag: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_machineTags_ArticleMachineTag = {
  __typename?: 'ArticleMachineTag',
  order: number,
  machineTag: UpdateArticleMutation_mutation_updateArticle_Article_machineTags_ArticleMachineTag_machineTag_MachineTag
};

export type UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user = UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user_OneUser | UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user_SystemUser;

export type UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_article_Article = {
  __typename?: 'Article',
  id: string
};

export type UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  id: string,
  createdAt: string,
  user?: UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_user | null,
  article: UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory_article_Article
};

export type UpdateArticleMutation_mutation_updateArticle_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  pushCount: number,
  canonical?: string | null,
  lockedAt?: string | null,
  secondaryTitle?: string | null,
  partnerTitle?: string | null,
  discoverTitle?: string | null,
  lead?: any | null,
  slug?: string | null,
  platformId?: string | null,
  live?: UpsertArticleMutation_mutation_upsertArticle_Article_live_Live | null,
  categories: Array<UpdateArticleMutation_mutation_updateArticle_Article_categories_ArticleCategory>,
  channels: Array<UpdateArticleMutation_mutation_updateArticle_Article_channels_ArticleChannel>,
  creator?: UpdateArticleMutation_mutation_updateArticle_Article_creator_OneUser | null,
  urls: Array<UpdateArticleMutation_mutation_updateArticle_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: UpdateArticleMutation_mutation_updateArticle_Article_lockedBy_OneUser | null,
  tags: Array<UpdateArticleMutation_mutation_updateArticle_Article_tags_ArticleTag>,
  authors: Array<UpdateArticleMutation_mutation_updateArticle_Article_authors_ArticleAuthor>,
  source?: UpdateArticleMutation_mutation_updateArticle_Article_source_Source | null,
  events: Array<UpdateArticleMutation_mutation_updateArticle_Article_events_ArticleEvent>,
  guides: Array<UpdateArticleMutation_mutation_updateArticle_Article_guides_ArticleGuide>,
  machineTags: Array<UpdateArticleMutation_mutation_updateArticle_Article_machineTags_ArticleMachineTag>,
  histories: Array<UpdateArticleMutation_mutation_updateArticle_Article_histories_ArticleHistory>
};

export type UpdateArticleMutation_mutation = {
  __typename?: 'mutation',
  updateArticle: UpdateArticleMutation_mutation_updateArticle_Article
};


export type UpdateArticleMutationVariables = Exact<{
  where: ArticleUniqueFilterInput;
  data: ArticleUpdateInput;
}>;


export type UpdateArticleMutation = UpdateArticleMutation_mutation;

export type UpdateGoodDealPromptsMutation_mutation_updateArticleGoodDealAiPrompt_ArticleGoodDealAiPrompt = {
  __typename?: 'ArticleGoodDealAiPrompt',
  id: string
};

export type UpdateGoodDealPromptsMutation_mutation = {
  __typename?: 'mutation',
  updateArticleGoodDealAiPrompt: UpdateGoodDealPromptsMutation_mutation_updateArticleGoodDealAiPrompt_ArticleGoodDealAiPrompt
};


export type UpdateGoodDealPromptsMutationVariables = Exact<{
  where: ArticleGoodDealAiPromptUniqueFilterInput;
  data: ArticleGoodDealAiPromptUpdateInput;
}>;


export type UpdateGoodDealPromptsMutation = UpdateGoodDealPromptsMutation_mutation;

export type LockArticleMutation_mutation = {
  __typename?: 'mutation',
  lockArticle: boolean
};


export type LockArticleMutationVariables = Exact<{
  where: ArticleUniqueFilterInput;
}>;


export type LockArticleMutation = LockArticleMutation_mutation;

export type RetainLockArticleMutation_mutation = {
  __typename?: 'mutation',
  retainArticleLock: boolean
};


export type RetainLockArticleMutationVariables = Exact<{
  where: ArticleUniqueFilterInput;
}>;


export type RetainLockArticleMutation = RetainLockArticleMutation_mutation;

export type UnlockArticleMutation_mutation = {
  __typename?: 'mutation',
  unlockArticle: boolean
};


export type UnlockArticleMutationVariables = Exact<{
  where: ArticleUniqueFilterInput;
}>;


export type UnlockArticleMutation = UnlockArticleMutation_mutation;

export type UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user = UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user_OneUser | UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user_SystemUser;

export type UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory = {
  __typename?: 'AuthorHistory',
  createdAt: string,
  id: string,
  user?: UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory_user | null
};

export type UpdateAuthorMutation_mutation_updateAuthor_Author_attributes_AuthorAttribute_attribute_Attribute = {
  __typename?: 'Attribute',
  id: string,
  title: string
};

export type UpdateAuthorMutation_mutation_updateAuthor_Author_attributes_AuthorAttribute = {
  __typename?: 'AuthorAttribute',
  attribute: UpdateAuthorMutation_mutation_updateAuthor_Author_attributes_AuthorAttribute_attribute_Attribute
};

export type UpdateAuthorMutation_mutation_updateAuthor_Author = {
  __typename?: 'Author',
  avatarUrl?: string | null,
  brandKey: BrandKey,
  description?: string | null,
  facebookId?: string | null,
  googleId?: string | null,
  id: string,
  instagramId?: string | null,
  isMain: boolean,
  linkedinId?: string | null,
  media?: any | null,
  name: string,
  pinterestId?: string | null,
  snapchatId?: string | null,
  twitterId?: string | null,
  userId?: string | null,
  resume?: string | null,
  email?: string | null,
  hasPublicProfile: boolean,
  isExternal: boolean,
  histories: Array<UpdateAuthorMutation_mutation_updateAuthor_Author_histories_AuthorHistory>,
  attributes: Array<UpdateAuthorMutation_mutation_updateAuthor_Author_attributes_AuthorAttribute>
};

export type UpdateAuthorMutation_mutation = {
  __typename?: 'mutation',
  updateAuthor: UpdateAuthorMutation_mutation_updateAuthor_Author
};


export type UpdateAuthorMutationVariables = Exact<{
  where: AuthorUniqueFilterInput;
  data: AuthorUpdateInput;
}>;


export type UpdateAuthorMutation = UpdateAuthorMutation_mutation;

export type CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user = CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user_OneUser | CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user_SystemUser;

export type CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory = {
  __typename?: 'AuthorHistory',
  createdAt: string,
  id: string,
  user?: CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory_user | null
};

export type CreateAuthorMutation_mutation_createAuthor_Author_attributes_AuthorAttribute_attribute_Attribute = {
  __typename?: 'Attribute',
  id: string,
  title: string
};

export type CreateAuthorMutation_mutation_createAuthor_Author_attributes_AuthorAttribute = {
  __typename?: 'AuthorAttribute',
  attribute: CreateAuthorMutation_mutation_createAuthor_Author_attributes_AuthorAttribute_attribute_Attribute
};

export type CreateAuthorMutation_mutation_createAuthor_Author = {
  __typename?: 'Author',
  avatarUrl?: string | null,
  brandKey: BrandKey,
  description?: string | null,
  facebookId?: string | null,
  googleId?: string | null,
  id: string,
  instagramId?: string | null,
  isMain: boolean,
  linkedinId?: string | null,
  media?: any | null,
  name: string,
  pinterestId?: string | null,
  snapchatId?: string | null,
  twitterId?: string | null,
  userId?: string | null,
  resume?: string | null,
  email?: string | null,
  hasPublicProfile: boolean,
  isExternal: boolean,
  histories: Array<CreateAuthorMutation_mutation_createAuthor_Author_histories_AuthorHistory>,
  attributes: Array<CreateAuthorMutation_mutation_createAuthor_Author_attributes_AuthorAttribute>
};

export type CreateAuthorMutation_mutation = {
  __typename?: 'mutation',
  createAuthor: CreateAuthorMutation_mutation_createAuthor_Author
};


export type CreateAuthorMutationVariables = Exact<{
  data: AuthorCreationInput;
}>;


export type CreateAuthorMutation = CreateAuthorMutation_mutation;

export type UpsertCardMutation_mutation_upsertCard_Card_categories_CardCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  level: number,
  title: string
};

export type UpsertCardMutation_mutation_upsertCard_Card_categories_CardCategory = {
  __typename?: 'CardCategory',
  order: number,
  category: UpsertCardMutation_mutation_upsertCard_Card_categories_CardCategory_category_Category
};

export type UpsertCardMutation_mutation_upsertCard_Card_tags_CardTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType
};

export type UpsertCardMutation_mutation_upsertCard_Card_tags_CardTag = {
  __typename?: 'CardTag',
  order: number,
  tag: UpsertCardMutation_mutation_upsertCard_Card_tags_CardTag_tag_Tag
};

export type UpsertCardMutation_mutation_upsertCard_Card = {
  __typename?: 'Card',
  id: string,
  title: string,
  secondaryTitle?: string | null,
  description?: string | null,
  url: string,
  label: string,
  brandKey: BrandKey,
  status: CardStatus,
  media?: any | null,
  body?: any | null,
  categories: Array<UpsertCardMutation_mutation_upsertCard_Card_categories_CardCategory>,
  tags: Array<UpsertCardMutation_mutation_upsertCard_Card_tags_CardTag>
};

export type UpsertCardMutation_mutation = {
  __typename?: 'mutation',
  upsertCard: UpsertCardMutation_mutation_upsertCard_Card
};


export type UpsertCardMutationVariables = Exact<{
  create: CardCreationInput;
  update: CardUpdateInput;
  where: CardUniqueFilterInput;
}>;


export type UpsertCardMutation = UpsertCardMutation_mutation;

export type CompleteSlideshowIaMutation_mutation_completeAISlideshow_OpenAiProcess = {
  __typename?: 'OpenAiProcess',
  status: OpenAiProcessStatus
};

export type CompleteSlideshowIaMutation_mutation = {
  __typename?: 'mutation',
  completeAISlideshow: CompleteSlideshowIaMutation_mutation_completeAISlideshow_OpenAiProcess
};


export type CompleteSlideshowIaMutationVariables = Exact<{
  recipeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  recipeNumber: Scalars['Int']['input'];
  slideshowSubject: Scalars['NonEmptyString']['input'];
  slideshowEditionId: Scalars['UUIDv4']['input'];
  brandKey: BrandKey;
}>;


export type CompleteSlideshowIaMutation = CompleteSlideshowIaMutation_mutation;

export type CreateAttributeMutation_mutation_createAttribute_Attribute = {
  __typename?: 'Attribute',
  id: string
};

export type CreateAttributeMutation_mutation = {
  __typename?: 'mutation',
  createAttribute: CreateAttributeMutation_mutation_createAttribute_Attribute
};


export type CreateAttributeMutationVariables = Exact<{
  data: AttributeCreationInput;
}>;


export type CreateAttributeMutation = CreateAttributeMutation_mutation;

export type UpdateDailymotionMutation_mutation_importDailymotionVideo_Article = {
  __typename?: 'Article',
  id: string,
  status: ArticleStatus,
  title: string
};

export type UpdateDailymotionMutation_mutation = {
  __typename?: 'mutation',
  importDailymotionVideo: UpdateDailymotionMutation_mutation_importDailymotionVideo_Article
};


export type UpdateDailymotionMutationVariables = Exact<{
  brandKey: BrandKey;
  dailymotionPublicId: Scalars['ID']['input'];
}>;


export type UpdateDailymotionMutation = UpdateDailymotionMutation_mutation;

export type GenerateGoodDealArticleMutation_mutation_generateAIGoodDealArticle_ArticleGoodDealAiProcess = {
  __typename?: 'ArticleGoodDealAiProcess',
  status?: ArticleGoodDealAiProcessStatus | null
};

export type GenerateGoodDealArticleMutation_mutation = {
  __typename?: 'mutation',
  generateAIGoodDealArticle: GenerateGoodDealArticleMutation_mutation_generateAIGoodDealArticle_ArticleGoodDealAiProcess
};


export type GenerateGoodDealArticleMutationVariables = Exact<{
  productUrl: Scalars['URL']['input'];
}>;


export type GenerateGoodDealArticleMutation = GenerateGoodDealArticleMutation_mutation;

export type GenerateSlideshowIaMutation_mutation_generateAISlideshow_OpenAiProcess = {
  __typename?: 'OpenAiProcess',
  status: OpenAiProcessStatus
};

export type GenerateSlideshowIaMutation_mutation = {
  __typename?: 'mutation',
  generateAISlideshow: GenerateSlideshowIaMutation_mutation_generateAISlideshow_OpenAiProcess
};


export type GenerateSlideshowIaMutationVariables = Exact<{
  recipeNumber: Scalars['Int']['input'];
  slideshowSubject: Scalars['NonEmptyString']['input'];
  brandKey: BrandKey;
  recipeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateSlideshowIaMutation = GenerateSlideshowIaMutation_mutation;

export type UpsertLiveMutation_mutation_upsertLive_Live_article_Article = {
  __typename?: 'Article',
  id: string
};

export type UpsertLiveMutation_mutation_upsertLive_Live_posts_LivePost = {
  __typename?: 'LivePost',
  id: string,
  publishedAt: string,
  title?: string | null,
  body?: any | null
};

export type UpsertLiveMutation_mutation_upsertLive_Live = {
  __typename?: 'Live',
  id: string,
  endedAt?: string | null,
  article: UpsertLiveMutation_mutation_upsertLive_Live_article_Article,
  posts: Array<UpsertLiveMutation_mutation_upsertLive_Live_posts_LivePost>
};

export type UpsertLiveMutation_mutation = {
  __typename?: 'mutation',
  upsertLive: UpsertLiveMutation_mutation_upsertLive_Live
};


export type UpsertLiveMutationVariables = Exact<{
  where: LiveUniqueFilterInput;
  create: LiveCreationInput;
  update: LiveUpdateInput;
}>;


export type UpsertLiveMutation = UpsertLiveMutation_mutation;

export type UpdateLiveDatesMutation_mutation_updateLive_Live_posts_LivePost = {
  __typename?: 'LivePost',
  id: string,
  publishedAt: string,
  title?: string | null,
  body?: any | null
};

export type UpdateLiveDatesMutation_mutation_updateLive_Live = {
  __typename?: 'Live',
  id: string,
  endedAt?: string | null,
  posts: Array<UpdateLiveDatesMutation_mutation_updateLive_Live_posts_LivePost>
};

export type UpdateLiveDatesMutation_mutation = {
  __typename?: 'mutation',
  updateLive: UpdateLiveDatesMutation_mutation_updateLive_Live
};


export type UpdateLiveDatesMutationVariables = Exact<{
  where: LiveUniqueFilterInput;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateLiveDatesMutation = UpdateLiveDatesMutation_mutation;

export type UpsertLivePostMutation_mutation_upsertLivePost_LivePost_live_Live = {
  __typename?: 'Live',
  id: string,
  endedAt?: string | null
};

export type UpsertLivePostMutation_mutation_upsertLivePost_LivePost = {
  __typename?: 'LivePost',
  id: string,
  publishedAt: string,
  title?: string | null,
  body?: any | null,
  live: UpsertLivePostMutation_mutation_upsertLivePost_LivePost_live_Live
};

export type UpsertLivePostMutation_mutation = {
  __typename?: 'mutation',
  upsertLivePost: UpsertLivePostMutation_mutation_upsertLivePost_LivePost
};


export type UpsertLivePostMutationVariables = Exact<{
  create: LivePostCreationInput;
  where: LivePostUniqueFilterInput;
  update: LivePostUpdateInput;
}>;


export type UpsertLivePostMutation = UpsertLivePostMutation_mutation;

export type UpdatePromptMutation_mutation_updatePrompt_Prompt = {
  __typename?: 'Prompt',
  body: string
};

export type UpdatePromptMutation_mutation = {
  __typename?: 'mutation',
  updatePrompt: UpdatePromptMutation_mutation_updatePrompt_Prompt
};


export type UpdatePromptMutationVariables = Exact<{
  where: PromptUniqueFilterInput;
  data: PromptUpdateInput;
}>;


export type UpdatePromptMutation = UpdatePromptMutation_mutation;

export type CreatePushMutation_mutation_createPush_Push_article_Article = {
  __typename?: 'Article',
  id: string
};

export type CreatePushMutation_mutation_createPush_Push_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null
};

export type CreatePushMutation_mutation_createPush_Push_segments_PushSegment_segment_Segment = {
  __typename?: 'Segment',
  title: string
};

export type CreatePushMutation_mutation_createPush_Push_segments_PushSegment = {
  __typename?: 'PushSegment',
  segment: CreatePushMutation_mutation_createPush_Push_segments_PushSegment_segment_Segment
};

export type CreatePushMutation_mutation_createPush_Push = {
  __typename?: 'Push',
  id: string,
  title?: string | null,
  body: string,
  targetDevice: string,
  userId: string,
  scheduledAt: string,
  isCancelled: boolean,
  sentAt?: string | null,
  article: CreatePushMutation_mutation_createPush_Push_article_Article,
  user?: CreatePushMutation_mutation_createPush_Push_user_OneUser | null,
  segments: Array<CreatePushMutation_mutation_createPush_Push_segments_PushSegment>
};

export type CreatePushMutation_mutation = {
  __typename?: 'mutation',
  createPush: CreatePushMutation_mutation_createPush_Push
};


export type CreatePushMutationVariables = Exact<{
  data: PushCreationInput;
}>;


export type CreatePushMutation = CreatePushMutation_mutation;

export type RecipeDescriptionsMutation_mutation_updateSlidehowRecipesDescriptions_OpenAiProcess = {
  __typename?: 'OpenAiProcess',
  status: OpenAiProcessStatus
};

export type RecipeDescriptionsMutation_mutation = {
  __typename?: 'mutation',
  updateSlidehowRecipesDescriptions: RecipeDescriptionsMutation_mutation_updateSlidehowRecipesDescriptions_OpenAiProcess
};


export type RecipeDescriptionsMutationVariables = Exact<{
  brandKey: BrandKey;
  slideshowEditionId: Scalars['String']['input'];
  recipesUrls: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RecipeDescriptionsMutation = RecipeDescriptionsMutation_mutation;

export type GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult_pageable_searchAffilizzProductResultPageable = {
  __typename?: 'searchAffilizzProductResultPageable',
  pageNumber?: number | null
};

export type GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult_content_AffilizzProduct = {
  __typename?: 'AffilizzProduct',
  type: AffilizzProductType,
  id: string,
  productLocalizedId: string,
  currencyCode?: string | null,
  defaultImage: string,
  minPrice: number,
  maxPrice?: number | null,
  nbOffers: number,
  name: string,
  upsides?: Array<string> | null,
  downsides?: Array<string> | null
};

export type GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult = {
  __typename?: 'searchAffilizzProductResult',
  totalElements?: number | null,
  totalPages?: number | null,
  pageable?: GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult_pageable_searchAffilizzProductResultPageable | null,
  content: Array<GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult_content_AffilizzProduct>
};

export type GetSearchAffiliationProductQuery_query = {
  __typename?: 'query',
  searchAffiliationProduct: GetSearchAffiliationProductQuery_query_searchAffiliationProduct_searchAffilizzProductResult
};


export type GetSearchAffiliationProductQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<AffilizzProductSearchSort>;
  page?: InputMaybe<Scalars['UnsignedInt']['input']>;
  size?: InputMaybe<Scalars['UnsignedInt']['input']>;
}>;


export type GetSearchAffiliationProductQuery = GetSearchAffiliationProductQuery_query;

export type GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult = {
  __typename?: 'searchAffilizzDesignResult',
  id: string,
  name: string,
  defaultDesign: boolean,
  renderingType: AffilizzDesignRenderingTypeResult
};

export type GetAffilizzDesignsQuery_query = {
  __typename?: 'query',
  searchAffiliationDesign: Array<GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult>
};


export type GetAffilizzDesignsQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type GetAffilizzDesignsQuery = GetAffilizzDesignsQuery_query;

export type GetGoodDealPromptsQuery_query_articleGoodDealAiPrompts_ArticleGoodDealAiPrompt = {
  __typename?: 'ArticleGoodDealAiPrompt',
  promptOrder: number,
  prompt?: string | null
};

export type GetGoodDealPromptsQuery_query = {
  __typename?: 'query',
  articleGoodDealAiPrompts: Array<GetGoodDealPromptsQuery_query_articleGoodDealAiPrompts_ArticleGoodDealAiPrompt>
};


export type GetGoodDealPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoodDealPromptsQuery = GetGoodDealPromptsQuery_query;

export type GetArticleHistoryCountQuery_query = {
  __typename?: 'query',
  articleHistoryCount: number
};


export type GetArticleHistoryCountQueryVariables = Exact<{
  where?: InputMaybe<ArticleHistoryFilterInput>;
}>;


export type GetArticleHistoryCountQuery = GetArticleHistoryCountQuery_query;

export type GetArticlesQuery_query_articles_Article_live_Live = {
  __typename?: 'Live',
  postCount: number
};

export type GetArticlesQuery_query_articles_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticlesQuery_query_articles_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: GetArticlesQuery_query_articles_Article_categories_ArticleCategory_category_Category
};

export type GetArticlesQuery_query_articles_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticlesQuery_query_articles_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: GetArticlesQuery_query_articles_Article_channels_ArticleChannel_category_Category
};

export type GetArticlesQuery_query_articles_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type GetArticlesQuery_query_articles_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type GetArticlesQuery_query_articles_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type GetArticlesQuery_query_articles_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticlesQuery_query_articles_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: GetArticlesQuery_query_articles_Article_events_ArticleEvent_category_Category
};

export type GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user = GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user_OneUser | GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user_SystemUser;

export type GetArticlesQuery_query_articles_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  createdAt: string,
  user?: GetArticlesQuery_query_articles_Article_histories_ArticleHistory_user | null
};

export type GetArticlesQuery_query_articles_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  avatarUrl?: string | null
};

export type GetArticlesQuery_query_articles_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  author: GetArticlesQuery_query_articles_Article_authors_ArticleAuthor_author_Author
};

export type GetArticlesQuery_query_articles_Article_newsletterFlashSenderHistories_NewsletterFlashSenderHistory = {
  __typename?: 'NewsletterFlashSenderHistory',
  createdAt: string
};

export type GetArticlesQuery_query_articles_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  updatedAt: string,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  pushCount: number,
  canonical?: string | null,
  lockedAt?: string | null,
  live?: GetArticlesQuery_query_articles_Article_live_Live | null,
  categories: Array<GetArticlesQuery_query_articles_Article_categories_ArticleCategory>,
  channels: Array<GetArticlesQuery_query_articles_Article_channels_ArticleChannel>,
  creator?: GetArticlesQuery_query_articles_Article_creator_OneUser | null,
  urls: Array<GetArticlesQuery_query_articles_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: GetArticlesQuery_query_articles_Article_lockedBy_OneUser | null,
  events: Array<GetArticlesQuery_query_articles_Article_events_ArticleEvent>,
  histories: Array<GetArticlesQuery_query_articles_Article_histories_ArticleHistory>,
  authors: Array<GetArticlesQuery_query_articles_Article_authors_ArticleAuthor>,
  newsletterFlashSenderHistories: Array<GetArticlesQuery_query_articles_Article_newsletterFlashSenderHistories_NewsletterFlashSenderHistory>
};

export type GetArticlesQuery_query = {
  __typename?: 'query',
  articles: Array<GetArticlesQuery_query_articles_Article>
};


export type GetArticlesQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<ArticleFilterInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  orderBy?: InputMaybe<Array<ArticleOrderingInput> | ArticleOrderingInput>;
}>;


export type GetArticlesQuery = GetArticlesQuery_query;

export type GetArticleCountQuery_query = {
  __typename?: 'query',
  articleCount: number
};


export type GetArticleCountQueryVariables = Exact<{
  where?: InputMaybe<ArticleFilterInput>;
}>;


export type GetArticleCountQuery = GetArticleCountQuery_query;

export type GetArticleQuery_query_article_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticleQuery_query_article_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: GetArticleQuery_query_article_Article_categories_ArticleCategory_category_Category
};

export type GetArticleQuery_query_article_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticleQuery_query_article_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: GetArticleQuery_query_article_Article_channels_ArticleChannel_category_Category
};

export type GetArticleQuery_query_article_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type GetArticleQuery_query_article_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type GetArticleQuery_query_article_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  relationId?: string | null,
  title: string,
  type: TagType
};

export type GetArticleQuery_query_article_Article_tags_ArticleTag = {
  __typename?: 'ArticleTag',
  order: number,
  tag: GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag
};

export type GetArticleQuery_query_article_Article_authors_ArticleAuthor_author_Author_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type GetArticleQuery_query_article_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  user?: GetArticleQuery_query_article_Article_authors_ArticleAuthor_author_Author_user_OneUser | null
};

export type GetArticleQuery_query_article_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  order: number,
  author: GetArticleQuery_query_article_Article_authors_ArticleAuthor_author_Author
};

export type GetArticleQuery_query_article_Article_source_Source = {
  __typename?: 'Source',
  id: string,
  title: string,
  status: SourceStatus
};

export type GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticleQuery_query_article_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category
};

export type GetArticleQuery_query_article_Article_guides_ArticleGuide_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetArticleQuery_query_article_Article_guides_ArticleGuide = {
  __typename?: 'ArticleGuide',
  order: number,
  category: GetArticleQuery_query_article_Article_guides_ArticleGuide_category_Category
};

export type GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag_machineTag_MachineTag = {
  __typename?: 'MachineTag',
  id: string,
  tag: string
};

export type GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag = {
  __typename?: 'ArticleMachineTag',
  order: number,
  machineTag: GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag_machineTag_MachineTag
};

export type GetArticleQuery_query_article_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type GetArticleQuery_query_article_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type GetArticleQuery_query_article_Article_histories_ArticleHistory_user = GetArticleQuery_query_article_Article_histories_ArticleHistory_user_OneUser | GetArticleQuery_query_article_Article_histories_ArticleHistory_user_SystemUser;

export type GetArticleQuery_query_article_Article_histories_ArticleHistory_article_Article = {
  __typename?: 'Article',
  id: string
};

export type GetArticleQuery_query_article_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  id: string,
  createdAt: string,
  user?: GetArticleQuery_query_article_Article_histories_ArticleHistory_user | null,
  article: GetArticleQuery_query_article_Article_histories_ArticleHistory_article_Article
};

export type GetArticleQuery_query_article_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  updatedAt: string,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  pushCount: number,
  canonical?: string | null,
  lockedAt?: string | null,
  secondaryTitle?: string | null,
  partnerTitle?: string | null,
  discoverTitle?: string | null,
  lead?: any | null,
  slug?: string | null,
  platformId?: string | null,
  live?: UpsertArticleMutation_mutation_upsertArticle_Article_live_Live | null,
  categories: Array<GetArticleQuery_query_article_Article_categories_ArticleCategory>,
  channels: Array<GetArticleQuery_query_article_Article_channels_ArticleChannel>,
  creator?: GetArticleQuery_query_article_Article_creator_OneUser | null,
  urls: Array<GetArticleQuery_query_article_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: GetArticleQuery_query_article_Article_lockedBy_OneUser | null,
  tags: Array<GetArticleQuery_query_article_Article_tags_ArticleTag>,
  authors: Array<GetArticleQuery_query_article_Article_authors_ArticleAuthor>,
  source?: GetArticleQuery_query_article_Article_source_Source | null,
  events: Array<GetArticleQuery_query_article_Article_events_ArticleEvent>,
  guides: Array<GetArticleQuery_query_article_Article_guides_ArticleGuide>,
  machineTags: Array<GetArticleQuery_query_article_Article_machineTags_ArticleMachineTag>,
  histories: Array<GetArticleQuery_query_article_Article_histories_ArticleHistory>
};

export type GetArticleQuery_query = {
  __typename?: 'query',
  article: GetArticleQuery_query_article_Article
};


export type GetArticleQueryVariables = Exact<{
  where: ArticleUniqueFilterInput;
}>;


export type GetArticleQuery = GetArticleQuery_query;

export type GetArticleUrlStatusQuery_query_article_Article_urls_ArticleUrl_status_HTTPStatus = {
  __typename?: 'HTTPStatus',
  ok: boolean
};

export type GetArticleUrlStatusQuery_query_article_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  status: GetArticleUrlStatusQuery_query_article_Article_urls_ArticleUrl_status_HTTPStatus
};

export type GetArticleUrlStatusQuery_query_article_Article = {
  __typename?: 'Article',
  urls: Array<GetArticleUrlStatusQuery_query_article_Article_urls_ArticleUrl>
};

export type GetArticleUrlStatusQuery_query = {
  __typename?: 'query',
  article: GetArticleUrlStatusQuery_query_article_Article
};


export type GetArticleUrlStatusQueryVariables = Exact<{
  where: ArticleUniqueFilterInput;
}>;


export type GetArticleUrlStatusQuery = GetArticleUrlStatusQuery_query;

export type GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user = GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user_OneUser | GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user_SystemUser;

export type GetAuthorsQuery_query_authors_Author_histories_AuthorHistory = {
  __typename?: 'AuthorHistory',
  createdAt: string,
  id: string,
  user?: GetAuthorsQuery_query_authors_Author_histories_AuthorHistory_user | null
};

export type GetAuthorsQuery_query_authors_Author_attributes_AuthorAttribute_attribute_Attribute = {
  __typename?: 'Attribute',
  id: string,
  title: string
};

export type GetAuthorsQuery_query_authors_Author_attributes_AuthorAttribute = {
  __typename?: 'AuthorAttribute',
  attribute: GetAuthorsQuery_query_authors_Author_attributes_AuthorAttribute_attribute_Attribute
};

export type GetAuthorsQuery_query_authors_Author = {
  __typename?: 'Author',
  avatarUrl?: string | null,
  brandKey: BrandKey,
  description?: string | null,
  facebookId?: string | null,
  googleId?: string | null,
  id: string,
  instagramId?: string | null,
  isMain: boolean,
  linkedinId?: string | null,
  media?: any | null,
  name: string,
  pinterestId?: string | null,
  snapchatId?: string | null,
  twitterId?: string | null,
  userId?: string | null,
  resume?: string | null,
  email?: string | null,
  hasPublicProfile: boolean,
  isExternal: boolean,
  histories: Array<GetAuthorsQuery_query_authors_Author_histories_AuthorHistory>,
  attributes: Array<GetAuthorsQuery_query_authors_Author_attributes_AuthorAttribute>
};

export type GetAuthorsQuery_query = {
  __typename?: 'query',
  authors: Array<GetAuthorsQuery_query_authors_Author>
};


export type GetAuthorsQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<AuthorFilterInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  orderBy?: InputMaybe<Array<AuthorOrderingInput> | AuthorOrderingInput>;
}>;


export type GetAuthorsQuery = GetAuthorsQuery_query;

export type GetAuthorQuery_query_author_Author_histories_AuthorHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type GetAuthorQuery_query_author_Author_histories_AuthorHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type GetAuthorQuery_query_author_Author_histories_AuthorHistory_user = GetAuthorQuery_query_author_Author_histories_AuthorHistory_user_OneUser | GetAuthorQuery_query_author_Author_histories_AuthorHistory_user_SystemUser;

export type GetAuthorQuery_query_author_Author_histories_AuthorHistory = {
  __typename?: 'AuthorHistory',
  createdAt: string,
  id: string,
  user?: GetAuthorQuery_query_author_Author_histories_AuthorHistory_user | null
};

export type GetAuthorQuery_query_author_Author_attributes_AuthorAttribute_attribute_Attribute = {
  __typename?: 'Attribute',
  id: string,
  title: string
};

export type GetAuthorQuery_query_author_Author_attributes_AuthorAttribute = {
  __typename?: 'AuthorAttribute',
  attribute: GetAuthorQuery_query_author_Author_attributes_AuthorAttribute_attribute_Attribute
};

export type GetAuthorQuery_query_author_Author = {
  __typename?: 'Author',
  avatarUrl?: string | null,
  brandKey: BrandKey,
  description?: string | null,
  facebookId?: string | null,
  googleId?: string | null,
  id: string,
  instagramId?: string | null,
  isMain: boolean,
  linkedinId?: string | null,
  media?: any | null,
  name: string,
  pinterestId?: string | null,
  snapchatId?: string | null,
  twitterId?: string | null,
  userId?: string | null,
  resume?: string | null,
  email?: string | null,
  hasPublicProfile: boolean,
  isExternal: boolean,
  histories: Array<GetAuthorQuery_query_author_Author_histories_AuthorHistory>,
  attributes: Array<GetAuthorQuery_query_author_Author_attributes_AuthorAttribute>
};

export type GetAuthorQuery_query = {
  __typename?: 'query',
  author: GetAuthorQuery_query_author_Author
};


export type GetAuthorQueryVariables = Exact<{
  where: AuthorUniqueFilterInput;
}>;


export type GetAuthorQuery = GetAuthorQuery_query;

export type GetCardQuery_query_card_Card_categories_CardCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  level: number,
  title: string
};

export type GetCardQuery_query_card_Card_categories_CardCategory = {
  __typename?: 'CardCategory',
  order: number,
  category: GetCardQuery_query_card_Card_categories_CardCategory_category_Category
};

export type GetCardQuery_query_card_Card_tags_CardTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType
};

export type GetCardQuery_query_card_Card_tags_CardTag = {
  __typename?: 'CardTag',
  order: number,
  tag: GetCardQuery_query_card_Card_tags_CardTag_tag_Tag
};

export type GetCardQuery_query_card_Card = {
  __typename?: 'Card',
  id: string,
  title: string,
  secondaryTitle?: string | null,
  description?: string | null,
  url: string,
  label: string,
  brandKey: BrandKey,
  status: CardStatus,
  media?: any | null,
  body?: any | null,
  categories: Array<GetCardQuery_query_card_Card_categories_CardCategory>,
  tags: Array<GetCardQuery_query_card_Card_tags_CardTag>
};

export type GetCardQuery_query = {
  __typename?: 'query',
  card: GetCardQuery_query_card_Card
};


export type GetCardQueryVariables = Exact<{
  where: CardUniqueFilterInput;
}>;


export type GetCardQuery = GetCardQuery_query;

export type GetCardsQuery_query_cards_Card_categories_CardCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  level: number,
  title: string
};

export type GetCardsQuery_query_cards_Card_categories_CardCategory = {
  __typename?: 'CardCategory',
  order: number,
  category: GetCardsQuery_query_cards_Card_categories_CardCategory_category_Category
};

export type GetCardsQuery_query_cards_Card_tags_CardTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType
};

export type GetCardsQuery_query_cards_Card_tags_CardTag = {
  __typename?: 'CardTag',
  order: number,
  tag: GetCardsQuery_query_cards_Card_tags_CardTag_tag_Tag
};

export type GetCardsQuery_query_cards_Card = {
  __typename?: 'Card',
  id: string,
  title: string,
  secondaryTitle?: string | null,
  description?: string | null,
  url: string,
  label: string,
  brandKey: BrandKey,
  status: CardStatus,
  media?: any | null,
  body?: any | null,
  categories: Array<GetCardsQuery_query_cards_Card_categories_CardCategory>,
  tags: Array<GetCardsQuery_query_cards_Card_tags_CardTag>
};

export type GetCardsQuery_query = {
  __typename?: 'query',
  cards: Array<GetCardsQuery_query_cards_Card>
};


export type GetCardsQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<CardFilterInput>;
  orderBy?: InputMaybe<Array<CardOrderingInput> | CardOrderingInput>;
}>;


export type GetCardsQuery = GetCardsQuery_query;

export type GetDailymotionUploadUrlQuery_query_dailymotionUploadURL_DailymotionUploadURL = {
  __typename?: 'DailymotionUploadURL',
  uploadUrl: string,
  progressUrl: string
};

export type GetDailymotionUploadUrlQuery_query = {
  __typename?: 'query',
  dailymotionUploadURL: GetDailymotionUploadUrlQuery_query_dailymotionUploadURL_DailymotionUploadURL
};


export type GetDailymotionUploadUrlQueryVariables = Exact<{
  brandKey: BrandKey;
}>;


export type GetDailymotionUploadUrlQuery = GetDailymotionUploadUrlQuery_query;

export type ExecuteImagePromptQuery_query_executeImagePrompt_ImagePrompt = {
  __typename?: 'ImagePrompt',
  b64Json: string
};

export type ExecuteImagePromptQuery_query = {
  __typename?: 'query',
  executeImagePrompt: ExecuteImagePromptQuery_query_executeImagePrompt_ImagePrompt
};


export type ExecuteImagePromptQueryVariables = Exact<{
  prompt: Scalars['NonEmptyTrimmedString']['input'];
}>;


export type ExecuteImagePromptQuery = ExecuteImagePromptQuery_query;

export type ExecuteTextPromptQuery_query_executeTextPrompt_TextPrompt = {
  __typename?: 'TextPrompt',
  content: string
};

export type ExecuteTextPromptQuery_query = {
  __typename?: 'query',
  executeTextPrompt: ExecuteTextPromptQuery_query_executeTextPrompt_TextPrompt
};


export type ExecuteTextPromptQueryVariables = Exact<{
  prompt: Scalars['NonEmptyTrimmedString']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  max_completion_tokens?: InputMaybe<Scalars['UnsignedInt']['input']>;
  temperature?: InputMaybe<Scalars['UnsignedFloat']['input']>;
  top_p?: InputMaybe<Scalars['UnsignedFloat']['input']>;
  frequency_penalty?: InputMaybe<Scalars['Float']['input']>;
  presence_penalty?: InputMaybe<Scalars['Float']['input']>;
  response_format?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ExecuteTextPromptQuery = ExecuteTextPromptQuery_query;

export type GetArticleGoodDealIaProcessQuery_query_articleGoodDealAiProcesses_ArticleGoodDealAiProcess_article_Article = {
  __typename?: 'Article',
  id: string
};

export type GetArticleGoodDealIaProcessQuery_query_articleGoodDealAiProcesses_ArticleGoodDealAiProcess = {
  __typename?: 'ArticleGoodDealAiProcess',
  status?: ArticleGoodDealAiProcessStatus | null,
  id: string,
  createdAt: string,
  updatedAt: string,
  productTitle?: string | null,
  error?: string | null,
  article?: GetArticleGoodDealIaProcessQuery_query_articleGoodDealAiProcesses_ArticleGoodDealAiProcess_article_Article | null
};

export type GetArticleGoodDealIaProcessQuery_query = {
  __typename?: 'query',
  articleGoodDealAiProcesses: Array<GetArticleGoodDealIaProcessQuery_query_articleGoodDealAiProcesses_ArticleGoodDealAiProcess>
};


export type GetArticleGoodDealIaProcessQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUIDv4']['input']>;
}>;


export type GetArticleGoodDealIaProcessQuery = GetArticleGoodDealIaProcessQuery_query;

export type GetAttributesQuery_query_attributes_Attribute_authors_AuthorAttribute_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string
};

export type GetAttributesQuery_query_attributes_Attribute_authors_AuthorAttribute = {
  __typename?: 'AuthorAttribute',
  author: GetAttributesQuery_query_attributes_Attribute_authors_AuthorAttribute_author_Author
};

export type GetAttributesQuery_query_attributes_Attribute = {
  __typename?: 'Attribute',
  id: string,
  title: string,
  createdAt: string,
  updatedAt: string,
  brandKey: BrandKey,
  slug: string,
  authors: Array<GetAttributesQuery_query_attributes_Attribute_authors_AuthorAttribute>
};

export type GetAttributesQuery_query = {
  __typename?: 'query',
  attributes: Array<GetAttributesQuery_query_attributes_Attribute>
};


export type GetAttributesQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<AttributeFilterInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  orderBy?: InputMaybe<Array<AttributeOrderingInput> | AttributeOrderingInput>;
}>;


export type GetAttributesQuery = GetAttributesQuery_query;

export type SearchTagFragment_Tag_brandedContents_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  isActive: boolean,
  brandKey: BrandKey
};

export type SearchTagFragment = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType,
  relationId?: string | null,
  articleCount: number,
  brandedContents: Array<SearchTagFragment_Tag_brandedContents_TagBrandedContent>
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage = {
  __typename?: 'BrandedArticleUsage',
  brandKey: BrandKey,
  total: number
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_brandedContents_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  isActive: boolean,
  brandKey: BrandKey
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_categories_CardCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  level: number,
  title: string
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_categories_CardCategory = {
  __typename?: 'CardCategory',
  order: number,
  category: GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_categories_CardCategory_category_Category
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_tags_CardTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_tags_CardTag = {
  __typename?: 'CardTag',
  order: number,
  tag: GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_tags_CardTag_tag_Tag
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card = {
  __typename?: 'Card',
  id: string,
  title: string,
  secondaryTitle?: string | null,
  description?: string | null,
  url: string,
  label: string,
  brandKey: BrandKey,
  status: CardStatus,
  media?: any | null,
  body?: any | null,
  categories: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_categories_CardCategory>,
  tags: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card_tags_CardTag>
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag = {
  __typename?: 'CardTag',
  order: number,
  card: GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_card_Card,
  tag: GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag_tag_Tag
};

export type GetSearchEnabledTagsQuery_query_searchTags_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType,
  relationId?: string | null,
  cardCount: number,
  articleUsages: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag_articleUsages_BrandedArticleUsage>,
  brandedContents: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag_brandedContents_TagBrandedContent>,
  cards: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag_cards_CardTag>
};

export type GetSearchEnabledTagsQuery_query = {
  __typename?: 'query',
  searchTags: Array<GetSearchEnabledTagsQuery_query_searchTags_Tag>
};


export type GetSearchEnabledTagsQueryVariables = Exact<{
  where?: InputMaybe<TagFilterSearchInput>;
  first: Scalars['UnsignedInt']['input'];
  skip: Scalars['UnsignedInt']['input'];
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  like?: InputMaybe<TagLikeInput>;
}>;


export type GetSearchEnabledTagsQuery = GetSearchEnabledTagsQuery_query;

export type GetTagQuery_query_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string
};

export type GetTagQuery_query = {
  __typename?: 'query',
  tag: GetTagQuery_query_tag_Tag
};


export type GetTagQueryVariables = Exact<{
  where: TagUniqueFilterInput;
}>;


export type GetTagQuery = GetTagQuery_query;

export type GetOpenAiProcessesQuery_query_openAiProcesses_OpenAiProcess_article_Article = {
  __typename?: 'Article',
  id: string
};

export type GetOpenAiProcessesQuery_query_openAiProcesses_OpenAiProcess = {
  __typename?: 'OpenAiProcess',
  id: string,
  slideshowSubject?: string | null,
  recipeNumber?: number | null,
  status: OpenAiProcessStatus,
  errorMsg?: string | null,
  createdAt: string,
  updatedAt: string,
  generatedTitle?: string | null,
  article?: GetOpenAiProcessesQuery_query_openAiProcesses_OpenAiProcess_article_Article | null
};

export type GetOpenAiProcessesQuery_query = {
  __typename?: 'query',
  openAiProcesses: Array<GetOpenAiProcessesQuery_query_openAiProcesses_OpenAiProcess>
};


export type GetOpenAiProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpenAiProcessesQuery = GetOpenAiProcessesQuery_query;

export type GetSearchTvCollectionQuery_query_searchTvCollections_TvCollection = {
  __typename?: 'TvCollection',
  id: string,
  title: string,
  season?: number | null,
  type: string,
  boneUUID: string
};

export type GetSearchTvCollectionQuery_query = {
  __typename?: 'query',
  searchTvCollections: Array<GetSearchTvCollectionQuery_query_searchTvCollections_TvCollection>
};


export type GetSearchTvCollectionQueryVariables = Exact<{
  query: Scalars['NonEmptyTrimmedString']['input'];
  context: TvSearchContextType;
}>;


export type GetSearchTvCollectionQuery = GetSearchTvCollectionQuery_query;

export type GetSearchTvProgramQuery_query_searchTvPrograms_TvProgram = {
  __typename?: 'TvProgram',
  id: string,
  title: string,
  boneUUID: string,
  channel?: string | null,
  startedAt?: string | null
};

export type GetSearchTvProgramQuery_query = {
  __typename?: 'query',
  searchTvPrograms: Array<GetSearchTvProgramQuery_query_searchTvPrograms_TvProgram>
};


export type GetSearchTvProgramQueryVariables = Exact<{
  query: Scalars['NonEmptyTrimmedString']['input'];
  context: TvSearchContextType;
}>;


export type GetSearchTvProgramQuery = GetSearchTvProgramQuery_query;

export type GetSuggestedTagsListQuery_query_suggestTags_Tag_articleUsages_BrandedArticleUsage = {
  __typename?: 'BrandedArticleUsage',
  total: number,
  brandKey: BrandKey
};

export type GetSuggestedTagsListQuery_query_suggestTags_Tag_brandedContents_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  isActive: boolean,
  brandKey: BrandKey
};

export type GetSuggestedTagsListQuery_query_suggestTags_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  type: TagType,
  relationId?: string | null,
  articleUsages: Array<GetSuggestedTagsListQuery_query_suggestTags_Tag_articleUsages_BrandedArticleUsage>,
  brandedContents: Array<GetSuggestedTagsListQuery_query_suggestTags_Tag_brandedContents_TagBrandedContent>
};

export type GetSuggestedTagsListQuery_query = {
  __typename?: 'query',
  suggestTags: Array<GetSuggestedTagsListQuery_query_suggestTags_Tag>
};


export type GetSuggestedTagsListQueryVariables = Exact<{
  article: ArticleLikeInput;
  where?: InputMaybe<ArticleTagsTagFilterSearchInput>;
  brandKey?: InputMaybe<BrandKey>;
}>;


export type GetSuggestedTagsListQuery = GetSuggestedTagsListQuery_query;

export type GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult_items_ImageProviderResult_preview_PhotoPreview = {
  __typename?: 'PhotoPreview',
  height: number,
  url: string,
  width: number
};

export type GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult_items_ImageProviderResult = {
  __typename?: 'ImageProviderResult',
  id: string,
  medium?: string | null,
  large?: string | null,
  small?: string | null,
  preview?: GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult_items_ImageProviderResult_preview_PhotoPreview | null
};

export type GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult = {
  __typename?: 'PhotoSearchResult',
  name: ImageProviderName,
  items: Array<GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult_items_ImageProviderResult>
};

export type GetProvidersPhotosQuery_query = {
  __typename?: 'query',
  searchExternalImages: Array<GetProvidersPhotosQuery_query_searchExternalImages_PhotoSearchResult>
};


export type GetProvidersPhotosQueryVariables = Exact<{
  query: Scalars['NonEmptyTrimmedString']['input'];
  perPage: Scalars['UnsignedInt']['input'];
  providers: Array<ImageProviderName> | ImageProviderName;
  currentPage?: InputMaybe<Scalars['UnsignedInt']['input']>;
}>;


export type GetProvidersPhotosQuery = GetProvidersPhotosQuery_query;

export type GetPromptsQuery_query_prompts_Prompt = {
  __typename?: 'Prompt',
  field: PromptField,
  label: string,
  body: string,
  brandKey: BrandKey
};

export type GetPromptsQuery_query = {
  __typename?: 'query',
  prompts: Array<GetPromptsQuery_query_prompts_Prompt>
};


export type GetPromptsQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<PromptFilterInput>;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
}>;


export type GetPromptsQuery = GetPromptsQuery_query;

export type GetPromptQuery_query_prompt_Prompt = {
  __typename?: 'Prompt',
  body: string
};

export type GetPromptQuery_query = {
  __typename?: 'query',
  prompt: GetPromptQuery_query_prompt_Prompt
};


export type GetPromptQueryVariables = Exact<{
  brandKey: BrandKey;
  field: PromptField;
  label: Scalars['NonEmptyTrimmedString']['input'];
}>;


export type GetPromptQuery = GetPromptQuery_query;

export type SearchArticlesQuery_query_searchArticles_Article_live_Live = {
  __typename?: 'Live',
  postCount: number
};

export type SearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: SearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category
};

export type SearchArticlesQuery_query_searchArticles_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SearchArticlesQuery_query_searchArticles_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: SearchArticlesQuery_query_searchArticles_Article_channels_ArticleChannel_category_Category
};

export type SearchArticlesQuery_query_searchArticles_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type SearchArticlesQuery_query_searchArticles_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type SearchArticlesQuery_query_searchArticles_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type SearchArticlesQuery_query_searchArticles_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SearchArticlesQuery_query_searchArticles_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: SearchArticlesQuery_query_searchArticles_Article_events_ArticleEvent_category_Category
};

export type SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user = SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_OneUser | SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_SystemUser;

export type SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  createdAt: string,
  user?: SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user | null
};

export type SearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  relationId?: string | null,
  title: string,
  type: TagType
};

export type SearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag = {
  __typename?: 'ArticleTag',
  order: number,
  tag: SearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag_tag_Tag
};

export type SearchArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  avatarUrl?: string | null
};

export type SearchArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  author: SearchArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor_author_Author
};

export type SearchArticlesQuery_query_searchArticles_Article_newsletterFlashSenderHistories_NewsletterFlashSenderHistory = {
  __typename?: 'NewsletterFlashSenderHistory',
  createdAt: string
};

export type SearchArticlesQuery_query_searchArticles_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  updatedAt: string,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  pushCount: number,
  refererCount: number,
  lockedAt?: string | null,
  canonical?: string | null,
  live?: SearchArticlesQuery_query_searchArticles_Article_live_Live | null,
  categories: Array<SearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory>,
  channels: Array<SearchArticlesQuery_query_searchArticles_Article_channels_ArticleChannel>,
  creator?: SearchArticlesQuery_query_searchArticles_Article_creator_OneUser | null,
  urls: Array<SearchArticlesQuery_query_searchArticles_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: SearchArticlesQuery_query_searchArticles_Article_lockedBy_OneUser | null,
  events: Array<SearchArticlesQuery_query_searchArticles_Article_events_ArticleEvent>,
  histories: Array<SearchArticlesQuery_query_searchArticles_Article_histories_ArticleHistory>,
  tags: Array<SearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag>,
  authors: Array<SearchArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor>,
  newsletterFlashSenderHistories: Array<SearchArticlesQuery_query_searchArticles_Article_newsletterFlashSenderHistories_NewsletterFlashSenderHistory>
};

export type SearchArticlesQuery_query = {
  __typename?: 'query',
  searchArticles: Array<SearchArticlesQuery_query_searchArticles_Article>
};


export type SearchArticlesQueryVariables = Exact<{
  where?: InputMaybe<ArticleFilterSearchInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  like?: InputMaybe<ArticleLikeInput>;
  first: Scalars['UnsignedInt']['input'];
  skip: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingSearchInput> | ArticleOrderingSearchInput>;
}>;


export type SearchArticlesQuery = SearchArticlesQuery_query;

export type SearchArticleCountQuery_query = {
  __typename?: 'query',
  searchArticleCount: number
};


export type SearchArticleCountQueryVariables = Exact<{
  where?: InputMaybe<ArticleFilterSearchInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
}>;


export type SearchArticleCountQuery = SearchArticleCountQuery_query;

export type ExportSearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  category: ExportSearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_qualifiers_ArticleQualifier_qualifier_Qualifier = {
  __typename?: 'Qualifier',
  id: string,
  title: string
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_qualifiers_ArticleQualifier = {
  __typename?: 'ArticleQualifier',
  qualifier: ExportSearchArticlesQuery_query_searchArticles_Article_qualifiers_ArticleQualifier_qualifier_Qualifier
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string
};

export type ExportSearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag = {
  __typename?: 'ArticleTag',
  tag: ExportSearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag_tag_Tag
};

export type ExportSearchArticlesQuery_query_searchArticles_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  publishedAt?: string | null,
  brandKey: BrandKey,
  format: ArticleFormat,
  categories: Array<ExportSearchArticlesQuery_query_searchArticles_Article_categories_ArticleCategory>,
  urls: Array<ExportSearchArticlesQuery_query_searchArticles_Article_urls_ArticleUrl>,
  qualifiers: Array<ExportSearchArticlesQuery_query_searchArticles_Article_qualifiers_ArticleQualifier>,
  tags: Array<ExportSearchArticlesQuery_query_searchArticles_Article_tags_ArticleTag>
};

export type ExportSearchArticlesQuery_query = {
  __typename?: 'query',
  searchArticles: Array<ExportSearchArticlesQuery_query_searchArticles_Article>
};


export type ExportSearchArticlesQueryVariables = Exact<{
  where?: InputMaybe<ArticleFilterSearchInput>;
  query?: InputMaybe<Scalars['NonEmptyTrimmedString']['input']>;
  like?: InputMaybe<ArticleLikeInput>;
  first: Scalars['UnsignedInt']['input'];
  skip: Scalars['UnsignedInt']['input'];
  orderBy?: InputMaybe<Array<ArticleOrderingSearchInput> | ArticleOrderingSearchInput>;
}>;


export type ExportSearchArticlesQuery = ExportSearchArticlesQuery_query;

export type GetOrphansQuery_query_orphanPages_OrphanPage = {
  __typename: 'OrphanPage',
  id: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  status: OrphanPageStatus,
  title: string,
  metas?: any | null,
  isCMPEnabled: boolean,
  isFullScreen: boolean,
  brandKey: BrandKey,
  uri: string
};

export type GetOrphansQuery_query = {
  __typename?: 'query',
  orphanPages: Array<GetOrphansQuery_query_orphanPages_OrphanPage>
};


export type GetOrphansQueryVariables = Exact<{
  where?: InputMaybe<OrphanPageFilterInput>;
  first: Scalars['UnsignedInt']['input'];
  skip: Scalars['UnsignedInt']['input'];
}>;


export type GetOrphansQuery = GetOrphansQuery_query;

export type SuggestArticlesQuery_query_searchArticles_Article_live_Live = {
  __typename?: 'Live',
  postCount: number
};

export type SuggestArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SuggestArticlesQuery_query_searchArticles_Article_categories_ArticleCategory = {
  __typename?: 'ArticleCategory',
  order: number,
  category: SuggestArticlesQuery_query_searchArticles_Article_categories_ArticleCategory_category_Category
};

export type SuggestArticlesQuery_query_searchArticles_Article_channels_ArticleChannel_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SuggestArticlesQuery_query_searchArticles_Article_channels_ArticleChannel = {
  __typename?: 'ArticleChannel',
  order: number,
  category: SuggestArticlesQuery_query_searchArticles_Article_channels_ArticleChannel_category_Category
};

export type SuggestArticlesQuery_query_searchArticles_Article_creator_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type SuggestArticlesQuery_query_searchArticles_Article_urls_ArticleUrl = {
  __typename?: 'ArticleUrl',
  origin: string,
  path: string
};

export type SuggestArticlesQuery_query_searchArticles_Article_lockedBy_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  email: string,
  avatarUrl?: string | null
};

export type SuggestArticlesQuery_query_searchArticles_Article_events_ArticleEvent_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type SuggestArticlesQuery_query_searchArticles_Article_events_ArticleEvent = {
  __typename?: 'ArticleEvent',
  order: number,
  category: SuggestArticlesQuery_query_searchArticles_Article_events_ArticleEvent_category_Category
};

export type SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_OneUser = {
  __typename?: 'OneUser',
  name?: string | null
};

export type SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user = SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_OneUser | SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user_SystemUser;

export type SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory = {
  __typename?: 'ArticleHistory',
  user?: SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory_user | null
};

export type SuggestArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor_author_Author = {
  __typename?: 'Author',
  id: string,
  name: string,
  avatarUrl?: string | null
};

export type SuggestArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor = {
  __typename?: 'ArticleAuthor',
  author: SuggestArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor_author_Author
};

export type SuggestArticlesQuery_query_searchArticles_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  status: ArticleStatus,
  body?: any | null,
  createdAt: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  brandKey: BrandKey,
  format: ArticleFormat,
  medias?: any | null,
  canonical?: string | null,
  pushCount: number,
  refererCount: number,
  lockedAt?: string | null,
  live?: SuggestArticlesQuery_query_searchArticles_Article_live_Live | null,
  categories: Array<SuggestArticlesQuery_query_searchArticles_Article_categories_ArticleCategory>,
  channels: Array<SuggestArticlesQuery_query_searchArticles_Article_channels_ArticleChannel>,
  creator?: SuggestArticlesQuery_query_searchArticles_Article_creator_OneUser | null,
  urls: Array<SuggestArticlesQuery_query_searchArticles_Article_urls_ArticleUrl>,
  qualifiers: Array<UpsertArticleMutation_mutation_upsertArticle_Article_qualifiers_ArticleQualifier>,
  lockedBy?: SuggestArticlesQuery_query_searchArticles_Article_lockedBy_OneUser | null,
  events: Array<SuggestArticlesQuery_query_searchArticles_Article_events_ArticleEvent>,
  histories: Array<SuggestArticlesQuery_query_searchArticles_Article_histories_ArticleHistory>,
  authors: Array<SuggestArticlesQuery_query_searchArticles_Article_authors_ArticleAuthor>
};

export type SuggestArticlesQuery_query = {
  __typename?: 'query',
  searchArticles: Array<SuggestArticlesQuery_query_searchArticles_Article>
};


export type SuggestArticlesQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  like: ArticleLikeInput;
  where?: InputMaybe<ArticleFilterSearchInput>;
}>;


export type SuggestArticlesQuery = SuggestArticlesQuery_query;

export type GetSuggestedCategoryQuery_query_suggestCategories_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  slug: string,
  format: CategoryFormat,
  level: number
};

export type GetSuggestedCategoryQuery_query_suggestCategories_Category = {
  __typename?: 'Category',
  childCount: number,
  children: Array<GetSuggestedCategoryQuery_query_suggestCategories_Category_children_Category>
};

export type GetSuggestedCategoryQuery_query = {
  __typename?: 'query',
  suggestCategories: Array<GetSuggestedCategoryQuery_query_suggestCategories_Category>
};


export type GetSuggestedCategoryQueryVariables = Exact<{
  article: ArticleLikeInput;
  first: Scalars['UnsignedInt']['input'];
}>;


export type GetSuggestedCategoryQuery = GetSuggestedCategoryQuery_query;

export type SuggestInternalLinksQuery_query_suggestInternalLinks_suggestInternalLinksResult = {
  __typename?: 'suggestInternalLinksResult',
  url: string,
  relevance: string,
  title: string,
  word: string,
  sentence: string,
  blockKey: string
};

export type SuggestInternalLinksQuery_query = {
  __typename?: 'query',
  suggestInternalLinks: Array<SuggestInternalLinksQuery_query_suggestInternalLinks_suggestInternalLinksResult>
};


export type SuggestInternalLinksQueryVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  brandKey: BrandKey;
  existingLinksLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  idArticle?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestInternalLinksQuery = SuggestInternalLinksQuery_query;

export type GetBodyWithSuggestedLinksQuery_query_getBodyWithSuggestedLinks_GetBodyWithSuggestedLinksResult = {
  __typename?: 'GetBodyWithSuggestedLinksResult',
  updatedBody: string
};

export type GetBodyWithSuggestedLinksQuery_query = {
  __typename?: 'query',
  getBodyWithSuggestedLinks: GetBodyWithSuggestedLinksQuery_query_getBodyWithSuggestedLinks_GetBodyWithSuggestedLinksResult
};


export type GetBodyWithSuggestedLinksQueryVariables = Exact<{
  body: Scalars['String']['input'];
  links: Array<InputMaybe<LinkInput>> | InputMaybe<LinkInput>;
}>;


export type GetBodyWithSuggestedLinksQuery = GetBodyWithSuggestedLinksQuery_query;

export type TranslateArticleQuery_query_translateArticle_Article = {
  __typename?: 'Article',
  title: string,
  body?: any | null,
  lead?: any | null
};

export type TranslateArticleQuery_query = {
  __typename?: 'query',
  translateArticle: TranslateArticleQuery_query_translateArticle_Article
};


export type TranslateArticleQueryVariables = Exact<{
  where: ArticleUniqueFilterInput;
  lang: Scalars['NonEmptyTrimmedString']['input'];
}>;


export type TranslateArticleQuery = TranslateArticleQuery_query;

export type GetCategoriesQuery_query_categories_Category_parent_Category = {
  __typename?: 'Category',
  id: string
};

export type GetCategoriesQuery_query_categories_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  parent?: GetCategoriesQuery_query_categories_Category_parent_Category | null
};

export type GetCategoriesQuery_query = {
  __typename?: 'query',
  categories: Array<GetCategoriesQuery_query_categories_Category>
};


export type GetCategoriesQueryVariables = Exact<{
  where: CategoryFilterInput;
}>;


export type GetCategoriesQuery = GetCategoriesQuery_query;

export type GetCategoryQuery_query_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetCategoryQuery_query = {
  __typename?: 'query',
  category: GetCategoryQuery_query_category_Category
};


export type GetCategoryQueryVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type GetCategoryQuery = GetCategoryQuery_query;

export type GetBrandKeysQuery_query_categories_Category = {
  __typename?: 'Category',
  brandKey: BrandKey,
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null
};

export type GetBrandKeysQuery_query = {
  __typename?: 'query',
  categories: Array<GetBrandKeysQuery_query_categories_Category>
};


export type GetBrandKeysQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  level: Scalars['UnsignedInt']['input'];
}>;


export type GetBrandKeysQuery = GetBrandKeysQuery_query;

export type GetImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory_sources_ImageSource = {
  __typename?: 'ImageSource',
  id: string,
  title: string
};

export type GetImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory = {
  __typename?: 'ImageSourceCategory',
  id: string,
  title: string,
  sources: Array<GetImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory_sources_ImageSource>
};

export type GetImageSourceCategoriesQuery_query = {
  __typename?: 'query',
  imageSourceCategories: Array<GetImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory>
};


export type GetImageSourceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImageSourceCategoriesQuery = GetImageSourceCategoriesQuery_query;

export type SearchImageSourcesQuery_query_imageSources_ImageSource_category_ImageSourceCategory = {
  __typename?: 'ImageSourceCategory',
  id: string,
  title: string
};

export type SearchImageSourcesQuery_query_imageSources_ImageSource = {
  __typename: 'ImageSource',
  id: string,
  title: string,
  category: SearchImageSourcesQuery_query_imageSources_ImageSource_category_ImageSourceCategory
};

export type SearchImageSourcesQuery_query = {
  __typename?: 'query',
  imageSources: Array<SearchImageSourcesQuery_query_imageSources_ImageSource>
};


export type SearchImageSourcesQueryVariables = Exact<{
  where?: InputMaybe<ImageSourceFilterInput>;
}>;


export type SearchImageSourcesQuery = SearchImageSourcesQuery_query;

export type SearchImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory_sources_ImageSource = {
  __typename?: 'ImageSource',
  id: string,
  title: string
};

export type SearchImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory = {
  __typename?: 'ImageSourceCategory',
  id: string,
  title: string,
  sources: Array<SearchImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory_sources_ImageSource>
};

export type SearchImageSourceCategoriesQuery_query = {
  __typename?: 'query',
  imageSourceCategories: Array<SearchImageSourceCategoriesQuery_query_imageSourceCategories_ImageSourceCategory>
};


export type SearchImageSourceCategoriesQueryVariables = Exact<{
  where?: InputMaybe<ImageSourceCategoryFilterInput>;
}>;


export type SearchImageSourceCategoriesQuery = SearchImageSourceCategoriesQuery_query;

export type GetSearchCategoryMediasQuery_query_category_Category = {
  __typename?: 'Category',
  medias?: any | null
};

export type GetSearchCategoryMediasQuery_query = {
  __typename?: 'query',
  category: GetSearchCategoryMediasQuery_query_category_Category
};


export type GetSearchCategoryMediasQueryVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type GetSearchCategoryMediasQuery = GetSearchCategoryMediasQuery_query;

export type GetQualifierQuery_query_qualifier_Qualifier = {
  __typename?: 'Qualifier',
  id: string,
  title: string,
  status: QualifierStatus,
  brandKey: BrandKey,
  format: ArticleFormat
};

export type GetQualifierQuery_query = {
  __typename?: 'query',
  qualifier: GetQualifierQuery_query_qualifier_Qualifier
};


export type GetQualifierQueryVariables = Exact<{
  where: QualifierUniqueFilterInput;
}>;


export type GetQualifierQuery = GetQualifierQuery_query;

export type UpdateQualifierMutation_mutation_updateQualifier_Qualifier = {
  __typename?: 'Qualifier',
  id: string
};

export type UpdateQualifierMutation_mutation = {
  __typename?: 'mutation',
  updateQualifier: UpdateQualifierMutation_mutation_updateQualifier_Qualifier
};


export type UpdateQualifierMutationVariables = Exact<{
  where: QualifierUniqueFilterInput;
  data: QualifierUpdateInput;
}>;


export type UpdateQualifierMutation = UpdateQualifierMutation_mutation;

export type CreateQualifierMutation_mutation_createQualifier_Qualifier = {
  __typename?: 'Qualifier',
  id: string
};

export type CreateQualifierMutation_mutation = {
  __typename?: 'mutation',
  createQualifier: CreateQualifierMutation_mutation_createQualifier_Qualifier
};


export type CreateQualifierMutationVariables = Exact<{
  data: QualifierCreationInput;
}>;


export type CreateQualifierMutation = CreateQualifierMutation_mutation;

export type GetSegmentQuery_query_segment_Segment = {
  __typename?: 'Segment',
  active?: boolean | null,
  id: string,
  title: string,
  ios?: any | null,
  android?: any | null,
  brandKey: BrandKey,
  status: SegmentStatus,
  editorialAlert?: any | null
};

export type GetSegmentQuery_query = {
  __typename?: 'query',
  segment: GetSegmentQuery_query_segment_Segment
};


export type GetSegmentQueryVariables = Exact<{
  where: SegmentUniqueFilterInput;
}>;


export type GetSegmentQuery = GetSegmentQuery_query;

export type UpdateSegmentMutation_mutation_updateSegment_Segment = {
  __typename?: 'Segment',
  id: string
};

export type UpdateSegmentMutation_mutation = {
  __typename?: 'mutation',
  updateSegment: UpdateSegmentMutation_mutation_updateSegment_Segment
};


export type UpdateSegmentMutationVariables = Exact<{
  where: SegmentUniqueFilterInput;
  data: SegmentUpdateInput;
}>;


export type UpdateSegmentMutation = UpdateSegmentMutation_mutation;

export type CreateSegmentMutation_mutation_createSegment_Segment = {
  __typename?: 'Segment',
  id: string
};

export type CreateSegmentMutation_mutation = {
  __typename?: 'mutation',
  createSegment: CreateSegmentMutation_mutation_createSegment_Segment
};


export type CreateSegmentMutationVariables = Exact<{
  data: SegmentCreationInput;
}>;


export type CreateSegmentMutation = CreateSegmentMutation_mutation;

export type GetSegmentsQuery_query_segments_Segment = {
  __typename?: 'Segment',
  active?: boolean | null,
  id: string,
  title: string,
  brandKey: BrandKey,
  status: SegmentStatus
};

export type GetSegmentsQuery_query = {
  __typename?: 'query',
  segmentCount: number,
  segments: Array<GetSegmentsQuery_query_segments_Segment>
};


export type GetSegmentsQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<SegmentFilterInput>;
  orderBy?: InputMaybe<Array<SegmentOrderingInput> | SegmentOrderingInput>;
}>;


export type GetSegmentsQuery = GetSegmentsQuery_query;

export type GetQualifiersQuery_query_qualifiers_Qualifier = {
  __typename?: 'Qualifier',
  id: string,
  title: string,
  status: QualifierStatus,
  brandKey: BrandKey,
  format: ArticleFormat
};

export type GetQualifiersQuery_query = {
  __typename?: 'query',
  qualifiers: Array<GetQualifiersQuery_query_qualifiers_Qualifier>
};


export type GetQualifiersQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<QualifierFilterInput>;
  orderBy?: InputMaybe<Array<QualifierOrderingInput> | QualifierOrderingInput>;
}>;


export type GetQualifiersQuery = GetQualifiersQuery_query;

export type GetSourcesQuery_query_sources_Source = {
  __typename?: 'Source',
  id: string,
  title: string,
  brandKey: BrandKey,
  status: SourceStatus
};

export type GetSourcesQuery_query = {
  __typename?: 'query',
  sources: Array<GetSourcesQuery_query_sources_Source>
};


export type GetSourcesQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<SourceFilterInput>;
  orderBy?: InputMaybe<Array<SourceOrderingInput> | SourceOrderingInput>;
}>;


export type GetSourcesQuery = GetSourcesQuery_query;

export type GetSourceQuery_query_source_Source = {
  __typename?: 'Source',
  id: string,
  title: string
};

export type GetSourceQuery_query = {
  __typename?: 'query',
  source: GetSourceQuery_query_source_Source
};


export type GetSourceQueryVariables = Exact<{
  where: SourceUniqueFilterInput;
}>;


export type GetSourceQuery = GetSourceQuery_query;

export type GetSourceCountQuery_query = {
  __typename?: 'query',
  sourceCount: number
};


export type GetSourceCountQueryVariables = Exact<{
  where?: InputMaybe<SourceFilterInput>;
}>;


export type GetSourceCountQuery = GetSourceCountQuery_query;

export type CreateMachineTagForDuplicationMutation_mutation_createMachineTag_MachineTag = {
  __typename?: 'MachineTag',
  id: string
};

export type CreateMachineTagForDuplicationMutation_mutation = {
  __typename?: 'mutation',
  createMachineTag: CreateMachineTagForDuplicationMutation_mutation_createMachineTag_MachineTag
};


export type CreateMachineTagForDuplicationMutationVariables = Exact<{
  data: MachineTagCreationInput;
}>;


export type CreateMachineTagForDuplicationMutation = CreateMachineTagForDuplicationMutation_mutation;

export type UpsertTagMutation_mutation_upsertTag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  slug: string,
  type: TagType,
  relationId?: string | null
};

export type UpsertTagMutation_mutation = {
  __typename?: 'mutation',
  upsertTag: UpsertTagMutation_mutation_upsertTag_Tag
};


export type UpsertTagMutationVariables = Exact<{
  create: TagCreationInput;
  update: TagUpdateInput;
  where: TagUniqueFilterInput;
}>;


export type UpsertTagMutation = UpsertTagMutation_mutation;

export type DeleteLivePostMutation_mutation_deleteLivePost_LivePost = {
  __typename?: 'LivePost',
  id: string
};

export type DeleteLivePostMutation_mutation = {
  __typename?: 'mutation',
  deleteLivePost: DeleteLivePostMutation_mutation_deleteLivePost_LivePost
};


export type DeleteLivePostMutationVariables = Exact<{
  where: LivePostUniqueFilterInput;
}>;


export type DeleteLivePostMutation = DeleteLivePostMutation_mutation;

export type GetPushesByBrandKeyQuery_query_pushes_Push_article_Article = {
  __typename?: 'Article',
  id: string,
  title: string,
  brandKey: BrandKey,
  format: ArticleFormat
};

export type GetPushesByBrandKeyQuery_query_pushes_Push_user_OneUser = {
  __typename?: 'OneUser',
  name?: string | null,
  id: string
};

export type GetPushesByBrandKeyQuery_query_pushes_Push_segments_PushSegment_segment_Segment = {
  __typename?: 'Segment',
  title: string,
  id: string
};

export type GetPushesByBrandKeyQuery_query_pushes_Push_segments_PushSegment = {
  __typename?: 'PushSegment',
  segment: GetPushesByBrandKeyQuery_query_pushes_Push_segments_PushSegment_segment_Segment
};

export type GetPushesByBrandKeyQuery_query_pushes_Push = {
  __typename?: 'Push',
  id: string,
  title?: string | null,
  userId: string,
  sentAt?: string | null,
  targetDevice: string,
  scheduledAt: string,
  article: GetPushesByBrandKeyQuery_query_pushes_Push_article_Article,
  user?: GetPushesByBrandKeyQuery_query_pushes_Push_user_OneUser | null,
  segments: Array<GetPushesByBrandKeyQuery_query_pushes_Push_segments_PushSegment>
};

export type GetPushesByBrandKeyQuery_query = {
  __typename?: 'query',
  pushCount: number,
  pushes: Array<GetPushesByBrandKeyQuery_query_pushes_Push>
};


export type GetPushesByBrandKeyQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
  where?: InputMaybe<PushFilterInput>;
  orderBy?: InputMaybe<Array<PushOrderingInput> | PushOrderingInput>;
}>;


export type GetPushesByBrandKeyQuery = GetPushesByBrandKeyQuery_query;

export type GetPushQuery_query_pushes_Push_article_Article = {
  __typename?: 'Article',
  id: string
};

export type GetPushQuery_query_pushes_Push_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null
};

export type GetPushQuery_query_pushes_Push_segments_PushSegment_segment_Segment = {
  __typename?: 'Segment',
  title: string
};

export type GetPushQuery_query_pushes_Push_segments_PushSegment = {
  __typename?: 'PushSegment',
  segment: GetPushQuery_query_pushes_Push_segments_PushSegment_segment_Segment
};

export type GetPushQuery_query_pushes_Push = {
  __typename?: 'Push',
  id: string,
  title?: string | null,
  body: string,
  targetDevice: string,
  userId: string,
  scheduledAt: string,
  sentAt?: string | null,
  isCancelled: boolean,
  article: GetPushQuery_query_pushes_Push_article_Article,
  user?: GetPushQuery_query_pushes_Push_user_OneUser | null,
  segments: Array<GetPushQuery_query_pushes_Push_segments_PushSegment>
};

export type GetPushQuery_query = {
  __typename?: 'query',
  pushes: Array<GetPushQuery_query_pushes_Push>
};


export type GetPushQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<PushFilterInput>;
}>;


export type GetPushQuery = GetPushQuery_query;

export type GetSegmentsByBrandKeyQuery_query_segments_Segment_pushes_PushSegment_segment_Segment = {
  __typename?: 'Segment',
  title: string,
  id: string
};

export type GetSegmentsByBrandKeyQuery_query_segments_Segment_pushes_PushSegment = {
  __typename?: 'PushSegment',
  segment: GetSegmentsByBrandKeyQuery_query_segments_Segment_pushes_PushSegment_segment_Segment
};

export type GetSegmentsByBrandKeyQuery_query_segments_Segment = {
  __typename?: 'Segment',
  id: string,
  createdAt: string,
  updatedAt: string,
  title: string,
  active?: boolean | null,
  device?: string | null,
  brandKey: BrandKey,
  ios?: any | null,
  android?: any | null,
  editorialAlert?: any | null,
  status: SegmentStatus,
  pushes: Array<GetSegmentsByBrandKeyQuery_query_segments_Segment_pushes_PushSegment>
};

export type GetSegmentsByBrandKeyQuery_query = {
  __typename?: 'query',
  segments: Array<GetSegmentsByBrandKeyQuery_query_segments_Segment>
};


export type GetSegmentsByBrandKeyQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where?: InputMaybe<SegmentFilterInput>;
  orderBy?: InputMaybe<Array<SegmentOrderingInput> | SegmentOrderingInput>;
}>;


export type GetSegmentsByBrandKeyQuery = GetSegmentsByBrandKeyQuery_query;

export type UpdatePushMutation_mutation_updatePush_Push = {
  __typename?: 'Push',
  id: string,
  title?: string | null,
  body: string,
  isCancelled: boolean
};

export type UpdatePushMutation_mutation = {
  __typename?: 'mutation',
  updatePush: UpdatePushMutation_mutation_updatePush_Push
};


export type UpdatePushMutationVariables = Exact<{
  where: PushUniqueFilterInput;
  data: PushUpdateInput;
}>;


export type UpdatePushMutation = UpdatePushMutation_mutation;

export type GetOrphanPageQuery_query_orphanPage_OrphanPage = {
  __typename?: 'OrphanPage',
  id: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  status: OrphanPageStatus,
  title: string,
  content?: string | null,
  metas?: any | null,
  isCMPEnabled: boolean,
  isAdsEnabled: boolean,
  isFullScreen: boolean,
  brandKey: BrandKey,
  uri: string
};

export type GetOrphanPageQuery_query = {
  __typename?: 'query',
  orphanPage: GetOrphanPageQuery_query_orphanPage_OrphanPage
};


export type GetOrphanPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetOrphanPageQuery = GetOrphanPageQuery_query;

export type UpsertOrphanPageMutation_mutation_upsertOrphanPage_OrphanPage = {
  __typename?: 'OrphanPage',
  id: string,
  publishedAt?: string | null,
  editedAt?: string | null,
  status: OrphanPageStatus,
  title: string,
  content?: string | null,
  metas?: any | null,
  isCMPEnabled: boolean,
  isAdsEnabled: boolean,
  isFullScreen: boolean,
  brandKey: BrandKey,
  uri: string
};

export type UpsertOrphanPageMutation_mutation = {
  __typename?: 'mutation',
  upsertOrphanPage: UpsertOrphanPageMutation_mutation_upsertOrphanPage_OrphanPage
};


export type UpsertOrphanPageMutationVariables = Exact<{
  where: OrphanPageUniqueFilterInput;
  update: OrphanPageUpdateInput;
  create: OrphanPageCreationInput;
}>;


export type UpsertOrphanPageMutation = UpsertOrphanPageMutation_mutation;

export type CategoryFragment_Category_lockedBy_OneUser = {
  __typename?: 'OneUser',
  avatarUrl?: string | null,
  email: string,
  id: string,
  name?: string | null
};

export type CategoryFragment_Category_parent_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type CategoryFragment_Category_tabs_Tab = {
  __typename?: 'Tab',
  content?: any | null,
  createdAt: string,
  description?: string | null,
  id: string,
  isOnline: boolean,
  order: number,
  title: string,
  type: TabType,
  updatedAt: string,
  metas?: string | null,
  slug: string
};

export type CategoryFragment_Category_tags_CategoryTag_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string
};

export type CategoryFragment_Category_tags_CategoryTag = {
  __typename?: 'CategoryTag',
  tag: CategoryFragment_Category_tags_CategoryTag_tag_Tag
};

export type CategoryFragment_Category_urls_CategoryUrl = {
  __typename?: 'CategoryUrl',
  id: string,
  origin: string,
  path: string
};

export type CategoryFragment = {
  __typename?: 'Category',
  brandKey: BrandKey,
  body?: any | null,
  historyCount: number,
  createdAt: string,
  description?: string | null,
  format: CategoryFormat,
  isHeadlined: boolean,
  id: string,
  level: number,
  lockedAt?: string | null,
  medias?: any | null,
  publishedAt?: string | null,
  slug: string,
  status: CategoryStatus,
  subtitle?: string | null,
  title: string,
  updatedAt: string,
  editedAt?: string | null,
  lockedBy?: CategoryFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryFragment_Category_parent_Category | null,
  tabs: Array<CategoryFragment_Category_tabs_Tab>,
  tags: Array<CategoryFragment_Category_tags_CategoryTag>,
  urls: Array<CategoryFragment_Category_urls_CategoryUrl>
};

export type CategoryListFragment_Category_lockedBy_OneUser = {
  __typename?: 'OneUser',
  avatarUrl?: string | null,
  email: string,
  id: string,
  name?: string | null
};

export type CategoryListFragment_Category_parent_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type CategoryListFragment_Category_children_Category = {
  __typename?: 'Category',
  id: string
};

export type CategoryListFragment = {
  __typename?: 'Category',
  id: string,
  title: string,
  format: CategoryFormat,
  medias?: any | null,
  updatedAt: string,
  status: CategoryStatus,
  level: number,
  brandKey: BrandKey,
  lockedBy?: CategoryListFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryListFragment_Category_parent_Category | null,
  children: Array<CategoryListFragment_Category_children_Category>
};

export type UpdatePageCategoryMutation_mutation_updateCategory_Category = {
  __typename?: 'Category',
  brandKey: BrandKey,
  body?: any | null,
  historyCount: number,
  createdAt: string,
  description?: string | null,
  format: CategoryFormat,
  isHeadlined: boolean,
  id: string,
  level: number,
  lockedAt?: string | null,
  medias?: any | null,
  publishedAt?: string | null,
  slug: string,
  status: CategoryStatus,
  subtitle?: string | null,
  title: string,
  updatedAt: string,
  editedAt?: string | null,
  lockedBy?: CategoryFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryFragment_Category_parent_Category | null,
  tabs: Array<CategoryFragment_Category_tabs_Tab>,
  tags: Array<CategoryFragment_Category_tags_CategoryTag>,
  urls: Array<CategoryFragment_Category_urls_CategoryUrl>
};

export type UpdatePageCategoryMutation_mutation = {
  __typename?: 'mutation',
  updateCategory: UpdatePageCategoryMutation_mutation_updateCategory_Category
};


export type UpdatePageCategoryMutationVariables = Exact<{
  where: CategoryUniqueFilterInput;
  data: CategoryUpdateInput;
}>;


export type UpdatePageCategoryMutation = UpdatePageCategoryMutation_mutation;

export type CreatePageCategoryMutation_mutation_createCategory_Category = {
  __typename?: 'Category',
  brandKey: BrandKey,
  body?: any | null,
  historyCount: number,
  createdAt: string,
  description?: string | null,
  format: CategoryFormat,
  isHeadlined: boolean,
  id: string,
  level: number,
  lockedAt?: string | null,
  medias?: any | null,
  publishedAt?: string | null,
  slug: string,
  status: CategoryStatus,
  subtitle?: string | null,
  title: string,
  updatedAt: string,
  editedAt?: string | null,
  lockedBy?: CategoryFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryFragment_Category_parent_Category | null,
  tabs: Array<CategoryFragment_Category_tabs_Tab>,
  tags: Array<CategoryFragment_Category_tags_CategoryTag>,
  urls: Array<CategoryFragment_Category_urls_CategoryUrl>
};

export type CreatePageCategoryMutation_mutation = {
  __typename?: 'mutation',
  createCategory: CreatePageCategoryMutation_mutation_createCategory_Category
};


export type CreatePageCategoryMutationVariables = Exact<{
  data: CategoryCreationInput;
}>;


export type CreatePageCategoryMutation = CreatePageCategoryMutation_mutation;

export type LockCategoryMutation_mutation = {
  __typename?: 'mutation',
  lockCategory: boolean
};


export type LockCategoryMutationVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type LockCategoryMutation = LockCategoryMutation_mutation;

export type RetainLockCategoryMutation_mutation = {
  __typename?: 'mutation',
  retainCategoryLock: boolean
};


export type RetainLockCategoryMutationVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type RetainLockCategoryMutation = RetainLockCategoryMutation_mutation;

export type UnlockCategoryMutation_mutation = {
  __typename?: 'mutation',
  unlockCategory: boolean
};


export type UnlockCategoryMutationVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type UnlockCategoryMutation = UnlockCategoryMutation_mutation;

export type GetPageCategoriesQuery_query_categories_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  format: CategoryFormat,
  medias?: any | null,
  updatedAt: string,
  status: CategoryStatus,
  level: number,
  brandKey: BrandKey,
  lockedBy?: CategoryListFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryListFragment_Category_parent_Category | null,
  children: Array<CategoryListFragment_Category_children_Category>
};

export type GetPageCategoriesQuery_query_categories_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  format: CategoryFormat,
  medias?: any | null,
  updatedAt: string,
  status: CategoryStatus,
  level: number,
  brandKey: BrandKey,
  children: Array<GetPageCategoriesQuery_query_categories_Category_children_Category>,
  lockedBy?: CategoryListFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryListFragment_Category_parent_Category | null
};

export type GetPageCategoriesQuery_query = {
  __typename?: 'query',
  categories: Array<GetPageCategoriesQuery_query_categories_Category>
};


export type GetPageCategoriesQueryVariables = Exact<{
  first: Scalars['UnsignedInt']['input'];
  where: CategoryFilterInput;
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
}>;


export type GetPageCategoriesQuery = GetPageCategoriesQuery_query;

export type GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_category_Category = {
  __typename?: 'Category',
  brandKey: BrandKey,
  body?: any | null,
  historyCount: number,
  createdAt: string,
  description?: string | null,
  format: CategoryFormat,
  isHeadlined: boolean,
  id: string,
  level: number,
  lockedAt?: string | null,
  medias?: any | null,
  publishedAt?: string | null,
  slug: string,
  status: CategoryStatus,
  subtitle?: string | null,
  title: string,
  updatedAt: string,
  editedAt?: string | null,
  lockedBy?: CategoryFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryFragment_Category_parent_Category | null,
  tabs: Array<CategoryFragment_Category_tabs_Tab>,
  tags: Array<CategoryFragment_Category_tags_CategoryTag>,
  urls: Array<CategoryFragment_Category_urls_CategoryUrl>
};

export type GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user_OneUser = {
  __typename?: 'OneUser',
  id: string,
  name?: string | null,
  avatarUrl?: string | null
};

export type GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user_SystemUser = {
  __typename?: 'SystemUser'
};

export type GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user = GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user_OneUser | GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user_SystemUser;

export type GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory = {
  __typename?: 'CategoryHistory',
  createdAt: string,
  id: string,
  category: GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_category_Category,
  user?: GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory_user | null
};

export type GetPageCategoryHistoryQuery_query = {
  __typename?: 'query',
  categoryHistories: Array<GetPageCategoryHistoryQuery_query_categoryHistories_CategoryHistory>
};


export type GetPageCategoryHistoryQueryVariables = Exact<{
  where?: InputMaybe<CategoryHistoryFilterInput>;
  orderBy?: InputMaybe<Array<CategoryHistoryOrderingInput> | CategoryHistoryOrderingInput>;
}>;


export type GetPageCategoryHistoryQuery = GetPageCategoryHistoryQuery_query;

export type GetCategoryForEditQuery_query_category_Category = {
  __typename?: 'Category',
  articleCategoryCount: number,
  articleChannelCount: number,
  articleEventCount: number,
  articleGuideCount: number,
  brandKey: BrandKey,
  body?: any | null,
  historyCount: number,
  createdAt: string,
  description?: string | null,
  format: CategoryFormat,
  isHeadlined: boolean,
  id: string,
  level: number,
  lockedAt?: string | null,
  medias?: any | null,
  publishedAt?: string | null,
  slug: string,
  status: CategoryStatus,
  subtitle?: string | null,
  title: string,
  updatedAt: string,
  editedAt?: string | null,
  lockedBy?: CategoryFragment_Category_lockedBy_OneUser | null,
  parent?: CategoryFragment_Category_parent_Category | null,
  tabs: Array<CategoryFragment_Category_tabs_Tab>,
  tags: Array<CategoryFragment_Category_tags_CategoryTag>,
  urls: Array<CategoryFragment_Category_urls_CategoryUrl>
};

export type GetCategoryForEditQuery_query = {
  __typename?: 'query',
  category: GetCategoryForEditQuery_query_category_Category
};


export type GetCategoryForEditQueryVariables = Exact<{
  where: CategoryUniqueFilterInput;
}>;


export type GetCategoryForEditQuery = GetCategoryForEditQuery_query;

export type GetBrandsQuery_query_categories_Category = {
  __typename?: 'Category',
  brandKey: BrandKey,
  title: string
};

export type GetBrandsQuery_query = {
  __typename?: 'query',
  categories: Array<GetBrandsQuery_query_categories_Category>
};


export type GetBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsQuery = GetBrandsQuery_query;

export type BrandCategoryFragmentFragment = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null
};

export type GetBrandCategoriesQuery_query_categories_Category_children_Category_children_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null
};

export type GetBrandCategoriesQuery_query_categories_Category_children_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandCategoriesQuery_query_categories_Category_children_Category_children_Category_children_Category>
};

export type GetBrandCategoriesQuery_query_categories_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandCategoriesQuery_query_categories_Category_children_Category_children_Category>
};

export type GetBrandCategoriesQuery_query_categories_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandCategoriesQuery_query_categories_Category_children_Category>
};

export type GetBrandCategoriesQuery_query = {
  __typename?: 'query',
  categories: Array<GetBrandCategoriesQuery_query_categories_Category>
};


export type GetBrandCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  format?: InputMaybe<CategoryFormat>;
  status?: InputMaybe<CategoryStatus>;
}>;


export type GetBrandCategoriesQuery = GetBrandCategoriesQuery_query;

export type GetBrandFilterCategoriesQuery_query_categories_Category_children_Category_children_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null
};

export type GetBrandFilterCategoriesQuery_query_categories_Category_children_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandFilterCategoriesQuery_query_categories_Category_children_Category_children_Category_children_Category>
};

export type GetBrandFilterCategoriesQuery_query_categories_Category_children_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandFilterCategoriesQuery_query_categories_Category_children_Category_children_Category>
};

export type GetBrandFilterCategoriesQuery_query_categories_Category = {
  __typename?: 'Category',
  id: string,
  title: string,
  level: number,
  status: CategoryStatus,
  metas?: any | null,
  children: Array<GetBrandFilterCategoriesQuery_query_categories_Category_children_Category>
};

export type GetBrandFilterCategoriesQuery_query = {
  __typename?: 'query',
  categories: Array<GetBrandFilterCategoriesQuery_query_categories_Category>
};


export type GetBrandFilterCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  format?: InputMaybe<CategoryFormat>;
  status?: InputMaybe<CategoryStatus>;
  title_not_in?: InputMaybe<Array<Scalars['NonEmptyTrimmedString']['input']> | Scalars['NonEmptyTrimmedString']['input']>;
}>;


export type GetBrandFilterCategoriesQuery = GetBrandFilterCategoriesQuery_query;

export type GetTagForTagEditQuery_query_tag_Tag_brandedContents_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  id: string,
  createdAt: string,
  updatedAt: string,
  body?: any | null,
  media?: any | null,
  isActive: boolean
};

export type GetTagForTagEditQuery_query_tag_Tag_articleUsages_BrandedArticleUsage = {
  __typename?: 'BrandedArticleUsage',
  total: number
};

export type GetTagForTagEditQuery_query_tag_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  slug: string,
  type: TagType,
  lang: TagLang,
  brandedContents: Array<GetTagForTagEditQuery_query_tag_Tag_brandedContents_TagBrandedContent>,
  articleUsages: Array<GetTagForTagEditQuery_query_tag_Tag_articleUsages_BrandedArticleUsage>
};

export type GetTagForTagEditQuery_query = {
  __typename?: 'query',
  tag: GetTagForTagEditQuery_query_tag_Tag
};


export type GetTagForTagEditQueryVariables = Exact<{
  where: TagUniqueFilterInput;
  brandKey?: InputMaybe<BrandKey>;
}>;


export type GetTagForTagEditQuery = GetTagForTagEditQuery_query;

export type UpdateBrandedContentForTagEditMutation_mutation_updateTagBrandedContent_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  id: string,
  body?: any | null,
  media?: any | null
};

export type UpdateBrandedContentForTagEditMutation_mutation = {
  __typename?: 'mutation',
  updateTagBrandedContent: UpdateBrandedContentForTagEditMutation_mutation_updateTagBrandedContent_TagBrandedContent
};


export type UpdateBrandedContentForTagEditMutationVariables = Exact<{
  data: TagBrandedContentUpdateInput;
  where: TagBrandedContentUniqueFilterInput;
}>;


export type UpdateBrandedContentForTagEditMutation = UpdateBrandedContentForTagEditMutation_mutation;

export type GetTagsQuery_query_tags_Tag_brandedContents_TagBrandedContent = {
  __typename?: 'TagBrandedContent',
  id: string,
  brandKey: BrandKey,
  isActive: boolean,
  body?: any | null,
  media?: any | null
};

export type GetTagsQuery_query_tags_Tag_articleUsages_BrandedArticleUsage = {
  __typename?: 'BrandedArticleUsage',
  brandKey: BrandKey,
  total: number
};

export type GetTagsQuery_query_tags_Tag = {
  __typename?: 'Tag',
  id: string,
  title: string,
  slug: string,
  type: TagType,
  articleCount: number,
  brandedContents: Array<GetTagsQuery_query_tags_Tag_brandedContents_TagBrandedContent>,
  articleUsages: Array<GetTagsQuery_query_tags_Tag_articleUsages_BrandedArticleUsage>
};

export type GetTagsQuery_query = {
  __typename?: 'query',
  tags: Array<GetTagsQuery_query_tags_Tag>
};


export type GetTagsQueryVariables = Exact<{
  where?: InputMaybe<TagFilterInput>;
  orderBy?: InputMaybe<Array<TagOrderingInput> | TagOrderingInput>;
  first: Scalars['UnsignedInt']['input'];
  skip?: InputMaybe<Scalars['UnsignedInt']['input']>;
}>;


export type GetTagsQuery = GetTagsQuery_query;

export const LivePostFragmentDoc = gql`
    fragment LivePost on LivePost {
  id
  publishedAt
  title
  body
  live {
    id
    endedAt
  }
}
    `;
export const LiveFragmentDoc = gql`
    fragment Live on Live {
  id
  endedAt
  posts(first: 200, orderBy: [publishedAt_DESC]) {
    id
    publishedAt
    title
    body
  }
}
    `;
export const SearchTagFragmentDoc = gql`
    fragment SearchTag on Tag {
  id
  title
  type
  relationId
  articleCount
  brandedContents {
    isActive
    brandKey
  }
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  brandKey
  body
  historyCount
  createdAt
  description
  format
  isHeadlined
  id
  level
  lockedAt
  lockedBy {
    avatarUrl
    email
    id
    name
  }
  medias
  parent {
    id
    title
  }
  publishedAt
  slug
  status
  subtitle
  tabs(first: 50, orderBy: order_ASC) {
    content
    createdAt
    description
    id
    isOnline
    order
    title
    type
    updatedAt
    metas
    slug
  }
  tags(first: 50) {
    tag {
      id
      title
    }
  }
  title
  updatedAt
  editedAt
  urls {
    id
    origin
    path
  }
}
    `;
export const CategoryListFragmentDoc = gql`
    fragment CategoryList on Category {
  id
  title
  format
  medias
  updatedAt
  status
  level
  brandKey
  lockedBy {
    avatarUrl
    email
    id
    name
  }
  parent {
    id
    title
  }
  children(first: 1000, orderBy: title_ASC) {
    id
  }
}
    `;
export const BrandCategoryFragmentFragmentDoc = gql`
    fragment BrandCategoryFragment on Category {
  id
  title
  level
  status
  metas
}
    `;
export const CreateAffiliationCatalogProductDocument = gql`
    mutation CreateAffiliationCatalogProduct($localizedProductId: String!, $name: String!) {
  createAffiliationCatalogProduct(localizedProductId: $localizedProductId, name: $name) {
    productCatalogLocalizedId
  }
}
    `;
export type CreateAffiliationCatalogProductMutationFn = Apollo.MutationFunction<CreateAffiliationCatalogProductMutation, CreateAffiliationCatalogProductMutationVariables>;

/**
 * __useCreateAffiliationCatalogProductMutation__
 *
 * To run a mutation, you first call `useCreateAffiliationCatalogProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliationCatalogProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliationCatalogProductMutation, { data, loading, error }] = useCreateAffiliationCatalogProductMutation({
 *   variables: {
 *      localizedProductId: // value for 'localizedProductId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateAffiliationCatalogProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliationCatalogProductMutation, CreateAffiliationCatalogProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliationCatalogProductMutation, CreateAffiliationCatalogProductMutationVariables>(CreateAffiliationCatalogProductDocument, options);
      }
export type CreateAffiliationCatalogProductMutationHookResult = ReturnType<typeof useCreateAffiliationCatalogProductMutation>;
export type CreateAffiliationCatalogProductMutationResult = Apollo.MutationResult<CreateAffiliationCatalogProductMutation>;
export type CreateAffiliationCatalogProductMutationOptions = Apollo.BaseMutationOptions<CreateAffiliationCatalogProductMutation, CreateAffiliationCatalogProductMutationVariables>;
export const CreateAffiliationCardDocument = gql`
    mutation CreateAffiliationCard($localizedProductId: String!, $title: String!, $tag: String, $description: String, $mediaId: String!, $positivePoints: [String], $negativePoints: [String]) {
  createAffiliationCard(localizedProductId: $localizedProductId, title: $title, tag: $tag, description: $description, mediaId: $mediaId, positivePoints: $positivePoints, negativePoints: $negativePoints) {
    id
    name
    contents {
      id
    }
  }
}
    `;
export type CreateAffiliationCardMutationFn = Apollo.MutationFunction<CreateAffiliationCardMutation, CreateAffiliationCardMutationVariables>;

/**
 * __useCreateAffiliationCardMutation__
 *
 * To run a mutation, you first call `useCreateAffiliationCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliationCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliationCardMutation, { data, loading, error }] = useCreateAffiliationCardMutation({
 *   variables: {
 *      localizedProductId: // value for 'localizedProductId'
 *      title: // value for 'title'
 *      tag: // value for 'tag'
 *      description: // value for 'description'
 *      mediaId: // value for 'mediaId'
 *      positivePoints: // value for 'positivePoints'
 *      negativePoints: // value for 'negativePoints'
 *   },
 * });
 */
export function useCreateAffiliationCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliationCardMutation, CreateAffiliationCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliationCardMutation, CreateAffiliationCardMutationVariables>(CreateAffiliationCardDocument, options);
      }
export type CreateAffiliationCardMutationHookResult = ReturnType<typeof useCreateAffiliationCardMutation>;
export type CreateAffiliationCardMutationResult = Apollo.MutationResult<CreateAffiliationCardMutation>;
export type CreateAffiliationCardMutationOptions = Apollo.BaseMutationOptions<CreateAffiliationCardMutation, CreateAffiliationCardMutationVariables>;
export const UpsertArticleDocument = gql`
    mutation UpsertArticle($create: ArticleCreationInput!, $update: ArticleUpdateInput!, $where: ArticleUniqueFilterInput!) {
  upsertArticle(create: $create, update: $update, where: $where) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    brandKey
    format
    medias
    pushCount
    canonical
    live {
      postCount
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      ... on OneUser {
        name
      }
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    secondaryTitle
    partnerTitle
    discoverTitle
    lead
    slug
    live {
      postCount
      endedAt
    }
    tags(first: 20, orderBy: order_ASC) {
      order
      tag {
        id
        relationId
        title
        type
      }
    }
    authors(first: 10) {
      order
      author {
        id
        name
        user {
          id
          name
          avatarUrl
        }
      }
    }
    source {
      id
      title
      status
    }
    events(first: 100) {
      order
      category {
        id
        title
      }
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    guides(first: 1) {
      order
      category {
        id
        title
      }
    }
    machineTags(first: 100) {
      order
      machineTag {
        id
        tag
      }
    }
    histories(first: 100, orderBy: createdAt_DESC) {
      id
      createdAt
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
      article {
        id
      }
    }
    platformId
  }
}
    `;
export type UpsertArticleMutationFn = Apollo.MutationFunction<UpsertArticleMutation, UpsertArticleMutationVariables>;

/**
 * __useUpsertArticleMutation__
 *
 * To run a mutation, you first call `useUpsertArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertArticleMutation, { data, loading, error }] = useUpsertArticleMutation({
 *   variables: {
 *      create: // value for 'create'
 *      update: // value for 'update'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpsertArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertArticleMutation, UpsertArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertArticleMutation, UpsertArticleMutationVariables>(UpsertArticleDocument, options);
      }
export type UpsertArticleMutationHookResult = ReturnType<typeof useUpsertArticleMutation>;
export type UpsertArticleMutationResult = Apollo.MutationResult<UpsertArticleMutation>;
export type UpsertArticleMutationOptions = Apollo.BaseMutationOptions<UpsertArticleMutation, UpsertArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation UpdateArticle($where: ArticleUniqueFilterInput!, $data: ArticleUpdateInput!) {
  updateArticle(where: $where, data: $data) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    brandKey
    format
    medias
    pushCount
    canonical
    live {
      postCount
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    secondaryTitle
    partnerTitle
    discoverTitle
    lead
    slug
    live {
      postCount
      endedAt
    }
    tags(first: 20, orderBy: order_ASC) {
      order
      tag {
        id
        relationId
        title
        type
      }
    }
    authors(first: 10) {
      order
      author {
        id
        name
        user {
          id
          name
          avatarUrl
        }
      }
    }
    source {
      id
      title
      status
    }
    events(first: 100) {
      order
      category {
        id
        title
      }
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    guides(first: 1) {
      order
      category {
        id
        title
      }
    }
    machineTags(first: 100) {
      order
      machineTag {
        id
        tag
      }
    }
    histories(first: 100, orderBy: createdAt_DESC) {
      id
      createdAt
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
      article {
        id
      }
    }
    platformId
  }
}
    `;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const UpdateGoodDealPromptsDocument = gql`
    mutation UpdateGoodDealPrompts($where: ArticleGoodDealAiPromptUniqueFilterInput!, $data: ArticleGoodDealAiPromptUpdateInput!) {
  updateArticleGoodDealAiPrompt(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateGoodDealPromptsMutationFn = Apollo.MutationFunction<UpdateGoodDealPromptsMutation, UpdateGoodDealPromptsMutationVariables>;

/**
 * __useUpdateGoodDealPromptsMutation__
 *
 * To run a mutation, you first call `useUpdateGoodDealPromptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoodDealPromptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoodDealPromptsMutation, { data, loading, error }] = useUpdateGoodDealPromptsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGoodDealPromptsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoodDealPromptsMutation, UpdateGoodDealPromptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoodDealPromptsMutation, UpdateGoodDealPromptsMutationVariables>(UpdateGoodDealPromptsDocument, options);
      }
export type UpdateGoodDealPromptsMutationHookResult = ReturnType<typeof useUpdateGoodDealPromptsMutation>;
export type UpdateGoodDealPromptsMutationResult = Apollo.MutationResult<UpdateGoodDealPromptsMutation>;
export type UpdateGoodDealPromptsMutationOptions = Apollo.BaseMutationOptions<UpdateGoodDealPromptsMutation, UpdateGoodDealPromptsMutationVariables>;
export const LockArticleDocument = gql`
    mutation LockArticle($where: ArticleUniqueFilterInput!) {
  lockArticle(where: $where)
}
    `;
export type LockArticleMutationFn = Apollo.MutationFunction<LockArticleMutation, LockArticleMutationVariables>;

/**
 * __useLockArticleMutation__
 *
 * To run a mutation, you first call `useLockArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockArticleMutation, { data, loading, error }] = useLockArticleMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLockArticleMutation(baseOptions?: Apollo.MutationHookOptions<LockArticleMutation, LockArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockArticleMutation, LockArticleMutationVariables>(LockArticleDocument, options);
      }
export type LockArticleMutationHookResult = ReturnType<typeof useLockArticleMutation>;
export type LockArticleMutationResult = Apollo.MutationResult<LockArticleMutation>;
export type LockArticleMutationOptions = Apollo.BaseMutationOptions<LockArticleMutation, LockArticleMutationVariables>;
export const RetainLockArticleDocument = gql`
    mutation RetainLockArticle($where: ArticleUniqueFilterInput!) {
  retainArticleLock(where: $where)
}
    `;
export type RetainLockArticleMutationFn = Apollo.MutationFunction<RetainLockArticleMutation, RetainLockArticleMutationVariables>;

/**
 * __useRetainLockArticleMutation__
 *
 * To run a mutation, you first call `useRetainLockArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetainLockArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retainLockArticleMutation, { data, loading, error }] = useRetainLockArticleMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRetainLockArticleMutation(baseOptions?: Apollo.MutationHookOptions<RetainLockArticleMutation, RetainLockArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetainLockArticleMutation, RetainLockArticleMutationVariables>(RetainLockArticleDocument, options);
      }
export type RetainLockArticleMutationHookResult = ReturnType<typeof useRetainLockArticleMutation>;
export type RetainLockArticleMutationResult = Apollo.MutationResult<RetainLockArticleMutation>;
export type RetainLockArticleMutationOptions = Apollo.BaseMutationOptions<RetainLockArticleMutation, RetainLockArticleMutationVariables>;
export const UnlockArticleDocument = gql`
    mutation UnlockArticle($where: ArticleUniqueFilterInput!) {
  unlockArticle(where: $where)
}
    `;
export type UnlockArticleMutationFn = Apollo.MutationFunction<UnlockArticleMutation, UnlockArticleMutationVariables>;

/**
 * __useUnlockArticleMutation__
 *
 * To run a mutation, you first call `useUnlockArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockArticleMutation, { data, loading, error }] = useUnlockArticleMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnlockArticleMutation(baseOptions?: Apollo.MutationHookOptions<UnlockArticleMutation, UnlockArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockArticleMutation, UnlockArticleMutationVariables>(UnlockArticleDocument, options);
      }
export type UnlockArticleMutationHookResult = ReturnType<typeof useUnlockArticleMutation>;
export type UnlockArticleMutationResult = Apollo.MutationResult<UnlockArticleMutation>;
export type UnlockArticleMutationOptions = Apollo.BaseMutationOptions<UnlockArticleMutation, UnlockArticleMutationVariables>;
export const UpdateAuthorDocument = gql`
    mutation UpdateAuthor($where: AuthorUniqueFilterInput!, $data: AuthorUpdateInput!) {
  updateAuthor(where: $where, data: $data) {
    avatarUrl
    brandKey
    description
    facebookId
    googleId
    id
    instagramId
    isMain
    linkedinId
    media
    name
    pinterestId
    snapchatId
    twitterId
    userId
    resume
    email
    media
    hasPublicProfile
    isExternal
    histories(first: 1000) {
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
    attributes(first: 100) {
      attribute {
        id
        title
      }
    }
  }
}
    `;
export type UpdateAuthorMutationFn = Apollo.MutationFunction<UpdateAuthorMutation, UpdateAuthorMutationVariables>;

/**
 * __useUpdateAuthorMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorMutation, { data, loading, error }] = useUpdateAuthorMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthorMutation, UpdateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthorMutation, UpdateAuthorMutationVariables>(UpdateAuthorDocument, options);
      }
export type UpdateAuthorMutationHookResult = ReturnType<typeof useUpdateAuthorMutation>;
export type UpdateAuthorMutationResult = Apollo.MutationResult<UpdateAuthorMutation>;
export type UpdateAuthorMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorMutation, UpdateAuthorMutationVariables>;
export const CreateAuthorDocument = gql`
    mutation CreateAuthor($data: AuthorCreationInput!) {
  createAuthor(data: $data) {
    avatarUrl
    brandKey
    description
    facebookId
    googleId
    id
    instagramId
    isMain
    linkedinId
    media
    name
    pinterestId
    snapchatId
    twitterId
    userId
    resume
    email
    media
    hasPublicProfile
    isExternal
    histories(first: 1000) {
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
    attributes(first: 100) {
      attribute {
        id
        title
      }
    }
  }
}
    `;
export type CreateAuthorMutationFn = Apollo.MutationFunction<CreateAuthorMutation, CreateAuthorMutationVariables>;

/**
 * __useCreateAuthorMutation__
 *
 * To run a mutation, you first call `useCreateAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorMutation, { data, loading, error }] = useCreateAuthorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAuthorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthorMutation, CreateAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(CreateAuthorDocument, options);
      }
export type CreateAuthorMutationHookResult = ReturnType<typeof useCreateAuthorMutation>;
export type CreateAuthorMutationResult = Apollo.MutationResult<CreateAuthorMutation>;
export type CreateAuthorMutationOptions = Apollo.BaseMutationOptions<CreateAuthorMutation, CreateAuthorMutationVariables>;
export const UpsertCardDocument = gql`
    mutation UpsertCard($create: CardCreationInput!, $update: CardUpdateInput!, $where: CardUniqueFilterInput!) {
  upsertCard(create: $create, update: $update, where: $where) {
    id
    title
    secondaryTitle
    description
    url
    label
    brandKey
    status
    media
    body
    categories(first: 100) {
      order
      category {
        id
        level
        title
      }
    }
    tags(first: 100) {
      order
      tag {
        id
        title
        type
      }
    }
  }
}
    `;
export type UpsertCardMutationFn = Apollo.MutationFunction<UpsertCardMutation, UpsertCardMutationVariables>;

/**
 * __useUpsertCardMutation__
 *
 * To run a mutation, you first call `useUpsertCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCardMutation, { data, loading, error }] = useUpsertCardMutation({
 *   variables: {
 *      create: // value for 'create'
 *      update: // value for 'update'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpsertCardMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCardMutation, UpsertCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCardMutation, UpsertCardMutationVariables>(UpsertCardDocument, options);
      }
export type UpsertCardMutationHookResult = ReturnType<typeof useUpsertCardMutation>;
export type UpsertCardMutationResult = Apollo.MutationResult<UpsertCardMutation>;
export type UpsertCardMutationOptions = Apollo.BaseMutationOptions<UpsertCardMutation, UpsertCardMutationVariables>;
export const CompleteSlideshowIaDocument = gql`
    mutation CompleteSlideshowIA($recipeIds: [String!]!, $recipeNumber: Int!, $slideshowSubject: NonEmptyString!, $slideshowEditionId: UUIDv4!, $brandKey: BrandKey!) {
  completeAISlideshow(brandKey: $brandKey, recipeNumber: $recipeNumber, slideshowEditionId: $slideshowEditionId, slideshowSubject: $slideshowSubject, recipeIds: $recipeIds) {
    status
  }
}
    `;
export type CompleteSlideshowIaMutationFn = Apollo.MutationFunction<CompleteSlideshowIaMutation, CompleteSlideshowIaMutationVariables>;

/**
 * __useCompleteSlideshowIaMutation__
 *
 * To run a mutation, you first call `useCompleteSlideshowIaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSlideshowIaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSlideshowIaMutation, { data, loading, error }] = useCompleteSlideshowIaMutation({
 *   variables: {
 *      recipeIds: // value for 'recipeIds'
 *      recipeNumber: // value for 'recipeNumber'
 *      slideshowSubject: // value for 'slideshowSubject'
 *      slideshowEditionId: // value for 'slideshowEditionId'
 *      brandKey: // value for 'brandKey'
 *   },
 * });
 */
export function useCompleteSlideshowIaMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSlideshowIaMutation, CompleteSlideshowIaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSlideshowIaMutation, CompleteSlideshowIaMutationVariables>(CompleteSlideshowIaDocument, options);
      }
export type CompleteSlideshowIaMutationHookResult = ReturnType<typeof useCompleteSlideshowIaMutation>;
export type CompleteSlideshowIaMutationResult = Apollo.MutationResult<CompleteSlideshowIaMutation>;
export type CompleteSlideshowIaMutationOptions = Apollo.BaseMutationOptions<CompleteSlideshowIaMutation, CompleteSlideshowIaMutationVariables>;
export const CreateAttributeDocument = gql`
    mutation CreateAttribute($data: AttributeCreationInput!) {
  createAttribute(data: $data) {
    id
  }
}
    `;
export type CreateAttributeMutationFn = Apollo.MutationFunction<CreateAttributeMutation, CreateAttributeMutationVariables>;

/**
 * __useCreateAttributeMutation__
 *
 * To run a mutation, you first call `useCreateAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributeMutation, { data, loading, error }] = useCreateAttributeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAttributeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributeMutation, CreateAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributeMutation, CreateAttributeMutationVariables>(CreateAttributeDocument, options);
      }
export type CreateAttributeMutationHookResult = ReturnType<typeof useCreateAttributeMutation>;
export type CreateAttributeMutationResult = Apollo.MutationResult<CreateAttributeMutation>;
export type CreateAttributeMutationOptions = Apollo.BaseMutationOptions<CreateAttributeMutation, CreateAttributeMutationVariables>;
export const UpdateDailymotionDocument = gql`
    mutation UpdateDailymotion($brandKey: BrandKey!, $dailymotionPublicId: ID!) {
  importDailymotionVideo(brandKey: $brandKey, dailymotionPublicId: $dailymotionPublicId) {
    id
    status
    title
  }
}
    `;
export type UpdateDailymotionMutationFn = Apollo.MutationFunction<UpdateDailymotionMutation, UpdateDailymotionMutationVariables>;

/**
 * __useUpdateDailymotionMutation__
 *
 * To run a mutation, you first call `useUpdateDailymotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailymotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailymotionMutation, { data, loading, error }] = useUpdateDailymotionMutation({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      dailymotionPublicId: // value for 'dailymotionPublicId'
 *   },
 * });
 */
export function useUpdateDailymotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailymotionMutation, UpdateDailymotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailymotionMutation, UpdateDailymotionMutationVariables>(UpdateDailymotionDocument, options);
      }
export type UpdateDailymotionMutationHookResult = ReturnType<typeof useUpdateDailymotionMutation>;
export type UpdateDailymotionMutationResult = Apollo.MutationResult<UpdateDailymotionMutation>;
export type UpdateDailymotionMutationOptions = Apollo.BaseMutationOptions<UpdateDailymotionMutation, UpdateDailymotionMutationVariables>;
export const GenerateGoodDealArticleDocument = gql`
    mutation GenerateGoodDealArticle($productUrl: URL!) {
  generateAIGoodDealArticle(productUrl: $productUrl) {
    status
  }
}
    `;
export type GenerateGoodDealArticleMutationFn = Apollo.MutationFunction<GenerateGoodDealArticleMutation, GenerateGoodDealArticleMutationVariables>;

/**
 * __useGenerateGoodDealArticleMutation__
 *
 * To run a mutation, you first call `useGenerateGoodDealArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGoodDealArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGoodDealArticleMutation, { data, loading, error }] = useGenerateGoodDealArticleMutation({
 *   variables: {
 *      productUrl: // value for 'productUrl'
 *   },
 * });
 */
export function useGenerateGoodDealArticleMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGoodDealArticleMutation, GenerateGoodDealArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGoodDealArticleMutation, GenerateGoodDealArticleMutationVariables>(GenerateGoodDealArticleDocument, options);
      }
export type GenerateGoodDealArticleMutationHookResult = ReturnType<typeof useGenerateGoodDealArticleMutation>;
export type GenerateGoodDealArticleMutationResult = Apollo.MutationResult<GenerateGoodDealArticleMutation>;
export type GenerateGoodDealArticleMutationOptions = Apollo.BaseMutationOptions<GenerateGoodDealArticleMutation, GenerateGoodDealArticleMutationVariables>;
export const GenerateSlideshowIaDocument = gql`
    mutation GenerateSlideshowIA($recipeNumber: Int!, $slideshowSubject: NonEmptyString!, $brandKey: BrandKey!, $recipeIds: [String!]!) {
  generateAISlideshow(brandKey: $brandKey, recipeNumber: $recipeNumber, slideshowSubject: $slideshowSubject, recipeIds: $recipeIds) {
    status
  }
}
    `;
export type GenerateSlideshowIaMutationFn = Apollo.MutationFunction<GenerateSlideshowIaMutation, GenerateSlideshowIaMutationVariables>;

/**
 * __useGenerateSlideshowIaMutation__
 *
 * To run a mutation, you first call `useGenerateSlideshowIaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSlideshowIaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSlideshowIaMutation, { data, loading, error }] = useGenerateSlideshowIaMutation({
 *   variables: {
 *      recipeNumber: // value for 'recipeNumber'
 *      slideshowSubject: // value for 'slideshowSubject'
 *      brandKey: // value for 'brandKey'
 *      recipeIds: // value for 'recipeIds'
 *   },
 * });
 */
export function useGenerateSlideshowIaMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSlideshowIaMutation, GenerateSlideshowIaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSlideshowIaMutation, GenerateSlideshowIaMutationVariables>(GenerateSlideshowIaDocument, options);
      }
export type GenerateSlideshowIaMutationHookResult = ReturnType<typeof useGenerateSlideshowIaMutation>;
export type GenerateSlideshowIaMutationResult = Apollo.MutationResult<GenerateSlideshowIaMutation>;
export type GenerateSlideshowIaMutationOptions = Apollo.BaseMutationOptions<GenerateSlideshowIaMutation, GenerateSlideshowIaMutationVariables>;
export const UpsertLiveDocument = gql`
    mutation UpsertLive($where: LiveUniqueFilterInput!, $create: LiveCreationInput!, $update: LiveUpdateInput!) {
  upsertLive(where: $where, create: $create, update: $update) {
    article {
      id
    }
    id
    endedAt
    posts(first: 200, orderBy: [publishedAt_DESC]) {
      id
      publishedAt
      title
      body
    }
  }
}
    `;
export type UpsertLiveMutationFn = Apollo.MutationFunction<UpsertLiveMutation, UpsertLiveMutationVariables>;

/**
 * __useUpsertLiveMutation__
 *
 * To run a mutation, you first call `useUpsertLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLiveMutation, { data, loading, error }] = useUpsertLiveMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertLiveMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLiveMutation, UpsertLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLiveMutation, UpsertLiveMutationVariables>(UpsertLiveDocument, options);
      }
export type UpsertLiveMutationHookResult = ReturnType<typeof useUpsertLiveMutation>;
export type UpsertLiveMutationResult = Apollo.MutationResult<UpsertLiveMutation>;
export type UpsertLiveMutationOptions = Apollo.BaseMutationOptions<UpsertLiveMutation, UpsertLiveMutationVariables>;
export const UpdateLiveDatesDocument = gql`
    mutation UpdateLiveDates($where: LiveUniqueFilterInput!, $endDate: DateTime) {
  updateLive(where: $where, data: {endedAt: $endDate}) {
    id
    endedAt
    posts(first: 200, orderBy: [publishedAt_DESC]) {
      id
      publishedAt
      title
      body
    }
  }
}
    `;
export type UpdateLiveDatesMutationFn = Apollo.MutationFunction<UpdateLiveDatesMutation, UpdateLiveDatesMutationVariables>;

/**
 * __useUpdateLiveDatesMutation__
 *
 * To run a mutation, you first call `useUpdateLiveDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiveDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiveDatesMutation, { data, loading, error }] = useUpdateLiveDatesMutation({
 *   variables: {
 *      where: // value for 'where'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUpdateLiveDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLiveDatesMutation, UpdateLiveDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLiveDatesMutation, UpdateLiveDatesMutationVariables>(UpdateLiveDatesDocument, options);
      }
export type UpdateLiveDatesMutationHookResult = ReturnType<typeof useUpdateLiveDatesMutation>;
export type UpdateLiveDatesMutationResult = Apollo.MutationResult<UpdateLiveDatesMutation>;
export type UpdateLiveDatesMutationOptions = Apollo.BaseMutationOptions<UpdateLiveDatesMutation, UpdateLiveDatesMutationVariables>;
export const UpsertLivePostDocument = gql`
    mutation UpsertLivePost($create: LivePostCreationInput!, $where: LivePostUniqueFilterInput!, $update: LivePostUpdateInput!) {
  upsertLivePost(create: $create, where: $where, update: $update) {
    id
    publishedAt
    title
    body
    live {
      id
      endedAt
    }
  }
}
    `;
export type UpsertLivePostMutationFn = Apollo.MutationFunction<UpsertLivePostMutation, UpsertLivePostMutationVariables>;

/**
 * __useUpsertLivePostMutation__
 *
 * To run a mutation, you first call `useUpsertLivePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLivePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLivePostMutation, { data, loading, error }] = useUpsertLivePostMutation({
 *   variables: {
 *      create: // value for 'create'
 *      where: // value for 'where'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertLivePostMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLivePostMutation, UpsertLivePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLivePostMutation, UpsertLivePostMutationVariables>(UpsertLivePostDocument, options);
      }
export type UpsertLivePostMutationHookResult = ReturnType<typeof useUpsertLivePostMutation>;
export type UpsertLivePostMutationResult = Apollo.MutationResult<UpsertLivePostMutation>;
export type UpsertLivePostMutationOptions = Apollo.BaseMutationOptions<UpsertLivePostMutation, UpsertLivePostMutationVariables>;
export const UpdatePromptDocument = gql`
    mutation UpdatePrompt($where: PromptUniqueFilterInput!, $data: PromptUpdateInput!) {
  updatePrompt(where: $where, data: $data) {
    body
  }
}
    `;
export type UpdatePromptMutationFn = Apollo.MutationFunction<UpdatePromptMutation, UpdatePromptMutationVariables>;

/**
 * __useUpdatePromptMutation__
 *
 * To run a mutation, you first call `useUpdatePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePromptMutation, { data, loading, error }] = useUpdatePromptMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePromptMutation, UpdatePromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePromptMutation, UpdatePromptMutationVariables>(UpdatePromptDocument, options);
      }
export type UpdatePromptMutationHookResult = ReturnType<typeof useUpdatePromptMutation>;
export type UpdatePromptMutationResult = Apollo.MutationResult<UpdatePromptMutation>;
export type UpdatePromptMutationOptions = Apollo.BaseMutationOptions<UpdatePromptMutation, UpdatePromptMutationVariables>;
export const CreatePushDocument = gql`
    mutation CreatePush($data: PushCreationInput!) {
  createPush(data: $data) {
    id
    title
    body
    targetDevice
    article {
      id
    }
    userId
    user {
      id
      name
    }
    scheduledAt
    isCancelled
    sentAt
    segments(first: 100) {
      segment {
        title
      }
    }
  }
}
    `;
export type CreatePushMutationFn = Apollo.MutationFunction<CreatePushMutation, CreatePushMutationVariables>;

/**
 * __useCreatePushMutation__
 *
 * To run a mutation, you first call `useCreatePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPushMutation, { data, loading, error }] = useCreatePushMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePushMutation(baseOptions?: Apollo.MutationHookOptions<CreatePushMutation, CreatePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePushMutation, CreatePushMutationVariables>(CreatePushDocument, options);
      }
export type CreatePushMutationHookResult = ReturnType<typeof useCreatePushMutation>;
export type CreatePushMutationResult = Apollo.MutationResult<CreatePushMutation>;
export type CreatePushMutationOptions = Apollo.BaseMutationOptions<CreatePushMutation, CreatePushMutationVariables>;
export const RecipeDescriptionsDocument = gql`
    mutation recipeDescriptions($brandKey: BrandKey!, $slideshowEditionId: String!, $recipesUrls: [String]!) {
  updateSlidehowRecipesDescriptions(brandKey: $brandKey, slideshowEditionId: $slideshowEditionId, recipesUrls: $recipesUrls) {
    status
  }
}
    `;
export type RecipeDescriptionsMutationFn = Apollo.MutationFunction<RecipeDescriptionsMutation, RecipeDescriptionsMutationVariables>;

/**
 * __useRecipeDescriptionsMutation__
 *
 * To run a mutation, you first call `useRecipeDescriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecipeDescriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recipeDescriptionsMutation, { data, loading, error }] = useRecipeDescriptionsMutation({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      slideshowEditionId: // value for 'slideshowEditionId'
 *      recipesUrls: // value for 'recipesUrls'
 *   },
 * });
 */
export function useRecipeDescriptionsMutation(baseOptions?: Apollo.MutationHookOptions<RecipeDescriptionsMutation, RecipeDescriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecipeDescriptionsMutation, RecipeDescriptionsMutationVariables>(RecipeDescriptionsDocument, options);
      }
export type RecipeDescriptionsMutationHookResult = ReturnType<typeof useRecipeDescriptionsMutation>;
export type RecipeDescriptionsMutationResult = Apollo.MutationResult<RecipeDescriptionsMutation>;
export type RecipeDescriptionsMutationOptions = Apollo.BaseMutationOptions<RecipeDescriptionsMutation, RecipeDescriptionsMutationVariables>;
export const GetSearchAffiliationProductDocument = gql`
    query GetSearchAffiliationProduct($keyword: String!, $minPrice: Float, $maxPrice: Float, $sort: AffilizzProductSearchSort, $page: UnsignedInt, $size: UnsignedInt) {
  searchAffiliationProduct(keyword: $keyword, minPrice: $minPrice, maxPrice: $maxPrice, sort: $sort, page: $page, size: $size) {
    totalElements
    totalPages
    pageable {
      pageNumber
    }
    content {
      type
      id
      productLocalizedId
      currencyCode
      defaultImage
      minPrice
      maxPrice
      nbOffers
      name
      upsides
      downsides
    }
  }
}
    `;

/**
 * __useGetSearchAffiliationProductQuery__
 *
 * To run a query within a React component, call `useGetSearchAffiliationProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchAffiliationProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchAffiliationProductQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      minPrice: // value for 'minPrice'
 *      maxPrice: // value for 'maxPrice'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetSearchAffiliationProductQuery(baseOptions: Apollo.QueryHookOptions<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables> & ({ variables: GetSearchAffiliationProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>(GetSearchAffiliationProductDocument, options);
      }
export function useGetSearchAffiliationProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>(GetSearchAffiliationProductDocument, options);
        }
export function useGetSearchAffiliationProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>(GetSearchAffiliationProductDocument, options);
        }
export type GetSearchAffiliationProductQueryHookResult = ReturnType<typeof useGetSearchAffiliationProductQuery>;
export type GetSearchAffiliationProductLazyQueryHookResult = ReturnType<typeof useGetSearchAffiliationProductLazyQuery>;
export type GetSearchAffiliationProductSuspenseQueryHookResult = ReturnType<typeof useGetSearchAffiliationProductSuspenseQuery>;
export type GetSearchAffiliationProductQueryResult = Apollo.QueryResult<GetSearchAffiliationProductQuery, GetSearchAffiliationProductQueryVariables>;
export const GetAffilizzDesignsDocument = gql`
    query GetAffilizzDesigns($mediaId: String!) {
  searchAffiliationDesign(mediaId: $mediaId) {
    id
    name
    defaultDesign
    renderingType
  }
}
    `;

/**
 * __useGetAffilizzDesignsQuery__
 *
 * To run a query within a React component, call `useGetAffilizzDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffilizzDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffilizzDesignsQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useGetAffilizzDesignsQuery(baseOptions: Apollo.QueryHookOptions<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables> & ({ variables: GetAffilizzDesignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>(GetAffilizzDesignsDocument, options);
      }
export function useGetAffilizzDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>(GetAffilizzDesignsDocument, options);
        }
export function useGetAffilizzDesignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>(GetAffilizzDesignsDocument, options);
        }
export type GetAffilizzDesignsQueryHookResult = ReturnType<typeof useGetAffilizzDesignsQuery>;
export type GetAffilizzDesignsLazyQueryHookResult = ReturnType<typeof useGetAffilizzDesignsLazyQuery>;
export type GetAffilizzDesignsSuspenseQueryHookResult = ReturnType<typeof useGetAffilizzDesignsSuspenseQuery>;
export type GetAffilizzDesignsQueryResult = Apollo.QueryResult<GetAffilizzDesignsQuery, GetAffilizzDesignsQueryVariables>;
export const GetGoodDealPromptsDocument = gql`
    query GetGoodDealPrompts {
  articleGoodDealAiPrompts(first: 10) {
    promptOrder
    prompt
  }
}
    `;

/**
 * __useGetGoodDealPromptsQuery__
 *
 * To run a query within a React component, call `useGetGoodDealPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoodDealPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoodDealPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoodDealPromptsQuery(baseOptions?: Apollo.QueryHookOptions<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>(GetGoodDealPromptsDocument, options);
      }
export function useGetGoodDealPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>(GetGoodDealPromptsDocument, options);
        }
export function useGetGoodDealPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>(GetGoodDealPromptsDocument, options);
        }
export type GetGoodDealPromptsQueryHookResult = ReturnType<typeof useGetGoodDealPromptsQuery>;
export type GetGoodDealPromptsLazyQueryHookResult = ReturnType<typeof useGetGoodDealPromptsLazyQuery>;
export type GetGoodDealPromptsSuspenseQueryHookResult = ReturnType<typeof useGetGoodDealPromptsSuspenseQuery>;
export type GetGoodDealPromptsQueryResult = Apollo.QueryResult<GetGoodDealPromptsQuery, GetGoodDealPromptsQueryVariables>;
export const GetArticleHistoryCountDocument = gql`
    query GetArticleHistoryCount($where: ArticleHistoryFilterInput) {
  articleHistoryCount(where: $where)
}
    `;

/**
 * __useGetArticleHistoryCountQuery__
 *
 * To run a query within a React component, call `useGetArticleHistoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleHistoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleHistoryCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetArticleHistoryCountQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>(GetArticleHistoryCountDocument, options);
      }
export function useGetArticleHistoryCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>(GetArticleHistoryCountDocument, options);
        }
export function useGetArticleHistoryCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>(GetArticleHistoryCountDocument, options);
        }
export type GetArticleHistoryCountQueryHookResult = ReturnType<typeof useGetArticleHistoryCountQuery>;
export type GetArticleHistoryCountLazyQueryHookResult = ReturnType<typeof useGetArticleHistoryCountLazyQuery>;
export type GetArticleHistoryCountSuspenseQueryHookResult = ReturnType<typeof useGetArticleHistoryCountSuspenseQuery>;
export type GetArticleHistoryCountQueryResult = Apollo.QueryResult<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>;
export const GetArticlesDocument = gql`
    query GetArticles($first: UnsignedInt!, $where: ArticleFilterInput, $skip: UnsignedInt, $orderBy: [ArticleOrderingInput!]) {
  articles(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    updatedAt
    brandKey
    format
    medias
    pushCount
    canonical
    live {
      postCount
    }
    categories(first: $first, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    events(first: 10) {
      category {
        id
        title
      }
      order
    }
    histories(first: 100, orderBy: createdAt_ASC) {
      createdAt
      user {
        ... on OneUser {
          name
        }
      }
    }
    qualifiers(first: 100) {
      qualifier {
        id
        title
      }
    }
    authors(first: 1) {
      author {
        id
        name
        avatarUrl
      }
    }
    newsletterFlashSenderHistories {
      createdAt
    }
  }
}
    `;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables> & ({ variables: GetArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesSuspenseQueryHookResult = ReturnType<typeof useGetArticlesSuspenseQuery>;
export type GetArticlesQueryResult = Apollo.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetArticleCountDocument = gql`
    query GetArticleCount($where: ArticleFilterInput) {
  articleCount(where: $where)
}
    `;

/**
 * __useGetArticleCountQuery__
 *
 * To run a query within a React component, call `useGetArticleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetArticleCountQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleCountQuery, GetArticleCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleCountQuery, GetArticleCountQueryVariables>(GetArticleCountDocument, options);
      }
export function useGetArticleCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleCountQuery, GetArticleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleCountQuery, GetArticleCountQueryVariables>(GetArticleCountDocument, options);
        }
export function useGetArticleCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleCountQuery, GetArticleCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleCountQuery, GetArticleCountQueryVariables>(GetArticleCountDocument, options);
        }
export type GetArticleCountQueryHookResult = ReturnType<typeof useGetArticleCountQuery>;
export type GetArticleCountLazyQueryHookResult = ReturnType<typeof useGetArticleCountLazyQuery>;
export type GetArticleCountSuspenseQueryHookResult = ReturnType<typeof useGetArticleCountSuspenseQuery>;
export type GetArticleCountQueryResult = Apollo.QueryResult<GetArticleCountQuery, GetArticleCountQueryVariables>;
export const GetArticleDocument = gql`
    query GetArticle($where: ArticleUniqueFilterInput!) {
  article(where: $where) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    updatedAt
    brandKey
    format
    medias
    pushCount
    canonical
    live {
      postCount
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    secondaryTitle
    partnerTitle
    discoverTitle
    lead
    slug
    live {
      postCount
      endedAt
    }
    tags(first: 20, orderBy: order_ASC) {
      order
      tag {
        id
        relationId
        title
        type
      }
    }
    authors(first: 10) {
      order
      author {
        id
        name
        user {
          id
          name
          avatarUrl
        }
      }
    }
    source {
      id
      title
      status
    }
    events(first: 100) {
      order
      category {
        id
        title
      }
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    guides(first: 100) {
      order
      category {
        id
        title
      }
    }
    machineTags(first: 100) {
      order
      machineTag {
        id
        tag
      }
    }
    histories(first: 100, orderBy: createdAt_DESC) {
      id
      createdAt
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
      article {
        id
      }
    }
    platformId
  }
}
    `;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a React component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetArticleQuery(baseOptions: Apollo.QueryHookOptions<GetArticleQuery, GetArticleQueryVariables> & ({ variables: GetArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
      }
export function useGetArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export function useGetArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
        }
export type GetArticleQueryHookResult = ReturnType<typeof useGetArticleQuery>;
export type GetArticleLazyQueryHookResult = ReturnType<typeof useGetArticleLazyQuery>;
export type GetArticleSuspenseQueryHookResult = ReturnType<typeof useGetArticleSuspenseQuery>;
export type GetArticleQueryResult = Apollo.QueryResult<GetArticleQuery, GetArticleQueryVariables>;
export const GetArticleUrlStatusDocument = gql`
    query GetArticleUrlStatus($where: ArticleUniqueFilterInput!) {
  article(where: $where) {
    urls(first: 1) {
      status {
        ok
      }
    }
  }
}
    `;

/**
 * __useGetArticleUrlStatusQuery__
 *
 * To run a query within a React component, call `useGetArticleUrlStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleUrlStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleUrlStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetArticleUrlStatusQuery(baseOptions: Apollo.QueryHookOptions<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables> & ({ variables: GetArticleUrlStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>(GetArticleUrlStatusDocument, options);
      }
export function useGetArticleUrlStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>(GetArticleUrlStatusDocument, options);
        }
export function useGetArticleUrlStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>(GetArticleUrlStatusDocument, options);
        }
export type GetArticleUrlStatusQueryHookResult = ReturnType<typeof useGetArticleUrlStatusQuery>;
export type GetArticleUrlStatusLazyQueryHookResult = ReturnType<typeof useGetArticleUrlStatusLazyQuery>;
export type GetArticleUrlStatusSuspenseQueryHookResult = ReturnType<typeof useGetArticleUrlStatusSuspenseQuery>;
export type GetArticleUrlStatusQueryResult = Apollo.QueryResult<GetArticleUrlStatusQuery, GetArticleUrlStatusQueryVariables>;
export const GetAuthorsDocument = gql`
    query GetAuthors($first: UnsignedInt!, $where: AuthorFilterInput, $skip: UnsignedInt, $orderBy: [AuthorOrderingInput!]) {
  authors(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
    avatarUrl
    brandKey
    description
    facebookId
    googleId
    id
    instagramId
    isMain
    linkedinId
    media
    name
    pinterestId
    snapchatId
    twitterId
    userId
    resume
    email
    media
    hasPublicProfile
    isExternal
    histories(first: 1000) {
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
    attributes(first: 100) {
      attribute {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetAuthorsQuery__
 *
 * To run a query within a React component, call `useGetAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAuthorsQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables> & ({ variables: GetAuthorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
      }
export function useGetAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
        }
export function useGetAuthorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorsQuery, GetAuthorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorsQuery, GetAuthorsQueryVariables>(GetAuthorsDocument, options);
        }
export type GetAuthorsQueryHookResult = ReturnType<typeof useGetAuthorsQuery>;
export type GetAuthorsLazyQueryHookResult = ReturnType<typeof useGetAuthorsLazyQuery>;
export type GetAuthorsSuspenseQueryHookResult = ReturnType<typeof useGetAuthorsSuspenseQuery>;
export type GetAuthorsQueryResult = Apollo.QueryResult<GetAuthorsQuery, GetAuthorsQueryVariables>;
export const GetAuthorDocument = gql`
    query GetAuthor($where: AuthorUniqueFilterInput!) {
  author(where: $where) {
    avatarUrl
    brandKey
    description
    facebookId
    googleId
    id
    instagramId
    isMain
    linkedinId
    media
    name
    pinterestId
    snapchatId
    twitterId
    userId
    resume
    email
    media
    hasPublicProfile
    isExternal
    histories(first: 1000) {
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
    attributes(first: 100) {
      attribute {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetAuthorQuery__
 *
 * To run a query within a React component, call `useGetAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAuthorQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables> & ({ variables: GetAuthorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
      }
export function useGetAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export function useGetAuthorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorQuery, GetAuthorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorQuery, GetAuthorQueryVariables>(GetAuthorDocument, options);
        }
export type GetAuthorQueryHookResult = ReturnType<typeof useGetAuthorQuery>;
export type GetAuthorLazyQueryHookResult = ReturnType<typeof useGetAuthorLazyQuery>;
export type GetAuthorSuspenseQueryHookResult = ReturnType<typeof useGetAuthorSuspenseQuery>;
export type GetAuthorQueryResult = Apollo.QueryResult<GetAuthorQuery, GetAuthorQueryVariables>;
export const GetCardDocument = gql`
    query GetCard($where: CardUniqueFilterInput!) {
  card(where: $where) {
    id
    title
    secondaryTitle
    description
    url
    label
    brandKey
    status
    media
    body
    categories(first: 100) {
      order
      category {
        id
        level
        title
      }
    }
    tags(first: 100) {
      order
      tag {
        id
        title
        type
      }
    }
  }
}
    `;

/**
 * __useGetCardQuery__
 *
 * To run a query within a React component, call `useGetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCardQuery(baseOptions: Apollo.QueryHookOptions<GetCardQuery, GetCardQueryVariables> & ({ variables: GetCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
      }
export function useGetCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
        }
export function useGetCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
        }
export type GetCardQueryHookResult = ReturnType<typeof useGetCardQuery>;
export type GetCardLazyQueryHookResult = ReturnType<typeof useGetCardLazyQuery>;
export type GetCardSuspenseQueryHookResult = ReturnType<typeof useGetCardSuspenseQuery>;
export type GetCardQueryResult = Apollo.QueryResult<GetCardQuery, GetCardQueryVariables>;
export const GetCardsDocument = gql`
    query GetCards($first: UnsignedInt!, $where: CardFilterInput, $orderBy: [CardOrderingInput!]) {
  cards(first: $first, where: $where, orderBy: $orderBy) {
    id
    title
    secondaryTitle
    description
    url
    label
    brandKey
    status
    media
    body
    categories(first: 100) {
      order
      category {
        id
        level
        title
      }
    }
    tags(first: 100) {
      order
      tag {
        id
        title
        type
      }
    }
  }
}
    `;

/**
 * __useGetCardsQuery__
 *
 * To run a query within a React component, call `useGetCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCardsQuery(baseOptions: Apollo.QueryHookOptions<GetCardsQuery, GetCardsQueryVariables> & ({ variables: GetCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
      }
export function useGetCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
        }
export function useGetCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardsQuery, GetCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardsQuery, GetCardsQueryVariables>(GetCardsDocument, options);
        }
export type GetCardsQueryHookResult = ReturnType<typeof useGetCardsQuery>;
export type GetCardsLazyQueryHookResult = ReturnType<typeof useGetCardsLazyQuery>;
export type GetCardsSuspenseQueryHookResult = ReturnType<typeof useGetCardsSuspenseQuery>;
export type GetCardsQueryResult = Apollo.QueryResult<GetCardsQuery, GetCardsQueryVariables>;
export const GetDailymotionUploadUrlDocument = gql`
    query getDailymotionUploadURL($brandKey: BrandKey!) {
  dailymotionUploadURL(brandKey: $brandKey) {
    uploadUrl
    progressUrl
  }
}
    `;

/**
 * __useGetDailymotionUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetDailymotionUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailymotionUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailymotionUploadUrlQuery({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *   },
 * });
 */
export function useGetDailymotionUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables> & ({ variables: GetDailymotionUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>(GetDailymotionUploadUrlDocument, options);
      }
export function useGetDailymotionUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>(GetDailymotionUploadUrlDocument, options);
        }
export function useGetDailymotionUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>(GetDailymotionUploadUrlDocument, options);
        }
export type GetDailymotionUploadUrlQueryHookResult = ReturnType<typeof useGetDailymotionUploadUrlQuery>;
export type GetDailymotionUploadUrlLazyQueryHookResult = ReturnType<typeof useGetDailymotionUploadUrlLazyQuery>;
export type GetDailymotionUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDailymotionUploadUrlSuspenseQuery>;
export type GetDailymotionUploadUrlQueryResult = Apollo.QueryResult<GetDailymotionUploadUrlQuery, GetDailymotionUploadUrlQueryVariables>;
export const ExecuteImagePromptDocument = gql`
    query ExecuteImagePrompt($prompt: NonEmptyTrimmedString!) {
  executeImagePrompt(prompt: $prompt) {
    b64Json
  }
}
    `;

/**
 * __useExecuteImagePromptQuery__
 *
 * To run a query within a React component, call `useExecuteImagePromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteImagePromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteImagePromptQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useExecuteImagePromptQuery(baseOptions: Apollo.QueryHookOptions<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables> & ({ variables: ExecuteImagePromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>(ExecuteImagePromptDocument, options);
      }
export function useExecuteImagePromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>(ExecuteImagePromptDocument, options);
        }
export function useExecuteImagePromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>(ExecuteImagePromptDocument, options);
        }
export type ExecuteImagePromptQueryHookResult = ReturnType<typeof useExecuteImagePromptQuery>;
export type ExecuteImagePromptLazyQueryHookResult = ReturnType<typeof useExecuteImagePromptLazyQuery>;
export type ExecuteImagePromptSuspenseQueryHookResult = ReturnType<typeof useExecuteImagePromptSuspenseQuery>;
export type ExecuteImagePromptQueryResult = Apollo.QueryResult<ExecuteImagePromptQuery, ExecuteImagePromptQueryVariables>;
export const ExecuteTextPromptDocument = gql`
    query ExecuteTextPrompt($prompt: NonEmptyTrimmedString!, $model: String, $max_completion_tokens: UnsignedInt, $temperature: UnsignedFloat, $top_p: UnsignedFloat, $frequency_penalty: Float, $presence_penalty: Float, $response_format: JSONObject) {
  executeTextPrompt(prompt: $prompt, model: $model, max_completion_tokens: $max_completion_tokens, temperature: $temperature, top_p: $top_p, frequency_penalty: $frequency_penalty, presence_penalty: $presence_penalty, response_format: $response_format) {
    content
  }
}
    `;

/**
 * __useExecuteTextPromptQuery__
 *
 * To run a query within a React component, call `useExecuteTextPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteTextPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteTextPromptQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      model: // value for 'model'
 *      max_completion_tokens: // value for 'max_completion_tokens'
 *      temperature: // value for 'temperature'
 *      top_p: // value for 'top_p'
 *      frequency_penalty: // value for 'frequency_penalty'
 *      presence_penalty: // value for 'presence_penalty'
 *      response_format: // value for 'response_format'
 *   },
 * });
 */
export function useExecuteTextPromptQuery(baseOptions: Apollo.QueryHookOptions<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables> & ({ variables: ExecuteTextPromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>(ExecuteTextPromptDocument, options);
      }
export function useExecuteTextPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>(ExecuteTextPromptDocument, options);
        }
export function useExecuteTextPromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>(ExecuteTextPromptDocument, options);
        }
export type ExecuteTextPromptQueryHookResult = ReturnType<typeof useExecuteTextPromptQuery>;
export type ExecuteTextPromptLazyQueryHookResult = ReturnType<typeof useExecuteTextPromptLazyQuery>;
export type ExecuteTextPromptSuspenseQueryHookResult = ReturnType<typeof useExecuteTextPromptSuspenseQuery>;
export type ExecuteTextPromptQueryResult = Apollo.QueryResult<ExecuteTextPromptQuery, ExecuteTextPromptQueryVariables>;
export const GetArticleGoodDealIaProcessDocument = gql`
    query GetArticleGoodDealIaProcess($userId: UUIDv4) {
  articleGoodDealAiProcesses(first: 30, orderBy: createdAt_DESC, where: {userId: $userId}) {
    article {
      id
    }
    status
    id
    createdAt
    updatedAt
    productTitle
    error
  }
}
    `;

/**
 * __useGetArticleGoodDealIaProcessQuery__
 *
 * To run a query within a React component, call `useGetArticleGoodDealIaProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleGoodDealIaProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleGoodDealIaProcessQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetArticleGoodDealIaProcessQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>(GetArticleGoodDealIaProcessDocument, options);
      }
export function useGetArticleGoodDealIaProcessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>(GetArticleGoodDealIaProcessDocument, options);
        }
export function useGetArticleGoodDealIaProcessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>(GetArticleGoodDealIaProcessDocument, options);
        }
export type GetArticleGoodDealIaProcessQueryHookResult = ReturnType<typeof useGetArticleGoodDealIaProcessQuery>;
export type GetArticleGoodDealIaProcessLazyQueryHookResult = ReturnType<typeof useGetArticleGoodDealIaProcessLazyQuery>;
export type GetArticleGoodDealIaProcessSuspenseQueryHookResult = ReturnType<typeof useGetArticleGoodDealIaProcessSuspenseQuery>;
export type GetArticleGoodDealIaProcessQueryResult = Apollo.QueryResult<GetArticleGoodDealIaProcessQuery, GetArticleGoodDealIaProcessQueryVariables>;
export const GetAttributesDocument = gql`
    query GetAttributes($first: UnsignedInt!, $where: AttributeFilterInput, $skip: UnsignedInt, $orderBy: [AttributeOrderingInput!]) {
  attributes(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
    id
    title
    createdAt
    updatedAt
    brandKey
    slug
    authors(first: 100) {
      author {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAttributesQuery__
 *
 * To run a query within a React component, call `useGetAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttributesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetAttributesQuery, GetAttributesQueryVariables> & ({ variables: GetAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttributesQuery, GetAttributesQueryVariables>(GetAttributesDocument, options);
      }
export function useGetAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttributesQuery, GetAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttributesQuery, GetAttributesQueryVariables>(GetAttributesDocument, options);
        }
export function useGetAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAttributesQuery, GetAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttributesQuery, GetAttributesQueryVariables>(GetAttributesDocument, options);
        }
export type GetAttributesQueryHookResult = ReturnType<typeof useGetAttributesQuery>;
export type GetAttributesLazyQueryHookResult = ReturnType<typeof useGetAttributesLazyQuery>;
export type GetAttributesSuspenseQueryHookResult = ReturnType<typeof useGetAttributesSuspenseQuery>;
export type GetAttributesQueryResult = Apollo.QueryResult<GetAttributesQuery, GetAttributesQueryVariables>;
export const GetSearchEnabledTagsDocument = gql`
    query GetSearchEnabledTags($where: TagFilterSearchInput, $first: UnsignedInt!, $skip: UnsignedInt!, $query: NonEmptyTrimmedString, $like: TagLikeInput) {
  searchTags(first: $first, where: $where, query: $query, like: $like, skip: $skip) {
    id
    title
    type
    relationId
    articleUsages {
      brandKey
      total
    }
    cardCount
    type
    brandedContents {
      isActive
      brandKey
    }
    cards(first: 100) {
      card {
        id
        title
        secondaryTitle
        description
        url
        label
        brandKey
        status
        media
        body
        categories(first: 100) {
          order
          category {
            id
            level
            title
          }
        }
        tags(first: 100) {
          order
          tag {
            id
            title
            type
          }
        }
      }
      tag {
        id
        title
        type
      }
      order
    }
  }
}
    `;

/**
 * __useGetSearchEnabledTagsQuery__
 *
 * To run a query within a React component, call `useGetSearchEnabledTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchEnabledTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchEnabledTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      query: // value for 'query'
 *      like: // value for 'like'
 *   },
 * });
 */
export function useGetSearchEnabledTagsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables> & ({ variables: GetSearchEnabledTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>(GetSearchEnabledTagsDocument, options);
      }
export function useGetSearchEnabledTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>(GetSearchEnabledTagsDocument, options);
        }
export function useGetSearchEnabledTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>(GetSearchEnabledTagsDocument, options);
        }
export type GetSearchEnabledTagsQueryHookResult = ReturnType<typeof useGetSearchEnabledTagsQuery>;
export type GetSearchEnabledTagsLazyQueryHookResult = ReturnType<typeof useGetSearchEnabledTagsLazyQuery>;
export type GetSearchEnabledTagsSuspenseQueryHookResult = ReturnType<typeof useGetSearchEnabledTagsSuspenseQuery>;
export type GetSearchEnabledTagsQueryResult = Apollo.QueryResult<GetSearchEnabledTagsQuery, GetSearchEnabledTagsQueryVariables>;
export const GetTagDocument = gql`
    query GetTag($where: TagUniqueFilterInput!) {
  tag(where: $where) {
    id
    title
  }
}
    `;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTagQuery(baseOptions: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables> & ({ variables: GetTagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
      }
export function useGetTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export function useGetTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(GetTagDocument, options);
        }
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<typeof useGetTagSuspenseQuery>;
export type GetTagQueryResult = Apollo.QueryResult<GetTagQuery, GetTagQueryVariables>;
export const GetOpenAiProcessesDocument = gql`
    query GetOpenAiProcesses {
  openAiProcesses(first: 100, orderBy: id_DESC) {
    article {
      id
    }
    id
    slideshowSubject
    recipeNumber
    status
    errorMsg
    createdAt
    updatedAt
    generatedTitle
  }
}
    `;

/**
 * __useGetOpenAiProcessesQuery__
 *
 * To run a query within a React component, call `useGetOpenAiProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenAiProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenAiProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenAiProcessesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>(GetOpenAiProcessesDocument, options);
      }
export function useGetOpenAiProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>(GetOpenAiProcessesDocument, options);
        }
export function useGetOpenAiProcessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>(GetOpenAiProcessesDocument, options);
        }
export type GetOpenAiProcessesQueryHookResult = ReturnType<typeof useGetOpenAiProcessesQuery>;
export type GetOpenAiProcessesLazyQueryHookResult = ReturnType<typeof useGetOpenAiProcessesLazyQuery>;
export type GetOpenAiProcessesSuspenseQueryHookResult = ReturnType<typeof useGetOpenAiProcessesSuspenseQuery>;
export type GetOpenAiProcessesQueryResult = Apollo.QueryResult<GetOpenAiProcessesQuery, GetOpenAiProcessesQueryVariables>;
export const GetSearchTvCollectionDocument = gql`
    query GetSearchTvCollection($query: NonEmptyTrimmedString!, $context: TvSearchContextType!) {
  searchTvCollections(query: $query, context: $context) {
    id
    title
    season
    type
    boneUUID
  }
}
    `;

/**
 * __useGetSearchTvCollectionQuery__
 *
 * To run a query within a React component, call `useGetSearchTvCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchTvCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchTvCollectionQuery({
 *   variables: {
 *      query: // value for 'query'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetSearchTvCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables> & ({ variables: GetSearchTvCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>(GetSearchTvCollectionDocument, options);
      }
export function useGetSearchTvCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>(GetSearchTvCollectionDocument, options);
        }
export function useGetSearchTvCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>(GetSearchTvCollectionDocument, options);
        }
export type GetSearchTvCollectionQueryHookResult = ReturnType<typeof useGetSearchTvCollectionQuery>;
export type GetSearchTvCollectionLazyQueryHookResult = ReturnType<typeof useGetSearchTvCollectionLazyQuery>;
export type GetSearchTvCollectionSuspenseQueryHookResult = ReturnType<typeof useGetSearchTvCollectionSuspenseQuery>;
export type GetSearchTvCollectionQueryResult = Apollo.QueryResult<GetSearchTvCollectionQuery, GetSearchTvCollectionQueryVariables>;
export const GetSearchTvProgramDocument = gql`
    query GetSearchTvProgram($query: NonEmptyTrimmedString!, $context: TvSearchContextType!) {
  searchTvPrograms(query: $query, first: 25, context: $context) {
    id
    title
    boneUUID
    channel
    startedAt
  }
}
    `;

/**
 * __useGetSearchTvProgramQuery__
 *
 * To run a query within a React component, call `useGetSearchTvProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchTvProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchTvProgramQuery({
 *   variables: {
 *      query: // value for 'query'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetSearchTvProgramQuery(baseOptions: Apollo.QueryHookOptions<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables> & ({ variables: GetSearchTvProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>(GetSearchTvProgramDocument, options);
      }
export function useGetSearchTvProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>(GetSearchTvProgramDocument, options);
        }
export function useGetSearchTvProgramSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>(GetSearchTvProgramDocument, options);
        }
export type GetSearchTvProgramQueryHookResult = ReturnType<typeof useGetSearchTvProgramQuery>;
export type GetSearchTvProgramLazyQueryHookResult = ReturnType<typeof useGetSearchTvProgramLazyQuery>;
export type GetSearchTvProgramSuspenseQueryHookResult = ReturnType<typeof useGetSearchTvProgramSuspenseQuery>;
export type GetSearchTvProgramQueryResult = Apollo.QueryResult<GetSearchTvProgramQuery, GetSearchTvProgramQueryVariables>;
export const GetSuggestedTagsListDocument = gql`
    query GetSuggestedTagsList($article: ArticleLikeInput!, $where: ArticleTagsTagFilterSearchInput, $brandKey: BrandKey) {
  suggestTags(article: $article, where: $where) {
    id
    title
    type
    relationId
    articleUsages(brandKeys: [$brandKey]) {
      total
      brandKey
    }
    brandedContents(where: {brandKey: $brandKey}) {
      isActive
      brandKey
    }
  }
}
    `;

/**
 * __useGetSuggestedTagsListQuery__
 *
 * To run a query within a React component, call `useGetSuggestedTagsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedTagsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedTagsListQuery({
 *   variables: {
 *      article: // value for 'article'
 *      where: // value for 'where'
 *      brandKey: // value for 'brandKey'
 *   },
 * });
 */
export function useGetSuggestedTagsListQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables> & ({ variables: GetSuggestedTagsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>(GetSuggestedTagsListDocument, options);
      }
export function useGetSuggestedTagsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>(GetSuggestedTagsListDocument, options);
        }
export function useGetSuggestedTagsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>(GetSuggestedTagsListDocument, options);
        }
export type GetSuggestedTagsListQueryHookResult = ReturnType<typeof useGetSuggestedTagsListQuery>;
export type GetSuggestedTagsListLazyQueryHookResult = ReturnType<typeof useGetSuggestedTagsListLazyQuery>;
export type GetSuggestedTagsListSuspenseQueryHookResult = ReturnType<typeof useGetSuggestedTagsListSuspenseQuery>;
export type GetSuggestedTagsListQueryResult = Apollo.QueryResult<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>;
export const GetProvidersPhotosDocument = gql`
    query GetProvidersPhotos($query: NonEmptyTrimmedString!, $perPage: UnsignedInt!, $providers: [ImageProviderName!]!, $currentPage: UnsignedInt) {
  searchExternalImages(query: $query, perPage: $perPage, currentPage: $currentPage, providers: $providers) {
    name
    items {
      id
      medium
      large
      preview {
        height
        url
        width
      }
      small
    }
  }
}
    `;

/**
 * __useGetProvidersPhotosQuery__
 *
 * To run a query within a React component, call `useGetProvidersPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersPhotosQuery({
 *   variables: {
 *      query: // value for 'query'
 *      perPage: // value for 'perPage'
 *      providers: // value for 'providers'
 *      currentPage: // value for 'currentPage'
 *   },
 * });
 */
export function useGetProvidersPhotosQuery(baseOptions: Apollo.QueryHookOptions<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables> & ({ variables: GetProvidersPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>(GetProvidersPhotosDocument, options);
      }
export function useGetProvidersPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>(GetProvidersPhotosDocument, options);
        }
export function useGetProvidersPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>(GetProvidersPhotosDocument, options);
        }
export type GetProvidersPhotosQueryHookResult = ReturnType<typeof useGetProvidersPhotosQuery>;
export type GetProvidersPhotosLazyQueryHookResult = ReturnType<typeof useGetProvidersPhotosLazyQuery>;
export type GetProvidersPhotosSuspenseQueryHookResult = ReturnType<typeof useGetProvidersPhotosSuspenseQuery>;
export type GetProvidersPhotosQueryResult = Apollo.QueryResult<GetProvidersPhotosQuery, GetProvidersPhotosQueryVariables>;
export const GetPromptsDocument = gql`
    query GetPrompts($first: UnsignedInt!, $where: PromptFilterInput, $skip: UnsignedInt) {
  prompts(first: $first, where: $where, skip: $skip) {
    field
    label
    body
    brandKey
  }
}
    `;

/**
 * __useGetPromptsQuery__
 *
 * To run a query within a React component, call `useGetPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPromptsQuery(baseOptions: Apollo.QueryHookOptions<GetPromptsQuery, GetPromptsQueryVariables> & ({ variables: GetPromptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromptsQuery, GetPromptsQueryVariables>(GetPromptsDocument, options);
      }
export function useGetPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromptsQuery, GetPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromptsQuery, GetPromptsQueryVariables>(GetPromptsDocument, options);
        }
export function useGetPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPromptsQuery, GetPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromptsQuery, GetPromptsQueryVariables>(GetPromptsDocument, options);
        }
export type GetPromptsQueryHookResult = ReturnType<typeof useGetPromptsQuery>;
export type GetPromptsLazyQueryHookResult = ReturnType<typeof useGetPromptsLazyQuery>;
export type GetPromptsSuspenseQueryHookResult = ReturnType<typeof useGetPromptsSuspenseQuery>;
export type GetPromptsQueryResult = Apollo.QueryResult<GetPromptsQuery, GetPromptsQueryVariables>;
export const GetPromptDocument = gql`
    query GetPrompt($brandKey: BrandKey!, $field: PromptField!, $label: NonEmptyTrimmedString!) {
  prompt(where: {brandKey: $brandKey, field: $field, label: $label}) {
    body
  }
}
    `;

/**
 * __useGetPromptQuery__
 *
 * To run a query within a React component, call `useGetPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptQuery({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      field: // value for 'field'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useGetPromptQuery(baseOptions: Apollo.QueryHookOptions<GetPromptQuery, GetPromptQueryVariables> & ({ variables: GetPromptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromptQuery, GetPromptQueryVariables>(GetPromptDocument, options);
      }
export function useGetPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromptQuery, GetPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromptQuery, GetPromptQueryVariables>(GetPromptDocument, options);
        }
export function useGetPromptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPromptQuery, GetPromptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromptQuery, GetPromptQueryVariables>(GetPromptDocument, options);
        }
export type GetPromptQueryHookResult = ReturnType<typeof useGetPromptQuery>;
export type GetPromptLazyQueryHookResult = ReturnType<typeof useGetPromptLazyQuery>;
export type GetPromptSuspenseQueryHookResult = ReturnType<typeof useGetPromptSuspenseQuery>;
export type GetPromptQueryResult = Apollo.QueryResult<GetPromptQuery, GetPromptQueryVariables>;
export const SearchArticlesDocument = gql`
    query SearchArticles($where: ArticleFilterSearchInput, $query: NonEmptyTrimmedString, $like: ArticleLikeInput, $first: UnsignedInt!, $skip: UnsignedInt!, $orderBy: [ArticleOrderingSearchInput!]) {
  searchArticles(first: $first, where: $where, query: $query, like: $like, skip: $skip, orderBy: $orderBy) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    updatedAt
    brandKey
    format
    medias
    pushCount
    refererCount
    live {
      postCount
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    canonical
    events(first: 10) {
      category {
        id
        title
      }
      order
    }
    histories(first: 100, orderBy: createdAt_ASC) {
      createdAt
      user {
        ... on OneUser {
          name
        }
      }
    }
    qualifiers(first: 100) {
      qualifier {
        id
        title
      }
    }
    tags(first: 20, orderBy: order_ASC) {
      order
      tag {
        id
        relationId
        title
        type
      }
    }
    authors(first: 1) {
      author {
        id
        name
        avatarUrl
      }
    }
    newsletterFlashSenderHistories {
      createdAt
    }
  }
}
    `;

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      query: // value for 'query'
 *      like: // value for 'like'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchArticlesQuery(baseOptions: Apollo.QueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables> & ({ variables: SearchArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
      }
export function useSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export function useSearchArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export type SearchArticlesQueryHookResult = ReturnType<typeof useSearchArticlesQuery>;
export type SearchArticlesLazyQueryHookResult = ReturnType<typeof useSearchArticlesLazyQuery>;
export type SearchArticlesSuspenseQueryHookResult = ReturnType<typeof useSearchArticlesSuspenseQuery>;
export type SearchArticlesQueryResult = Apollo.QueryResult<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const SearchArticleCountDocument = gql`
    query SearchArticleCount($where: ArticleFilterSearchInput, $query: NonEmptyTrimmedString) {
  searchArticleCount(where: $where, query: $query)
}
    `;

/**
 * __useSearchArticleCountQuery__
 *
 * To run a query within a React component, call `useSearchArticleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticleCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchArticleCountQuery(baseOptions?: Apollo.QueryHookOptions<SearchArticleCountQuery, SearchArticleCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticleCountQuery, SearchArticleCountQueryVariables>(SearchArticleCountDocument, options);
      }
export function useSearchArticleCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticleCountQuery, SearchArticleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticleCountQuery, SearchArticleCountQueryVariables>(SearchArticleCountDocument, options);
        }
export function useSearchArticleCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchArticleCountQuery, SearchArticleCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchArticleCountQuery, SearchArticleCountQueryVariables>(SearchArticleCountDocument, options);
        }
export type SearchArticleCountQueryHookResult = ReturnType<typeof useSearchArticleCountQuery>;
export type SearchArticleCountLazyQueryHookResult = ReturnType<typeof useSearchArticleCountLazyQuery>;
export type SearchArticleCountSuspenseQueryHookResult = ReturnType<typeof useSearchArticleCountSuspenseQuery>;
export type SearchArticleCountQueryResult = Apollo.QueryResult<SearchArticleCountQuery, SearchArticleCountQueryVariables>;
export const ExportSearchArticlesDocument = gql`
    query ExportSearchArticles($where: ArticleFilterSearchInput, $query: NonEmptyTrimmedString, $like: ArticleLikeInput, $first: UnsignedInt!, $skip: UnsignedInt!, $orderBy: [ArticleOrderingSearchInput!]) {
  searchArticles(first: $first, where: $where, query: $query, like: $like, skip: $skip, orderBy: $orderBy) {
    id
    title
    status
    publishedAt
    brandKey
    format
    categories(first: 100, orderBy: order_ASC) {
      category {
        id
        title
      }
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      qualifier {
        id
        title
      }
    }
    tags(first: 100, orderBy: order_ASC) {
      tag {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useExportSearchArticlesQuery__
 *
 * To run a query within a React component, call `useExportSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSearchArticlesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      query: // value for 'query'
 *      like: // value for 'like'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useExportSearchArticlesQuery(baseOptions: Apollo.QueryHookOptions<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables> & ({ variables: ExportSearchArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>(ExportSearchArticlesDocument, options);
      }
export function useExportSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>(ExportSearchArticlesDocument, options);
        }
export function useExportSearchArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>(ExportSearchArticlesDocument, options);
        }
export type ExportSearchArticlesQueryHookResult = ReturnType<typeof useExportSearchArticlesQuery>;
export type ExportSearchArticlesLazyQueryHookResult = ReturnType<typeof useExportSearchArticlesLazyQuery>;
export type ExportSearchArticlesSuspenseQueryHookResult = ReturnType<typeof useExportSearchArticlesSuspenseQuery>;
export type ExportSearchArticlesQueryResult = Apollo.QueryResult<ExportSearchArticlesQuery, ExportSearchArticlesQueryVariables>;
export const GetOrphansDocument = gql`
    query GetOrphans($where: OrphanPageFilterInput, $first: UnsignedInt!, $skip: UnsignedInt!) {
  orphanPages(first: $first, where: $where, orderBy: publishedAt_DESC, skip: $skip) {
    id
    publishedAt
    editedAt
    status
    title
    metas
    isCMPEnabled
    isFullScreen
    brandKey
    uri
    __typename
  }
}
    `;

/**
 * __useGetOrphansQuery__
 *
 * To run a query within a React component, call `useGetOrphansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrphansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrphansQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetOrphansQuery(baseOptions: Apollo.QueryHookOptions<GetOrphansQuery, GetOrphansQueryVariables> & ({ variables: GetOrphansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrphansQuery, GetOrphansQueryVariables>(GetOrphansDocument, options);
      }
export function useGetOrphansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrphansQuery, GetOrphansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrphansQuery, GetOrphansQueryVariables>(GetOrphansDocument, options);
        }
export function useGetOrphansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrphansQuery, GetOrphansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrphansQuery, GetOrphansQueryVariables>(GetOrphansDocument, options);
        }
export type GetOrphansQueryHookResult = ReturnType<typeof useGetOrphansQuery>;
export type GetOrphansLazyQueryHookResult = ReturnType<typeof useGetOrphansLazyQuery>;
export type GetOrphansSuspenseQueryHookResult = ReturnType<typeof useGetOrphansSuspenseQuery>;
export type GetOrphansQueryResult = Apollo.QueryResult<GetOrphansQuery, GetOrphansQueryVariables>;
export const SuggestArticlesDocument = gql`
    query SuggestArticles($first: UnsignedInt!, $like: ArticleLikeInput!, $where: ArticleFilterSearchInput) {
  searchArticles(first: $first, like: $like, where: $where) {
    id
    title
    status
    body
    createdAt
    publishedAt
    editedAt
    brandKey
    format
    medias
    canonical
    pushCount
    refererCount
    live {
      postCount
    }
    categories(first: 2, orderBy: order_ASC) {
      order
      category {
        id
        title
      }
    }
    channels(first: 1) {
      order
      category {
        id
        title
      }
    }
    creator {
      name
    }
    urls(first: 1, orderBy: order_ASC) {
      origin
      path
    }
    qualifiers(first: 100) {
      order
      qualifier {
        id
        title
      }
    }
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    events(first: 10) {
      category {
        id
        title
      }
      order
    }
    qualifiers(first: 100) {
      qualifier {
        id
        title
      }
    }
    histories(first: 100, orderBy: createdAt_ASC) {
      user {
        ... on OneUser {
          name
        }
      }
    }
    authors(first: 1) {
      author {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useSuggestArticlesQuery__
 *
 * To run a query within a React component, call `useSuggestArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestArticlesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      like: // value for 'like'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSuggestArticlesQuery(baseOptions: Apollo.QueryHookOptions<SuggestArticlesQuery, SuggestArticlesQueryVariables> & ({ variables: SuggestArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestArticlesQuery, SuggestArticlesQueryVariables>(SuggestArticlesDocument, options);
      }
export function useSuggestArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestArticlesQuery, SuggestArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestArticlesQuery, SuggestArticlesQueryVariables>(SuggestArticlesDocument, options);
        }
export function useSuggestArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestArticlesQuery, SuggestArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestArticlesQuery, SuggestArticlesQueryVariables>(SuggestArticlesDocument, options);
        }
export type SuggestArticlesQueryHookResult = ReturnType<typeof useSuggestArticlesQuery>;
export type SuggestArticlesLazyQueryHookResult = ReturnType<typeof useSuggestArticlesLazyQuery>;
export type SuggestArticlesSuspenseQueryHookResult = ReturnType<typeof useSuggestArticlesSuspenseQuery>;
export type SuggestArticlesQueryResult = Apollo.QueryResult<SuggestArticlesQuery, SuggestArticlesQueryVariables>;
export const GetSuggestedCategoryDocument = gql`
    query GetSuggestedCategory($article: ArticleLikeInput!, $first: UnsignedInt!) {
  suggestCategories(article: $article, first: $first) {
    childCount
    children(first: $first) {
      id
      title
      slug
      format
      level
    }
  }
}
    `;

/**
 * __useGetSuggestedCategoryQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCategoryQuery({
 *   variables: {
 *      article: // value for 'article'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetSuggestedCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables> & ({ variables: GetSuggestedCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>(GetSuggestedCategoryDocument, options);
      }
export function useGetSuggestedCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>(GetSuggestedCategoryDocument, options);
        }
export function useGetSuggestedCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>(GetSuggestedCategoryDocument, options);
        }
export type GetSuggestedCategoryQueryHookResult = ReturnType<typeof useGetSuggestedCategoryQuery>;
export type GetSuggestedCategoryLazyQueryHookResult = ReturnType<typeof useGetSuggestedCategoryLazyQuery>;
export type GetSuggestedCategorySuspenseQueryHookResult = ReturnType<typeof useGetSuggestedCategorySuspenseQuery>;
export type GetSuggestedCategoryQueryResult = Apollo.QueryResult<GetSuggestedCategoryQuery, GetSuggestedCategoryQueryVariables>;
export const SuggestInternalLinksDocument = gql`
    query SuggestInternalLinks($title: String!, $body: String!, $brandKey: BrandKey!, $existingLinksLabels: [String], $idArticle: String) {
  suggestInternalLinks(title: $title, body: $body, brandKey: $brandKey, existingLinksLabels: $existingLinksLabels, idArticle: $idArticle) {
    url
    relevance
    title
    word
    sentence
    blockKey
  }
}
    `;

/**
 * __useSuggestInternalLinksQuery__
 *
 * To run a query within a React component, call `useSuggestInternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestInternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestInternalLinksQuery({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      brandKey: // value for 'brandKey'
 *      existingLinksLabels: // value for 'existingLinksLabels'
 *      idArticle: // value for 'idArticle'
 *   },
 * });
 */
export function useSuggestInternalLinksQuery(baseOptions: Apollo.QueryHookOptions<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables> & ({ variables: SuggestInternalLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>(SuggestInternalLinksDocument, options);
      }
export function useSuggestInternalLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>(SuggestInternalLinksDocument, options);
        }
export function useSuggestInternalLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>(SuggestInternalLinksDocument, options);
        }
export type SuggestInternalLinksQueryHookResult = ReturnType<typeof useSuggestInternalLinksQuery>;
export type SuggestInternalLinksLazyQueryHookResult = ReturnType<typeof useSuggestInternalLinksLazyQuery>;
export type SuggestInternalLinksSuspenseQueryHookResult = ReturnType<typeof useSuggestInternalLinksSuspenseQuery>;
export type SuggestInternalLinksQueryResult = Apollo.QueryResult<SuggestInternalLinksQuery, SuggestInternalLinksQueryVariables>;
export const GetBodyWithSuggestedLinksDocument = gql`
    query GetBodyWithSuggestedLinks($body: String!, $links: [LinkInput]!) {
  getBodyWithSuggestedLinks(body: $body, links: $links) {
    updatedBody
  }
}
    `;

/**
 * __useGetBodyWithSuggestedLinksQuery__
 *
 * To run a query within a React component, call `useGetBodyWithSuggestedLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBodyWithSuggestedLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBodyWithSuggestedLinksQuery({
 *   variables: {
 *      body: // value for 'body'
 *      links: // value for 'links'
 *   },
 * });
 */
export function useGetBodyWithSuggestedLinksQuery(baseOptions: Apollo.QueryHookOptions<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables> & ({ variables: GetBodyWithSuggestedLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>(GetBodyWithSuggestedLinksDocument, options);
      }
export function useGetBodyWithSuggestedLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>(GetBodyWithSuggestedLinksDocument, options);
        }
export function useGetBodyWithSuggestedLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>(GetBodyWithSuggestedLinksDocument, options);
        }
export type GetBodyWithSuggestedLinksQueryHookResult = ReturnType<typeof useGetBodyWithSuggestedLinksQuery>;
export type GetBodyWithSuggestedLinksLazyQueryHookResult = ReturnType<typeof useGetBodyWithSuggestedLinksLazyQuery>;
export type GetBodyWithSuggestedLinksSuspenseQueryHookResult = ReturnType<typeof useGetBodyWithSuggestedLinksSuspenseQuery>;
export type GetBodyWithSuggestedLinksQueryResult = Apollo.QueryResult<GetBodyWithSuggestedLinksQuery, GetBodyWithSuggestedLinksQueryVariables>;
export const TranslateArticleDocument = gql`
    query TranslateArticle($where: ArticleUniqueFilterInput!, $lang: NonEmptyTrimmedString!) {
  translateArticle(where: $where, lang: $lang) {
    title
    body
    lead
  }
}
    `;

/**
 * __useTranslateArticleQuery__
 *
 * To run a query within a React component, call `useTranslateArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslateArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslateArticleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useTranslateArticleQuery(baseOptions: Apollo.QueryHookOptions<TranslateArticleQuery, TranslateArticleQueryVariables> & ({ variables: TranslateArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslateArticleQuery, TranslateArticleQueryVariables>(TranslateArticleDocument, options);
      }
export function useTranslateArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslateArticleQuery, TranslateArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslateArticleQuery, TranslateArticleQueryVariables>(TranslateArticleDocument, options);
        }
export function useTranslateArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslateArticleQuery, TranslateArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranslateArticleQuery, TranslateArticleQueryVariables>(TranslateArticleDocument, options);
        }
export type TranslateArticleQueryHookResult = ReturnType<typeof useTranslateArticleQuery>;
export type TranslateArticleLazyQueryHookResult = ReturnType<typeof useTranslateArticleLazyQuery>;
export type TranslateArticleSuspenseQueryHookResult = ReturnType<typeof useTranslateArticleSuspenseQuery>;
export type TranslateArticleQueryResult = Apollo.QueryResult<TranslateArticleQuery, TranslateArticleQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($where: CategoryFilterInput!) {
  categories(first: 1000, where: $where, orderBy: title_ASC) {
    id
    title
    level
    parent {
      id
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryDocument = gql`
    query GetCategory($where: CategoryUniqueFilterInput!) {
  category(where: $where) {
    id
    title
  }
}
    `;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables> & ({ variables: GetCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export function useGetCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategorySuspenseQueryHookResult = ReturnType<typeof useGetCategorySuspenseQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetBrandKeysDocument = gql`
    query GetBrandKeys($first: UnsignedInt!, $level: UnsignedInt!) {
  categories(where: {level: $level, format: Category}, first: $first) {
    ...BrandCategoryFragment
    brandKey
  }
}
    ${BrandCategoryFragmentFragmentDoc}`;

/**
 * __useGetBrandKeysQuery__
 *
 * To run a query within a React component, call `useGetBrandKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandKeysQuery({
 *   variables: {
 *      first: // value for 'first'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useGetBrandKeysQuery(baseOptions: Apollo.QueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables> & ({ variables: GetBrandKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
      }
export function useGetBrandKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
        }
export function useGetBrandKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandKeysQuery, GetBrandKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandKeysQuery, GetBrandKeysQueryVariables>(GetBrandKeysDocument, options);
        }
export type GetBrandKeysQueryHookResult = ReturnType<typeof useGetBrandKeysQuery>;
export type GetBrandKeysLazyQueryHookResult = ReturnType<typeof useGetBrandKeysLazyQuery>;
export type GetBrandKeysSuspenseQueryHookResult = ReturnType<typeof useGetBrandKeysSuspenseQuery>;
export type GetBrandKeysQueryResult = Apollo.QueryResult<GetBrandKeysQuery, GetBrandKeysQueryVariables>;
export const GetImageSourceCategoriesDocument = gql`
    query GetImageSourceCategories {
  imageSourceCategories(first: 100, orderBy: title_ASC) {
    id
    title
    sources(first: 100, orderBy: title_ASC) {
      id
      title
    }
  }
}
    `;

/**
 * __useGetImageSourceCategoriesQuery__
 *
 * To run a query within a React component, call `useGetImageSourceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageSourceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageSourceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImageSourceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
      }
export function useGetImageSourceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
        }
export function useGetImageSourceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>(GetImageSourceCategoriesDocument, options);
        }
export type GetImageSourceCategoriesQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesQuery>;
export type GetImageSourceCategoriesLazyQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesLazyQuery>;
export type GetImageSourceCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetImageSourceCategoriesSuspenseQuery>;
export type GetImageSourceCategoriesQueryResult = Apollo.QueryResult<GetImageSourceCategoriesQuery, GetImageSourceCategoriesQueryVariables>;
export const SearchImageSourcesDocument = gql`
    query SearchImageSources($where: ImageSourceFilterInput) {
  imageSources(orderBy: title_ASC, first: 100, where: $where) {
    id
    title
    category {
      id
      title
    }
    __typename
  }
}
    `;

/**
 * __useSearchImageSourcesQuery__
 *
 * To run a query within a React component, call `useSearchImageSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchImageSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchImageSourcesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchImageSourcesQuery(baseOptions?: Apollo.QueryHookOptions<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>(SearchImageSourcesDocument, options);
      }
export function useSearchImageSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>(SearchImageSourcesDocument, options);
        }
export function useSearchImageSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>(SearchImageSourcesDocument, options);
        }
export type SearchImageSourcesQueryHookResult = ReturnType<typeof useSearchImageSourcesQuery>;
export type SearchImageSourcesLazyQueryHookResult = ReturnType<typeof useSearchImageSourcesLazyQuery>;
export type SearchImageSourcesSuspenseQueryHookResult = ReturnType<typeof useSearchImageSourcesSuspenseQuery>;
export type SearchImageSourcesQueryResult = Apollo.QueryResult<SearchImageSourcesQuery, SearchImageSourcesQueryVariables>;
export const SearchImageSourceCategoriesDocument = gql`
    query SearchImageSourceCategories($where: ImageSourceCategoryFilterInput) {
  imageSourceCategories(first: 100, where: $where) {
    id
    title
    sources(first: 100, orderBy: title_ASC) {
      id
      title
    }
  }
}
    `;

/**
 * __useSearchImageSourceCategoriesQuery__
 *
 * To run a query within a React component, call `useSearchImageSourceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchImageSourceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchImageSourceCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchImageSourceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>(SearchImageSourceCategoriesDocument, options);
      }
export function useSearchImageSourceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>(SearchImageSourceCategoriesDocument, options);
        }
export function useSearchImageSourceCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>(SearchImageSourceCategoriesDocument, options);
        }
export type SearchImageSourceCategoriesQueryHookResult = ReturnType<typeof useSearchImageSourceCategoriesQuery>;
export type SearchImageSourceCategoriesLazyQueryHookResult = ReturnType<typeof useSearchImageSourceCategoriesLazyQuery>;
export type SearchImageSourceCategoriesSuspenseQueryHookResult = ReturnType<typeof useSearchImageSourceCategoriesSuspenseQuery>;
export type SearchImageSourceCategoriesQueryResult = Apollo.QueryResult<SearchImageSourceCategoriesQuery, SearchImageSourceCategoriesQueryVariables>;
export const GetSearchCategoryMediasDocument = gql`
    query GetSearchCategoryMedias($where: CategoryUniqueFilterInput!) {
  category(where: $where) {
    medias
  }
}
    `;

/**
 * __useGetSearchCategoryMediasQuery__
 *
 * To run a query within a React component, call `useGetSearchCategoryMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCategoryMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCategoryMediasQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSearchCategoryMediasQuery(baseOptions: Apollo.QueryHookOptions<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables> & ({ variables: GetSearchCategoryMediasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>(GetSearchCategoryMediasDocument, options);
      }
export function useGetSearchCategoryMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>(GetSearchCategoryMediasDocument, options);
        }
export function useGetSearchCategoryMediasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>(GetSearchCategoryMediasDocument, options);
        }
export type GetSearchCategoryMediasQueryHookResult = ReturnType<typeof useGetSearchCategoryMediasQuery>;
export type GetSearchCategoryMediasLazyQueryHookResult = ReturnType<typeof useGetSearchCategoryMediasLazyQuery>;
export type GetSearchCategoryMediasSuspenseQueryHookResult = ReturnType<typeof useGetSearchCategoryMediasSuspenseQuery>;
export type GetSearchCategoryMediasQueryResult = Apollo.QueryResult<GetSearchCategoryMediasQuery, GetSearchCategoryMediasQueryVariables>;
export const GetQualifierDocument = gql`
    query GetQualifier($where: QualifierUniqueFilterInput!) {
  qualifier(where: $where) {
    id
    title
    status
    brandKey
    format
  }
}
    `;

/**
 * __useGetQualifierQuery__
 *
 * To run a query within a React component, call `useGetQualifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualifierQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetQualifierQuery(baseOptions: Apollo.QueryHookOptions<GetQualifierQuery, GetQualifierQueryVariables> & ({ variables: GetQualifierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQualifierQuery, GetQualifierQueryVariables>(GetQualifierDocument, options);
      }
export function useGetQualifierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQualifierQuery, GetQualifierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQualifierQuery, GetQualifierQueryVariables>(GetQualifierDocument, options);
        }
export function useGetQualifierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQualifierQuery, GetQualifierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQualifierQuery, GetQualifierQueryVariables>(GetQualifierDocument, options);
        }
export type GetQualifierQueryHookResult = ReturnType<typeof useGetQualifierQuery>;
export type GetQualifierLazyQueryHookResult = ReturnType<typeof useGetQualifierLazyQuery>;
export type GetQualifierSuspenseQueryHookResult = ReturnType<typeof useGetQualifierSuspenseQuery>;
export type GetQualifierQueryResult = Apollo.QueryResult<GetQualifierQuery, GetQualifierQueryVariables>;
export const UpdateQualifierDocument = gql`
    mutation UpdateQualifier($where: QualifierUniqueFilterInput!, $data: QualifierUpdateInput!) {
  updateQualifier(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateQualifierMutationFn = Apollo.MutationFunction<UpdateQualifierMutation, UpdateQualifierMutationVariables>;

/**
 * __useUpdateQualifierMutation__
 *
 * To run a mutation, you first call `useUpdateQualifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQualifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQualifierMutation, { data, loading, error }] = useUpdateQualifierMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateQualifierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQualifierMutation, UpdateQualifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQualifierMutation, UpdateQualifierMutationVariables>(UpdateQualifierDocument, options);
      }
export type UpdateQualifierMutationHookResult = ReturnType<typeof useUpdateQualifierMutation>;
export type UpdateQualifierMutationResult = Apollo.MutationResult<UpdateQualifierMutation>;
export type UpdateQualifierMutationOptions = Apollo.BaseMutationOptions<UpdateQualifierMutation, UpdateQualifierMutationVariables>;
export const CreateQualifierDocument = gql`
    mutation CreateQualifier($data: QualifierCreationInput!) {
  createQualifier(data: $data) {
    id
  }
}
    `;
export type CreateQualifierMutationFn = Apollo.MutationFunction<CreateQualifierMutation, CreateQualifierMutationVariables>;

/**
 * __useCreateQualifierMutation__
 *
 * To run a mutation, you first call `useCreateQualifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQualifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQualifierMutation, { data, loading, error }] = useCreateQualifierMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQualifierMutation(baseOptions?: Apollo.MutationHookOptions<CreateQualifierMutation, CreateQualifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQualifierMutation, CreateQualifierMutationVariables>(CreateQualifierDocument, options);
      }
export type CreateQualifierMutationHookResult = ReturnType<typeof useCreateQualifierMutation>;
export type CreateQualifierMutationResult = Apollo.MutationResult<CreateQualifierMutation>;
export type CreateQualifierMutationOptions = Apollo.BaseMutationOptions<CreateQualifierMutation, CreateQualifierMutationVariables>;
export const GetSegmentDocument = gql`
    query GetSegment($where: SegmentUniqueFilterInput!) {
  segment(where: $where) {
    active
    id
    title
    ios
    android
    brandKey
    status
    editorialAlert
  }
}
    `;

/**
 * __useGetSegmentQuery__
 *
 * To run a query within a React component, call `useGetSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSegmentQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables> & ({ variables: GetSegmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
      }
export function useGetSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
        }
export function useGetSegmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
        }
export type GetSegmentQueryHookResult = ReturnType<typeof useGetSegmentQuery>;
export type GetSegmentLazyQueryHookResult = ReturnType<typeof useGetSegmentLazyQuery>;
export type GetSegmentSuspenseQueryHookResult = ReturnType<typeof useGetSegmentSuspenseQuery>;
export type GetSegmentQueryResult = Apollo.QueryResult<GetSegmentQuery, GetSegmentQueryVariables>;
export const UpdateSegmentDocument = gql`
    mutation UpdateSegment($where: SegmentUniqueFilterInput!, $data: SegmentUpdateInput!) {
  updateSegment(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<UpdateSegmentMutation, UpdateSegmentMutationVariables>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentMutation, UpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
      }
export type UpdateSegmentMutationHookResult = ReturnType<typeof useUpdateSegmentMutation>;
export type UpdateSegmentMutationResult = Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const CreateSegmentDocument = gql`
    mutation CreateSegment($data: SegmentCreationInput!) {
  createSegment(data: $data) {
    id
  }
}
    `;
export type CreateSegmentMutationFn = Apollo.MutationFunction<CreateSegmentMutation, CreateSegmentMutationVariables>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentMutation, CreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentMutation, CreateSegmentMutationVariables>(CreateSegmentDocument, options);
      }
export type CreateSegmentMutationHookResult = ReturnType<typeof useCreateSegmentMutation>;
export type CreateSegmentMutationResult = Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const GetSegmentsDocument = gql`
    query GetSegments($first: UnsignedInt!, $where: SegmentFilterInput, $orderBy: [SegmentOrderingInput!]) {
  segments(first: $first, where: $where, orderBy: $orderBy) {
    active
    id
    title
    brandKey
    status
  }
  segmentCount
}
    `;

/**
 * __useGetSegmentsQuery__
 *
 * To run a query within a React component, call `useGetSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSegmentsQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables> & ({ variables: GetSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
      }
export function useGetSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export function useGetSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export type GetSegmentsQueryHookResult = ReturnType<typeof useGetSegmentsQuery>;
export type GetSegmentsLazyQueryHookResult = ReturnType<typeof useGetSegmentsLazyQuery>;
export type GetSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetSegmentsSuspenseQuery>;
export type GetSegmentsQueryResult = Apollo.QueryResult<GetSegmentsQuery, GetSegmentsQueryVariables>;
export const GetQualifiersDocument = gql`
    query GetQualifiers($first: UnsignedInt!, $where: QualifierFilterInput, $orderBy: [QualifierOrderingInput!]) {
  qualifiers(first: $first, where: $where, orderBy: $orderBy) {
    id
    title
    status
    brandKey
    format
  }
}
    `;

/**
 * __useGetQualifiersQuery__
 *
 * To run a query within a React component, call `useGetQualifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualifiersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetQualifiersQuery(baseOptions: Apollo.QueryHookOptions<GetQualifiersQuery, GetQualifiersQueryVariables> & ({ variables: GetQualifiersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQualifiersQuery, GetQualifiersQueryVariables>(GetQualifiersDocument, options);
      }
export function useGetQualifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQualifiersQuery, GetQualifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQualifiersQuery, GetQualifiersQueryVariables>(GetQualifiersDocument, options);
        }
export function useGetQualifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQualifiersQuery, GetQualifiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQualifiersQuery, GetQualifiersQueryVariables>(GetQualifiersDocument, options);
        }
export type GetQualifiersQueryHookResult = ReturnType<typeof useGetQualifiersQuery>;
export type GetQualifiersLazyQueryHookResult = ReturnType<typeof useGetQualifiersLazyQuery>;
export type GetQualifiersSuspenseQueryHookResult = ReturnType<typeof useGetQualifiersSuspenseQuery>;
export type GetQualifiersQueryResult = Apollo.QueryResult<GetQualifiersQuery, GetQualifiersQueryVariables>;
export const GetSourcesDocument = gql`
    query GetSources($first: UnsignedInt!, $where: SourceFilterInput, $orderBy: [SourceOrderingInput!]) {
  sources(first: $first, where: $where, orderBy: $orderBy) {
    id
    title
    brandKey
    status
  }
}
    `;

/**
 * __useGetSourcesQuery__
 *
 * To run a query within a React component, call `useGetSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSourcesQuery(baseOptions: Apollo.QueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables> & ({ variables: GetSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
      }
export function useGetSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
export function useGetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourcesQuery, GetSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourcesQuery, GetSourcesQueryVariables>(GetSourcesDocument, options);
        }
export type GetSourcesQueryHookResult = ReturnType<typeof useGetSourcesQuery>;
export type GetSourcesLazyQueryHookResult = ReturnType<typeof useGetSourcesLazyQuery>;
export type GetSourcesSuspenseQueryHookResult = ReturnType<typeof useGetSourcesSuspenseQuery>;
export type GetSourcesQueryResult = Apollo.QueryResult<GetSourcesQuery, GetSourcesQueryVariables>;
export const GetSourceDocument = gql`
    query GetSource($where: SourceUniqueFilterInput!) {
  source(where: $where) {
    id
    title
  }
}
    `;

/**
 * __useGetSourceQuery__
 *
 * To run a query within a React component, call `useGetSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSourceQuery(baseOptions: Apollo.QueryHookOptions<GetSourceQuery, GetSourceQueryVariables> & ({ variables: GetSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
      }
export function useGetSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceQuery, GetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
        }
export function useGetSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourceQuery, GetSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourceQuery, GetSourceQueryVariables>(GetSourceDocument, options);
        }
export type GetSourceQueryHookResult = ReturnType<typeof useGetSourceQuery>;
export type GetSourceLazyQueryHookResult = ReturnType<typeof useGetSourceLazyQuery>;
export type GetSourceSuspenseQueryHookResult = ReturnType<typeof useGetSourceSuspenseQuery>;
export type GetSourceQueryResult = Apollo.QueryResult<GetSourceQuery, GetSourceQueryVariables>;
export const GetSourceCountDocument = gql`
    query GetSourceCount($where: SourceFilterInput) {
  sourceCount(where: $where)
}
    `;

/**
 * __useGetSourceCountQuery__
 *
 * To run a query within a React component, call `useGetSourceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSourceCountQuery(baseOptions?: Apollo.QueryHookOptions<GetSourceCountQuery, GetSourceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceCountQuery, GetSourceCountQueryVariables>(GetSourceCountDocument, options);
      }
export function useGetSourceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceCountQuery, GetSourceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceCountQuery, GetSourceCountQueryVariables>(GetSourceCountDocument, options);
        }
export function useGetSourceCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourceCountQuery, GetSourceCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourceCountQuery, GetSourceCountQueryVariables>(GetSourceCountDocument, options);
        }
export type GetSourceCountQueryHookResult = ReturnType<typeof useGetSourceCountQuery>;
export type GetSourceCountLazyQueryHookResult = ReturnType<typeof useGetSourceCountLazyQuery>;
export type GetSourceCountSuspenseQueryHookResult = ReturnType<typeof useGetSourceCountSuspenseQuery>;
export type GetSourceCountQueryResult = Apollo.QueryResult<GetSourceCountQuery, GetSourceCountQueryVariables>;
export const CreateMachineTagForDuplicationDocument = gql`
    mutation CreateMachineTagForDuplication($data: MachineTagCreationInput!) {
  createMachineTag(data: $data) {
    id
  }
}
    `;
export type CreateMachineTagForDuplicationMutationFn = Apollo.MutationFunction<CreateMachineTagForDuplicationMutation, CreateMachineTagForDuplicationMutationVariables>;

/**
 * __useCreateMachineTagForDuplicationMutation__
 *
 * To run a mutation, you first call `useCreateMachineTagForDuplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMachineTagForDuplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMachineTagForDuplicationMutation, { data, loading, error }] = useCreateMachineTagForDuplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMachineTagForDuplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMachineTagForDuplicationMutation, CreateMachineTagForDuplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMachineTagForDuplicationMutation, CreateMachineTagForDuplicationMutationVariables>(CreateMachineTagForDuplicationDocument, options);
      }
export type CreateMachineTagForDuplicationMutationHookResult = ReturnType<typeof useCreateMachineTagForDuplicationMutation>;
export type CreateMachineTagForDuplicationMutationResult = Apollo.MutationResult<CreateMachineTagForDuplicationMutation>;
export type CreateMachineTagForDuplicationMutationOptions = Apollo.BaseMutationOptions<CreateMachineTagForDuplicationMutation, CreateMachineTagForDuplicationMutationVariables>;
export const UpsertTagDocument = gql`
    mutation UpsertTag($create: TagCreationInput!, $update: TagUpdateInput!, $where: TagUniqueFilterInput!) {
  upsertTag(create: $create, update: $update, where: $where) {
    id
    title
    slug
    type
    relationId
  }
}
    `;
export type UpsertTagMutationFn = Apollo.MutationFunction<UpsertTagMutation, UpsertTagMutationVariables>;

/**
 * __useUpsertTagMutation__
 *
 * To run a mutation, you first call `useUpsertTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTagMutation, { data, loading, error }] = useUpsertTagMutation({
 *   variables: {
 *      create: // value for 'create'
 *      update: // value for 'update'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpsertTagMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTagMutation, UpsertTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTagMutation, UpsertTagMutationVariables>(UpsertTagDocument, options);
      }
export type UpsertTagMutationHookResult = ReturnType<typeof useUpsertTagMutation>;
export type UpsertTagMutationResult = Apollo.MutationResult<UpsertTagMutation>;
export type UpsertTagMutationOptions = Apollo.BaseMutationOptions<UpsertTagMutation, UpsertTagMutationVariables>;
export const DeleteLivePostDocument = gql`
    mutation DeleteLivePost($where: LivePostUniqueFilterInput!) {
  deleteLivePost(where: $where) {
    id
  }
}
    `;
export type DeleteLivePostMutationFn = Apollo.MutationFunction<DeleteLivePostMutation, DeleteLivePostMutationVariables>;

/**
 * __useDeleteLivePostMutation__
 *
 * To run a mutation, you first call `useDeleteLivePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLivePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLivePostMutation, { data, loading, error }] = useDeleteLivePostMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteLivePostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLivePostMutation, DeleteLivePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLivePostMutation, DeleteLivePostMutationVariables>(DeleteLivePostDocument, options);
      }
export type DeleteLivePostMutationHookResult = ReturnType<typeof useDeleteLivePostMutation>;
export type DeleteLivePostMutationResult = Apollo.MutationResult<DeleteLivePostMutation>;
export type DeleteLivePostMutationOptions = Apollo.BaseMutationOptions<DeleteLivePostMutation, DeleteLivePostMutationVariables>;
export const GetPushesByBrandKeyDocument = gql`
    query getPushesByBrandKey($first: UnsignedInt!, $skip: UnsignedInt, $where: PushFilterInput, $orderBy: [PushOrderingInput!]) {
  pushCount(where: $where)
  pushes(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
    id
    title
    article {
      id
      title
      brandKey
      format
    }
    userId
    user {
      name
      id
    }
    sentAt
    targetDevice
    scheduledAt
    segments(first: 10) {
      segment {
        title
        id
      }
    }
  }
}
    `;

/**
 * __useGetPushesByBrandKeyQuery__
 *
 * To run a query within a React component, call `useGetPushesByBrandKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushesByBrandKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushesByBrandKeyQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPushesByBrandKeyQuery(baseOptions: Apollo.QueryHookOptions<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables> & ({ variables: GetPushesByBrandKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>(GetPushesByBrandKeyDocument, options);
      }
export function useGetPushesByBrandKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>(GetPushesByBrandKeyDocument, options);
        }
export function useGetPushesByBrandKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>(GetPushesByBrandKeyDocument, options);
        }
export type GetPushesByBrandKeyQueryHookResult = ReturnType<typeof useGetPushesByBrandKeyQuery>;
export type GetPushesByBrandKeyLazyQueryHookResult = ReturnType<typeof useGetPushesByBrandKeyLazyQuery>;
export type GetPushesByBrandKeySuspenseQueryHookResult = ReturnType<typeof useGetPushesByBrandKeySuspenseQuery>;
export type GetPushesByBrandKeyQueryResult = Apollo.QueryResult<GetPushesByBrandKeyQuery, GetPushesByBrandKeyQueryVariables>;
export const GetPushDocument = gql`
    query getPush($first: UnsignedInt!, $where: PushFilterInput) {
  pushes(first: $first, where: $where) {
    id
    title
    body
    targetDevice
    article {
      id
    }
    userId
    user {
      id
      name
    }
    scheduledAt
    sentAt
    isCancelled
    segments(first: 100) {
      segment {
        title
      }
    }
  }
}
    `;

/**
 * __useGetPushQuery__
 *
 * To run a query within a React component, call `useGetPushQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPushQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPushQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPushQuery(baseOptions: Apollo.QueryHookOptions<GetPushQuery, GetPushQueryVariables> & ({ variables: GetPushQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPushQuery, GetPushQueryVariables>(GetPushDocument, options);
      }
export function useGetPushLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPushQuery, GetPushQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPushQuery, GetPushQueryVariables>(GetPushDocument, options);
        }
export function useGetPushSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPushQuery, GetPushQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPushQuery, GetPushQueryVariables>(GetPushDocument, options);
        }
export type GetPushQueryHookResult = ReturnType<typeof useGetPushQuery>;
export type GetPushLazyQueryHookResult = ReturnType<typeof useGetPushLazyQuery>;
export type GetPushSuspenseQueryHookResult = ReturnType<typeof useGetPushSuspenseQuery>;
export type GetPushQueryResult = Apollo.QueryResult<GetPushQuery, GetPushQueryVariables>;
export const GetSegmentsByBrandKeyDocument = gql`
    query GetSegmentsByBrandKey($first: UnsignedInt!, $where: SegmentFilterInput, $orderBy: [SegmentOrderingInput!]) {
  segments(first: $first, where: $where, orderBy: $orderBy) {
    id
    createdAt
    updatedAt
    title
    active
    device
    brandKey
    ios
    android
    editorialAlert
    status
    pushes(first: 10) {
      segment {
        title
        id
      }
    }
  }
}
    `;

/**
 * __useGetSegmentsByBrandKeyQuery__
 *
 * To run a query within a React component, call `useGetSegmentsByBrandKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentsByBrandKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentsByBrandKeyQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSegmentsByBrandKeyQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables> & ({ variables: GetSegmentsByBrandKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>(GetSegmentsByBrandKeyDocument, options);
      }
export function useGetSegmentsByBrandKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>(GetSegmentsByBrandKeyDocument, options);
        }
export function useGetSegmentsByBrandKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>(GetSegmentsByBrandKeyDocument, options);
        }
export type GetSegmentsByBrandKeyQueryHookResult = ReturnType<typeof useGetSegmentsByBrandKeyQuery>;
export type GetSegmentsByBrandKeyLazyQueryHookResult = ReturnType<typeof useGetSegmentsByBrandKeyLazyQuery>;
export type GetSegmentsByBrandKeySuspenseQueryHookResult = ReturnType<typeof useGetSegmentsByBrandKeySuspenseQuery>;
export type GetSegmentsByBrandKeyQueryResult = Apollo.QueryResult<GetSegmentsByBrandKeyQuery, GetSegmentsByBrandKeyQueryVariables>;
export const UpdatePushDocument = gql`
    mutation updatePush($where: PushUniqueFilterInput!, $data: PushUpdateInput!) {
  updatePush(where: $where, data: $data) {
    id
    title
    body
    isCancelled
  }
}
    `;
export type UpdatePushMutationFn = Apollo.MutationFunction<UpdatePushMutation, UpdatePushMutationVariables>;

/**
 * __useUpdatePushMutation__
 *
 * To run a mutation, you first call `useUpdatePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePushMutation, { data, loading, error }] = useUpdatePushMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePushMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePushMutation, UpdatePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePushMutation, UpdatePushMutationVariables>(UpdatePushDocument, options);
      }
export type UpdatePushMutationHookResult = ReturnType<typeof useUpdatePushMutation>;
export type UpdatePushMutationResult = Apollo.MutationResult<UpdatePushMutation>;
export type UpdatePushMutationOptions = Apollo.BaseMutationOptions<UpdatePushMutation, UpdatePushMutationVariables>;
export const GetOrphanPageDocument = gql`
    query getOrphanPage($id: UUID) {
  orphanPage(where: {id: $id}) {
    id
    publishedAt
    editedAt
    status
    title
    content
    metas
    isCMPEnabled
    isAdsEnabled
    isFullScreen
    brandKey
    uri
  }
}
    `;

/**
 * __useGetOrphanPageQuery__
 *
 * To run a query within a React component, call `useGetOrphanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrphanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrphanPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrphanPageQuery(baseOptions?: Apollo.QueryHookOptions<GetOrphanPageQuery, GetOrphanPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrphanPageQuery, GetOrphanPageQueryVariables>(GetOrphanPageDocument, options);
      }
export function useGetOrphanPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrphanPageQuery, GetOrphanPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrphanPageQuery, GetOrphanPageQueryVariables>(GetOrphanPageDocument, options);
        }
export function useGetOrphanPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrphanPageQuery, GetOrphanPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrphanPageQuery, GetOrphanPageQueryVariables>(GetOrphanPageDocument, options);
        }
export type GetOrphanPageQueryHookResult = ReturnType<typeof useGetOrphanPageQuery>;
export type GetOrphanPageLazyQueryHookResult = ReturnType<typeof useGetOrphanPageLazyQuery>;
export type GetOrphanPageSuspenseQueryHookResult = ReturnType<typeof useGetOrphanPageSuspenseQuery>;
export type GetOrphanPageQueryResult = Apollo.QueryResult<GetOrphanPageQuery, GetOrphanPageQueryVariables>;
export const UpsertOrphanPageDocument = gql`
    mutation upsertOrphanPage($where: OrphanPageUniqueFilterInput!, $update: OrphanPageUpdateInput!, $create: OrphanPageCreationInput!) {
  upsertOrphanPage(where: $where, update: $update, create: $create) {
    id
    publishedAt
    editedAt
    status
    title
    content
    metas
    isCMPEnabled
    isAdsEnabled
    isFullScreen
    brandKey
    uri
  }
}
    `;
export type UpsertOrphanPageMutationFn = Apollo.MutationFunction<UpsertOrphanPageMutation, UpsertOrphanPageMutationVariables>;

/**
 * __useUpsertOrphanPageMutation__
 *
 * To run a mutation, you first call `useUpsertOrphanPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrphanPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrphanPageMutation, { data, loading, error }] = useUpsertOrphanPageMutation({
 *   variables: {
 *      where: // value for 'where'
 *      update: // value for 'update'
 *      create: // value for 'create'
 *   },
 * });
 */
export function useUpsertOrphanPageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrphanPageMutation, UpsertOrphanPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrphanPageMutation, UpsertOrphanPageMutationVariables>(UpsertOrphanPageDocument, options);
      }
export type UpsertOrphanPageMutationHookResult = ReturnType<typeof useUpsertOrphanPageMutation>;
export type UpsertOrphanPageMutationResult = Apollo.MutationResult<UpsertOrphanPageMutation>;
export type UpsertOrphanPageMutationOptions = Apollo.BaseMutationOptions<UpsertOrphanPageMutation, UpsertOrphanPageMutationVariables>;
export const UpdatePageCategoryDocument = gql`
    mutation UpdatePageCategory($where: CategoryUniqueFilterInput!, $data: CategoryUpdateInput!) {
  updateCategory(where: $where, data: $data) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type UpdatePageCategoryMutationFn = Apollo.MutationFunction<UpdatePageCategoryMutation, UpdatePageCategoryMutationVariables>;

/**
 * __useUpdatePageCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageCategoryMutation, { data, loading, error }] = useUpdatePageCategoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePageCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageCategoryMutation, UpdatePageCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageCategoryMutation, UpdatePageCategoryMutationVariables>(UpdatePageCategoryDocument, options);
      }
export type UpdatePageCategoryMutationHookResult = ReturnType<typeof useUpdatePageCategoryMutation>;
export type UpdatePageCategoryMutationResult = Apollo.MutationResult<UpdatePageCategoryMutation>;
export type UpdatePageCategoryMutationOptions = Apollo.BaseMutationOptions<UpdatePageCategoryMutation, UpdatePageCategoryMutationVariables>;
export const CreatePageCategoryDocument = gql`
    mutation CreatePageCategory($data: CategoryCreationInput!) {
  createCategory(data: $data) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type CreatePageCategoryMutationFn = Apollo.MutationFunction<CreatePageCategoryMutation, CreatePageCategoryMutationVariables>;

/**
 * __useCreatePageCategoryMutation__
 *
 * To run a mutation, you first call `useCreatePageCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageCategoryMutation, { data, loading, error }] = useCreatePageCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePageCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageCategoryMutation, CreatePageCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageCategoryMutation, CreatePageCategoryMutationVariables>(CreatePageCategoryDocument, options);
      }
export type CreatePageCategoryMutationHookResult = ReturnType<typeof useCreatePageCategoryMutation>;
export type CreatePageCategoryMutationResult = Apollo.MutationResult<CreatePageCategoryMutation>;
export type CreatePageCategoryMutationOptions = Apollo.BaseMutationOptions<CreatePageCategoryMutation, CreatePageCategoryMutationVariables>;
export const LockCategoryDocument = gql`
    mutation LockCategory($where: CategoryUniqueFilterInput!) {
  lockCategory(where: $where)
}
    `;
export type LockCategoryMutationFn = Apollo.MutationFunction<LockCategoryMutation, LockCategoryMutationVariables>;

/**
 * __useLockCategoryMutation__
 *
 * To run a mutation, you first call `useLockCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockCategoryMutation, { data, loading, error }] = useLockCategoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLockCategoryMutation(baseOptions?: Apollo.MutationHookOptions<LockCategoryMutation, LockCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockCategoryMutation, LockCategoryMutationVariables>(LockCategoryDocument, options);
      }
export type LockCategoryMutationHookResult = ReturnType<typeof useLockCategoryMutation>;
export type LockCategoryMutationResult = Apollo.MutationResult<LockCategoryMutation>;
export type LockCategoryMutationOptions = Apollo.BaseMutationOptions<LockCategoryMutation, LockCategoryMutationVariables>;
export const RetainLockCategoryDocument = gql`
    mutation RetainLockCategory($where: CategoryUniqueFilterInput!) {
  retainCategoryLock(where: $where)
}
    `;
export type RetainLockCategoryMutationFn = Apollo.MutationFunction<RetainLockCategoryMutation, RetainLockCategoryMutationVariables>;

/**
 * __useRetainLockCategoryMutation__
 *
 * To run a mutation, you first call `useRetainLockCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetainLockCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retainLockCategoryMutation, { data, loading, error }] = useRetainLockCategoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRetainLockCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RetainLockCategoryMutation, RetainLockCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetainLockCategoryMutation, RetainLockCategoryMutationVariables>(RetainLockCategoryDocument, options);
      }
export type RetainLockCategoryMutationHookResult = ReturnType<typeof useRetainLockCategoryMutation>;
export type RetainLockCategoryMutationResult = Apollo.MutationResult<RetainLockCategoryMutation>;
export type RetainLockCategoryMutationOptions = Apollo.BaseMutationOptions<RetainLockCategoryMutation, RetainLockCategoryMutationVariables>;
export const UnlockCategoryDocument = gql`
    mutation UnlockCategory($where: CategoryUniqueFilterInput!) {
  unlockCategory(where: $where)
}
    `;
export type UnlockCategoryMutationFn = Apollo.MutationFunction<UnlockCategoryMutation, UnlockCategoryMutationVariables>;

/**
 * __useUnlockCategoryMutation__
 *
 * To run a mutation, you first call `useUnlockCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockCategoryMutation, { data, loading, error }] = useUnlockCategoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnlockCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UnlockCategoryMutation, UnlockCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockCategoryMutation, UnlockCategoryMutationVariables>(UnlockCategoryDocument, options);
      }
export type UnlockCategoryMutationHookResult = ReturnType<typeof useUnlockCategoryMutation>;
export type UnlockCategoryMutationResult = Apollo.MutationResult<UnlockCategoryMutation>;
export type UnlockCategoryMutationOptions = Apollo.BaseMutationOptions<UnlockCategoryMutation, UnlockCategoryMutationVariables>;
export const GetPageCategoriesDocument = gql`
    query GetPageCategories($first: UnsignedInt!, $where: CategoryFilterInput!, $skip: UnsignedInt) {
  categories(first: $first, where: $where, orderBy: title_ASC, skip: $skip) {
    ...CategoryList
    children(first: 1000, orderBy: title_ASC) {
      ...CategoryList
    }
  }
}
    ${CategoryListFragmentDoc}`;

/**
 * __useGetPageCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPageCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      where: // value for 'where'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPageCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetPageCategoriesQuery, GetPageCategoriesQueryVariables> & ({ variables: GetPageCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>(GetPageCategoriesDocument, options);
      }
export function useGetPageCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>(GetPageCategoriesDocument, options);
        }
export function useGetPageCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>(GetPageCategoriesDocument, options);
        }
export type GetPageCategoriesQueryHookResult = ReturnType<typeof useGetPageCategoriesQuery>;
export type GetPageCategoriesLazyQueryHookResult = ReturnType<typeof useGetPageCategoriesLazyQuery>;
export type GetPageCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetPageCategoriesSuspenseQuery>;
export type GetPageCategoriesQueryResult = Apollo.QueryResult<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>;
export const GetPageCategoryHistoryDocument = gql`
    query GetPageCategoryHistory($where: CategoryHistoryFilterInput, $orderBy: [CategoryHistoryOrderingInput!]) {
  categoryHistories(where: $where, orderBy: $orderBy, first: 999) {
    category {
      ...Category
    }
    createdAt
    id
    user {
      ... on OneUser {
        id
        name
        avatarUrl
      }
    }
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useGetPageCategoryHistoryQuery__
 *
 * To run a query within a React component, call `useGetPageCategoryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageCategoryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageCategoryHistoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPageCategoryHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>(GetPageCategoryHistoryDocument, options);
      }
export function useGetPageCategoryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>(GetPageCategoryHistoryDocument, options);
        }
export function useGetPageCategoryHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>(GetPageCategoryHistoryDocument, options);
        }
export type GetPageCategoryHistoryQueryHookResult = ReturnType<typeof useGetPageCategoryHistoryQuery>;
export type GetPageCategoryHistoryLazyQueryHookResult = ReturnType<typeof useGetPageCategoryHistoryLazyQuery>;
export type GetPageCategoryHistorySuspenseQueryHookResult = ReturnType<typeof useGetPageCategoryHistorySuspenseQuery>;
export type GetPageCategoryHistoryQueryResult = Apollo.QueryResult<GetPageCategoryHistoryQuery, GetPageCategoryHistoryQueryVariables>;
export const GetCategoryForEditDocument = gql`
    query GetCategoryForEdit($where: CategoryUniqueFilterInput!) {
  category(where: $where) {
    ...Category
    articleCategoryCount(where: {article: {status: Published}})
    articleChannelCount(where: {article: {status: Published}})
    articleEventCount(where: {article: {status: Published}})
    articleGuideCount(where: {article: {status: Published}})
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useGetCategoryForEditQuery__
 *
 * To run a query within a React component, call `useGetCategoryForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryForEditQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCategoryForEditQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryForEditQuery, GetCategoryForEditQueryVariables> & ({ variables: GetCategoryForEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>(GetCategoryForEditDocument, options);
      }
export function useGetCategoryForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>(GetCategoryForEditDocument, options);
        }
export function useGetCategoryForEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>(GetCategoryForEditDocument, options);
        }
export type GetCategoryForEditQueryHookResult = ReturnType<typeof useGetCategoryForEditQuery>;
export type GetCategoryForEditLazyQueryHookResult = ReturnType<typeof useGetCategoryForEditLazyQuery>;
export type GetCategoryForEditSuspenseQueryHookResult = ReturnType<typeof useGetCategoryForEditSuspenseQuery>;
export type GetCategoryForEditQueryResult = Apollo.QueryResult<GetCategoryForEditQuery, GetCategoryForEditQueryVariables>;
export const GetBrandsDocument = gql`
    query GetBrands {
  categories(where: {level: 2, format: Category}, first: 25) {
    brandKey
    title
  }
}
    `;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export function useGetBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsSuspenseQueryHookResult = ReturnType<typeof useGetBrandsSuspenseQuery>;
export type GetBrandsQueryResult = Apollo.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const GetBrandCategoriesDocument = gql`
    query GetBrandCategories($brandKey: BrandKey!, $format: CategoryFormat = Category, $status: CategoryStatus) {
  categories(where: {brandKey: $brandKey, level: 2, format: $format, status: $status}, first: 500) {
    ...BrandCategoryFragment
    children(first: 500, where: {status: $status}) {
      ...BrandCategoryFragment
      children(first: 500, where: {status: $status}) {
        ...BrandCategoryFragment
        children(first: 500, where: {status: $status}) {
          ...BrandCategoryFragment
        }
      }
    }
  }
}
    ${BrandCategoryFragmentFragmentDoc}`;

/**
 * __useGetBrandCategoriesQuery__
 *
 * To run a query within a React component, call `useGetBrandCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCategoriesQuery({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      format: // value for 'format'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBrandCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables> & ({ variables: GetBrandCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>(GetBrandCategoriesDocument, options);
      }
export function useGetBrandCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>(GetBrandCategoriesDocument, options);
        }
export function useGetBrandCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>(GetBrandCategoriesDocument, options);
        }
export type GetBrandCategoriesQueryHookResult = ReturnType<typeof useGetBrandCategoriesQuery>;
export type GetBrandCategoriesLazyQueryHookResult = ReturnType<typeof useGetBrandCategoriesLazyQuery>;
export type GetBrandCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetBrandCategoriesSuspenseQuery>;
export type GetBrandCategoriesQueryResult = Apollo.QueryResult<GetBrandCategoriesQuery, GetBrandCategoriesQueryVariables>;
export const GetBrandFilterCategoriesDocument = gql`
    query GetBrandFilterCategories($brandKey: BrandKey!, $format: CategoryFormat = Category, $status: CategoryStatus, $title_not_in: [NonEmptyTrimmedString!]) {
  categories(where: {brandKey: $brandKey, level: 2, format: $format, status: $status}, first: 500) {
    ...BrandCategoryFragment
    children(first: 500, where: {status: $status}) {
      ...BrandCategoryFragment
      children(first: 500, where: {status: $status, title_not_in: $title_not_in}) {
        ...BrandCategoryFragment
        children(first: 500, where: {status: $status}) {
          ...BrandCategoryFragment
        }
      }
    }
  }
}
    ${BrandCategoryFragmentFragmentDoc}`;

/**
 * __useGetBrandFilterCategoriesQuery__
 *
 * To run a query within a React component, call `useGetBrandFilterCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandFilterCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandFilterCategoriesQuery({
 *   variables: {
 *      brandKey: // value for 'brandKey'
 *      format: // value for 'format'
 *      status: // value for 'status'
 *      title_not_in: // value for 'title_not_in'
 *   },
 * });
 */
export function useGetBrandFilterCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables> & ({ variables: GetBrandFilterCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>(GetBrandFilterCategoriesDocument, options);
      }
export function useGetBrandFilterCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>(GetBrandFilterCategoriesDocument, options);
        }
export function useGetBrandFilterCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>(GetBrandFilterCategoriesDocument, options);
        }
export type GetBrandFilterCategoriesQueryHookResult = ReturnType<typeof useGetBrandFilterCategoriesQuery>;
export type GetBrandFilterCategoriesLazyQueryHookResult = ReturnType<typeof useGetBrandFilterCategoriesLazyQuery>;
export type GetBrandFilterCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetBrandFilterCategoriesSuspenseQuery>;
export type GetBrandFilterCategoriesQueryResult = Apollo.QueryResult<GetBrandFilterCategoriesQuery, GetBrandFilterCategoriesQueryVariables>;
export const GetTagForTagEditDocument = gql`
    query GetTagForTagEdit($where: TagUniqueFilterInput!, $brandKey: BrandKey) {
  tag(where: $where) {
    id
    title
    slug
    type
    lang
    brandedContents(first: 1, where: {brandKey: $brandKey}) {
      id
      createdAt
      updatedAt
      body
      media
      isActive
    }
    articleUsages {
      total
    }
  }
}
    `;

/**
 * __useGetTagForTagEditQuery__
 *
 * To run a query within a React component, call `useGetTagForTagEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagForTagEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagForTagEditQuery({
 *   variables: {
 *      where: // value for 'where'
 *      brandKey: // value for 'brandKey'
 *   },
 * });
 */
export function useGetTagForTagEditQuery(baseOptions: Apollo.QueryHookOptions<GetTagForTagEditQuery, GetTagForTagEditQueryVariables> & ({ variables: GetTagForTagEditQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>(GetTagForTagEditDocument, options);
      }
export function useGetTagForTagEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>(GetTagForTagEditDocument, options);
        }
export function useGetTagForTagEditSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>(GetTagForTagEditDocument, options);
        }
export type GetTagForTagEditQueryHookResult = ReturnType<typeof useGetTagForTagEditQuery>;
export type GetTagForTagEditLazyQueryHookResult = ReturnType<typeof useGetTagForTagEditLazyQuery>;
export type GetTagForTagEditSuspenseQueryHookResult = ReturnType<typeof useGetTagForTagEditSuspenseQuery>;
export type GetTagForTagEditQueryResult = Apollo.QueryResult<GetTagForTagEditQuery, GetTagForTagEditQueryVariables>;
export const UpdateBrandedContentForTagEditDocument = gql`
    mutation UpdateBrandedContentForTagEdit($data: TagBrandedContentUpdateInput!, $where: TagBrandedContentUniqueFilterInput!) {
  updateTagBrandedContent(data: $data, where: $where) {
    id
    body
    media
  }
}
    `;
export type UpdateBrandedContentForTagEditMutationFn = Apollo.MutationFunction<UpdateBrandedContentForTagEditMutation, UpdateBrandedContentForTagEditMutationVariables>;

/**
 * __useUpdateBrandedContentForTagEditMutation__
 *
 * To run a mutation, you first call `useUpdateBrandedContentForTagEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandedContentForTagEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandedContentForTagEditMutation, { data, loading, error }] = useUpdateBrandedContentForTagEditMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateBrandedContentForTagEditMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandedContentForTagEditMutation, UpdateBrandedContentForTagEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandedContentForTagEditMutation, UpdateBrandedContentForTagEditMutationVariables>(UpdateBrandedContentForTagEditDocument, options);
      }
export type UpdateBrandedContentForTagEditMutationHookResult = ReturnType<typeof useUpdateBrandedContentForTagEditMutation>;
export type UpdateBrandedContentForTagEditMutationResult = Apollo.MutationResult<UpdateBrandedContentForTagEditMutation>;
export type UpdateBrandedContentForTagEditMutationOptions = Apollo.BaseMutationOptions<UpdateBrandedContentForTagEditMutation, UpdateBrandedContentForTagEditMutationVariables>;
export const GetTagsDocument = gql`
    query GetTags($where: TagFilterInput, $orderBy: [TagOrderingInput!], $first: UnsignedInt!, $skip: UnsignedInt) {
  tags(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
    id
    title
    slug
    type
    brandedContents(first: 100) {
      id
      brandKey
      isActive
      body
      media
    }
    articleUsages {
      brandKey
      total
    }
    articleCount
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables> & ({ variables: GetTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export function useGetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsSuspenseQueryHookResult = ReturnType<typeof useGetTagsSuspenseQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;